require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/button-location-select-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<label id=\"location-select-label\" for=\"core-wizard-location-select\" class=\"col\">\n	<span class=\"label\">Nearby</span>\n	<button id=\"core-wizard-location-select\" type=\"button\"><span class=\"visuallyhidden\">Detect my location</span></button>\n</label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-calendar-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n    data-control=\"datepicker\"\n    class=\"col text datepicker theme-standard pin-left "
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    data-auto-pos=\"true\">\n  <label class=\"datepicker-label datepicker-arrow text icon-before\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n    <span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "<span class=\"datepicker-expand-collapse visuallyhidden\"> expanded. Enter a date or choose one from the table below.</span></span>\n    <input\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " datepicker-trigger-input\"\n        type=\"text\"\n        placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-cal-version=\"touch-keyboard\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['aria-describedby'] : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.inputAttributes : depth0),{"name":"each","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    />\n    <span class=\"icon icon-calendar\"></span>\n  </label>\n  <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>\n\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"4":function(depth0,helpers,partials,data) {
    return "invalid";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['companion-attr'] : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "          "
    + this.escapeExpression(((helper = (helper = helpers['companion-attr'] || (depth0 != null ? depth0['companion-attr'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion-attr","hash":{},"data":data}) : helper)))
    + "=\"&#35;"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.companion || (depth0 != null ? depth0.companion : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "        "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"11":function(depth0,helpers,partials,data) {
    return "disabled";
},"13":function(depth0,helpers,partials,data) {
    return "error";
},"15":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "data-number=\""
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"17":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "aria-describedby=\""
    + ((stack1 = ((helper = (helper = helpers['aria-describedby'] || (depth0 != null ? depth0['aria-describedby'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"aria-describedby","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"19":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n<label class=\"text calendar "
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " icon-before col "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" >\n  <span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n  <input\n      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      type=\"text\"\n      id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n      data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n      class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"unless","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      data-control=\"calendar\"\n      placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n      data-cal-version=\"touch-keyboard\"\n      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['aria-describedby'] : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  />\n  <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n</label>\n\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['companion-attr'] : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"23":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "              "
    + this.escapeExpression(((helper = (helper = helpers['companion-attr'] || (depth0 != null ? depth0['companion-attr'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion-attr","hash":{},"data":data}) : helper)))
    + "=\"&#35;"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.companion || (depth0 != null ? depth0.companion : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-checkbox-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "checked";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label class=\"check\" id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\">\n        <input \n          type=\"checkbox\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" \n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-radio-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "disabled";
},"3":function(depth0,helpers,partials,data) {
    return "checked";
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "class=\"checked\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label name=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" class=\"check "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n        <input \n          type=\"radio\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-ta-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"5":function(depth0,helpers,partials,data) {
    return "class=\"error\"";
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "          data-js-theme=\"typeahead\"\n          data-provide=\"typeahead\"\n          aria-autocomplete=\"list\"\n          autocomplete=\"off\"\n          spellcheck=\"false\"\n          data-ta-key="
    + ((stack1 = ((helper = (helper = helpers.ta_key || (depth0 != null ? depth0.ta_key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ta_key","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n          data-tooltip-id=\"typeahead-list\"\n          aria-owns=\"typeahead-list\"\n          aria-labelledby=\"flight-"
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"11":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-search\" aria-hidden=\"true\"></span>\n";
},"13":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div class=\"container-ta-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n    <label class=\"text icon-before col "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" >\n      <span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n      <input\n        type=\"text\"\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.TAoff : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        data-autoselect=\"touch\"\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      />\n      \n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearch : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "")
    + "    </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/select-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return " invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>";
},"5":function(depth0,helpers,partials,data) {
    return " error";
},"7":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.program(14, data, 0),"data":data})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <optgroup label=\""
    + ((stack1 = this.lambda((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          </optgroup>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "              <option\n                "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \n                value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\">\n                  "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n              </option>\n\n";
},"12":function(depth0,helpers,partials,data) {
    return "selected=\"selected\"";
},"14":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          <option\n            "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\">\n              "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n          </option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label\n      id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\"\n      class=\"select icon col icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['label-class'] || (depth0 != null ? depth0['label-class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-text'] : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      <select\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        class=\""
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      >\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </select>\n    </label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-vacation-rentals", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-vacation-rentals\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-activities", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-activities\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-carFlight", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-carHotel", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-carHotelFlight", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-cars", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-cruise", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-cruise\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-flightCar", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-flightHotel", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-flightHotelCar", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-flights", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-hotelCar", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-hotelFlight", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-hotelFlightCar", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-hotels", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-packages", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-packages\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-search", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-search\" aria-hidden=\"true\"></span>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/soft-package-checkbox-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return " checked";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "\n<label class=\"col link\">\n  <input type=\"checkbox\"\n  	id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-"
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-checkbox\"\n  	data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n  	data-wizard-action=\""
    + alias3(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"action","hash":{},"data":data}) : helper)))
    + "\"\n    data-package-wrapper=\""
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-package-wrapper\"\n    data-tracking=\"softPackageCheckbox\"\n  	"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.checked : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <span class=\"inline-label\"><span class=\"icon icon-"
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" aria-hidden=\"true\"></span>"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n</label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/includes/next-trip-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "	<section class=\"itin-next-trip\" id=\"next-trip\">\n		<h4 class=\"trip-title\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isFlight : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "		</h4>\n\n		<span class=\"trip-name-icon\">\n			<span class=\"icon icon-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.lob : stack1), depth0))
    + "\"></span>\n			"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1), depth0))
    + "\n		</span>\n\n		<span class=\"trip-date\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "		</span>\n\n		<a class=\"trip-link\" href="
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.link : stack1), depth0))
    + ">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.seeMyTripLinkText : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n	</section>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingFlight : stack1), depth0))
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingHotel : stack1), depth0))
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.program(10, data, 0),"data":data})) != null ? stack1 : "");
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "						"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCar : stack1), depth0))
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCruise : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "							"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCruise : stack1), depth0))
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.program(16, data, 0),"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingActivity : stack1), depth0))
    + "\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingTrip : stack1), depth0))
    + "\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return "			"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.checkInTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.program(23, data, 0),"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.pickUpTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.program(26, data, 0),"data":data})) != null ? stack1 : "");
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.activityStartsTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.departureTextForUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/activity-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane geolocation-enabled on\" id=\"tab-activity\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-activity\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleActivitiesOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXThingsTodo : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    </div>\n\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXThingsTodo</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXAirportRides</div>\n";
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.activityDestinationPlaceholder : stack1),"ia-data-lob":"ACTIVITIES","has-error":(depth0 != null ? depth0.destinationError : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.activityDestinationLabel : stack1),"ta-key":"activity"},"data":data}))
    + "\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.program(17, data, 0),"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"start",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-end-date":"&#35;activity-end-wrapper","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.startDate : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.startDateLabel : stack1)},"data":data}))
    + "\n    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"end",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-start-date":"&#35;activity-start-wrapper","wizard-action":"{\"endDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.endDateLabel : stack1)},"data":data}))
    + "\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "         "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"start",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-end-date":"#activity-end","ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.startDate : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.startDateLabel : stack1)},"data":data}))
    + "\n     "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"end",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-start-date":"#activity-start","wizard-action":"{\"endDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.endDateLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=helpers.helperMissing, buffer = 
  ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXActivityABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
  stack1 = ((helper = (helper = helpers.row || (depth0 != null ? depth0.row : depth0)) != null ? helper : alias1),(options={"name":"row","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.row) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/direct-flight-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","directFlight",(depth0 != null ? depth0.isDirectFlight : depth0),{"name":"input","hash":{"wizard-action":"{\"isDirectFlight\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.directFlightLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDirectFlightCheckbox : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-type-hbs'],depth0,{"name":"corewizard/field-groups/flights-type-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <div class=\"flight-passenger-container col\">\n          <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    return "          <div class=\"flight-passenger-wrapper\">\n";
},"9":function(depth0,helpers,partials,data) {
    return "          </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"col\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-multi-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-multi-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/advanced-options-hbs'],depth0,{"name":"corewizard/field-groups/advanced-options-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n  "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-origin-destination-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested flight-date-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/advanced-options-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <section class=\"advanced-options\">\n    <a\n      href=\"#advanced-options-fields\"\n      role=\"button\"\n      id=\"advanced-options\"\n      aria-controls=\"advanced-options-fields\"\n      aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      class=\"toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'>\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </section>\n";
},"2":function(depth0,helpers,partials,data) {
    return "false";
},"4":function(depth0,helpers,partials,data) {
    return "true";
},"6":function(depth0,helpers,partials,data) {
    return "viewed";
},"8":function(depth0,helpers,partials,data) {
    return "open";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <div id=\"advanced-options-fields\">\n        <fieldset class=\"advanced-checkboxes\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/nonstop-flight-hbs'],depth0,{"name":"corewizard/fields/nonstop-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/refundable-flight-hbs'],depth0,{"name":"corewizard/fields/refundable-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPreferredAirline : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = "";

  stack1 = ((helper = (helper = helpers.row || (depth0 != null ? depth0.row : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"row","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.row) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.preferredAirlines : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/preferred-class-hbs'],depth0,{"name":"corewizard/fields/preferred-class-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/preferred-airline-hbs'],depth0,{"name":"corewizard/fields/preferred-airline-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/error-messages-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-errors\" class=\"alert-container alert alert-error validation-alert\">\n  <span class=\"icon icon-warn\" aria-hidden=\"true\"></span>\n  <h5 class=\"alert-title\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.errorMessageTitle : stack1), depth0))
    + "</h5>\n    <div class=\"alert-message\">\n      <ul>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearchErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateRangeTooLongErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateOutOfRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBeforeCurrentDateMessage : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateTimeRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.partialStayDatesOutOfRange : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateError : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfTravellersMessage : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.childAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n  </div>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-searchQuery\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlank\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"12":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"14":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-checkin\">"
    + alias3(((helper = (helper = helpers.dateRangeTooLongErrorMessageText || (depth0 != null ? depth0.dateRangeTooLongErrorMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateRangeTooLongErrorMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"16":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateOutOfRangeMessageText || (depth0 != null ? depth0.dateOutOfRangeMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateOutOfRangeMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBeforeCurrentDateMessageText : stack1), depth0))
    + "</a></li>\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateTimeRangeMessageText : stack1), depth0))
    + "</a></li>\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"partialStayDatesOutOfRange\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-checkin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayDatesOutOfRangeText : stack1), depth0))
    + "</a></li>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"multiDestDateError\" href=\"&#35;flight-2-departing\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfTravellersMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.numberOfTravellersMessageText : stack1), depth0))
    + "</a></li>\n";
},"28":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"childAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.childAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showErrors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-lap-or-seat-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "    "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.escapeExpression, alias2=helpers.helperMissing;

  return "<div class=\"young-child-note\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <fieldset class=\"children-lap-wrapper cf\">\n  <legend>"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildNote : stack1), depth0))
    + "</legend>\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-lap",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"input","hash":{"ia-value":"lap","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : true}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInLapLabel : stack1)},"data":data}))
    + "\n    "
    + alias1((helpers.assign || (depth0 && depth0.assign) || alias2).call(depth0,depth0,"inSeat","!",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"assign","hash":{},"data":data}))
    + "\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-seat",(depth0 != null ? depth0.inSeat : depth0),{"name":"input","hash":{"ia-value":"seat","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInSeatLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-children-fieldset-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "  <fieldset class=\"children-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-children-fieldset=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/children-age-select-hbs'],depth0,{"name":"corewizard/field-groups/children-age-select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-rooms-container-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<div class=\"rooms-container total-rooms-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + " total-room-1-children-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-rooms\" data-id-prefix=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-highest-tnum=\"0\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-room-hbs'],depth0,{"name":"corewizard/field-groups/hotels-room-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-location-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination location-select-enabled\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination\">\n";
},"5":function(depth0,helpers,partials,data) {
    return " invalid";
},"7":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/button-location-select-hbs'],depth0,{"name":"corewizard/components/button-location-select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n            ";
},"13":function(depth0,helpers,partials,data) {
    return "                disabled\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car\">\n  <label class=\"text type-ahead icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-label\">\n      <span class=\"label\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n        <input\n            type=\"text\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            value=\""
    + alias3(((helper = (helper = helpers.pickup || (depth0 != null ? depth0.pickup : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"pickup","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupPlaceholder : stack1), depth0))
    + "\"\n            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_origin\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"31\"\n            data-version=\"v3\"\n            data-wizard-action='{\"destination\" : \"$value1\"}'\n            data-autoselect=\"touch\" aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n</div>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car\">\n  <label class=\"text type-ahead icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\">\n      <span class=\"label\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffLabel : stack1), depth0))
    + "</span>\n        <input\n            type=\"text\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " value=\""
    + alias3(((helper = (helper = helpers.dropoff || (depth0 != null ? depth0.dropoff : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dropoff","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffPlaceholder : stack1), depth0))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.carShowDropOff : depth0),{"name":"unless","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_dest\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"1\"\n            data-version=\"v1\"\n            data-forceicon=\"flights\"\n            data-wizard-action='{\"carReturn\" : \"$value1\"}'\n            data-autoselect=\"touch\"\n            aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n            aria-labelledby=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\"\n            title=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffPlaceholder : stack1), depth0))
    + "\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n</div>\n</fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-children-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/children-age-select-hbs'],depth0,{"name":"corewizard/field-groups/children-age-select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "<fieldset class=\"total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " children-fieldset cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-multi-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-flights\" class=\"multi-dest-container\" data-highest-tnum=\"1\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-flight-hbs'],depth0,{"name":"corewizard/field-groups/flights-flight-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-dates-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-hotel",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "\n        <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n          "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n        </div>\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.checkinValue : depth0),"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkinAction : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCheckinLabel : stack1)},"data":data}))
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"aria-describedby":"length-of-stay-counter","ia-value":(depth0 != null ? depth0.checkoutValue : depth0),"has-error":(depth0 != null ? depth0.endDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkoutAction : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCheckoutLabel : stack1)},"data":data}))
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/partial-stay-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","partialHotelBooking",(depth0 != null ? depth0.isPartialStay : depth0),{"name":"input","hash":{"wizard-action":"{\"isPartialStay\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-package-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-remove-type=\"cars-package\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.parent || (depth0 != null ? depth0.parent : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"parent","hash":{},"data":data}) : helper)))
    + "\">\n  <p>"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carWillBeAddedLabel : stack1), depth0))
    + "</p>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-children-help-and-options-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<fieldset class=\"three-pp-airline-age-rules cols-nested\">\n  <label class=\"col three-pp-airline-age-rules-label\">\n      <span class=\"label\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.ageHelpMessage : stack1), depth0))
    + "</span>\n  </label>\n  <a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n</fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-lap-or-seat-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-lap-or-seat-hbs'],depth0,{"name":"corewizard/field-groups/flights-lap-or-seat-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLapOrSeat : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-origin-destination-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-origin-hbs'],depth0,{"name":"corewizard/fields/flights-origin-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    \n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightDestination : depth0),{"name":"unless","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-destination-hbs'],depth0,{"name":"corewizard/fields/flights-destination-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"origin-destination typeahead-container"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "            <label id=\"hotel-1-guests-label\" class=\"select icon col icon-toggle180 \">\n                <span class=\"label\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.guestsLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                <select id=\"hotel-1-guests\" data-wizard-action=\"{&quot;guestMoreOptionsSelected&quot; : $value1}\">\n                   <option selected=\"selected\" value=\"2\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions2Adults : stack1), depth0))
    + " </option>\n                   <option value=\"1\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions1Adult : stack1), depth0))
    + " </option>\n                   <option value=\"99\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptionsMoreOptions : stack1), depth0))
    + " </option>\n                </select>\n            </label>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotels-rooms-count-hbs'],depth0,{"name":"corewizard/fields/hotels-rooms-count-hbs","data":data,"indent":"               ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            <div class=\"rooms-container stacked-rooms total-rooms-"
    + alias1(((helper = (helper = helpers.roomCount || (depth0 != null ? depth0.roomCount : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"roomCount","hash":{},"data":data}) : helper)))
    + " total-room-1-children-"
    + alias1(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"               ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div class=\"total-rooms-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelDestinationVisible : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      <fieldset class=\"cols-nested\">\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useDetailedGuestDropdown : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n\n</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/children-age-select-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,(depth0 != null ? depth0.id : depth0),"childAges",{"name":"select","hash":{"label-text":(depth0 != null ? depth0.label : depth0),"options-list":(depth0 != null ? depth0.childAgeOptions : depth0),"ia-aria-required":"true","ia-data-select-value":(depth0 != null ? depth0.age : depth0),"ia-data-redraw":true,"ia-data-wizard-owner":(depth0 != null ? depth0.parent : depth0),"wizard-action":(depth0 != null ? depth0.wizardAction : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-dates-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-returning-hbs'],depth0,{"name":"corewizard/fields/flights-returning-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-departing-hbs'],depth0,{"name":"corewizard/fields/flights-departing-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-passengers-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/children-age-select-hbs'],depth0,{"name":"corewizard/field-groups/children-age-select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-passengers\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/flights-adults-hbs'],depth0,{"name":"corewizard/fields/flights-adults-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/flights-children-select-hbs'],depth0,{"name":"corewizard/fields/flights-children-select-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-flight-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <hr class=\"default\" />\n  <fieldset data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-container=\""
    + alias3(((helper = (helper = helpers.container || (depth0 != null ? depth0.container : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"container","hash":{},"data":data}) : helper)))
    + "\" class=\"cols-nested origin-destination additional-flight\">\n    <legend id=\"flight-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(this.lambda(((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightLabel : stack1), depth0))
    + " "
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "</legend>\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ta-key":"flight_multi","wizard-action":(depth0 != null ? depth0.originWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightOriginLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":"flight_multi","wizard-action":(depth0 != null ? depth0.destinationWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDestinationLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.departing : depth0),"wizard-action":(depth0 != null ? depth0.dateWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDepartingLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.multidest : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-type-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","type-multi-dest",(depth0 != null ? depth0.isMultiDest : depth0),{"name":"input","hash":{"ia-value":"multi","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightMultidestLabel : stack1),"class":"col"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "\n\n      <a href=\"#flight-type-help-container\" id=\"flight-type-help-default\" data-control=\"tooltip\" data-width=\"300\" data-arrow=\"true\" aria-describedby=\"flight-type-help-container\" data-fade=\"out\" data-manual=\"none\" data-tooltip-classes=\"example\"><span class=\"icon icon-help\"><span class=\"visuallyhidden\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpToolTipText : stack1), depth0))
    + "</span></span></a><div id=\"flight-type-help-container\" role=\"tooltip\" class=\"visuallyhidden\"><p>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpMessage : stack1), depth0))
    + "</p></div>\n\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<fieldset class=\"flight-type-select\">\n   <legend class=\"visuallyhidden\">Flight type - changes form below</legend>\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-roundtrip",(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"input","hash":{"ia-value":"roundtrip","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRoundtripLabel : stack1),"class":"col"},"data":data}))
    + "\n\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-one-way",(depth0 != null ? depth0.isOneWay : depth0),{"name":"input","hash":{"ia-value":"oneway","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightOnewayLabel : stack1),"class":"col"},"data":data}))
    + "\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasMultiDestFlight : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</fieldset>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-room-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"cols-row hotel-room room-count-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + " total-children-"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id="
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + " data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.ownerId || (depth0 != null ? depth0.ownerId : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ownerId","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n    <fieldset class=\"occupants-select\">\n    <legend class=\"room-count-legend\">"
    + alias3(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper)))
    + "</legend>\n\n    "
    + alias3((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"adults","hotelAdults",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.adults : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelAdultsLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"children","hotelChildren",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.childCount : depth0),"ia-data-redraw":"true","ia-data-children-fieldset":(depth0 != null ? depth0.id : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelChildrenLabel : stack1),"id":(depth0 != null ? depth0.id : depth0),"class":"children-select number-of-travellers"},"data":data}))
    + "\n  </fieldset>\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-children-fieldset-hbs'],depth0,{"name":"corewizard/field-groups/hotels-children-fieldset-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.rooms : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/package-price-savings", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightHotelPackageUpsell : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "            <p class=\"fh\">\n                <strong>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.fhMessage1 : stack1), depth0))
    + "</strong>\n                <br />\n                "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.fhMessage2 : stack1), depth0))
    + "\n            </p>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageSavingsDisclaimer : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "                <p class=\"fh package-val-prop-disclaimer\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.disclaimer : stack1), depth0))
    + "</p>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <p class=\"nonfh single-line-val-prop\" id=\"single-line-val-prop\">\n                <strong>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.nonfhMessage : stack1), depth0))
    + "</strong>\n            </p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"fh-msg-tooltip\" class=\"sub-600 package-val-prop\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageValueMessage : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/open-search-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "     "
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"searchQuery",{"name":"input-TA","hash":{"openSearch":true,"ia-data-lob":"OPENSEARCH","ta-key":"openSearch","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchLabel : stack1),"ia-value":(depth0 != null ? depth0.searchQuery : depth0),"has-error":(depth0 != null ? depth0.openSearchError : depth0),"wizard-action":"{\"searchQuery\" : \"$value1\"}"},"data":data}))
    + "  \n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on\" id=\"tab-openSearch\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"   ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</section>";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/cars-rental-company", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">No Preference</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"MW\">Midway Car Rental</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"SV\">U-Save</option>\n";
},"3":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n";
},"5":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"SV\">U-Save</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allVendors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.corporateVendors : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.specialVendors : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-departing-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"flight-departing","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightDepartingLabel : stack1)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-returning-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"returning",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightReturningLabel : stack1)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/hotels-rooms-count-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"rooms","rooms",{"name":"select","hash":{"ia-aria-required":"true","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-data-select-value":(depth0 != null ? depth0.roomCount : depth0),"wizard-action":"{\"roomCount\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelRoomsCountLabel : stack1)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/preferred-airline-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"advanced-preferred-airline","",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.preferredAirlines : depth0),"ia-name":"select","ia-data-select-value":(depth0 != null ? depth0.carrier : depth0),"wizard-action":"{\"carrier\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.perferredAirlineLabel : stack1)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-adults-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "  "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"adults","flightAdults",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.numberOfAdultsSelectOptions : depth0),"ia-aria-required":"true","ia-wizard-owner":"adults","ia-data-select-value":(depth0 != null ? depth0.adults : depth0),"class":"number-of-travellers","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightAdultsLabel : stack1),"wizard-action":"{\"rooms[0].adults\" : $value1}"},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightPlaceholderText : stack1),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.destination : depth0),"has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightDestinationLabel : stack1)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/hotel-car-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.placeholderText : stack1),"ia-data-lob":"HOTELS","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.label : stack1),"ta-key":"package_hotel_car","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}));
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/nonstop-flight-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-nonstop",(depth0 != null ? depth0.nonStop : depth0),{"name":"input","hash":{"wizard-action":"{\"nonStop\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightNonStopLabel : stack1),"id":"advanced-flight-nonstop"},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/preferred-class-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"advanced-preferred-class","preferredClass",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.cabinClass : depth0),"wizard-action":"{\"cabinClass\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.perferredClassLabel : stack1)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-children-select-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"children","flightChildren",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.numberOfChildrenSelectOptions : depth0),"ia-aria-required":"true","ia-data-redraw":"true","ia-data-children-fieldset":"children","ia-data-wizard-owner":"children","ia-data-select-value":(depth0 != null ? depth0.children : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildrenLabel : stack1),"class":"children-select number-of-travellers","wizard-action":"{\"rooms[0].childCount\" : $value1}"},"data":data}))
    + "  \n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-origin-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightPlaceholderText : stack1),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":"{\"origin\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightOriginLabel : stack1),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/hotel-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestinationPlaceholderText : stack1),"ia-data-lob":"HOTELS","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestinationLabel : stack1),"ta-key":"hotel","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}));
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/package-radio-buttons-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "\n    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","package",(depth0 != null ? depth0.isCurrentPackageType : depth0),{"name":"input","hash":{"ia-data-tracking":"packageLob","ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":"package-lob","label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":"{\"packages.flight\" : $value1, \"packages.hotel\" : $value2, \"packages.car\" : $value3, \"packages.train\" : $value4}"},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.packageData : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/refundable-flight-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-refundable",(depth0 != null ? depth0.noPenalty : depth0),{"name":"input","hash":{"wizard-action":"{\"noPenalty\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRefundableLabel : stack1),"id":"advanced-flight"},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/sub-tabs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "\n  "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio",(depth0 != null ? depth0.id : depth0),(depth0 != null ? depth0.selected : depth0),{"name":"input","hash":{"ia-data-tracking":(depth0 != null ? depth0.tracking : depth0),"ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":(depth0 != null ? depth0.name : depth0),"label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":(depth0 != null ? depth0.action : depth0)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.subTab : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/cruise-dates-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "<div id=\"earliestDepartureDateParent\" data-control=\"datepicker\" class=\"col datepicker theme-standard pin-left earliest-departure-date\" data-auto-pos=\"true\" data-end-date=\"#latestDepartureDateParent\"  data-blackout-dates='"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.whitelistedDates : stack1), depth0))
    + "'>\n    <label id=\"earliestDepartureDateLabel\" class=\"datepicker-label datepicker-arrow text icon-before\" for=\"cruise-departing\">\n        <span class=\"label\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.cruiseSailDatesLabel : stack1), depth0))
    + "<span class=\"datepicker-expand-collapse visuallyhidden\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.earliestSailingDatePickerMessage : stack1), depth0))
    + "</span></span>\n        <input id=\"cruise-departing\" class=\"text datepicker-trigger-input\" type=\"text\" placeholder=\"mm/dd/yyyy\" data-wizard-action='{\"cruiseEarliestDepartureDate\" : \"$value1\"}' value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.earliestDepartureDate : stack1), depth0))
    + "\"/>\n        <span class=\"icon icon-calendar\"></span>\n    </label>\n    <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>\n<div id=\"latestDepartureDateParent\" data-control=\"datepicker\" class=\"col datepicker theme-standard pin-left latest-departure-date\" data-auto-pos=\"true\" data-start-date=\"#earliestDepartureDateParent\" data-blackout-dates='"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.whitelistedDates : stack1), depth0))
    + "'>\n    <label id=\"latestDepartureDateLabel\" class=\"datepicker-label datepicker-arrow text icon-before\" for=\"cruise-returning\">\n        <span class=\"datepicker-expand-collapse visuallyhidden\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.latestSailingDatePickerMessage : stack1), depth0))
    + "</span>\n        <input id=\"cruise-returning\" class=\"text datepicker-trigger-input\" type=\"text\" placeholder=\"mm/dd/yyyy\" data-wizard-action='{\"cruiseLatestDepartureDate\" : \"$value1\"}' value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.latestDepartureDate : stack1), depth0))
    + "\">\n        <span class=\"icon icon-calendar\"></span>\n    </label>\n    <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/cruise-month-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"departure-month",{"name":"select","hash":{"ia-name":"select","ia-data-select-value":(depth0 != null ? depth0.cruiseMonth : depth0),"label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.departureMonthLabel : stack1),"options-list":(depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0),"wizard-action":"{\"cruiseMonth\" : \"$value1\"}"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "    <label class=\"search-type select col icon icon-toggle180\" id=\"cruise-departure-month-label\">\n        <span class=\"label\">"
    + alias1(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.departureMonthLabel : stack1), depth0))
    + "</span>\n        <select id=\"cruise-departure-month\" data-wizard-action='{\"cruiseMonth\" : \"$value1\"}' class=\"\" name=\"select\" data-select-value=\""
    + alias1(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\"departure-month\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.months : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </select>\n    </label>\n";
},"4":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + alias3(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"display","hash":{},"data":data}) : helper)))
    + "\n                </option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/flight-passenger", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-cars", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car geolocation-enabled tab-pane on\" id=\"tab-car\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car tab-pane on\" id=\"tab-car\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleCarOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRentalCars : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "        <div>Content FROM showRentalCars</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM airportRides</div>\n";
},"12":function(depth0,helpers,partials,data) {
    return " <!-- TODO: AB Test 6555 -->\n                "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"pickup-date",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-end-date":"&#35;car-dropoff-date","ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":"${carPickupDateLabel}"},"data":data}))
    + "\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "              <label class=\"text depart-return calendar icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startDateError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-date-label\">\n                <span class=\"label\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupDateLabel : stack1), depth0))
    + "</span>\n                <input type=\"text\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-date\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startDateError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" value=\""
    + alias3(((helper = (helper = helpers.startDate || (depth0 != null ? depth0.startDate : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"startDate","hash":{},"data":data}) : helper)))
    + "\" data-max-booking-length=\""
    + alias3(((helper = (helper = helpers.maxTripLength || (depth0 != null ? depth0.maxTripLength : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"maxTripLength","hash":{},"data":data}) : helper)))
    + "\" data-last-valid-date=\""
    + alias3(((helper = (helper = helpers.lastValidDate || (depth0 != null ? depth0.lastValidDate : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lastValidDate","hash":{},"data":data}) : helper)))
    + "\" data-min-booking-length=\""
    + alias3(((helper = (helper = helpers.minTripLength || (depth0 != null ? depth0.minTripLength : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"minTripLength","hash":{},"data":data}) : helper)))
    + "\" data-control=\"calendar\" data-end-date=\"&#35;car-dropoff-date\" data-wizard-action='{\"startDate\" : \"$value1\"}' aria-required='true'/>\n                <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n              </label>\n";
},"16":function(depth0,helpers,partials,data) {
    return " invalid";
},"18":function(depth0,helpers,partials,data) {
    return " class=\"error\"";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"pickup-date",{"name":"input-calendar","hash":{"ia-data-end-date":"&#35;car-dropoff-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"pickup-date-label","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupDateLabel : stack1)},"data":data}))
    + "\n";
},"22":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  	            <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.key || (depth0 != null ? depth0.key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"key","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"24":function(depth0,helpers,partials,data) {
    return "<!-- AB Test 6555 -->\n                "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"dropoff-date",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.endDate : depth0),"ia-data-start-date":"&#35;car-pickup-date","ia-aria-required":"true","has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":"${carDropoffDateLabel}"},"data":data}))
    + "\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"unless","hash":{},"fn":this.program(27, data, 0),"inverse":this.program(29, data, 0),"data":data})) != null ? stack1 : "")
    + "\n";
},"27":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <label class=\"text depart-return calendar icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endDateError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-date-label\">\n                  <span class=\"label\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffDateLabel : stack1), depth0))
    + "</span>\n                  <input type=\"text\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-date\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endDateError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" value=\""
    + alias3(((helper = (helper = helpers.endDate || (depth0 != null ? depth0.endDate : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"endDate","hash":{},"data":data}) : helper)))
    + "\" data-control=\"calendar\" data-start-date=\"&#35;car-pickup-date\" data-wizard-action='{\"endDate\" : \"$value1\"}' aria-required='true' aria-required='true'/>\n                  <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n                </label>\n";
},"29":function(depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"dropoff-date",{"name":"input-calendar","hash":{"ia-data-start-date":"&#35;car-pickup-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"ia-data-tid":"dropoff-date-label","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffDateLabel : stack1)},"data":data}))
    + "\n";
},"31":function(depth0,helpers,partials,data) {
    return "false";
},"33":function(depth0,helpers,partials,data) {
    return "true";
},"35":function(depth0,helpers,partials,data) {
    return "open";
},"37":function(depth0,helpers,partials,data) {
    return "viewed";
},"39":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "    <div id=\"car-options\">\n        <fieldset class=\"cols-nested from-to\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carOptions : depth0),{"name":"each","hash":{},"fn":this.program(40, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDiscountCodeFields : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <fieldset class=\"cols-nested equipment-options cf\">\n            <legend>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carSpecialEquipment : stack1), depth0))
    + "</legend>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.specialEquipmentOptions : depth0),{"name":"each","hash":{},"fn":this.program(46, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </fieldset>\n    </div>\n";
},"40":function(depth0,helpers,partials,data,blockParams,depths) {
    return "                "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depths[1],(depth0 != null ? depth0.namespace : depth0),{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['ia-data-select-value'] : depth0),"options-list":(depth0 != null ? depth0['options-list'] : depth0),"wizard_action":(depth0 != null ? depth0.wizard_action : depth0),"label-text":(depth0 != null ? depth0['label-text'] : depth0)},"data":data}))
    + "\n";
},"42":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <fieldset class=\"cols-nested origin-destination\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carDiscountCodeOptions : depth0),{"name":"each","hash":{},"fn":this.program(43, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </fieldset>\n";
},"43":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['show-car-discount-options'] : depth0),{"name":"if","hash":{},"fn":this.program(44, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"44":function(depth0,helpers,partials,data) {
    var alias1=this.lambda, alias2=this.escapeExpression;

  return "            <label class=\"text col\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "-label\">\n                <span class=\"label\">"
    + alias2(alias1((depth0 != null ? depth0['label-text'] : depth0), depth0))
    + "</span>\n                <input type=\"text\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "\" placeholder=\""
    + alias2(alias1((depth0 != null ? depth0.placeholder : depth0), depth0))
    + "\" data-wizard-action=\""
    + alias2(alias1((depth0 != null ? depth0.wizard_action : depth0), depth0))
    + "\" value=\""
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\"/>\n            </label>\n";
},"46":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "            <ul class=\"cols-nested col\" role=\"presentation\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(47, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </ul>\n";
},"47":function(depth0,helpers,partials,data,blockParams,depths) {
    return "                <li role=\"presentation\">\n                    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depths[2],"checkbox",(depth0 != null ? depth0.namespace : depth0),(depth0 != null ? depth0.isChecked : depth0),{"name":"input","hash":{"ia-data-tid":(depth0 != null ? depth0.namespace : depth0),"wizard_action":(depth0 != null ? depth0.wizard_action : depth0),"label-text":(depth0 != null ? depth0['label-text'] : depth0)},"data":data}))
    + "\n                </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda, alias5=helpers.blockHelperMissing, buffer = 
  ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXCarABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-location-hbs'],depth0,{"name":"corewizard/field-groups/cars-location-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested pickup-dropoff\">\n\n            "
    + ((stack1 = helpers['if'].call(depth0,false,{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.program(14, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time-label\" >\n  	    <span class=\"label visuallyhidden\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"startTime\" : \"$value1\"}' data-select-value=\""
    + alias3(((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"startTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(22, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias2 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  buffer += "  	    </select>\n  	</label>\n\n            "
    + ((stack1 = helpers['if'].call(depth0,false,{"name":"if","hash":{},"fn":this.program(24, data, 0, blockParams, depths),"inverse":this.program(26, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time-label\">\n  	    <span class=\"label visuallyhidden\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropOffTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"endTime\" : \"$value1\"}' data-select-value=\""
    + alias3(((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"endTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(22, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias2 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  	    </select>\n  	</label>\n  </fieldset>\n\n  <a\n    id=\"car-options-toggle\"\n    data-wizard-action='{\"showCarOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(31, data, 0, blockParams, depths),"inverse":this.program(33, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + " }'\n    class=\"link show-options toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(35, data, 0, blockParams, depths),"inverse":this.program(37, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n    href=\"#car-options\"\n    role=\"button\"\n    aria-controls=\"advanced-options-fields\"\n    aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(33, data, 0, blockParams, depths),"inverse":this.program(31, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n    aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(33, data, 0, blockParams, depths),"inverse":this.program(31, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n  >\n    "
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carShowOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n  </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(39, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</section>\n";
},"usePartial":true,"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-flights", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "soft-package-hotel";
},"3":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"hotels","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addHotelLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),"action":(depth0 != null ? depth0.addHotelAction : depth0),"lob":"hotel","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"hotel-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-hotel\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"car-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-car\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<section class=\"tab-pane on\" id=\"tab-flight\">\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-tab\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-misc", Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"19":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.program(24, data, 0),"data":data})) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(13, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "ab6555_1";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "        <h1 class=\"col wizard-title\">"
    + ((stack1 = ((helper = (helper = helpers.wizardTitle || (depth0 != null ? depth0.wizardTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"wizardTitle","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h1>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/next-trip-hbs'],depth0,{"name":"corewizard/includes/next-trip-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <ul class=\"tabs cf col\" role=\"tablist\" data-tid=\"wizard-tablist\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.lobs : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/layouts/tab-hbs'],depth0,{"name":"corewizard/layouts/tab-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var helper;

  return "        <span class='hotel-value-prop-tablet' id='hotel-tab-value-prop'>\n            <span>"
    + this.escapeExpression(((helper = (helper = helpers.hotelTabletValueProp || (depth0 != null ? depth0.hotelTabletValueProp : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelTabletValueProp","hash":{},"data":data}) : helper)))
    + "</span>\n        </span>\n";
},"12":function(depth0,helpers,partials,data) {
    return " no-tabs";
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.packagePriceSavingsDollarValue : stack1),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/package-price-savings'],depth0,{"name":"corewizard/field-groups/package-price-savings","data":data,"indent":"                        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['handlebars/wizard/promo-message'],depth0,{"name":"handlebars/wizard/promo-message","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/bpg'],depth0,{"name":"corewizard/includes/bpg","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<div>\n    <div  class=\"cols-row search theme-inverse-pills "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab6555 : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \" id=\"wizard-theme-wrapper\" data-tid=\"region\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.wizardTitle : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.displayNextTrip : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs - pills -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showValueProp : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"col forms"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"unless","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " tabs-container\" data-tid=\"tab-container\">\n        <form autocomplete=\"off\">\n            <div data-wizard-action=\"form-wrapper\">\n            "
    + ((stack1 = (helpers['wizard-form'] || (depth0 && depth0['wizard-form']) || alias1).call(depth0,depth0,{"name":"wizard-form","hash":{},"data":data})) != null ? stack1 : "")
    + "\n            </div>\n            <fieldset class=\"cols submit-and-mixin-fieldset\">\n                <label class=\"col search-btn-col\">\n                    <button type=\"submit\" data-wizard-action=\"{submit:true}\" class=\"btn-action btn-primary\" id=\"search-button\" data-tid=\"search-button\">\n                        <span class=\"btn-label\">"
    + this.escapeExpression(((helper = (helper = helpers.searchText || (depth0 != null ? depth0.searchText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"searchText","hash":{},"data":data}) : helper)))
    + "</span>\n                    </button>\n                </label>\n\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePackageValuePropMessage : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePromoMessage : stack1),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n        </form>\n    </div><!-- .tab-content -->\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.useBestPriceGuaranteeLogo : stack1),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div><!-- .search -->\n</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/tab-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "            data-wizard-action='{\"tab\" : \""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\", \"packages.flight\" : "
    + alias3(((helper = (helper = helpers.flightsPackage || (depth0 != null ? depth0.flightsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"flightsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.hotel\" : "
    + alias3(((helper = (helper = helpers.hotelsPackage || (depth0 != null ? depth0.hotelsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"hotelsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.car\" : "
    + alias3(((helper = (helper = helpers.carsPackage || (depth0 != null ? depth0.carsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.train\" : "
    + alias3(((helper = (helper = helpers.trainsPackage || (depth0 != null ? depth0.trainsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"trainsPackage","hash":{},"data":data}) : helper)))
    + " }'\n";
},"3":function(depth0,helpers,partials,data) {
    return "            data-wizard-action='{}'\n";
},"5":function(depth0,helpers,partials,data) {
    return "            class=\"on\" aria-selected=\"true\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "            class=\"\" aria-selected=\"false\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<li  class=\"tab\" role=\"presentation\" data-lobtab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\">\n    <a role=\"tab\" href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\"\n        data-tab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isPackageTab : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            id=\"tab-"
    + alias3(((helper = (helper = helpers['tab-id'] || (depth0 != null ? depth0['tab-id'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab-id","hash":{},"data":data}) : helper)))
    + "-tab\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCurrentTab : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "        data-tracking=\"tab\"\n    >\n        "
    + ((stack1 = (helpers['uitk-lobIcon'] || (depth0 && depth0['uitk-lobIcon']) || alias1).call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"uitk-lobIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n        <span class=\"visuallyhidden\">Search for </span><span class=\"tab-label\">"
    + ((stack1 = ((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </a>\n</li>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-hotels", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on geolocation-enabled\" id=\"tab-hotel\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-hotel\">\n";
},"5":function(depth0,helpers,partials,data) {
    return "soft-package-flight";
},"7":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(25, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useHotelGroupBookingLink : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"flights","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),"action":(depth0 != null ? depth0.addFlightAction : depth0),"lob":"flight","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"15":function(depth0,helpers,partials,data) {
    return "        <@ui.dctkExperimentAware testIds=\"7385\" />\n        <label class=\"col link\">\n        <span class=\"inline-label\">\n            <a href=\"http://groups.expedia.com/GroupForm.cfm\" target=\"_blank\">\n                Booking a group?<@uitk.icon name=\"popup\" content=\" Booking a group?\" />\n            </a>\n        </span>\n        </label>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"flight-package-wrapper\" tabindex=\"-1\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    return " visuallyhidden";
},"21":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#flight-package-wrapper\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-flights\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\"  class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightHotelMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-flight\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"25":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"car-package-wrapper\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasCar : depth0),{"name":"if","hash":{},"fn":this.program(30, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"28":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#add-car\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-cars\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCarMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"30":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "      <div class=\"package-container cf\" id=\"hotel-added-car\" data-wizard-owner=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationNotCuba : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-packages", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " geolocation-enabled\" id=\"tab-package\">\n";
},"2":function(depth0,helpers,partials,data) {
    return " car-message car";
},"4":function(depth0,helpers,partials,data) {
    return " hotel";
},"6":function(depth0,helpers,partials,data) {
    return " flight";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"tab-package\">\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-origin-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-car-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-car-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    var helper;

  return "                  <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n                    "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n                  </div>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"partial-stay"},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(30, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(33, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      ";
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotels-rooms-count-hbs'],depth0,{"name":"corewizard/fields/hotels-rooms-count-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotels-rooms-count-hbs'],depth0,{"name":"corewizard/fields/hotels-rooms-count-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"28":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/direct-flight-hbs'],depth0,{"name":"corewizard/field-groups/direct-flight-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/partial-stay-hbs'],depth0,{"name":"corewizard/field-groups/partial-stay-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"30":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"is-partial-stay"},"fn":this.program(31, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"31":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"33":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"35":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['default/templates/advanced-options-package-hbs'],depth0,{"name":"default/templates/advanced-options-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"37":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"package-rooms-travellers-container\">\n          <fieldset class=\"cols-nested flights-passengers cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n      ";
},"39":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(40, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"40":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"42":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <div class=\"package-car-message label\" id=\"package-car\">\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carWillBeAddedLabel : stack1), depth0))
    + "\n      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "\n  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiplePackageOrder : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRooms : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.enableAdvancedOptions : depth0),{"name":"if","hash":{},"fn":this.program(35, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.noRooms : depth0),{"name":"if","hash":{},"fn":this.program(37, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideChildrenFlightFields : depth0),{"name":"unless","hash":{},"fn":this.program(39, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </fieldset>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarMessage : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/typeahead/category", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/typeahead/open-search-ta", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "               <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/typeahead/default", Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/templates/advanced-options-package-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "false";
},"3":function(depth0,helpers,partials,data) {
    return "true";
},"5":function(depth0,helpers,partials,data) {
    return "viewed";
},"7":function(depth0,helpers,partials,data) {
    return "open";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = 
  "        <div id=\"advanced-options-fields\">\n";
  stack1 = ((helper = (helper = helpers.row || (depth0 != null ? depth0.row : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"row","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.row) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "        </div>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['default/templates/preferred-class-package-hbs'],depth0,{"name":"default/templates/preferred-class-package-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"advanced-options col\">\n    <a\n            href=\"#advanced-options-fields\"\n            role=\"button\"\n            id=\"advanced-options\"\n            aria-controls=\"advanced-options-fields\"\n            aria-expanded=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            aria-pressed=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"toggle-trigger "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'\n            >\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/templates/preferred-class-package-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"advanced-preferred-class","preferredClass",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.preferredClass : depth0),"ia-data-select-value":(depth0 != null ? depth0.cabinClass : depth0),"wizard-action":"{\"cabinClass\" : \"$value1\"}","label-text":""},"data":data}));
},"useData":true}));});
this["Handlebars"] = this["Handlebars"] || {};
this["Handlebars"]["templates"] = this["Handlebars"]["templates"] || {};
this["Handlebars"]["templates"]["button-location-select-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<label id=\"location-select-label\" for=\"core-wizard-location-select\" class=\"col\">\n	<span class=\"label\">Nearby</span>\n	<button id=\"core-wizard-location-select\" type=\"button\"><span class=\"visuallyhidden\">Detect my location</span></button>\n</label>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-calendar-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n    data-control=\"datepicker\"\n    class=\"col text datepicker theme-standard pin-left "
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    data-auto-pos=\"true\">\n  <label class=\"datepicker-label datepicker-arrow text icon-before\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n    <span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "<span class=\"datepicker-expand-collapse visuallyhidden\"> expanded. Enter a date or choose one from the table below.</span></span>\n    <input\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " datepicker-trigger-input\"\n        type=\"text\"\n        placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-cal-version=\"touch-keyboard\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['aria-describedby'] : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.inputAttributes : depth0),{"name":"each","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    />\n    <span class=\"icon icon-calendar\"></span>\n  </label>\n  <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>\n\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"4":function(depth0,helpers,partials,data) {
    return "invalid";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['companion-attr'] : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "          "
    + this.escapeExpression(((helper = (helper = helpers['companion-attr'] || (depth0 != null ? depth0['companion-attr'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion-attr","hash":{},"data":data}) : helper)))
    + "=\"&#35;"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.companion || (depth0 != null ? depth0.companion : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "        "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"11":function(depth0,helpers,partials,data) {
    return "disabled";
},"13":function(depth0,helpers,partials,data) {
    return "error";
},"15":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "data-number=\""
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"17":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "aria-describedby=\""
    + ((stack1 = ((helper = (helper = helpers['aria-describedby'] || (depth0 != null ? depth0['aria-describedby'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"aria-describedby","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"19":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n<label class=\"text calendar "
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " icon-before col "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" >\n  <span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n  <input\n      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      type=\"text\"\n      id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n      data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n      class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"unless","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      data-control=\"calendar\"\n      placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n      data-cal-version=\"touch-keyboard\"\n      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['aria-describedby'] : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  />\n  <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n</label>\n\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['companion-attr'] : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"23":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "              "
    + this.escapeExpression(((helper = (helper = helpers['companion-attr'] || (depth0 != null ? depth0['companion-attr'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion-attr","hash":{},"data":data}) : helper)))
    + "=\"&#35;"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.companion || (depth0 != null ? depth0.companion : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["input-checkbox-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "checked";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label class=\"check\" id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\">\n        <input \n          type=\"checkbox\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" \n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-radio-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "disabled";
},"3":function(depth0,helpers,partials,data) {
    return "checked";
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "class=\"checked\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label name=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" class=\"check "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n        <input \n          type=\"radio\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-ta-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"5":function(depth0,helpers,partials,data) {
    return "class=\"error\"";
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "          data-js-theme=\"typeahead\"\n          data-provide=\"typeahead\"\n          aria-autocomplete=\"list\"\n          autocomplete=\"off\"\n          spellcheck=\"false\"\n          data-ta-key="
    + ((stack1 = ((helper = (helper = helpers.ta_key || (depth0 != null ? depth0.ta_key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ta_key","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n          data-tooltip-id=\"typeahead-list\"\n          aria-owns=\"typeahead-list\"\n          aria-labelledby=\"flight-"
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"11":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-search\" aria-hidden=\"true\"></span>\n";
},"13":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div class=\"container-ta-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n    <label class=\"text icon-before col "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" >\n      <span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n      <input\n        type=\"text\"\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.TAoff : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        data-autoselect=\"touch\"\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      />\n      \n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearch : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "")
    + "    </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["select-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return " invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>";
},"5":function(depth0,helpers,partials,data) {
    return " error";
},"7":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.program(14, data, 0),"data":data})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <optgroup label=\""
    + ((stack1 = this.lambda((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          </optgroup>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "              <option\n                "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \n                value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\">\n                  "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n              </option>\n\n";
},"12":function(depth0,helpers,partials,data) {
    return "selected=\"selected\"";
},"14":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          <option\n            "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\">\n              "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n          </option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label\n      id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\"\n      class=\"select icon col icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['label-class'] || (depth0 != null ? depth0['label-class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n      "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-text'] : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      <select\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        class=\""
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      >\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </select>\n    </label>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-vacation-rentals"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-vacation-rentals\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-activities"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-activities\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-carFlight"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-carHotel"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-carHotelFlight"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-cars"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-cruise"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-cruise\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-flightCar"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-flightHotel"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-flightHotelCar"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-flights"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-hotelCar"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-hotelFlight"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-hotelFlightCar"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"multiPkgIcon\">\n  <span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-flights\" aria-hidden=\"true\"></span>\n  &nbsp;\n  <span class=\"icon icon-cars\" aria-hidden=\"true\"></span>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-hotels"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-hotels\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-packages"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-packages\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-search"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"icon icon-search\" aria-hidden=\"true\"></span>\n";
},"useData":true};
this["Handlebars"]["templates"]["soft-package-checkbox-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return " checked";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "\n<label class=\"col link\">\n  <input type=\"checkbox\"\n  	id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-"
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-checkbox\"\n  	data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n  	data-wizard-action=\""
    + alias3(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"action","hash":{},"data":data}) : helper)))
    + "\"\n    data-package-wrapper=\""
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-package-wrapper\"\n    data-tracking=\"softPackageCheckbox\"\n  	"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.checked : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <span class=\"inline-label\"><span class=\"icon icon-"
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" aria-hidden=\"true\"></span>"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n</label>\n";
},"useData":true};
this["Handlebars"]["templates"]["next-trip-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "	<section class=\"itin-next-trip\" id=\"next-trip\">\n		<h4 class=\"trip-title\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isFlight : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "		</h4>\n\n		<span class=\"trip-name-icon\">\n			<span class=\"icon icon-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.lob : stack1), depth0))
    + "\"></span>\n			"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1), depth0))
    + "\n		</span>\n\n		<span class=\"trip-date\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "		</span>\n\n		<a class=\"trip-link\" href="
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.link : stack1), depth0))
    + ">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.seeMyTripLinkText : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n	</section>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingFlight : stack1), depth0))
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingHotel : stack1), depth0))
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.program(10, data, 0),"data":data})) != null ? stack1 : "");
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "						"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCar : stack1), depth0))
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCruise : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "							"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCruise : stack1), depth0))
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.program(16, data, 0),"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingActivity : stack1), depth0))
    + "\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingTrip : stack1), depth0))
    + "\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return "			"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.checkInTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.program(23, data, 0),"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.pickUpTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.program(26, data, 0),"data":data})) != null ? stack1 : "");
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.activityStartsTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.departureTextForUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["activity-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane geolocation-enabled on\" id=\"tab-activity\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-activity\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleActivitiesOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXThingsTodo : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    </div>\n\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXThingsTodo</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXAirportRides</div>\n";
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.activityDestinationPlaceholder : stack1),"ia-data-lob":"ACTIVITIES","has-error":(depth0 != null ? depth0.destinationError : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.activityDestinationLabel : stack1),"ta-key":"activity"},"data":data}))
    + "\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.program(17, data, 0),"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"start",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-end-date":"&#35;activity-end-wrapper","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.startDate : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.startDateLabel : stack1)},"data":data}))
    + "\n    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"end",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-start-date":"&#35;activity-start-wrapper","wizard-action":"{\"endDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.endDateLabel : stack1)},"data":data}))
    + "\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "         "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"start",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-end-date":"#activity-end","ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.startDate : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.startDateLabel : stack1)},"data":data}))
    + "\n     "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"end",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-data-start-date":"#activity-start","wizard-action":"{\"endDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.endDateLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=helpers.helperMissing, buffer = 
  ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXActivityABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
  stack1 = ((helper = (helper = helpers.row || (depth0 != null ? depth0.row : depth0)) != null ? helper : alias1),(options={"name":"row","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.row) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["direct-flight-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","directFlight",(depth0 != null ? depth0.isDirectFlight : depth0),{"name":"input","hash":{"wizard-action":"{\"isDirectFlight\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.directFlightLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDirectFlightCheckbox : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-type-hbs'],depth0,{"name":"corewizard/field-groups/flights-type-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <div class=\"flight-passenger-container col\">\n          <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    return "          <div class=\"flight-passenger-wrapper\">\n";
},"9":function(depth0,helpers,partials,data) {
    return "          </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"col\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-multi-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-multi-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/advanced-options-hbs'],depth0,{"name":"corewizard/field-groups/advanced-options-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n  "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-origin-destination-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested flight-date-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["advanced-options-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <section class=\"advanced-options\">\n    <a\n      href=\"#advanced-options-fields\"\n      role=\"button\"\n      id=\"advanced-options\"\n      aria-controls=\"advanced-options-fields\"\n      aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      class=\"toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'>\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </section>\n";
},"2":function(depth0,helpers,partials,data) {
    return "false";
},"4":function(depth0,helpers,partials,data) {
    return "true";
},"6":function(depth0,helpers,partials,data) {
    return "viewed";
},"8":function(depth0,helpers,partials,data) {
    return "open";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <div id=\"advanced-options-fields\">\n        <fieldset class=\"advanced-checkboxes\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/nonstop-flight-hbs'],depth0,{"name":"corewizard/fields/nonstop-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/refundable-flight-hbs'],depth0,{"name":"corewizard/fields/refundable-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPreferredAirline : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = "";

  stack1 = ((helper = (helper = helpers.row || (depth0 != null ? depth0.row : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"row","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.row) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.preferredAirlines : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/preferred-class-hbs'],depth0,{"name":"corewizard/fields/preferred-class-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/preferred-airline-hbs'],depth0,{"name":"corewizard/fields/preferred-airline-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["error-messages-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-errors\" class=\"alert-container alert alert-error validation-alert\">\n  <span class=\"icon icon-warn\" aria-hidden=\"true\"></span>\n  <h5 class=\"alert-title\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.errorMessageTitle : stack1), depth0))
    + "</h5>\n    <div class=\"alert-message\">\n      <ul>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearchErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateRangeTooLongErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateOutOfRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBeforeCurrentDateMessage : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateTimeRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.partialStayDatesOutOfRange : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateError : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfTravellersMessage : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.childAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n  </div>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-searchQuery\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlank\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"12":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"14":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-checkin\">"
    + alias3(((helper = (helper = helpers.dateRangeTooLongErrorMessageText || (depth0 != null ? depth0.dateRangeTooLongErrorMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateRangeTooLongErrorMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"16":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateOutOfRangeMessageText || (depth0 != null ? depth0.dateOutOfRangeMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateOutOfRangeMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBeforeCurrentDateMessageText : stack1), depth0))
    + "</a></li>\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateTimeRangeMessageText : stack1), depth0))
    + "</a></li>\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"partialStayDatesOutOfRange\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-checkin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayDatesOutOfRangeText : stack1), depth0))
    + "</a></li>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"multiDestDateError\" href=\"&#35;flight-2-departing\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfTravellersMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.numberOfTravellersMessageText : stack1), depth0))
    + "</a></li>\n";
},"28":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"childAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.childAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showErrors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-lap-or-seat-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "    "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.escapeExpression, alias2=helpers.helperMissing;

  return "<div class=\"young-child-note\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <fieldset class=\"children-lap-wrapper cf\">\n  <legend>"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildNote : stack1), depth0))
    + "</legend>\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-lap",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"input","hash":{"ia-value":"lap","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : true}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInLapLabel : stack1)},"data":data}))
    + "\n    "
    + alias1((helpers.assign || (depth0 && depth0.assign) || alias2).call(depth0,depth0,"inSeat","!",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"assign","hash":{},"data":data}))
    + "\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-seat",(depth0 != null ? depth0.inSeat : depth0),{"name":"input","hash":{"ia-value":"seat","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInSeatLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["hotels-children-fieldset-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "  <fieldset class=\"children-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-children-fieldset=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/children-age-select-hbs'],depth0,{"name":"corewizard/field-groups/children-age-select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["hotels-rooms-container-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<div class=\"rooms-container total-rooms-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + " total-room-1-children-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-rooms\" data-id-prefix=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-highest-tnum=\"0\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-room-hbs'],depth0,{"name":"corewizard/field-groups/hotels-room-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["cars-location-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination location-select-enabled\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination\">\n";
},"5":function(depth0,helpers,partials,data) {
    return " invalid";
},"7":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/button-location-select-hbs'],depth0,{"name":"corewizard/components/button-location-select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n            ";
},"13":function(depth0,helpers,partials,data) {
    return "                disabled\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car\">\n  <label class=\"text type-ahead icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-label\">\n      <span class=\"label\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n        <input\n            type=\"text\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            value=\""
    + alias3(((helper = (helper = helpers.pickup || (depth0 != null ? depth0.pickup : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"pickup","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupPlaceholder : stack1), depth0))
    + "\"\n            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_origin\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"31\"\n            data-version=\"v3\"\n            data-wizard-action='{\"destination\" : \"$value1\"}'\n            data-autoselect=\"touch\" aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n</div>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car\">\n  <label class=\"text type-ahead icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\">\n      <span class=\"label\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffLabel : stack1), depth0))
    + "</span>\n        <input\n            type=\"text\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " value=\""
    + alias3(((helper = (helper = helpers.dropoff || (depth0 != null ? depth0.dropoff : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dropoff","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffPlaceholder : stack1), depth0))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.carShowDropOff : depth0),{"name":"unless","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_dest\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"1\"\n            data-version=\"v1\"\n            data-forceicon=\"flights\"\n            data-wizard-action='{\"carReturn\" : \"$value1\"}'\n            data-autoselect=\"touch\"\n            aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n            aria-labelledby=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\"\n            title=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffPlaceholder : stack1), depth0))
    + "\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n</div>\n</fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-children-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/children-age-select-hbs'],depth0,{"name":"corewizard/field-groups/children-age-select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "<fieldset class=\"total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " children-fieldset cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-multi-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-flights\" class=\"multi-dest-container\" data-highest-tnum=\"1\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-flight-hbs'],depth0,{"name":"corewizard/field-groups/flights-flight-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["hotels-dates-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-hotel",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "\n        <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n          "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n        </div>\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.checkinValue : depth0),"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkinAction : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCheckinLabel : stack1)},"data":data}))
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"aria-describedby":"length-of-stay-counter","ia-value":(depth0 != null ? depth0.checkoutValue : depth0),"has-error":(depth0 != null ? depth0.endDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkoutAction : depth0),"class":"check-in-out","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCheckoutLabel : stack1)},"data":data}))
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["partial-stay-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","partialHotelBooking",(depth0 != null ? depth0.isPartialStay : depth0),{"name":"input","hash":{"wizard-action":"{\"isPartialStay\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["cars-package-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-remove-type=\"cars-package\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.parent || (depth0 != null ? depth0.parent : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"parent","hash":{},"data":data}) : helper)))
    + "\">\n  <p>"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carWillBeAddedLabel : stack1), depth0))
    + "</p>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-children-help-and-options-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<fieldset class=\"three-pp-airline-age-rules cols-nested\">\n  <label class=\"col three-pp-airline-age-rules-label\">\n      <span class=\"label\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.ageHelpMessage : stack1), depth0))
    + "</span>\n  </label>\n  <a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n</fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-lap-or-seat-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-lap-or-seat-hbs'],depth0,{"name":"corewizard/field-groups/flights-lap-or-seat-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLapOrSeat : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-origin-destination-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-origin-hbs'],depth0,{"name":"corewizard/fields/flights-origin-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    \n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightDestination : depth0),{"name":"unless","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-destination-hbs'],depth0,{"name":"corewizard/fields/flights-destination-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"origin-destination typeahead-container"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["hotels-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "            <label id=\"hotel-1-guests-label\" class=\"select icon col icon-toggle180 \">\n                <span class=\"label\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.guestsLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                <select id=\"hotel-1-guests\" data-wizard-action=\"{&quot;guestMoreOptionsSelected&quot; : $value1}\">\n                   <option selected=\"selected\" value=\"2\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions2Adults : stack1), depth0))
    + " </option>\n                   <option value=\"1\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions1Adult : stack1), depth0))
    + " </option>\n                   <option value=\"99\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptionsMoreOptions : stack1), depth0))
    + " </option>\n                </select>\n            </label>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotels-rooms-count-hbs'],depth0,{"name":"corewizard/fields/hotels-rooms-count-hbs","data":data,"indent":"               ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            <div class=\"rooms-container stacked-rooms total-rooms-"
    + alias1(((helper = (helper = helpers.roomCount || (depth0 != null ? depth0.roomCount : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"roomCount","hash":{},"data":data}) : helper)))
    + " total-room-1-children-"
    + alias1(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"               ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div class=\"total-rooms-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelDestinationVisible : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      <fieldset class=\"cols-nested\">\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useDetailedGuestDropdown : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n\n</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["children-age-select-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,(depth0 != null ? depth0.id : depth0),"childAges",{"name":"select","hash":{"label-text":(depth0 != null ? depth0.label : depth0),"options-list":(depth0 != null ? depth0.childAgeOptions : depth0),"ia-aria-required":"true","ia-data-select-value":(depth0 != null ? depth0.age : depth0),"ia-data-redraw":true,"ia-data-wizard-owner":(depth0 != null ? depth0.parent : depth0),"wizard-action":(depth0 != null ? depth0.wizardAction : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-dates-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-returning-hbs'],depth0,{"name":"corewizard/fields/flights-returning-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-departing-hbs'],depth0,{"name":"corewizard/fields/flights-departing-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-passengers-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/children-age-select-hbs'],depth0,{"name":"corewizard/field-groups/children-age-select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-passengers\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/flights-adults-hbs'],depth0,{"name":"corewizard/fields/flights-adults-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/flights-children-select-hbs'],depth0,{"name":"corewizard/fields/flights-children-select-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-flight-hbs"] = {"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <hr class=\"default\" />\n  <fieldset data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-container=\""
    + alias3(((helper = (helper = helpers.container || (depth0 != null ? depth0.container : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"container","hash":{},"data":data}) : helper)))
    + "\" class=\"cols-nested origin-destination additional-flight\">\n    <legend id=\"flight-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(this.lambda(((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightLabel : stack1), depth0))
    + " "
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "</legend>\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ta-key":"flight_multi","wizard-action":(depth0 != null ? depth0.originWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightOriginLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":"flight_multi","wizard-action":(depth0 != null ? depth0.destinationWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDestinationLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.departing : depth0),"wizard-action":(depth0 != null ? depth0.dateWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDepartingLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.multidest : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["flights-type-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","type-multi-dest",(depth0 != null ? depth0.isMultiDest : depth0),{"name":"input","hash":{"ia-value":"multi","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightMultidestLabel : stack1),"class":"col"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "\n\n      <a href=\"#flight-type-help-container\" id=\"flight-type-help-default\" data-control=\"tooltip\" data-width=\"300\" data-arrow=\"true\" aria-describedby=\"flight-type-help-container\" data-fade=\"out\" data-manual=\"none\" data-tooltip-classes=\"example\"><span class=\"icon icon-help\"><span class=\"visuallyhidden\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpToolTipText : stack1), depth0))
    + "</span></span></a><div id=\"flight-type-help-container\" role=\"tooltip\" class=\"visuallyhidden\"><p>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpMessage : stack1), depth0))
    + "</p></div>\n\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<fieldset class=\"flight-type-select\">\n   <legend class=\"visuallyhidden\">Flight type - changes form below</legend>\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-roundtrip",(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"input","hash":{"ia-value":"roundtrip","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRoundtripLabel : stack1),"class":"col"},"data":data}))
    + "\n\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-one-way",(depth0 != null ? depth0.isOneWay : depth0),{"name":"input","hash":{"ia-value":"oneway","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightOnewayLabel : stack1),"class":"col"},"data":data}))
    + "\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasMultiDestFlight : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</fieldset>\n";
},"useData":true};
this["Handlebars"]["templates"]["hotels-room-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"cols-row hotel-room room-count-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + " total-children-"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id="
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + " data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.ownerId || (depth0 != null ? depth0.ownerId : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ownerId","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n    <fieldset class=\"occupants-select\">\n    <legend class=\"room-count-legend\">"
    + alias3(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper)))
    + "</legend>\n\n    "
    + alias3((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"adults","hotelAdults",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.adults : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelAdultsLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"children","hotelChildren",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.childCount : depth0),"ia-data-redraw":"true","ia-data-children-fieldset":(depth0 != null ? depth0.id : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelChildrenLabel : stack1),"id":(depth0 != null ? depth0.id : depth0),"class":"children-select number-of-travellers"},"data":data}))
    + "\n  </fieldset>\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-children-fieldset-hbs'],depth0,{"name":"corewizard/field-groups/hotels-children-fieldset-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.rooms : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["package-price-savings"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightHotelPackageUpsell : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "            <p class=\"fh\">\n                <strong>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.fhMessage1 : stack1), depth0))
    + "</strong>\n                <br />\n                "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.fhMessage2 : stack1), depth0))
    + "\n            </p>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageSavingsDisclaimer : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "                <p class=\"fh package-val-prop-disclaimer\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.disclaimer : stack1), depth0))
    + "</p>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <p class=\"nonfh single-line-val-prop\" id=\"single-line-val-prop\">\n                <strong>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.nonfhMessage : stack1), depth0))
    + "</strong>\n            </p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"fh-msg-tooltip\" class=\"sub-600 package-val-prop\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageValueMessage : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["open-search-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "     "
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"searchQuery",{"name":"input-TA","hash":{"openSearch":true,"ia-data-lob":"OPENSEARCH","ta-key":"openSearch","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchLabel : stack1),"ia-value":(depth0 != null ? depth0.searchQuery : depth0),"has-error":(depth0 != null ? depth0.openSearchError : depth0),"wizard-action":"{\"searchQuery\" : \"$value1\"}"},"data":data}))
    + "  \n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on\" id=\"tab-openSearch\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"   ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</section>";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["cars-rental-company"] = {"1":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">No Preference</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"MW\">Midway Car Rental</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"SV\">U-Save</option>\n";
},"3":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n";
},"5":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"SV\">U-Save</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allVendors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.corporateVendors : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.specialVendors : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-departing-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"flight-departing","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightDepartingLabel : stack1)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-returning-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"returning",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightReturningLabel : stack1)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["hotels-rooms-count-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"rooms","rooms",{"name":"select","hash":{"ia-aria-required":"true","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-data-select-value":(depth0 != null ? depth0.roomCount : depth0),"wizard-action":"{\"roomCount\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelRoomsCountLabel : stack1)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["preferred-airline-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"advanced-preferred-airline","",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.preferredAirlines : depth0),"ia-name":"select","ia-data-select-value":(depth0 != null ? depth0.carrier : depth0),"wizard-action":"{\"carrier\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.perferredAirlineLabel : stack1)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-adults-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "  "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"adults","flightAdults",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.numberOfAdultsSelectOptions : depth0),"ia-aria-required":"true","ia-wizard-owner":"adults","ia-data-select-value":(depth0 != null ? depth0.adults : depth0),"class":"number-of-travellers","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightAdultsLabel : stack1),"wizard-action":"{\"rooms[0].adults\" : $value1}"},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightPlaceholderText : stack1),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.destination : depth0),"has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightDestinationLabel : stack1)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["hotel-car-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.placeholderText : stack1),"ia-data-lob":"HOTELS","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.label : stack1),"ta-key":"package_hotel_car","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}));
},"useData":true};
this["Handlebars"]["templates"]["nonstop-flight-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-nonstop",(depth0 != null ? depth0.nonStop : depth0),{"name":"input","hash":{"wizard-action":"{\"nonStop\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightNonStopLabel : stack1),"id":"advanced-flight-nonstop"},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["preferred-class-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"advanced-preferred-class","preferredClass",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.cabinClass : depth0),"wizard-action":"{\"cabinClass\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.perferredClassLabel : stack1)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-children-select-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"children","flightChildren",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.numberOfChildrenSelectOptions : depth0),"ia-aria-required":"true","ia-data-redraw":"true","ia-data-children-fieldset":"children","ia-data-wizard-owner":"children","ia-data-select-value":(depth0 != null ? depth0.children : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildrenLabel : stack1),"class":"children-select number-of-travellers","wizard-action":"{\"rooms[0].childCount\" : $value1}"},"data":data}))
    + "  \n";
},"useData":true};
this["Handlebars"]["templates"]["flights-origin-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightPlaceholderText : stack1),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":"{\"origin\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightOriginLabel : stack1),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["hotel-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestinationPlaceholderText : stack1),"ia-data-lob":"HOTELS","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestinationLabel : stack1),"ta-key":"hotel","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}));
},"useData":true};
this["Handlebars"]["templates"]["package-radio-buttons-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "\n    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","package",(depth0 != null ? depth0.isCurrentPackageType : depth0),{"name":"input","hash":{"ia-data-tracking":"packageLob","ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":"package-lob","label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":"{\"packages.flight\" : $value1, \"packages.hotel\" : $value2, \"packages.car\" : $value3, \"packages.train\" : $value4}"},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.packageData : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"useData":true};
this["Handlebars"]["templates"]["refundable-flight-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-refundable",(depth0 != null ? depth0.noPenalty : depth0),{"name":"input","hash":{"wizard-action":"{\"noPenalty\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRefundableLabel : stack1),"id":"advanced-flight"},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["sub-tabs"] = {"1":function(depth0,helpers,partials,data) {
    return "\n  "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio",(depth0 != null ? depth0.id : depth0),(depth0 != null ? depth0.selected : depth0),{"name":"input","hash":{"ia-data-tracking":(depth0 != null ? depth0.tracking : depth0),"ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":(depth0 != null ? depth0.name : depth0),"label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":(depth0 != null ? depth0.action : depth0)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.subTab : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>";
},"useData":true};
this["Handlebars"]["templates"]["cruise-dates-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "<div id=\"earliestDepartureDateParent\" data-control=\"datepicker\" class=\"col datepicker theme-standard pin-left earliest-departure-date\" data-auto-pos=\"true\" data-end-date=\"#latestDepartureDateParent\"  data-blackout-dates='"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.whitelistedDates : stack1), depth0))
    + "'>\n    <label id=\"earliestDepartureDateLabel\" class=\"datepicker-label datepicker-arrow text icon-before\" for=\"cruise-departing\">\n        <span class=\"label\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.cruiseSailDatesLabel : stack1), depth0))
    + "<span class=\"datepicker-expand-collapse visuallyhidden\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.earliestSailingDatePickerMessage : stack1), depth0))
    + "</span></span>\n        <input id=\"cruise-departing\" class=\"text datepicker-trigger-input\" type=\"text\" placeholder=\"mm/dd/yyyy\" data-wizard-action='{\"cruiseEarliestDepartureDate\" : \"$value1\"}' value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.earliestDepartureDate : stack1), depth0))
    + "\"/>\n        <span class=\"icon icon-calendar\"></span>\n    </label>\n    <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>\n<div id=\"latestDepartureDateParent\" data-control=\"datepicker\" class=\"col datepicker theme-standard pin-left latest-departure-date\" data-auto-pos=\"true\" data-start-date=\"#earliestDepartureDateParent\" data-blackout-dates='"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.whitelistedDates : stack1), depth0))
    + "'>\n    <label id=\"latestDepartureDateLabel\" class=\"datepicker-label datepicker-arrow text icon-before\" for=\"cruise-returning\">\n        <span class=\"datepicker-expand-collapse visuallyhidden\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.latestSailingDatePickerMessage : stack1), depth0))
    + "</span>\n        <input id=\"cruise-returning\" class=\"text datepicker-trigger-input\" type=\"text\" placeholder=\"mm/dd/yyyy\" data-wizard-action='{\"cruiseLatestDepartureDate\" : \"$value1\"}' value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.cruiseSailingDates : depth0)) != null ? stack1.latestDepartureDate : stack1), depth0))
    + "\">\n        <span class=\"icon icon-calendar\"></span>\n    </label>\n    <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>";
},"useData":true};
this["Handlebars"]["templates"]["cruise-month-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"departure-month",{"name":"select","hash":{"ia-name":"select","ia-data-select-value":(depth0 != null ? depth0.cruiseMonth : depth0),"label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.departureMonthLabel : stack1),"options-list":(depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0),"wizard-action":"{\"cruiseMonth\" : \"$value1\"}"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "    <label class=\"search-type select col icon icon-toggle180\" id=\"cruise-departure-month-label\">\n        <span class=\"label\">"
    + alias1(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.departureMonthLabel : stack1), depth0))
    + "</span>\n        <select id=\"cruise-departure-month\" data-wizard-action='{\"cruiseMonth\" : \"$value1\"}' class=\"\" name=\"select\" data-select-value=\""
    + alias1(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\"departure-month\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.months : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </select>\n    </label>\n";
},"4":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + alias3(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"display","hash":{},"data":data}) : helper)))
    + "\n                </option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flight-passenger"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-cars"] = {"1":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car geolocation-enabled tab-pane on\" id=\"tab-car\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car tab-pane on\" id=\"tab-car\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleCarOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRentalCars : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "        <div>Content FROM showRentalCars</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM airportRides</div>\n";
},"12":function(depth0,helpers,partials,data) {
    return " <!-- TODO: AB Test 6555 -->\n                "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"pickup-date",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-end-date":"&#35;car-dropoff-date","ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":"${carPickupDateLabel}"},"data":data}))
    + "\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "              <label class=\"text depart-return calendar icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startDateError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-date-label\">\n                <span class=\"label\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupDateLabel : stack1), depth0))
    + "</span>\n                <input type=\"text\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-date\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startDateError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" value=\""
    + alias3(((helper = (helper = helpers.startDate || (depth0 != null ? depth0.startDate : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"startDate","hash":{},"data":data}) : helper)))
    + "\" data-max-booking-length=\""
    + alias3(((helper = (helper = helpers.maxTripLength || (depth0 != null ? depth0.maxTripLength : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"maxTripLength","hash":{},"data":data}) : helper)))
    + "\" data-last-valid-date=\""
    + alias3(((helper = (helper = helpers.lastValidDate || (depth0 != null ? depth0.lastValidDate : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lastValidDate","hash":{},"data":data}) : helper)))
    + "\" data-min-booking-length=\""
    + alias3(((helper = (helper = helpers.minTripLength || (depth0 != null ? depth0.minTripLength : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"minTripLength","hash":{},"data":data}) : helper)))
    + "\" data-control=\"calendar\" data-end-date=\"&#35;car-dropoff-date\" data-wizard-action='{\"startDate\" : \"$value1\"}' aria-required='true'/>\n                <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n              </label>\n";
},"16":function(depth0,helpers,partials,data) {
    return " invalid";
},"18":function(depth0,helpers,partials,data) {
    return " class=\"error\"";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"pickup-date",{"name":"input-calendar","hash":{"ia-data-end-date":"&#35;car-dropoff-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"pickup-date-label","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupDateLabel : stack1)},"data":data}))
    + "\n";
},"22":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  	            <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.key || (depth0 != null ? depth0.key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"key","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"24":function(depth0,helpers,partials,data) {
    return "<!-- AB Test 6555 -->\n                "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"dropoff-date",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.endDate : depth0),"ia-data-start-date":"&#35;car-pickup-date","ia-aria-required":"true","has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":"${carDropoffDateLabel}"},"data":data}))
    + "\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.uitkAccessCal : depth0),{"name":"unless","hash":{},"fn":this.program(27, data, 0),"inverse":this.program(29, data, 0),"data":data})) != null ? stack1 : "")
    + "\n";
},"27":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <label class=\"text depart-return calendar icon-before col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endDateError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-date-label\">\n                  <span class=\"label\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffDateLabel : stack1), depth0))
    + "</span>\n                  <input type=\"text\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-date\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endDateError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" value=\""
    + alias3(((helper = (helper = helpers.endDate || (depth0 != null ? depth0.endDate : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"endDate","hash":{},"data":data}) : helper)))
    + "\" data-control=\"calendar\" data-start-date=\"&#35;car-pickup-date\" data-wizard-action='{\"endDate\" : \"$value1\"}' aria-required='true' aria-required='true'/>\n                  <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n                </label>\n";
},"29":function(depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"dropoff-date",{"name":"input-calendar","hash":{"ia-data-start-date":"&#35;car-pickup-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"ia-data-tid":"dropoff-date-label","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffDateLabel : stack1)},"data":data}))
    + "\n";
},"31":function(depth0,helpers,partials,data) {
    return "false";
},"33":function(depth0,helpers,partials,data) {
    return "true";
},"35":function(depth0,helpers,partials,data) {
    return "open";
},"37":function(depth0,helpers,partials,data) {
    return "viewed";
},"39":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "    <div id=\"car-options\">\n        <fieldset class=\"cols-nested from-to\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carOptions : depth0),{"name":"each","hash":{},"fn":this.program(40, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDiscountCodeFields : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <fieldset class=\"cols-nested equipment-options cf\">\n            <legend>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carSpecialEquipment : stack1), depth0))
    + "</legend>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.specialEquipmentOptions : depth0),{"name":"each","hash":{},"fn":this.program(46, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </fieldset>\n    </div>\n";
},"40":function(depth0,helpers,partials,data,blockParams,depths) {
    return "                "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depths[1],(depth0 != null ? depth0.namespace : depth0),{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['ia-data-select-value'] : depth0),"options-list":(depth0 != null ? depth0['options-list'] : depth0),"wizard_action":(depth0 != null ? depth0.wizard_action : depth0),"label-text":(depth0 != null ? depth0['label-text'] : depth0)},"data":data}))
    + "\n";
},"42":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <fieldset class=\"cols-nested origin-destination\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carDiscountCodeOptions : depth0),{"name":"each","hash":{},"fn":this.program(43, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </fieldset>\n";
},"43":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['show-car-discount-options'] : depth0),{"name":"if","hash":{},"fn":this.program(44, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"44":function(depth0,helpers,partials,data) {
    var alias1=this.lambda, alias2=this.escapeExpression;

  return "            <label class=\"text col\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "-label\">\n                <span class=\"label\">"
    + alias2(alias1((depth0 != null ? depth0['label-text'] : depth0), depth0))
    + "</span>\n                <input type=\"text\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "\" placeholder=\""
    + alias2(alias1((depth0 != null ? depth0.placeholder : depth0), depth0))
    + "\" data-wizard-action=\""
    + alias2(alias1((depth0 != null ? depth0.wizard_action : depth0), depth0))
    + "\" value=\""
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\"/>\n            </label>\n";
},"46":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "            <ul class=\"cols-nested col\" role=\"presentation\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(47, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </ul>\n";
},"47":function(depth0,helpers,partials,data,blockParams,depths) {
    return "                <li role=\"presentation\">\n                    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depths[2],"checkbox",(depth0 != null ? depth0.namespace : depth0),(depth0 != null ? depth0.isChecked : depth0),{"name":"input","hash":{"ia-data-tid":(depth0 != null ? depth0.namespace : depth0),"wizard_action":(depth0 != null ? depth0.wizard_action : depth0),"label-text":(depth0 != null ? depth0['label-text'] : depth0)},"data":data}))
    + "\n                </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda, alias5=helpers.blockHelperMissing, buffer = 
  ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXCarABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-location-hbs'],depth0,{"name":"corewizard/field-groups/cars-location-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested pickup-dropoff\">\n\n            "
    + ((stack1 = helpers['if'].call(depth0,false,{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.program(14, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time-label\" >\n  	    <span class=\"label visuallyhidden\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"startTime\" : \"$value1\"}' data-select-value=\""
    + alias3(((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"startTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(22, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias2 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  buffer += "  	    </select>\n  	</label>\n\n            "
    + ((stack1 = helpers['if'].call(depth0,false,{"name":"if","hash":{},"fn":this.program(24, data, 0, blockParams, depths),"inverse":this.program(26, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time-label\">\n  	    <span class=\"label visuallyhidden\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropOffTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"endTime\" : \"$value1\"}' data-select-value=\""
    + alias3(((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"endTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(22, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias2 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  	    </select>\n  	</label>\n  </fieldset>\n\n  <a\n    id=\"car-options-toggle\"\n    data-wizard-action='{\"showCarOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(31, data, 0, blockParams, depths),"inverse":this.program(33, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + " }'\n    class=\"link show-options toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(35, data, 0, blockParams, depths),"inverse":this.program(37, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n    href=\"#car-options\"\n    role=\"button\"\n    aria-controls=\"advanced-options-fields\"\n    aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(33, data, 0, blockParams, depths),"inverse":this.program(31, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n    aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(33, data, 0, blockParams, depths),"inverse":this.program(31, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n  >\n    "
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carShowOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n  </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(39, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</section>\n";
},"usePartial":true,"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["wizard-hbs-flights"] = {"1":function(depth0,helpers,partials,data) {
    return "soft-package-hotel";
},"3":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"hotels","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addHotelLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),"action":(depth0 != null ? depth0.addHotelAction : depth0),"lob":"hotel","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"hotel-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-hotel\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"car-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-car\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<section class=\"tab-pane on\" id=\"tab-flight\">\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-tab\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-misc"] = {"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"19":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.program(24, data, 0),"data":data})) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(13, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["wizard-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "ab6555_1";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "        <h1 class=\"col wizard-title\">"
    + ((stack1 = ((helper = (helper = helpers.wizardTitle || (depth0 != null ? depth0.wizardTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"wizardTitle","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h1>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/next-trip-hbs'],depth0,{"name":"corewizard/includes/next-trip-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <ul class=\"tabs cf col\" role=\"tablist\" data-tid=\"wizard-tablist\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.lobs : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/layouts/tab-hbs'],depth0,{"name":"corewizard/layouts/tab-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var helper;

  return "        <span class='hotel-value-prop-tablet' id='hotel-tab-value-prop'>\n            <span>"
    + this.escapeExpression(((helper = (helper = helpers.hotelTabletValueProp || (depth0 != null ? depth0.hotelTabletValueProp : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelTabletValueProp","hash":{},"data":data}) : helper)))
    + "</span>\n        </span>\n";
},"12":function(depth0,helpers,partials,data) {
    return " no-tabs";
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.packagePriceSavingsDollarValue : stack1),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/package-price-savings'],depth0,{"name":"corewizard/field-groups/package-price-savings","data":data,"indent":"                        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['handlebars/wizard/promo-message'],depth0,{"name":"handlebars/wizard/promo-message","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/bpg'],depth0,{"name":"corewizard/includes/bpg","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<div>\n    <div  class=\"cols-row search theme-inverse-pills "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab6555 : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \" id=\"wizard-theme-wrapper\" data-tid=\"region\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.wizardTitle : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.displayNextTrip : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs - pills -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showValueProp : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"col forms"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"unless","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " tabs-container\" data-tid=\"tab-container\">\n        <form autocomplete=\"off\">\n            <div data-wizard-action=\"form-wrapper\">\n            "
    + ((stack1 = (helpers['wizard-form'] || (depth0 && depth0['wizard-form']) || alias1).call(depth0,depth0,{"name":"wizard-form","hash":{},"data":data})) != null ? stack1 : "")
    + "\n            </div>\n            <fieldset class=\"cols submit-and-mixin-fieldset\">\n                <label class=\"col search-btn-col\">\n                    <button type=\"submit\" data-wizard-action=\"{submit:true}\" class=\"btn-action btn-primary\" id=\"search-button\" data-tid=\"search-button\">\n                        <span class=\"btn-label\">"
    + this.escapeExpression(((helper = (helper = helpers.searchText || (depth0 != null ? depth0.searchText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"searchText","hash":{},"data":data}) : helper)))
    + "</span>\n                    </button>\n                </label>\n\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePackageValuePropMessage : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePromoMessage : stack1),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n        </form>\n    </div><!-- .tab-content -->\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.useBestPriceGuaranteeLogo : stack1),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div><!-- .search -->\n</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["tab-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "            data-wizard-action='{\"tab\" : \""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\", \"packages.flight\" : "
    + alias3(((helper = (helper = helpers.flightsPackage || (depth0 != null ? depth0.flightsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"flightsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.hotel\" : "
    + alias3(((helper = (helper = helpers.hotelsPackage || (depth0 != null ? depth0.hotelsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"hotelsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.car\" : "
    + alias3(((helper = (helper = helpers.carsPackage || (depth0 != null ? depth0.carsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.train\" : "
    + alias3(((helper = (helper = helpers.trainsPackage || (depth0 != null ? depth0.trainsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"trainsPackage","hash":{},"data":data}) : helper)))
    + " }'\n";
},"3":function(depth0,helpers,partials,data) {
    return "            data-wizard-action='{}'\n";
},"5":function(depth0,helpers,partials,data) {
    return "            class=\"on\" aria-selected=\"true\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "            class=\"\" aria-selected=\"false\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<li  class=\"tab\" role=\"presentation\" data-lobtab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\">\n    <a role=\"tab\" href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\"\n        data-tab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isPackageTab : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            id=\"tab-"
    + alias3(((helper = (helper = helpers['tab-id'] || (depth0 != null ? depth0['tab-id'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab-id","hash":{},"data":data}) : helper)))
    + "-tab\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCurrentTab : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "        data-tracking=\"tab\"\n    >\n        "
    + ((stack1 = (helpers['uitk-lobIcon'] || (depth0 && depth0['uitk-lobIcon']) || alias1).call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"uitk-lobIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n        <span class=\"visuallyhidden\">Search for </span><span class=\"tab-label\">"
    + ((stack1 = ((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </a>\n</li>\n";
},"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-hotels"] = {"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on geolocation-enabled\" id=\"tab-hotel\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-hotel\">\n";
},"5":function(depth0,helpers,partials,data) {
    return "soft-package-flight";
},"7":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(25, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useHotelGroupBookingLink : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"flights","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),"action":(depth0 != null ? depth0.addFlightAction : depth0),"lob":"flight","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"15":function(depth0,helpers,partials,data) {
    return "        <@ui.dctkExperimentAware testIds=\"7385\" />\n        <label class=\"col link\">\n        <span class=\"inline-label\">\n            <a href=\"http://groups.expedia.com/GroupForm.cfm\" target=\"_blank\">\n                Booking a group?<@uitk.icon name=\"popup\" content=\" Booking a group?\" />\n            </a>\n        </span>\n        </label>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"flight-package-wrapper\" tabindex=\"-1\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    return " visuallyhidden";
},"21":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#flight-package-wrapper\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-flights\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\"  class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightHotelMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-flight\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"25":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"car-package-wrapper\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasCar : depth0),{"name":"if","hash":{},"fn":this.program(30, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"28":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#add-car\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-cars\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCarMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"30":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "      <div class=\"package-container cf\" id=\"hotel-added-car\" data-wizard-owner=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationNotCuba : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-packages"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " geolocation-enabled\" id=\"tab-package\">\n";
},"2":function(depth0,helpers,partials,data) {
    return " car-message car";
},"4":function(depth0,helpers,partials,data) {
    return " hotel";
},"6":function(depth0,helpers,partials,data) {
    return " flight";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"tab-package\">\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-origin-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"destination-only"},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-car-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-car-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    var helper;

  return "                  <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n                    "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n                  </div>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"partial-stay"},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(30, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(33, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      ";
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotels-rooms-count-hbs'],depth0,{"name":"corewizard/fields/hotels-rooms-count-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/hotels-rooms-count-hbs'],depth0,{"name":"corewizard/fields/hotels-rooms-count-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"28":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/direct-flight-hbs'],depth0,{"name":"corewizard/field-groups/direct-flight-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/partial-stay-hbs'],depth0,{"name":"corewizard/field-groups/partial-stay-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"30":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.row || (depth0 && depth0.row) || helpers.helperMissing).call(depth0,{"name":"row","hash":{"class":"is-partial-stay"},"fn":this.program(31, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"31":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"33":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"35":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['default/templates/advanced-options-package-hbs'],depth0,{"name":"default/templates/advanced-options-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"37":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"package-rooms-travellers-container\">\n          <fieldset class=\"cols-nested flights-passengers cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n      ";
},"39":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(40, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"40":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"42":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <div class=\"package-car-message label\" id=\"package-car\">\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carWillBeAddedLabel : stack1), depth0))
    + "\n      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "\n  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiplePackageOrder : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRooms : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.enableAdvancedOptions : depth0),{"name":"if","hash":{},"fn":this.program(35, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.noRooms : depth0),{"name":"if","hash":{},"fn":this.program(37, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideChildrenFlightFields : depth0),{"name":"unless","hash":{},"fn":this.program(39, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </fieldset>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarMessage : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["category"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true};
this["Handlebars"]["templates"]["open-search-ta"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "               <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true};
this["Handlebars"]["templates"]["default"] = {"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["advanced-options-package-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "false";
},"3":function(depth0,helpers,partials,data) {
    return "true";
},"5":function(depth0,helpers,partials,data) {
    return "viewed";
},"7":function(depth0,helpers,partials,data) {
    return "open";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = 
  "        <div id=\"advanced-options-fields\">\n";
  stack1 = ((helper = (helper = helpers.row || (depth0 != null ? depth0.row : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"row","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.row) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "        </div>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['default/templates/preferred-class-package-hbs'],depth0,{"name":"default/templates/preferred-class-package-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"advanced-options col\">\n    <a\n            href=\"#advanced-options-fields\"\n            role=\"button\"\n            id=\"advanced-options\"\n            aria-controls=\"advanced-options-fields\"\n            aria-expanded=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            aria-pressed=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"toggle-trigger "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'\n            >\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["preferred-class-package-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"advanced-preferred-class","preferredClass",{"name":"select","hash":{"options-list":(depth0 != null ? depth0.preferredClass : depth0),"ia-data-select-value":(depth0 != null ? depth0.cabinClass : depth0),"wizard-action":"{\"cabinClass\" : \"$value1\"}","label-text":""},"data":data}));
},"useData":true};
//https://gist.github.com/dhm116/1790197

if (!('forEach' in Array.prototype)) {
  Array.prototype.forEach= function(action, that /*opt*/) {
    for (var i= 0, n= this.length; i<n; i++)
      if (i in this)
        action.call(that, this[i], i, this);
  };
}

if (!('bind' in Function.prototype)) {
  Function.prototype.bind= function(owner) {
    var that= this;
    if (arguments.length<=1) {
      return function() {
        return that.apply(owner, arguments);
      };
    } else {
      var args= Array.prototype.slice.call(arguments, 1);
      return function() {
        return that.apply(owner, arguments.length===0? args : args.concat(Array.prototype.slice.call(arguments)));
      };
    }
  };
}
/*!

 handlebars v3.0.3

Copyright (C) 2011-2014 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
define("handlebars/utils", ["exports"], function(a) {
  modulizr.amd.handlebarsv3 = true;

  function b(a) {
    return i[a]
  }

  function c(a) {
    for (var b = 1; b < arguments.length; b++)
      for (var c in arguments[b]) Object.prototype.hasOwnProperty.call(arguments[b], c) && (a[c] = arguments[b][c]);
    return a
  }

  function d(a, b) {
    for (var c = 0, d = a.length; d > c; c++)
      if (a[c] === b) return c;
    return -1
  }

  function e(a) {
    if ("string" != typeof a) {
      if (a && a.toHTML) return a.toHTML();
      if (null == a) return "";
      if (!a) return a + "";
      a = "" + a
    }
    return k.test(a) ? a.replace(j, b) : a
  }

  function f(a) {
    return a || 0 === a ? n(a) && 0 === a.length ? !0 : !1 : !0
  }

  function g(a, b) {
    return a.path = b, a
  }

  function h(a, b) {
    return (a ? a + "." : "") + b
  }
  a.__esModule = !0, a.extend = c, a.indexOf = d, a.escapeExpression = e, a.isEmpty = f, a.blockParams = g, a.appendContextPath = h;
  var i = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "`": "&#x60;"
    },
    j = /[&<>"'`]/g,
    k = /[&<>"'`]/,
    l = Object.prototype.toString;
  a.toString = l;
  var m = function(a) {
    return "function" == typeof a
  };
  m(/x/) && (a.isFunction = m = function(a) {
    return "function" == typeof a && "[object Function]" === l.call(a)
  });
  var m;
  a.isFunction = m;
  var n = Array.isArray || function(a) {
    return a && "object" == typeof a ? "[object Array]" === l.call(a) : !1
  };
  a.isArray = n;
  return a;
}), define("handlebars/exception", ["exports", "module"], function(a, b) {
  function c(a, b) {
    var e = b && b.loc,
      f = void 0,
      g = void 0;
    e && (f = e.start.line, g = e.start.column, a += " - " + f + ":" + g);
    for (var h = Error.prototype.constructor.call(this, a), i = 0; i < d.length; i++) this[d[i]] = h[d[i]];
    Error.captureStackTrace && Error.captureStackTrace(this, c), e && (this.lineNumber = f, this.column = g)
  }
  var d = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
  c.prototype = new Error, b.exports = c;
  return b.exports;
}), define("handlebars/base", ["exports", "./utils", "./exception"], function(a, b, c) {
  function d(a, b) {
    this.helpers = a || {}, this.partials = b || {}, e(this)
  }

  function e(a) {
    a.registerHelper("helperMissing", function() {
      if (1 === arguments.length) return void 0;
      throw new h('Missing helper: "' + arguments[arguments.length - 1].name + '"')
    }), a.registerHelper("blockHelperMissing", function(c, d) {
      var e = d.inverse,
        g = d.fn;
      if (c === !0) return g(this);
      if (c === !1 || null == c) return e(this);
      if (l(c)) return c.length > 0 ? (d.ids && (d.ids = [d.name]), a.helpers.each(c, d)) : e(this);
      if (d.data && d.ids) {
        var h = f(d.data);
        h.contextPath = b.appendContextPath(d.data.contextPath, d.name), d = {
          data: h
        }
      }
      return g(c, d)
    }), a.registerHelper("each", function(a, c) {
      function d(c, d, f) {
        k && (k.key = c, k.index = d, k.first = 0 === d, k.last = !!f, n && (k.contextPath = n + c)), j += e(a[c], {
          data: k,
          blockParams: b.blockParams([a[c], c], [n + c, null])
        })
      }
      if (!c) throw new h("Must pass iterator to #each");
      var e = c.fn,
        g = c.inverse,
        i = 0,
        j = "",
        k = void 0,
        n = void 0;
      if (c.data && c.ids && (n = b.appendContextPath(c.data.contextPath, c.ids[0]) + "."), m(a) && (a = a.call(this)), c.data && (k = f(c.data)), a && "object" == typeof a)
        if (l(a))
          for (var o = a.length; o > i; i++) d(i, i, i === a.length - 1);
        else {
          var p = void 0;
          for (var q in a) a.hasOwnProperty(q) && (p && d(p, i - 1), p = q, i++);
          p && d(p, i - 1, !0)
        }
      return 0 === i && (j = g(this)), j
    }), a.registerHelper("if", function(a, c) {
      return m(a) && (a = a.call(this)), !c.hash.includeZero && !a || b.isEmpty(a) ? c.inverse(this) : c.fn(this)
    }), a.registerHelper("unless", function(b, c) {
      return a.helpers["if"].call(this, b, {
        fn: c.inverse,
        inverse: c.fn,
        hash: c.hash
      })
    }), a.registerHelper("with", function(a, c) {
      m(a) && (a = a.call(this));
      var d = c.fn;
      if (b.isEmpty(a)) return c.inverse(this);
      if (c.data && c.ids) {
        var e = f(c.data);
        e.contextPath = b.appendContextPath(c.data.contextPath, c.ids[0]), c = {
          data: e
        }
      }
      return d(a, c)
    }), a.registerHelper("log", function(b, c) {
      var d = c.data && null != c.data.level ? parseInt(c.data.level, 10) : 1;
      a.log(d, b)
    }), a.registerHelper("lookup", function(a, b) {
      return a && a[b]
    })
  }

  function f(a) {
    var c = b.extend({}, a);
    return c._parent = a, c
  }
  var g = function(a) {
    return a && a.__esModule ? a["default"] : a
  };
  a.__esModule = !0, a.HandlebarsEnvironment = d, a.createFrame = f;
  var h = g(c),
    i = "3.0.1";
  a.VERSION = i;
  var j = 6;
  a.COMPILER_REVISION = j;
  var k = {
    1: "<= 1.0.rc.2",
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1"
  };
  a.REVISION_CHANGES = k;
  var l = b.isArray,
    m = b.isFunction,
    n = b.toString,
    o = "[object Object]";
  d.prototype = {
    constructor: d,
    logger: p,
    log: q,
    registerHelper: function(a, c) {
      if (n.call(a) === o) {
        if (c) throw new h("Arg not supported with multiple helpers");
        b.extend(this.helpers, a)
      } else this.helpers[a] = c
    },
    unregisterHelper: function(a) {
      delete this.helpers[a]
    },
    registerPartial: function(a, c) {
      if (n.call(a) === o) b.extend(this.partials, a);
      else {
        if ("undefined" == typeof c) throw new h("Attempting to register a partial as undefined");
        this.partials[a] = c
      }
    },
    unregisterPartial: function(a) {
      delete this.partials[a]
    }
  };
  var p = {
    methodMap: {
      0: "debug",
      1: "info",
      2: "warn",
      3: "error"
    },
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    level: 1,
    log: function(a, b) {
      if ("undefined" != typeof console && p.level <= a) {
        var c = p.methodMap[a];
        (console[c] || console.log).call(console, b)
      }
    }
  };
  a.logger = p;
  var q = p.log;
  a.log = q;
  return a;
}), define("handlebars/safe-string", ["exports", "module"], function(a, b) {
  function c(a) {
    this.string = a
  }
  c.prototype.toString = c.prototype.toHTML = function() {
    return "" + this.string
  }, b.exports = c;
  return b.exports;
}), define("handlebars/runtime", ["exports", "./utils", "./exception", "./base"], function(a, b, c, d) {
  function e(a) {
    var b = a && a[0] || 1,
      c = d.COMPILER_REVISION;
    if (b !== c) {
      if (c > b) {
        var e = d.REVISION_CHANGES[c],
          f = d.REVISION_CHANGES[b];
        throw new m("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + e + ") or downgrade your runtime to an older version (" + f + ").")
      }
      throw new m("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + a[1] + ").")
    }
  }

  function f(a, c) {
    function d(d, e, f) {
      f.hash && (e = b.extend({}, e, f.hash)), d = c.VM.resolvePartial.call(this, d, e, f);
      var g = c.VM.invokePartial.call(this, d, e, f);
      if (null == g && c.compile && (f.partials[f.name] = c.compile(d, a.compilerOptions, c), g = f.partials[f.name](e, f)), null != g) {
        if (f.indent) {
          for (var h = g.split("\n"), i = 0, j = h.length; j > i && (h[i] || i + 1 !== j); i++) h[i] = f.indent + h[i];
          g = h.join("\n")
        }
        return g
      }
      throw new m("The partial " + f.name + " could not be compiled when running in runtime-only mode")
    }

    function e(b) {
      var c = void 0 === arguments[1] ? {} : arguments[1],
        d = c.data;
      e._setup(c), !c.partial && a.useData && (d = k(b, d));
      var g = void 0,
        h = a.useBlockParams ? [] : void 0;
      return a.useDepths && (g = c.depths ? [b].concat(c.depths) : [b]), a.main.call(f, b, f.helpers, f.partials, d, h, g)
    }
    if (!c) throw new m("No environment passed to template");
    if (!a || !a.main) throw new m("Unknown template object: " + typeof a);
    c.VM.checkRevision(a.compiler);
    var f = {
      strict: function(a, b) {
        if (!(b in a)) throw new m('"' + b + '" not defined in ' + a);
        return a[b]
      },
      lookup: function(a, b) {
        for (var c = a.length, d = 0; c > d; d++)
          if (a[d] && null != a[d][b]) return a[d][b]
      },
      lambda: function(a, b) {
        return "function" == typeof a ? a.call(b) : a
      },
      escapeExpression: b.escapeExpression,
      invokePartial: d,
      fn: function(b) {
        return a[b]
      },
      programs: [],
      program: function(a, b, c, d, e) {
        var f = this.programs[a],
          h = this.fn(a);
        return b || e || d || c ? f = g(this, a, h, b, c, d, e) : f || (f = this.programs[a] = g(this, a, h)), f
      },
      data: function(a, b) {
        for (; a && b--;) a = a._parent;
        return a
      },
      merge: function(a, c) {
        var d = a || c;
        return a && c && a !== c && (d = b.extend({}, c, a)), d
      },
      noop: c.VM.noop,
      compilerInfo: a.compiler
    };
    return e.isTop = !0, e._setup = function(b) {
      b.partial ? (f.helpers = b.helpers, f.partials = b.partials) : (f.helpers = f.merge(b.helpers, c.helpers), a.usePartial && (f.partials = f.merge(b.partials, c.partials)))
    }, e._child = function(b, c, d, e) {
      if (a.useBlockParams && !d) throw new m("must pass block params");
      if (a.useDepths && !e) throw new m("must pass parent depths");
      return g(f, b, a[b], c, 0, d, e)
    }, e
  }

  function g(a, b, c, d, e, f, g) {
    function h(b) {
      var e = void 0 === arguments[1] ? {} : arguments[1];
      return c.call(a, b, a.helpers, a.partials, e.data || d, f && [e.blockParams].concat(f), g && [b].concat(g))
    }
    return h.program = b, h.depth = g ? g.length : 0, h.blockParams = e || 0, h
  }

  function h(a, b, c) {
    return a ? a.call || c.name || (c.name = a, a = c.partials[a]) : a = c.partials[c.name], a
  }

  function i(a, b, c) {
    if (c.partial = !0, void 0 === a) throw new m("The partial " + c.name + " could not be found");
    return a instanceof Function ? a(b, c) : void 0
  }

  function j() {
    return ""
  }

  function k(a, b) {
    return b && "root" in b || (b = b ? d.createFrame(b) : {}, b.root = a), b
  }
  var l = function(a) {
    return a && a.__esModule ? a["default"] : a
  };
  a.__esModule = !0, a.checkRevision = e, a.template = f, a.wrapProgram = g, a.resolvePartial = h, a.invokePartial = i, a.noop = j;
  var m = l(c);
  return a;
}), define("handlebars/no-conflict", ["exports", "module"], function(a, b) {
  b.exports = function(a) {
    var b = "undefined" != typeof global ? global : window,
      c = b.Handlebars;
    a.noConflict = function() {
      b.Handlebars === a && (b.Handlebars = c)
    }
  };
  return b.exports;
}), define("handlebars.runtime", ["exports", "module", "./handlebars/base", "./handlebars/safe-string", "./handlebars/exception", "./handlebars/utils", "./handlebars/runtime", "./handlebars/no-conflict"], function(a, b, c, d, e, f, g, h) {
  function i() {
    var a = new c.HandlebarsEnvironment;
    return f.extend(a, c), a.SafeString = k, a.Exception = l, a.Utils = f, a.escapeExpression = f.escapeExpression, a.VM = g, a.template = function(b) {
      return g.template(b, a)
    }, a
  }
  var j = function(a) {
      return a && a.__esModule ? a["default"] : a
    },
    k = j(d),
    l = j(e),
    m = j(h),
    n = i();
  n.create = i, m(n), n["default"] = n, b.exports = n;
  return b.exports;
});
// Handlebars AMD is dependant on some features built into requirejs
// that aren't in modulizr. This file adds those features.

// module is not defined in modulizr, it is safe to just
// return a generic object
// define('jquery', function() { return $});
try {

define('module', function() {return {}});
define('exports', function() {return {}});
site_id = 1;

// requirejs handles paths to files while modulizr does not
// we point the paths handlebars expects at the objects
define('./utils', ['handlebars/utils'], function(utils) { return utils});
define('./handlebars/utils', ['handlebars/utils'], function(utils) { return utils});
define('./exception', ['handlebars/exception'], function(exception) { return exception});
define('./handlebars/exception', ['handlebars/exception'], function(exception) { return exception});
define('./safe-string', ['handlebars/safe-string'], function(safeString) { return safeString});
define('./handlebars/safe-string', ['handlebars/safe-string'], function(safeString) { return safeString});
define('./base', ['handlebars/base'], function(base) { return base});
define('./handlebars/base', ['handlebars/base'], function(base) { return base});
define('./no-conflict', ['handlebars/no-conflict'], function(noConflict) { return noConflict});
define('./handlebars/no-conflict', ['handlebars/no-conflict'], function(noConflict) { return noConflict});
define('./runtime', ['handlebars/runtime'], function(runtime) { return runtime});
define('./handlebars/runtime', ['handlebars/runtime'], function(runtime) { return runtime});

} catch (e) { }
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
    typeof global == 'object' && global.global === global && global ||
    this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  if (typeof exports != 'undefined') {
    if (typeof module != 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-parameter case has been omitted only because no current consumers
      // made use of it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // `identity`, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };

  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Similar to ES6's rest param (http://ariya.ofilabs.com/2013/03/es6-and-rest-parameter.html)
  // This accumulates the arguments passed into an array, after a given index.
  var restArgs = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0);
      var rest = Array(length);
      for (var index = 0; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
      length = (keys || obj).length,
      results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
      length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
      length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArgs(function(obj, method, args) {
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
      value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object') && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
      value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object') && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj ? obj.match(reStrSymbol) : [];
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArgs(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArgs(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArgs(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArgs(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Split an **array** into several arrays containing **count** or less elements
  // of initial array
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];

    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArgs(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArgs(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArgs(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArgs(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArgs(function(func, wait, args) {
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArgs = restArgs;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
      length = keys.length,
      results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArgs(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArgs(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
        _.isFunction(bCtor) && bCtor instanceof bCtor)
        && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
      return toString.call(obj) === '[object Array]';
    };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
      return new Date().getTime();
    };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, prop, fallback) {
    var value = object == null ? void 0 : object[prop];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || noMatch).source,
        (settings.interpolate || noMatch).source,
        (settings.evaluate || noMatch).source
      ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define == 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}());
//     Backbone.js 1.1.2

//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(root, factory) {
  // Set up Backbone appropriately for the environment. Start with AMD.
  //if (typeof define === 'function' && define.amd) {
  //  define('backbone', ['underscore', 'jquery', 'exports'], function(_, $, exports) {
  //    // Export global even in AMD case in case this script is loaded with
  //    // others that may still expect a global Backbone.
  //    root.Backbone = factory(root, exports, _, $);
  //  });
  //
  //// Next for Node.js or CommonJS. jQuery may not be needed as a module.
  //} else if (typeof exports !== 'undefined') {
  //  var _ = require('underscore');
  //  factory(root, exports, _);
  //
  //// Finally, as a browser global.
  //} else {
  root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  //}
}(this, function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.1.2';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = function(){};
  require(['jquery'], function($) {
    Backbone.$ = $;
  });

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = void 0;
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = models[i] = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model, options);
      }
      return singular ? models[0] : models;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : _.clone(models);
      var i, l, id, model, attrs, existing, sort;
      var at = options.at;
      var targetModel = this.model;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        attrs = models[i] || {};
        if (attrs instanceof Model) {
          id = model = attrs;
        } else {
          id = attrs[targetModel.prototype.idAttribute || 'id'];
        }

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(id)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge) {
            attrs = attrs === model ? model.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
        modelMap[model.id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || (order && order.length)) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (i = 0, l = toAdd.length; i < l; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (i = 0, l = orderedModels.length; i < l; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0, l = toAdd.length; i < l; i++) {
          (model = toAdd[i]).trigger('add', model, this, options);
        }
        if (sort || (order && order.length)) this.trigger('sort', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) return attrs;
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      if (model.id != null) this._byId[model.id] = model;
      if (!model.collection) model.collection = this;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
    'lastIndexOf', 'isEmpty', 'chain', 'sample'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    options || (options = {});
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && noXhrPatch) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  var noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        router.execute(callback, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = decodeURI(this.location.pathname + this.location.search);
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          this.fragment = this.getFragment(null, true);
          this.location.replace(this.root + '#' + this.fragment);
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot() && loc.hash) {
          this.fragment = this.getHash().replace(routeStripper, '');
          this.history.replaceState({}, document.title, this.root + this.fragment);
        }

      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      var url = this.root + (fragment = this.getFragment(fragment || ''));

      // Strip the hash for matching.
      fragment = fragment.replace(pathStripper, '');

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // Don't include a trailing slash on the root.
      if (fragment === '' && url !== '/') url = url.slice(0, -1);

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

(function(globalNames) {// Create a range object for efficently rendering strings to elements.
var range;

function toElement(str) {
    if (!range) {
        range = document.createRange();
        range.selectNode(document.body);
    }

    var fragment;
    if (range.createContextualFragment) {
        fragment = range.createContextualFragment(str);
    } else {
        fragment = document.createElement('body');
        fragment.innerHTML = str;
    }
    return fragment.childNodes[0];
}

var specialElHandlers = {
    /**
     * Needed for IE. Apparently IE doesn't think
     * that "selected" is an attribute when reading
     * over the attributes using selectEl.attributes
     */
    OPTION: function(fromEl, toEl) {
        if ((fromEl.selected = toEl.selected)) {
            fromEl.setAttribute('selected', '');
        } else {
            fromEl.removeAttribute('selected', '');
        }
    },
    /**
     * The "value" attribute is special for the <input> element
     * since it sets the initial value. Changing the "value"
     * attribute without changing the "value" property will have
     * no effect since it is only used to the set the initial value.
     * Similar for the "checked" attribute.
     */
    INPUT: function(fromEl, toEl) {
        fromEl.checked = toEl.checked;
        fromEl.value = toEl.value;

        if (!toEl.hasAttribute('checked')) {
            fromEl.removeAttribute('checked');
        }

        if (!toEl.hasAttribute('value')) {
            fromEl.removeAttribute('value');
        }
    }
};

function noop() {}

/**
 * Loop over all of the attributes on the target node and make sure the
 * original DOM node has the same attributes. If an attribute
 * found on the original node is not on the new node then remove it from
 * the original node
 * @param  {HTMLElement} fromNode
 * @param  {HTMLElement} toNode
 */
function morphAttrs(fromNode, toNode) {
    var attrs = toNode.attributes;
    var i;
    var attr;
    var attrName;
    var attrValue;
    var foundAttrs = {};

    for (i=attrs.length-1; i>=0; i--) {
        attr = attrs[i];
        if (attr.specified !== false) {
            attrName = attr.name;
            attrValue = attr.value;
            foundAttrs[attrName] = true;

            if (fromNode.getAttribute(attrName) !== attrValue) {
                fromNode.setAttribute(attrName, attrValue);
            }
        }
    }

    // Delete any extra attributes found on the original DOM element that weren't
    // found on the target element.
    attrs = fromNode.attributes;

    for (i=attrs.length-1; i>=0; i--) {
        attr = attrs[i];
        if (attr.specified !== false) {
            attrName = attr.name;
            if (!foundAttrs.hasOwnProperty(attrName)) {
                fromNode.removeAttribute(attrName);
            }
        }
    }
}

/**
 * Copies the children of one DOM element to another DOM element
 */
function moveChildren(from, to) {
    var curChild = from.firstChild;
    while(curChild) {
        var nextChild = curChild.nextSibling;
        to.appendChild(curChild);
        curChild = nextChild;
    }
    return to;
}

function morphdom(fromNode, toNode, options) {
    if (!options) {
        options = {};
    }

    if (typeof toNode === 'string') {
        toNode = toElement(toNode);
    }

    var savedEls = {}; // Used to save off DOM elements with IDs
    var unmatchedEls = {};
    var onNodeDiscarded = options.onNodeDiscarded || noop;
    var onBeforeMorphEl = options.onBeforeMorphEl || noop;
    var onBeforeMorphElChildren = options.onBeforeMorphElChildren || noop;
    var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;

    function removeNodeHelper(node, nestedInSavedEl) {
        var id = node.id;
        // If the node has an ID then save it off since we will want
        // to reuse it in case the target DOM tree has a DOM element
        // with the same ID
        if (id) {
            savedEls[id] = node;
        } else if (!nestedInSavedEl) {
            // If we are not nested in a saved element then we know that this node has been
            // completely discarded and will not exist in the final DOM.
            onNodeDiscarded(node);
        }

        if (node.nodeType === 1) {
            var curChild = node.firstChild;
            while(curChild) {
                removeNodeHelper(curChild, nestedInSavedEl || id);
                curChild = curChild.nextSibling;
            }
        }
    }

    function walkDiscardedChildNodes(node) {
        if (node.nodeType === 1) {
            var curChild = node.firstChild;
            while(curChild) {


                if (!curChild.id) {
                    // We only want to handle nodes that don't have an ID to avoid double
                    // walking the same saved element.

                    onNodeDiscarded(curChild);

                    // Walk recursively
                    walkDiscardedChildNodes(curChild);
                }

                curChild = curChild.nextSibling;
            }
        }
    }

    function removeNode(node, parentNode, alreadyVisited) {
        if (onBeforeNodeDiscarded(node) === false) {
            return;
        }

        parentNode.removeChild(node);
        if (alreadyVisited) {
            if (!node.id) {
                onNodeDiscarded(node);
                walkDiscardedChildNodes(node);
            }
        } else {
            removeNodeHelper(node);
        }
    }

    function morphEl(fromNode, toNode, alreadyVisited) {
        if (toNode.id) {
            // If an element with an ID is being morphed then it is will be in the final
            // DOM so clear it out of the saved elements collection
            delete savedEls[toNode.id];
        }

        if (onBeforeMorphEl(fromNode, toNode) === false) {
            return;
        }

        morphAttrs(fromNode, toNode);

        if (onBeforeMorphElChildren(fromNode, toNode) === false) {
            return;
        }

        var curToNodeChild = toNode.firstChild;
        var curFromNodeChild = fromNode.firstChild;
        var curToNodeId;

        var fromNextSibling;
        var toNextSibling;
        var savedEl;
        var unmatchedEl;

        outer: while(curToNodeChild) {
            toNextSibling = curToNodeChild.nextSibling;
            curToNodeId = curToNodeChild.id;

            while(curFromNodeChild) {
                var curFromNodeId = curFromNodeChild.id;
                fromNextSibling = curFromNodeChild.nextSibling;

                if (!alreadyVisited) {
                    if (curFromNodeId && (unmatchedEl = unmatchedEls[curFromNodeId])) {
                        unmatchedEl.parentNode.replaceChild(curFromNodeChild, unmatchedEl);
                        morphEl(curFromNodeChild, unmatchedEl, alreadyVisited);
                        curFromNodeChild = fromNextSibling;
                        continue;
                    }
                }

                var curFromNodeType = curFromNodeChild.nodeType;

                if (curFromNodeType === curToNodeChild.nodeType) {
                    var isCompatible = false;

                    if (curFromNodeType === 1) { // Both nodes being compared are Element nodes
                        if (curFromNodeChild.tagName === curToNodeChild.tagName) {
                            // We have compatible DOM elements
                            if (curFromNodeId || curToNodeId) {
                                // If either DOM element has an ID then we handle
                                // those differently since we want to match up
                                // by ID
                                if (curToNodeId === curFromNodeId) {
                                    isCompatible = true;
                                }
                            } else {
                                isCompatible = true;
                            }
                        }

                        if (isCompatible) {
                            // We found compatible DOM elements so transform the current "from" node
                            // to match the current target DOM node.
                            morphEl(curFromNodeChild, curToNodeChild, alreadyVisited);
                        }
                    } else if (curFromNodeType === 3) { // Both nodes being compared are Text nodes
                        isCompatible = true;
                        // Simply update nodeValue on the original node to change the text value
                        curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
                    }

                    if (isCompatible) {
                        curToNodeChild = toNextSibling;
                        curFromNodeChild = fromNextSibling;
                        continue outer;
                    }
                }

                // No compatible match so remove the old node from the DOM and continue trying
                // to find a match in the original DOM
                removeNode(curFromNodeChild, fromNode, alreadyVisited);
                curFromNodeChild = fromNextSibling;
            }

            if (curToNodeId) {
                if ((savedEl = savedEls[curToNodeId])) {
                    morphEl(savedEl, curToNodeChild, true);
                    curToNodeChild = savedEl; // We want to append the saved element instead
                } else {
                    // The current DOM element in the target tree has an ID
                    // but we did not find a match in any of the corresponding
                    // siblings. We just put the target element in the old DOM tree
                    // but if we later find an element in the old DOM tree that has
                    // a matching ID then we will replace the target element
                    // with the corresponding old element and morph the old element
                    unmatchedEls[curToNodeId] = curToNodeChild;
                }
            }

            // If we got this far then we did not find a candidate match for our "to node"
            // and we exhausted all of the children "from" nodes. Therefore, we will just
            // append the current "to node" to the end
            fromNode.appendChild(curToNodeChild);

            curToNodeChild = toNextSibling;
            curFromNodeChild = fromNextSibling;
        }

        // We have processed all of the "to nodes". If curFromNodeChild is non-null then
        // we still have some from nodes left over that need to be removed
        while(curFromNodeChild) {
            fromNextSibling = curFromNodeChild.nextSibling;
            removeNode(curFromNodeChild, fromNode, alreadyVisited);
            curFromNodeChild = fromNextSibling;
        }

        var specialElHandler = specialElHandlers[fromNode.tagName];
        if (specialElHandler) {
            specialElHandler(fromNode, toNode);
        }
    }

    var morphedNode = fromNode;
    var morphedNodeType = morphedNode.nodeType;
    var toNodeType = toNode.nodeType;

    // Handle the case where we are given two DOM nodes that are not
    // compatible (e.g. <div> --> <span> or <div> --> TEXT)
    if (morphedNodeType === 1) {
        if (toNodeType === 1) {
            if (morphedNode.tagName !== toNode.tagName) {
                onNodeDiscarded(fromNode);
                morphedNode = moveChildren(morphedNode, document.createElement(toNode.tagName));
            }
        } else {
            // Going from an element node to a text node
            return toNode;
        }
    } else if (morphedNodeType === 3) { // Text node
        if (toNodeType === 3) {
            morphedNode.nodeValue = toNode.nodeValue;
            return morphedNode;
        } else {
            onNodeDiscarded(fromNode);
            // Text node to something else
            return toNode;
        }
    }

    morphEl(morphedNode, toNode, false);

    // Fire the "onNodeDiscarded" event for any saved elements
    // that never found a new home in the morphed DOM
    for (var savedElId in savedEls) {
        if (savedEls.hasOwnProperty(savedElId)) {
            var savedEl = savedEls[savedElId];
            onNodeDiscarded(savedEl);
            walkDiscardedChildNodes(savedEl);
        }
    }

    if (morphedNode !== fromNode && fromNode.parentNode) {
        // If we had to swap out the from node with a new node because the old
        // node was not compatible with the target node then we need to
        // replace the old DOM node in the original DOM tree. This is only
        // possible if the original DOM node was part of a DOM tree which
        // we know is the case if it has a parent node.
        fromNode.parentNode.replaceChild(morphedNode, fromNode);
    }

    return morphedNode;
}

globalNames.morphdom = morphdom;
}(this));

define('gc/getLob', function() {
  return function(tab, pkg) {
    var lob = "";
    pkg = normalizeBooleans(pkg);
    if (tab == "flight" || ((tab == "package" || tab == "hotel") && (pkg.flight))) {
      lob = "flight";
    }
    if (pkg.train) {
      lob = "train";
    }
    if (tab == "hotel" || ((tab == "package" || tab == "flight") && (pkg.hotel))) {
      lob += (lob.length) ? "Hotel" : "hotel";
    }
    if (tab == "car" || ((tab == "package" || tab == "hotel" || tab == "flight") && (pkg.car))) {
      lob += (lob.length) ? "Car" : "car";
    }
    else if (tab == "overseaHotel") {
      lob = (pkg.flight) ? 'flightHotel' : 'overseaHotel';
    }
    return (lob.length) ? lob : tab;
  }//getLob

  function normalizeBooleans(array) {
    _.each(array, function(value, key) {
      if (value === 'false') array[key] = false;
      if (value === 'true') array[key] = true;
    });
    return array;
  }
});

define('gc/perfLogging', [], function() {
  var isLoggingEnabled = function() {
    if (window.dctk && dctk.enabled) {
      return (dctk.logging && dctk.logging.logTrxEvent)
    } else {
      return false;
    }
  }
  return {
    "responseToPaint" : function(t) {
      var now = Date.now();
      var fromResponseStart = (now - window.performance.timing.responseStart);
      if (isLoggingEnabled()) {
        dctk.logging.logTrxEvent("GC.Wizard.Perf", ['clEventName01=ResponseStartToPaint', 'clEventTime01='+fromResponseStart, 'clEventName02=RequestStartToPaint', 'clEventTime02='+Math.round(t)]);
      } else {
        // Allow for AMD compliant deferred loading.
        // This may hang on this requirement forever if dctk client logging is never loaded on this page.
        require('dctk/clientLogging', function(cl) {
          cl.logTrxEvent("GC.Wizard.Perf", ['clEventName01=ResponseStartToPaint', 'clEventTime01='+fromResponseStart, 'clEventName02=RequestStartToPaint', 'clEventTime02='+Math.round(t)]);
        })
      }
      if (performance && performance.mark) {
        performance.mark("GC.Wizard.Paint");
      }
    }
  }
})
define('gc/getDefaultTabAndPackages', ['underscore', 'gc/json-path'], function(_, jsonPath) {
  return function(config) {
    var tab = 'flight';
    var tabObj = _.find(jsonPath("wizardconfig.lobs", config), function(lob) {return lob.defaultLob});
    if (tabObj && tabObj.id) {
      tab = tabObj.id;
    }
    var packages = {};
    if (tab && (tab === "package" || (tabObj && tabObj.isPackage))) {
      var lobConfig = "" ;
      if (tab === 'package') {
        var pack = _.find(tabObj.lobs, function(lob) {return lob.defaultPackage});
        lobConfig = pack.id;
      } else {
        lobConfig = tab;
      }
      var packageSettings = config[lobConfig];
      packages = {
        flight: packageSettings.packageSetting_flight,
        hotel: packageSettings.packageSetting_hotel,
        car: packageSettings.packageSetting_car
      }
    }
    return {
      tab: tab,
      packages: packages
    };
  }
});

/**
 * Module is a function for merging two objects with properties. This module is
 * created for use with our config files. _.extend does not do a deep merge and
 * $.extend has some bugs where it will not correctly work with this example:
 * {foo:{me:true}} and {foo:{me:false, you:true}}
 * @exports gc/merge
 */
define('gc/merge', function() {
  /**
   * Returns true if the value is a plain Object
   * @param {object} value - any value
   * @returns {boolean} - true if the value is a plain Object, otherwise false
   */
  function isObject(value) {
    return value && // test for null since typeof null is 'object'
      (typeof value === 'object') &&
      !(value instanceof Array) && // Array and Date are also typeof 'object'
      !(value instanceof Date);
  }

  /**
   * Returns a copy of an object with the same structure and values. This
   * breaks all reffrences to the original object so changes in one will
   * not effect the other.
   * @param {object} value - any object with parameters
   * @returns {object} - a cloned copy of the object passed in
   */
  function clone(value) {
    var key;
    var output = {};
    if (isObject(value)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          output[key] = clone(value[key]);
        }
      }
      return output;
    } else {
      return value;
    }
  }

  /**
   * Copies the structure of default or override to the destination object
   * @param {object} destination - all properties end up being added here
   * @param {object} defaults - these are the default values to be copied
   * @param {object} overrides - these value override the default if they exsist
   */
  function copyBaseWithDefaultsAndOverrides(destination, defaults, overrides) {
    var key;
    for (key in defaults) {
      if (overrides.hasOwnProperty(key)) {
       if (isObject(defaults[key]) && isObject(overrides[key])) {
         destination[key] = merge(defaults[key], overrides[key])
       } else {
         destination[key] = clone(overrides[key]);
       }
      } else if (defaults.hasOwnProperty(key)) {
        destination[key] = clone(defaults[key]);
      }
    }
  }

  /**
   * Copies all properties from source to destination that don't already
   * exsist on the destination.
   * @param {object} destination - properties are copied to here
   * @param {object} source - properties are copied from here
   */
  function addSourcePropertiesToDestination(destination, source) { 
    var key;
    for (key in source) {
      if (source.hasOwnProperty(key) && !destination[key]) {
        destination[key] = clone(source[key]);
      }
    }
  }

  /**
   * Returns a new object with all properties from default and overrides copied
   * onto it. Properties are taken from default unless they exsist in override.
   * @param {object} defaults - the default properties
   * @param {object} overrides - the override properties
   * @returns {object} - a new object will all the properties
   */
  function merge(defaults, overrides) {
    var output = {};
    copyBaseWithDefaultsAndOverrides(output, defaults, overrides);
    addSourcePropertiesToDestination(output, overrides);
    return output;
  }

  /**
   * Wrapper around merge. Checks that both parameters are objects, otherwise
   * just returns the default.
   * @param {object} default - the default properties
   * @param {object} overrides - the override properties
   * @returns {object} - a new object with all the properties
   */
  return function(defaults, overrides) {
    if (isObject(defaults) && isObject(overrides)) {
      return merge(defaults, overrides);
    } else {
      return defaults;
    }
  }
});

define('gc/json-path', function() {
  return function(path, object) {
    var pathArray = splitPath(path);
    var value = getValue(pathArray, object);
    return value;
  }

  function splitPath(path) {
    return path.split(/\[|]\.|]|\./);
  }

  function getValue(path, object) {
    var key = path.shift();
    object = object[key];
    if (path.length === 0 || typeof object === 'undefined') {
      return object;
    } else {
      return getValue(path, object);
    }
  }

});

/**
 * Backbone-Nested 2.0.0 - An extension of Backbone.js that keeps track of nested attributes
 *
 * http://afeld.github.com/backbone-nested/
 *
 * Copyright (c) 2011-2012 Aidan Feldman
 * MIT Licensed (LICENSE)
 */
/*global $, _, Backbone */
(function(){
  'use strict';

  var _delayedTriggers = [],
    nestedChanges;

  Backbone.NestedModel = Backbone.Model.extend({

    get: function(attrStrOrPath){
      var attrPath = Backbone.NestedModel.attrPath(attrStrOrPath),
        result;

      Backbone.NestedModel.walkPath(this.attributes, attrPath, function(val, path){
        var attr = _.last(path);
        if (path.length === attrPath.length){
          // attribute found
          result = val[attr];
        }
      });

      return result;
    },

    has: function(attr){
      // for some reason this is not how Backbone.Model is implemented - it accesses the attributes object directly
      var result = this.get(attr);
      return !(result === null || _.isUndefined(result));
    },

    set: function(key, value, opts){
      var newAttrs = Backbone.NestedModel.deepClone(this.attributes),
        attrPath,
        unsetObj,
        validated;

      if (_.isString(key)){
        // Backbone 0.9.0+ syntax: `model.set(key, val)` - convert the key to an attribute path
        attrPath = Backbone.NestedModel.attrPath(key);
      } else if (_.isArray(key)){
        // attribute path
        attrPath = key;
      }

      if (attrPath){
        opts = opts || {};
        this._setAttr(newAttrs, attrPath, value, opts);
      } else { // it's an Object
        opts = value || {};
        var attrs = key;
        for (var _attrStr in attrs) {
          if (attrs.hasOwnProperty(_attrStr)) {
            this._setAttr(newAttrs,
                          Backbone.NestedModel.attrPath(_attrStr),
                          opts.unset ? void 0 : attrs[_attrStr],
                          opts);
          }
        }
      }

      nestedChanges = Backbone.NestedModel.__super__.changedAttributes.call(this);

      if (opts.unset && attrPath && attrPath.length === 1){ // assume it is a singular attribute being unset
        // unsetting top-level attribute
        unsetObj = {};
        unsetObj[key] = void 0;
        nestedChanges = _.omit(nestedChanges, _.keys(unsetObj));
        validated = Backbone.NestedModel.__super__.set.call(this, unsetObj, opts);
      } else {
        unsetObj = newAttrs;

        // normal set(), or an unset of nested attribute
        if (opts.unset && attrPath){
          // make sure Backbone.Model won't unset the top-level attribute
          opts = _.extend({}, opts);
          delete opts.unset;
        } else if (opts.unset && _.isObject(key)) {
          unsetObj = key;
        }
        nestedChanges = _.omit(nestedChanges, _.keys(unsetObj));
        validated = Backbone.NestedModel.__super__.set.call(this, unsetObj, opts);
      }


      if (!validated){
        // reset changed attributes
        this.changed = {};
        nestedChanges = {};
        return false;
      }


      this._runDelayedTriggers();
      return this;
    },

    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    clear: function(options) {
      nestedChanges = {};

      // Mostly taken from Backbone.Model.set, modified to work for NestedModel.
      options = options || {};
      // clone attributes so validate method can't mutate it from underneath us.
      var attrs = _.clone(this.attributes);
      if (!options.silent && this.validate && !this.validate(attrs, options)) {
        return false; // Should maybe return this instead?
      }

      var changed = this.changed = {};
      var model = this;

      var setChanged = function(obj, prefix, options) {
        // obj will be an Array or an Object
        _.each(obj, function(val, attr){
          var changedPath = prefix;
          if (_.isArray(obj)){
            // assume there is a prefix
            changedPath += '[' + attr + ']';
          } else if (prefix){
            changedPath += '.' + attr;
          } else {
            changedPath = attr;
          }

          val = obj[attr];
          if (_.isObject(val)) { // clear child attrs
            setChanged(val, changedPath, options);
          }
          if (!options.silent) model._delayedChange(changedPath, null, options);
          changed[changedPath] = null;
        });
      };
      setChanged(this.attributes, '', options);

      this.attributes = {};

      // Fire the `"change"` events.
      if (!options.silent) this._delayedTrigger('change');

      this._runDelayedTriggers();
      return this;
    },

    add: function(attrStr, value, opts){
      var current = this.get(attrStr);
      if (!_.isArray(current)) throw new Error('current value is not an array');
      return this.set(attrStr + '[' + current.length + ']', value, opts);
    },

    remove: function(attrStr, opts){
      opts = opts || {};

      var attrPath = Backbone.NestedModel.attrPath(attrStr),
        aryPath = _.initial(attrPath),
        val = this.get(aryPath),
        i = _.last(attrPath);

      if (!_.isArray(val)){
        throw new Error("remove() must be called on a nested array");
      }

      // only trigger if an element is actually being removed
      var trigger = !opts.silent && (val.length >= i + 1),
        oldEl = val[i];

      // remove the element from the array
      val.splice(i, 1);
      opts.silent = true; // Triggers should only be fired in trigger section below
      this.set(aryPath, val, opts);

      if (trigger){
        attrStr = Backbone.NestedModel.createAttrStr(aryPath);
        this.trigger('remove:' + attrStr, this, oldEl);
        for (var aryCount = aryPath.length; aryCount >= 1; aryCount--) {
          attrStr = Backbone.NestedModel.createAttrStr(_.first(aryPath, aryCount));
          this.trigger('change:' + attrStr, this, oldEl);
        }
        this.trigger('change', this, oldEl);
      }

      return this;
    },

    changedAttributes: function(diff) {
      var backboneChanged = Backbone.NestedModel.__super__.changedAttributes.call(this, diff);
      if (_.isObject(backboneChanged)) {
        return _.extend({}, nestedChanges, backboneChanged);
      }
      return false;
    },

    toJSON: function(){
      return Backbone.NestedModel.deepClone(this.attributes);
    },


    // private
    _delayedTrigger: function(/* the trigger args */){
      _delayedTriggers.push(arguments);
    },

    _delayedChange: function(attrStr, newVal, options){
      this._delayedTrigger('change:' + attrStr, this, newVal, options);

      // Check if `change` even *exists*, as it won't when the model is
      // freshly created.
      if (!this.changed) {
        this.changed = {};
      }

      this.changed[attrStr] = newVal;
    },

    _runDelayedTriggers: function(){
      while (_delayedTriggers.length > 0){
        this.trigger.apply(this, _delayedTriggers.shift());
      }
    },

    // note: modifies `newAttrs`
    _setAttr: function(newAttrs, attrPath, newValue, opts){
      opts = opts || {};

      var fullPathLength = attrPath.length;
      var model = this;

      Backbone.NestedModel.walkPath(newAttrs, attrPath, function(val, path){
        var attr = _.last(path);
        var attrStr = Backbone.NestedModel.createAttrStr(path);

        // See if this is a new value being set
        var isNewValue = !_.isEqual(val[attr], newValue);

        if (path.length === fullPathLength){
          // reached the attribute to be set

          if (opts.unset){
            // unset the value
            delete val[attr];

            // Trigger Remove Event if array being set to null
            if (_.isArray(val)){
              var parentPath = Backbone.NestedModel.createAttrStr(_.initial(attrPath));
              model._delayedTrigger('remove:' + parentPath, model, val[attr]);
            }
          } else {
            // Set the new value
            val[attr] = newValue;
          }

          // Trigger Change Event if new values are being set
          if (!opts.silent && _.isObject(newValue) && isNewValue){
            var visited = [];
            var checkChanges = function(obj, prefix) {
              // Don't choke on circular references
              if(_.indexOf(visited, obj) > -1) {
                return;
              } else {
                visited.push(obj);
              }

              var nestedAttr, nestedVal;
              for (var a in obj){
                if (obj.hasOwnProperty(a)) {
                  nestedAttr = prefix + '.' + a;
                  nestedVal = obj[a];
                  if (!_.isEqual(model.get(nestedAttr), nestedVal)) {
                    model._delayedChange(nestedAttr, nestedVal, opts);
                  }
                  if (_.isObject(nestedVal)) {
                    checkChanges(nestedVal, nestedAttr);
                  }
                }
              }
            };
            checkChanges(newValue, attrStr);

          }


        } else if (!val[attr]){
          if (_.isNumber(attr)){
            val[attr] = [];
          } else {
            val[attr] = {};
          }
        }

        if (!opts.silent){
          // let the superclass handle change events for top-level attributes
          if (path.length > 1 && isNewValue){
            model._delayedChange(attrStr, val[attr], opts);
          }

          if (_.isArray(val[attr])){
            model._delayedTrigger('add:' + attrStr, model, val[attr]);
          }
        }
      });
    }

  }, {
    // class methods

    attrPath: function(attrStrOrPath){
      var path;

      if (_.isString(attrStrOrPath)){
        // TODO this parsing can probably be more efficient
        path = (attrStrOrPath === '') ? [''] : attrStrOrPath.match(/[^\.\[\]]+/g);
        path = _.map(path, function(val){
          // convert array accessors to numbers
          return val.match(/^\d+$/) ? parseInt(val, 10) : val;
        });
      } else {
        path = attrStrOrPath;
      }

      return path;
    },

    createAttrStr: function(attrPath){
      var attrStr = attrPath[0];
      _.each(_.rest(attrPath), function(attr){
        attrStr += _.isNumber(attr) ? ('[' + attr + ']') : ('.' + attr);
      });

      return attrStr;
    },

    deepClone: function(obj){
      return $.extend(true, {}, obj);
    },

    walkPath: function(obj, attrPath, callback, scope){
      var val = obj,
        childAttr;

      // walk through the child attributes
      for (var i = 0; i < attrPath.length; i++){
        callback.call(scope || this, val, attrPath.slice(0, i + 1));

        childAttr = attrPath[i];
        val = val[childAttr];
        if (!val) break; // at the leaf
      }
    }

  });

}());

/*
 XDate v0.8
 Docs & Licensing: http://arshaw.com/xdate/
*/

var XDate=function(g,n,A,p){function f(){var a=this instanceof f?this:new f,c=arguments,b=c.length,d;typeof c[b-1]=="boolean"&&(d=c[--b],c=q(c,0,b));if(b)if(b==1)if(b=c[0],b instanceof g||typeof b=="number")a[0]=new g(+b);else if(b instanceof f){var c=a,h=new g(+b[0]);if(l(b))h.toString=v;c[0]=h}else{if(typeof b=="string"){a[0]=new g(0);a:{for(var c=b,b=d||!1,h=f.parsers,w=0,e;w<h.length;w++)if(e=h[w](c,b,a)){a=e;break a}a[0]=new g(c)}}}else a[0]=new g(m.apply(g,c)),d||(a[0]=r(a[0]));else a[0]=new g;
typeof d=="boolean"&&B(a,d);return a}function l(a){return a[0].toString===v}function B(a,c,b){if(c){if(!l(a))b&&(a[0]=new g(m(a[0].getFullYear(),a[0].getMonth(),a[0].getDate(),a[0].getHours(),a[0].getMinutes(),a[0].getSeconds(),a[0].getMilliseconds()))),a[0].toString=v}else l(a)&&(a[0]=b?r(a[0]):new g(+a[0]));return a}function C(a,c,b,d,h){var e=k(j,a[0],h),a=k(D,a[0],h),h=!1;d.length==2&&typeof d[1]=="boolean"&&(h=d[1],d=[b]);b=c==1?(b%12+12)%12:e(1);a(c,d);h&&e(1)!=b&&(a(1,[e(1)-1]),a(2,[E(e(0),
e(1))]))}function F(a,c,b,d){var b=Number(b),h=n.floor(b);a["set"+o[c]](a["get"+o[c]]()+h,d||!1);h!=b&&c<6&&F(a,c+1,(b-h)*G[c],d)}function H(a,c,b){var a=a.clone().setUTCMode(!0,!0),c=f(c).setUTCMode(!0,!0),d=0;if(b==0||b==1){for(var h=6;h>=b;h--)d/=G[h],d+=j(c,!1,h)-j(a,!1,h);b==1&&(d+=(c.getFullYear()-a.getFullYear())*12)}else b==2?(b=a.toDate().setUTCHours(0,0,0,0),d=c.toDate().setUTCHours(0,0,0,0),d=n.round((d-b)/864E5)+(c-d-(a-b))/864E5):d=(c-a)/[36E5,6E4,1E3,1][b-3];return d}function s(a){var c=
a(0),b=a(1),d=a(2),a=new g(m(c,b,d)),c=t(I(c,b,d));return n.floor(n.round((a-c)/864E5)/7)+1}function I(a,c,b){c=new g(m(a,c,b));if(c<t(a))return a-1;else if(c>=t(a+1))return a+1;return a}function t(a){a=new g(m(a,0,4));a.setUTCDate(a.getUTCDate()-(a.getUTCDay()+6)%7);return a}function J(a,c,b,d){var h=k(j,a,d),e=k(D,a,d);b===p&&(b=I(h(0),h(1),h(2)));b=t(b);d||(b=r(b));a.setTime(+b);e(2,[h(2)+(c-1)*7])}function K(a,c,b,d,h){var e=f.locales,g=e[f.defaultLocale]||{},i=k(j,a,h),b=(typeof b=="string"?
e[b]:b)||{};return x(a,c,function(a){if(d)for(var b=(a==7?2:a)-1;b>=0;b--)d.push(i(b));return i(a)},function(a){return b[a]||g[a]},h)}function x(a,c,b,d,e){for(var f,g,i="";f=c.match(N);){i+=c.substr(0,f.index);if(f[1]){g=i;for(var i=a,j=f[1],l=b,m=d,n=e,k=j.length,o=void 0,q="";k>0;)o=O(i,j.substr(0,k),l,m,n),o!==p?(q+=o,j=j.substr(k),k=j.length):k--;i=g+(q+j)}else f[3]?(g=x(a,f[4],b,d,e),parseInt(g.replace(/\D/g,""),10)&&(i+=g)):i+=f[7]||"'";c=c.substr(f.index+f[0].length)}return i+c}function O(a,
c,b,d,e){var g=f.formatters[c];if(typeof g=="string")return x(a,g,b,d,e);else if(typeof g=="function")return g(a,e||!1,d);switch(c){case "fff":return i(b(6),3);case "s":return b(5);case "ss":return i(b(5));case "m":return b(4);case "mm":return i(b(4));case "h":return b(3)%12||12;case "hh":return i(b(3)%12||12);case "H":return b(3);case "HH":return i(b(3));case "d":return b(2);case "dd":return i(b(2));case "ddd":return d("dayNamesShort")[b(7)]||"";case "dddd":return d("dayNames")[b(7)]||"";case "M":return b(1)+
1;case "MM":return i(b(1)+1);case "MMM":return d("monthNamesShort")[b(1)]||"";case "MMMM":return d("monthNames")[b(1)]||"";case "yy":return(b(0)+"").substring(2);case "yyyy":return b(0);case "t":return u(b,d).substr(0,1).toLowerCase();case "tt":return u(b,d).toLowerCase();case "T":return u(b,d).substr(0,1);case "TT":return u(b,d);case "z":case "zz":case "zzz":return e?c="Z":(d=a.getTimezoneOffset(),a=d<0?"+":"-",b=n.floor(n.abs(d)/60),d=n.abs(d)%60,e=b,c=="zz"?e=i(b):c=="zzz"&&(e=i(b)+":"+i(d)),c=
a+e),c;case "w":return s(b);case "ww":return i(s(b));case "S":return c=b(2),c>10&&c<20?"th":["st","nd","rd"][c%10-1]||"th"}}function u(a,c){return a(3)<12?c("amDesignator"):c("pmDesignator")}function y(a){return!isNaN(+a[0])}function j(a,c,b){return a["get"+(c?"UTC":"")+o[b]]()}function D(a,c,b,d){a["set"+(c?"UTC":"")+o[b]].apply(a,d)}function r(a){return new g(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate(),a.getUTCHours(),a.getUTCMinutes(),a.getUTCSeconds(),a.getUTCMilliseconds())}function E(a,
c){return 32-(new g(m(a,c,32))).getUTCDate()}function z(a){return function(){return a.apply(p,[this].concat(q(arguments)))}}function k(a){var c=q(arguments,1);return function(){return a.apply(p,c.concat(q(arguments)))}}function q(a,c,b){return A.prototype.slice.call(a,c||0,b===p?a.length:b)}function L(a,c){for(var b=0;b<a.length;b++)c(a[b],b)}function i(a,c){c=c||2;for(a+="";a.length<c;)a="0"+a;return a}var o="FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds,Day,Year".split(","),M=["Years",
"Months","Days"],G=[12,31,24,60,60,1E3,1],N=/(([a-zA-Z])\2*)|(\((('.*?'|\(.*?\)|.)*?)\))|('(.*?)')/,m=g.UTC,v=g.prototype.toUTCString,e=f.prototype;e.length=1;e.splice=A.prototype.splice;e.getUTCMode=z(l);e.setUTCMode=z(B);e.getTimezoneOffset=function(){return l(this)?0:this[0].getTimezoneOffset()};L(o,function(a,c){e["get"+a]=function(){return j(this[0],l(this),c)};c!=8&&(e["getUTC"+a]=function(){return j(this[0],!0,c)});c!=7&&(e["set"+a]=function(a){C(this,c,a,arguments,l(this));return this},c!=
8&&(e["setUTC"+a]=function(a){C(this,c,a,arguments,!0);return this},e["add"+(M[c]||a)]=function(a,d){F(this,c,a,d);return this},e["diff"+(M[c]||a)]=function(a){return H(this,a,c)}))});e.getWeek=function(){return s(k(j,this,!1))};e.getUTCWeek=function(){return s(k(j,this,!0))};e.setWeek=function(a,c){J(this,a,c,!1);return this};e.setUTCWeek=function(a,c){J(this,a,c,!0);return this};e.addWeeks=function(a){return this.addDays(Number(a)*7)};e.diffWeeks=function(a){return H(this,a,2)/7};f.parsers=[function(a,
c,b){if(a=a.match(/^(\d{4})(-(\d{2})(-(\d{2})([T ](\d{2}):(\d{2})(:(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/)){var d=new g(m(a[1],a[3]?a[3]-1:0,a[5]||1,a[7]||0,a[8]||0,a[10]||0,a[12]?Number("0."+a[12])*1E3:0));a[13]?a[14]&&d.setUTCMinutes(d.getUTCMinutes()+(a[15]=="-"?1:-1)*(Number(a[16])*60+(a[18]?Number(a[18]):0))):c||(d=r(d));return b.setTime(+d)}}];f.parse=function(a){return+f(""+a)};e.toString=function(a,c,b){return a===p||!y(this)?this[0].toString():K(this,a,c,b,l(this))};
e.toUTCString=e.toGMTString=function(a,c,b){return a===p||!y(this)?this[0].toUTCString():K(this,a,c,b,!0)};e.toISOString=function(){return this.toUTCString("yyyy-MM-dd'T'HH:mm:ss(.fff)zzz")};f.defaultLocale="";f.locales={"":{monthNames:"January,February,March,April,May,June,July,August,September,October,November,December".split(","),monthNamesShort:"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec".split(","),dayNames:"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(","),dayNamesShort:"Sun,Mon,Tue,Wed,Thu,Fri,Sat".split(","),
amDesignator:"AM",pmDesignator:"PM"}};f.formatters={i:"yyyy-MM-dd'T'HH:mm:ss(.fff)",u:"yyyy-MM-dd'T'HH:mm:ss(.fff)zzz"};L("getTime,valueOf,toDateString,toTimeString,toLocaleString,toLocaleDateString,toLocaleTimeString,toJSON".split(","),function(a){e[a]=function(){return this[0][a]()}});e.setTime=function(a){this[0].setTime(a);return this};e.valid=z(y);e.clone=function(){return new f(this)};e.clearTime=function(){return this.setHours(0,0,0,0)};e.toDate=function(){return new g(+this[0])};f.now=function(){return+new g};
f.today=function(){return(new f).clearTime()};f.UTC=m;f.getDaysInMonth=E;if(typeof module!=="undefined"&&module.exports)module.exports=f;typeof define==="function"&&define.amd&&define([],function(){return f});return f}(Date,Math,Array);
define('xdate', function() {
  return XDate;
});

define('gc/localStorage', function() {
  return {
    /**
     * Store data in local storage
     *
     * @param {Object} data JSON object to be stored in the local storage
     * @param  {String} storageKey Storage key
     * @returns {boolean} true if success, false otherwise
     */
    saveLocalStorage: function(storageKey, data) {
      // check if LocalStorage feature is enabled
      if ( ! window.localStorage) {
        return false;
      }

      try {
        localStorage.setItem(storageKey, (typeof data === 'string') ? data : JSON.stringify(data));
      }
      catch (ex) {
        return false;
      }

      return true;
    },

    /**
     * Retrieve data from the local storage
     *
     * @param {String} storageKey Storage key
     * @return {boolean | Object} false if failed, Object if found
     */
    getLocalStorage: function(storageKey) {
      // check if LocalStorage feature is enabled
      if ( ! window.localStorage) {
        return false;
      }

      try {
        var item = localStorage.getItem(storageKey);
        item = JSON.parse(item);
      }
      catch(ex) {
        return false;
      }

      return item;
    },
    localStorageKey: '_Expedia.Core.Wizard_'
  }
});
/*jslint nomen: true */
/*global _, corewizard, XDate , ab6072status*/

define('gc/modelHelpers', [
  'gc/modelHelpersOverride',
  'gc/loc',
  'underscore',
  'gc/predicates',
  'jquery'
], function(
  modelHelpersOverride,
  loc,
  _,
  predicates,
  $
) {
  var helpers = {};

  helpers.getChildForHotels = getChildForHotels = function (childAge, childIndex, roomIndex, roomId) {
      'use strict';
      if (typeof childAge === 'undefined') {
          childAge = '';
      }
      return {
          id: roomId + '-age-select-' + String(childIndex + 1),
          age: childAge,
          index: childIndex,
          roomIndex: roomIndex,
          parent: roomId,
          wizardAction: '{"rooms[' + roomIndex + '].children[' + childIndex + ']": $value1}',
          label: function(childNumber){
              'use strict';
              var childAgeCompile = Handlebars.compile(loc.childLabel);
              return childAgeCompile({childIndex: childNumber})
          }(childIndex+1)
      };
  };

  helpers.getChildrenForHotels = getChildrenForHotels = function (children, roomIndex, roomId) {
      'use strict';
      return _.map(children, function (age, index) {
          return getChildForHotels(age, index, roomIndex, roomId);
      });
  };
  helpers.getRoomForHotels = getRoomForHotels = function (lob, room, roomIndex, isSingleRoom) {
      'use strict';
      // replace placeholder in loc string for hotelRoomLabel
      var labelLocString = loc.hotelRoomLabel.replace('###number###', roomIndex + 1);
      return {
          adults: room.adults,
          children: room.children,
          childCount: room.children.length,
          id: lob + '-' + String(roomIndex + 1),
          ownerId: lob,
          number: roomIndex + 1,
          index: roomIndex,
          isHotelOnly: true,
          ages: getChildrenForHotels(room.children, roomIndex, lob + '-' + String(roomIndex + 1)),
          isSingleRoom : isSingleRoom,
          label: labelLocString
      };
  };
  helpers.getRoomsForHotels = getRoomsForHotels = function (lob, rooms) {
      'use strict';
      return _.map(rooms, function(room, index) {
          return getRoomForHotels(lob, room, index, rooms.length == 1);
      });
  };
  helpers.getRoomsForModel = getRoomsForModel = function (state, config) {
      'use strict';
      var roomsOut = [],
          i,
          j,
          adults,
          childCount,
          children,
          roomCount,
          maxRoomCount,
          stateRoomCount,
          childAge;

      maxRoomCount = config.get('travelers.maxRoomCount');
      if (state.get("tab") == "hotel" &&
              (state.get("roomCount") == 9) &&
              config.get("travelers.ninePlusRoomsAllowed"))
          maxRoomCount = 1;

      stateRoomCount = state.get('roomCount');
      roomCount = stateRoomCount <= maxRoomCount ? stateRoomCount : maxRoomCount;
      for (i = 0; i < roomCount; i += 1) {
          children = [];
          adults = state.get('rooms[' + i + '].adults') || 2;
          childCount = state.get('rooms[' + i + '].childCount') || 0;

          for (j = 0; j < childCount; j += 1) {
              childAge = state.get('rooms[' + i + '].children[' + j + ']');
              if (typeof childAge === 'undefined') {
                  childAge = '';
              }
              children.push(childAge);
          }

          roomsOut.push({'adults': adults, 'childCount': childCount, 'children': children});
      }
      return roomsOut;
  };
  helpers.getRoomsForModelFlights = getRoomsForModelFlights = function (state) {
      'use strict';
      var rooms,
          i,
          childAge,
          children;

      rooms = [];
      if (state.get('rooms') && state.get('rooms').length > 0) {
          rooms[0] = {};
          rooms[0].adults = state.get('rooms[0].adults');
          rooms[0].childCount = state.get('rooms[0].childCount');
      } else {
          rooms[0] = {adults: 1, childCount: 0, children: []};
      }

      children = [];
      for (i = 0; i < rooms[0].childCount; i += 1) {
          childAge = state.get('rooms[0].children[' + i + ']');
          if (typeof childAge === 'undefined') {
              childAge = '';
          }
          children.push(childAge);
      }
      rooms[0].children = children;

      return rooms;
  };
  helpers.getRulesForCheckingChildAges = getRulesForCheckingChildAges = function (model) {
      'use strict';
      var i,
          j,
          room,
          rules,
          child,
          roomCount,
          rooms;

      roomCount = model.get("roomCount");
      rooms = model.get("rooms");

      rules = [];

      for (i = 0; i < roomCount; i += 1) {
          room = rooms[i];

          for (j = 0; j < room.childCount; j += 1) {

              rules.push(["isNotDefaultValue", ["rooms[" + i + "].children[" + j + "]"], "child-age-not-provided"]);

          }
      }
      return rules;
  };
  helpers.getRegionNameOrDestination = getRegionNameOrDestination = function (state, config) {
      'use strict';
      return state.get("regionName") || state.get("destination");
  };
  helpers.getEndDate = getEndDate = function (state, config) {
      'use strict';
      var endDateString,
          endDate,
          startDateString,
          startDate,
          minDate,
          maxDate;

      // Bugfix for eph-511
      // Set the endDate in state if we have the startDate but not the endDate
      // Only for the Lob related to the hotel, we need to add one more day to the endDate
      if(!(state.get('endDate')) && state.get('startDate')){
          var currentStartDate = new XDate(state.get("startDate"));
          var currentEndDate = currentStartDate.clone().addDays(config.get("calendar.minTripLength")).toString(config.get("dateFormat"));
          return currentEndDate;
      }

      endDateString = state.get('endDate');
      //https://jira/jira/browse/MAIN-122282 Special case: partial LS data doesn't apply for hotel soft packaging.
      if (state.get('packages.flight') &&
          state.get('tab') === 'hotel' &&
          state.get('isPartialStay')) return state.get('checkout') || state.get('endDate');

      //commented out to fix https://jira/jira/browse/MAIN-123019
      // only run constraints when the LOB changes
      // if (!corewizard.core.state.changed.tab && !corewizard.core.state.changed.packages && typeof corewizard.core.state.changed.isPartialStay == 'undefined') {
      //   return endDateString;
      // }

      if (predicates.isNotBlank(endDateString).isValid &&
              predicates.isValidDate(endDateString).isValid) {
          endDate = new XDate(endDateString);
          if (_.isNaN(endDate)) {
            return '';
          }

          startDateString = state.get("startDate");

          if (predicates.isNotBlank(startDateString).isValid &&
                  predicates.isValidDate(startDateString).isValid) {
              startDate = new XDate(startDateString);

              minDate = startDate.clone().addDays(config.get("calendar.minTripLength"));
              maxDate = startDate.clone().addDays(config.get("calendar.maxTripLength"));
              if (endDate < minDate) {
                  var newEndDate = minDate.toString(config.get("dateFormat"));
                  state.set('endDate', newEndDate);
                  return newEndDate;
              }

              if(endDate > maxDate){
                  return "";
              }

          }
          return endDate.toString(config.get("dateFormat"));

        } else if (predicates.isNotBlank(endDateString).isValid) {
            return endDateString;      }
      return "";
  };
  helpers.getSoftPackageAction = getSoftPackageAction = function (buttonLob, model) {
      'use strict';
      var packages = ['flight', 'hotel', 'car'];
      var isFlightPackage = model.get('packages.flight'),
          isHotelPackage = model.get('packages.hotel'),
          isCarPackage = model.get('packages.car'),
          isTrainPackage = model.get('packages.train');
      var tab = model.get('tab');

      var isHotelTab = tab === 'hotel',
          isCarTab = tab === 'car',
          isFlightTab = tab === 'flight';

      var numberOfPackageTypesAdded = (isFlightPackage ? 1 : 0) +
                                      (isHotelPackage ? 1 : 0) +
                                      (isCarPackage ? 1 : 0) +
                                      (isTrainPackage ? 1 : 0);
      var moreThanTwoPackageTypes = numberOfPackageTypesAdded > 2,
          hasTwoPackageTypes = numberOfPackageTypesAdded === 2;
      var isCheckBoxStyle = isHotelTab;

      var values = _.map(packages, function(lob) {
          var isCurrentPackageType = lob === buttonLob;
          var isCurrentTab = lob === tab;

          if (isCheckBoxStyle) {
              if (isCurrentTab) {
                  if (moreThanTwoPackageTypes) {
                      return 'true';
                  } else {
                      return '$value1';
                  }
              } else if (isCurrentPackageType) {
                  return '$value1';
              } else {
                  return String(model.get('packages.' + lob));
              }
          } else {
              if (isCurrentTab) {
                  //return false if there's only two packages
                  //and this buttonID is one of them.
                  return String(!(
                      hasTwoPackageTypes &&
                      model.get('packages.' + buttonLob) === true)
                  );
              } else if (isCurrentPackageType) {
                  return String(!model.get('packages.' + lob));
              } else {
                  return String(model.get('packages.' + lob));
              }
          }
      });

      return '{"packages.flight" : ' + values[0] +
             ', "packages.hotel" : ' + values[1] +
             ', "packages.car" : '   + values[2] + '}';
  };

    helpers.mobileSuppress = mobileSuppress = function() {
        var isiPad = navigator.userAgent.match(/iPad/i) != null;
        var isMobile = navigator.userAgent.match(/Mobile|Android|BlackBerry/i) != null;
        return ( isMobile && !isiPad);
    };

    helpers.isUseSingleStackLaunchPages = isUseSingleStackLaunchPages = function() {
        return loc.masterconfig.switches.useSingleStackLaunchPages;
    };

    helpers.getHotelTabletValueProp = getHotelTabletValueProp = function () {
        'use strict';
        var hotelTabletValuePropCompile = Handlebars.compile(loc.hotelTabletValueProp);
        return hotelTabletValuePropCompile({package_search_over_hotel_count: loc.masterconfig.package_search_over_hotel_count});
    };

    $.extend(true, helpers, modelHelpersOverride);

  return helpers;
});


// XDate already knows how to handle MM/DD/YYYY & YYYY/MM/DD
// we need something for DD/MM/YYYY
// XDate allows us to extend the parser, but we're only allowed to pass in 1 string argument total
// also, FF doesnt like . or - as date separators

function parseDate(str) {
    var format = XDate.prototype.format;
    var parts = str.split(/[\s\.,/-]+/);
    var year, month, day
    if (format) {
        var formatParts = format.split(/[\s\.,/-]+/);
        if (formatParts.length == 3) {
            var $1 = formatParts[0][0].toUpperCase();
            var $2 = formatParts[1][0].toUpperCase();
            var $3 = formatParts[2][0].toUpperCase();
            if ($1 == 'D' && $2 == 'M' && $3 == 'Y') {
        	    year = parts[2];
        	    month = parts[1] ? parts[1]-1 : 0;
        	    day = parts[0];
            }
            else if ($1 == 'M' && $2 == 'D' && $3 == 'Y') {
        	    year = parts[2];
        	    month = parts[0] ? parts[0]-1 : 0;
        	    day = parts[1];
            }
            else if ($1 == 'Y' && $2 == 'M' && $3 == 'D') {
        	    year = parts[0];
        	    month = parts[1] ? parts[1]-1 : 0;
        	    day = parts[2];
            }
            if (year > 0 && year < 100) {
                // in case year is passed in as yy instead of yyyy
            	var thisyear = XDate.today().getFullYear();
            	year = Math.floor(thisyear/100) * 100 + parseInt(year);
            }
            return new XDate(year, month, day);
        }
    }
    return;
}

XDate.prototype.setParseDateFormat = function(format) {XDate.prototype.format = format;};
XDate.prototype.setParseDateFormat('mm/dd/yyyy'); // connect this with config
XDate.parsers.push(parseDate);
// jquery specific date util
if ('undefined' == typeof(exp)){var exp = {};}
if ('undefined' == typeof(exp.core)){exp.core = {};}
if ('undefined' == typeof(exp.core.date)){exp.core.date = {};}

exp.core.date.Calendar = function(_config){
    var Calendar = {
        config:_config,
        rM:[31,28,31,30,31,30,31,31,30,31,30,31],
        getDateFormat:function(){
            return this.config.getDateFormat();
        },
        getDateSeparator:function(){
            return this.config.getDateSeparator();
        },
        getStartOfWeek:function(){
            return this.config.getStartOfWeek();
        },
        getDateFromString:function(t){
            if(!t || !t.length) return null;
            t=t.replace(/\s+/g,"");
            if(t.match(/[^-|\d|\.|\/]/)) return null;
            var rgt=t.split(/-|\.|\//);
            for(var i=0;i<rgt.length;i++) rgt[i]=parseInt(rgt[i],10);
            if(!rgt[1]) return null;
            var m,d,y;
            var fmt=this.getDateFormat();
            if(fmt=="yymmdd")
            {
                if(!rgt[2]) return null;
                m=rgt[1];d=rgt[2];y=rgt[0];
            }
            else
            {
                if(fmt=="mmddyy"){m=rgt[0];d=rgt[1];}
                else{m=rgt[1];d=rgt[0];}//fmt=="ddmmyy"
                if(rgt[2])y=rgt[2];
                else y=this.DefYr(m-1,d);
            }
            var yearNow = new Date().getFullYear();
            m-=1;
            if(y.toString().length===2)y+=2000;
            if(y<yearNow)y=yearNow;
            if(y<1601||y>4500||m<0||m>11||d<1||d>this.getMonthCount(m,y))return null;
            return new Date(y,m,d);
        },
        toStringFromComp: function (d,m,y)
        {
            function pad(s) {
                return s < 10 ? '0' + s : s;
            }
            var out="";
            var ds=this.getDateSeparator();
            var fmt=this.getDateFormat();
            d = pad(d);
            m = pad(m);
            if(fmt=="mmddyy")out=m+ds+d+ds+y;
            else if(fmt=="ddmmyy")out=d+ds+m+ds+y;
            else out=y+ds+m+ds+d;
            return out;
        },
        toStringFromDate: function (dt)
        {
            var out="";
            var ds=this.getDateSeparator();
            var fmt=this.getDateFormat();
            var mm = dt.getMonth() + 1;
            var dd = dt.getDate();
            var yy = dt.getFullYear();
            if(fmt=="mmddyy")out=mm+ds+dd+ds+yy;
            else if(fmt=="ddmmyy")out=dd+ds+mm+ds+yy;
            else out=yy+ds+mm+ds+dd;
            return out;
        },
        IsLY: function (y){
            if(0==y%4&&((y%100!=0)||(y%400==0)))
                return true;
            else
                return false;
        },
        DefYr: function (m,d){
            var dt=new Date();
            var yC=(dt.getYear()<1000)?1900+dt.getYear():dt.getYear();
            if(m<dt.getMonth()||(m==dt.getMonth()&&d<dt.getDate()))yC++;
            return yC;
        },
        getMonthCount: function (m,y){
            var c=this.rM[m];
            if((1==m)&&this.IsLY(y))c++;
            return c;
        },
        IsLastDayOfMonth: function(date){
            return this.getMonthCount(date.getMonth(),date.getFullYear()) == date.getDate();
        },
        incrementMonth: function(date){
            if (date.getMonth() == 11)
            {
                date.setMonth(0);
                date.setFullYear(date.getFullYear() + 1);
            }
            else
            {
                date.setMonth(date.getMonth() + 1);
            }
            return date;
        },
        decrementMonth: function(date){
            if (date.getMonth() == 0)
            {
                date.setMonth(11);
                date.setFullYear(date.getFullYear() - 1);
            }
            else
            {
                date.setMonth(date.getMonth() - 1);
            }
            return date;
        }
    }
    return Calendar;
};


exp.core.date.DateUpdater = function(_calendar, _config){
    var me;
    var DateUpdater = {
        config:_config,
        calendar:_calendar,
        /*  Due to the calendar behaviour, the parameter 'c', when set, will act as a lower offset limit to the return date.
            As several pages depend on this behaviour, a non-limiting prefill is carried out via the 'defaultLengthOfStay' parameter    */
        register:function(objFrom,objTo,c,greyOutPreviousDays,greyOutPostDays,defaultLengthOfStay){
            c = c || 0;
            var $objFrom = $(objFrom);
            var dt1 = this.calendar.getDateFromString($objFrom[0].value);
            var $objTo = $(objTo);
            var dt2 = this.calendar.getDateFromString($objTo[0].value);

            var ds=this.calendar.getDateSeparator();
            var fmt=this.calendar.getDateFormat();
            var format = fmt.substring(0,2) + ds + fmt.substring(2,4) + ds + fmt.substring(4,6);

            var currentDateValue = new Date();
            currentDateValue.setHours(0,0,0,0);

            if(dt1 && dt1.valueOf() < currentDateValue.valueOf()){
                $objFrom[0].value = format;
            }
            if (dt2 && dt2.valueOf() < currentDateValue.valueOf()){
                $objTo[0].value = format;
            }

            me = this;
            var fn = function(){me.update("#"+objFrom.id, "#"+objTo.id, c, greyOutPreviousDays, defaultLengthOfStay);};
            var fn2 = function(){me.updateByNights($objFrom[0], $objTo[0], c); me.update($objFrom[0], $objTo[0], c, greyOutPreviousDays);};

            $("body").on("blur",  "#"+objFrom.id, fn);
            $("body").on("focus", "#"+objFrom.id, fn);
            $("body").on("blur",  "#"+objTo.id, fn);
            $("body").on("focus", "#"+objTo.id, fn);

            var $stayNights = $("#"+objFrom.id+"-stay-nights");
            if ($stayNights.length != 0) {
                $stayNights.change(fn2);
                $stayNights.keypress(fn2);
            }

        },
        days_between: function (date1, date2) {

            var ONE_DAY = 1000 * 60 * 60 * 24

            var date1_ms = date1.getTime()
            var date2_ms = date2.getTime()

            var difference_ms = Math.abs(date1_ms - date2_ms)

            return Math.round(difference_ms/ONE_DAY)
        },
        updateNumberOfNights: function (from,to){

            var nightsField = document.getElementById('hot-sear-date-num-nights');
            if(this.config != undefined && nightsField != null)
            {
                var nightText = this.config.getNightTextConfig();
                var days = this.days_between(to, from);
                if(days > 1) nightsField.innerHTML = days + " " + nightText[1];
                else nightsField.innerHTML = nightText[0];
                nightsField.style.display = "inline";
            }
        },
        updateDayName: function (obj, date){
            var $dayField = $("#"+obj.id+"-day");
            if (this.config != undefined && $dayField.length != 0) {
                try {
                    var index = date.getDay();
                    if (index == undefined) {
                        $dayField.html("");
                        return;
                    }
                    var names = this.config.getDayNames();
                    $dayField.html(names[index]);
                } catch(err) {
                    $dayField.html("");
                }
            }
        },
        updateByNights: function (objFrom, objTo, c) {
            var dt1 = this.calendar.getDateFromString($(objFrom).val());
            var $stayNights = $("#"+objFrom.id+"-stay-nights");
            if (dt1) {
                dt1.setDate(dt1.getDate() + parseInt($stayNights.get(0).value));
                $(objTo).val(this.calendar.toStringFromComp(dt1.getDate(),dt1.getMonth()+1,dt1.getFullYear()));
            }
        },
        update: function (objFrom, objTo, c, greyOutPreviousDays, defaultLengthOfStay) {
            var $objFrom = $(objFrom);
            var $objTo = $(objTo);
            var dt1 = this.calendar.getDateFromString($objFrom.val());
            var dt2 = this.calendar.getDateFromString($objTo.val());
            var $stayNights = $("#"+objFrom.id+"-stay-nights");
            c = $objFrom.attr('data-min-booking-length') || $objFrom.closest('[data-control="datepicker"]').attr('data-min-range-length') || 0;

            // No prefill if the return date is already set or no default value given
            if (!defaultLengthOfStay || isNaN(parseInt(defaultLengthOfStay)) || dt2) {
                defaultLengthOfStay = 0;
            }

            this.updateDayName(objFrom,dt1);
            this.updateDayName(objTo,dt2);

            // Update number of nights - AB Test
            if(dt1 && dt2)
            {
                this.updateNumberOfNights(dt1,dt2);
            }

            if (dt1)
            {
                //set the correct number of nights from the drop down
                if (dt2 && $stayNights.length != 0) {
                    var nights = Math.round((dt2-dt1)/1000/60/60/24);
                    if (nights < 1) nights = $stayNights.get(0).value;
                    $stayNights.get(0).value = nights;
                }

                // The return date will be prefilled with the given default offset or the minimum if no default given
                var returnDateOffset = Math.max(c, defaultLengthOfStay);
                dt1 = new Date(dt1.valueOf() + 1000 * 3600 * 24 * returnDateOffset);
                var dt1Value = this.calendar.toStringFromComp(dt1.getDate(),dt1.getMonth()+1,dt1.getFullYear());

                if (dt2 && dt2 <= dt1) dt2 = null;
                //if the return date  is earlier than departure date fill in the inputfield value
                if (null==dt2 && ($objTo.attr('data-optional') != "true" || $objTo.val() != "")){
                    // Update number of nights - AB Test
                    dt2 = this.calendar.getDateFromString($objFrom.val());
                    this.updateNumberOfNights(dt2,dt1);

                    //if the nights dropdown is set to more than 1 then the checkout date will be corrected
                    if ($stayNights.length != 0 && $stayNights.get(0).value != 1) {
                        dt1.setDate(dt1.getDate() + parseInt($stayNights.get(0).value)-1);
                        var dt1Value = this.calendar.toStringFromComp(dt1.getDate(),dt1.getMonth()+1,dt1.getFullYear());
                    }

                    if (dt1Value != $objTo.val()) {
                        $objTo.val(dt1Value);
                        $objTo.blur();
                    }
                    if(exp.core.date.datePicker){
                        exp.core.date.datePicker.entries[$objTo.attr('id')].currentValue = dt1;
                    }

                    this.updateDayName(objTo,dt1);
                }
            }
            if($objFrom.is('.fieldDefaultText')) {
                $objFrom.removeClass('fieldDefaultText');
            }
            if($objTo.is('.fieldDefaultText')) {
                $objTo.removeClass('fieldDefaultText');
            }


            //the following functions check whether the placeholder polyfill is being used if it is it checks if
            //the input is in a placeholder state or not and updates the class on the input accordingly.
            if (typeof uitk !== "undefined") {
                uitk.updatePlaceholderClass($objFrom);
                uitk.updatePlaceholderClass($objTo);
            }
        }
    }
    return DateUpdater;
}


exp.core.date.CalendarControl = function (){
    var date = function ()
    {
        var m_fmt = 'mmddyy';
        var m_sep = '/';
        var m_sow = 0;
        var m_months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var m_singleMonths = ['JAN','FEV','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
        var m_dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        var m_dayAbbrs = ['S','M','T','W','T','F','S'];
        var m_closeText = 'Close';
        var m_locale = '';
        var m_nightText = ['night', 'nights'];

        var setNightTextConfig = function (nightText)
        {
            m_nightText = nightText;
        };

        var setFormatConfig = function (fmt, sep)
        {
            m_fmt = fmt;
            m_sep = sep;
        };

        var setUnitConfig = function (sow, months, dayAbbrs, dayNames)
        {
            m_sow = sow;
            m_months = months;
            m_dayAbbrs = dayAbbrs;
            if (dayNames != undefined) {
                m_dayNames = dayNames;
            }
        };

        var setSingleUnitConfig = function (sow, months, dayAbbrs)
        {
            m_sow = sow;
            m_singleMonths = months;
            m_dayAbbrs = dayAbbrs;
        };

        var setTextConfig = function (closeText)
        {
            m_closeText = closeText;
        };

        var setLocaleConfig = function (locale)
        {
            m_locale = locale;
        };

        return {
            setFormatConfig: setFormatConfig,
            setUnitConfig: setUnitConfig,
            setSingleUnitConfig: setSingleUnitConfig,
            setTextConfig: setTextConfig,
            setLocaleConfig: setLocaleConfig,
            setNightTextConfig: setNightTextConfig,
            getDateFormat: function () {return m_fmt;},
            getDateSeparator: function () {return m_sep;},
            getStartOfWeek: function () {return m_sow;},
            getMonths: function () {return m_months;},
            getSingleMonths: function () {return m_singleMonths;},
            getDayAbbrs: function () {return m_dayAbbrs;},
            getDayNames: function () {return m_dayNames;},
            getCloseText: function () {return m_closeText;},
            getLocaleConfig: function () {return m_locale;},
            getNightTextConfig: function () {return m_nightText;}
        };
    }
    return {Config: new date('ddmmyy', '.', 2)};
}();

/* global window, dctk, Modernizr */

define('gc/core', [
  'gc/dataModels',
  'gc/preferredAirlines',
  'gc/Submit',
  'gc/wizardActionBinder',
  'gc/localStorage',
  'gc/importedState',
  'gc/searchExperiments',
  'handlebars.runtime',
  'gc/typeaheadConfig',
  'gc/abTest',
  'gc/getLob',
  'gc/conf',
  'gc/errorLogging',
  'gc/perfLogging',
  'uitk',
  'jquery'
], function(
  dataModels,
  preferredAirlines,
  Submit,
  wizardActionBinder,
  localStorage,
  importedState,
  searchExperiments,
  Handlebars,
  typeaheadConfig,
  abTest,
  getLob,
  conf,
  errorLogging,
  perfLogging,
  uitk,
  $
){
  function initCal(config) {
    try {
      var datePickerCalConfig = exp.core.date.CalendarControl.Config;
      datePickerCalConfig.setFormatConfig(config.get('calendar.format.date'), config.get('calendar.format.delimiter'));
      datePickerCalConfig.setUnitConfig(config.get('calendar.unit.sow'), config.get('calendar.unit.month'), config.get('calendar.unit.day'), config.get('calendar.unit.dayNames'));
      datePickerCalConfig.getSingleMonths(config.get('calendar.unit.sow'), config.get('calendar.unit.singleMonths'), config.get('calendar.unit.day'));
      datePickerCalConfig.setTextConfig(config.get('calendar.text.close'));
      datePickerCalConfig.setNightTextConfig(config.get('calendar.text.nights'));

      uitk.datePickerCalendarObj  = exp.core.date.Calendar(datePickerCalConfig);
      uitk.dateUpdater = exp.core.date.DateUpdater(uitk.datePickerCalendarObj , datePickerCalConfig);
    } catch (e) {
      errorLogging.logError(e, 'wizard', 'gc/core', 'initCal');
    }
  }

  shiftFocus = function(element, delay) {
    window.setTimeout(
      function() {element.focus();},
      delay || 0
    );
  }//shiftFocus

  return {
    dataModels: dataModels,
    init : function() {
      try {
        this.$wizardWrapper = $('div[data-wizard-action=search-wrapper]');
        this.$wizardFormWrapper = $('div[data-wizard-action=form-wrapper]');
        $('#WizardHero').addClass('core-wizard-loaded').attr('role', 'main');
        dataModels.update(conf);

        dataModels.state.set(importedState.importData(), {silent: true});

        this.setSelectValues();
        this.bindStateChangeEvents(dataModels.state);
        dataModels.state.on('reloadWizard', _.bind(this.reloadWizard,this));

        //Reset the state attributes related to Typeahead once the wizard is initialized
        searchExperiments.resetTypeaheadState(dataModels.state);

        this.reloadWizard();

        return this;
      } catch (e) {
        errorLogging.logError(e, 'wizard', 'gc/core', 'init');
      }
    },//init

    setSelectValues : function() { // changes display of select elements to match data-select-value
      $("select[data-select-value]").each(function(){
        if ($(this).find("option[value='" + $(this).attr("data-select-value") + "']").length) { // if the data-select-value set exists as an option...
          $(this).val($(this).attr("data-select-value")); // set the current value to it
        }
      });
    },//setSelectValues

    hideDropdown : function() { // force hiding of pop-up dropdown
      $(".DropDownCon").hide();
    },

    hideCalendars : function() { // force hiding of pop-up calendars
      $(".uitk-tooltip.theme-calendar").hide();
      if (abTest.get(6655).value == 1) $(".uitk-tooltip.theme-calendar-button").hide();
    },//hideCalendars

    // Wizard renders before UITK loads
    // But we need to wire up events after UITK loads
    // This function is called once the UITK loads
    uitkLoaded : function(uitk) {
      try {
        // set up all wizard events
        this.subscribeEvents.call(this, dataModels.state);
        this.bindEvents.call(this);
        wizardActionBinder.bindActions(this.$wizardWrapper, dataModels.state);

        // wire up search button onclick
        $('#new-homepage-search-wizard').on(uitk.clickEvent, 'button[type=submit]', _.bind(function(e) {
          e.preventDefault();
          wizardActionBinder.bindOpenSearchSubmitAction(this.$wizardWrapper, dataModels.state);
          this.submit();
        }, this));

        // set up media quierys
        uitk.mediaquery.register('(min-width: 320px) and (max-width: 491px)', 'wizard-not-desktop');
        uitk.mediaquery.register('(min-width: 492px)', 'wizard-min-desktop');

        preferredAirlines.setPreferredAirlines();
        dataModels.state.set('isInitialized', true);
        dataModels.state.set('initConfigDone', true);

        // setup typeahead and calendar
        Typeahead.init(typeaheadConfig);
        initCal(dataModels.config);

        // Hotel Specific wiring
        $("body").on(uitk.clickEvent, ".cal a", function(e) {
          'use strict';
          corewizard.helpers.unCheckNoDates();
        });

        $("body").on("keypress", "#hotel .check-in-out", function(e) {
          'use strict';
          corewizard.helpers.unCheckNoDates();
        });

        //and trigger change to run the above once on page load in case checkbox is pre-checked
        $('[data-wizard-type="noDate"]').trigger('change');

        uitk.subscribe('calendar.selectDate', function(topic, data){
          'use strict';
          if (!(window.isTablet && site_id == 1)) { // MAIN-124644
            if (corewizard.helpers.elementIsHotelDepartingField(data.element)) {
              corewizard.helpers.openCalendarField('endDate');
            }
          }
        });

        uitk.subscribe('corewizard.state.update.packages.flight:packages.hotel:packages.car', function(topic, data) {
          uitk.publish("corewizard.state.update.changeTab", {'field':$('#tab-package-tab')});
        });
      } catch (e) {
        errorLogging.logError(e, 'wizard', 'gc/core', 'uitkLoaded');
      }
    },

    writeHtmlToContainer : function(container, html) {
      if ($('html').hasClass('ie8')) {
        container.html(html);
      } else {
        if (!this.contentNode) {
          container.html(html);
          this.contentNode = container.children()[0];
          if(window.requestAnimationFrame) {
            window.requestAnimationFrame(perfLogging.responseToPaint);
          }
        } else {
          morphdom(this.contentNode, html);
        }
      }
    },

    reloadWizard : function(state, key) {
      try {
        //For instances where packages and tab change, don't double render!
        if (dataModels.state.hasChanged('packages') && dataModels.state.hasChanged('tab') && key === 'tab') {
          return;
        }
        if (dataModels.state.hasChanged('packages') || dataModels.state.hasChanged('tab')) {
          dataModels.state.set('validation', {});
        }
        var lobToLoad = dataModels.model.get('config.template');
        if (typeof lobToLoad === 'function') lobToLoad = lobToLoad(dataModels.model);

        if (!lobToLoad) {
          window.console &&
          console.warn &&
          console.warn('LOB template name is not defined. Check config for LOB.');
          return false;
        } else if (!Handlebars.partials[lobToLoad]) {
          window.console &&
          console.error &&
          console.error('Template named "' + lobToLoad + '" does not exist. Check LOB\'s config.template');
          return false;
        } else {
          //render the wizard.
          var context = dataModels.viewModel.toJSON();
          this.writeHtmlToContainer(this.$wizardWrapper, Handlebars.partials['corewizard/layouts/wizard-hbs'](context));
          if (typeof uitk !== 'undefined') {
            uitk.publish('corewizard.wizardReloaded');
          }
        }

        this.$wizardFormWrapper = $('div[data-wizard-action=form-wrapper]');
        this.handleKeyBoardFocus();
        this.hideCalendars();
        this.hideDropdown();
        this.setSelectValues();
        this.updateErrorLinks(context);
        if (typeof uitk !== 'undefined' && uitk.initCalendarInputs) {
          uitk.prepFields();
          this.setNumberOfHotelNights();
          this.setTabStateOnWizardContainer();
          //MAIN-123105 AB 5423 Event used by loyalty to show/hide hotel coupon msg
          uitk.publish("corewizard.tabsReloaded", getLob(dataModels.model.get('tab'), dataModels.model.get('packages')));
          uitk.mediaquery.register('(min-width: 320px) and (max-width: 491px)', 'wizard-not-desktop');
          uitk.mediaquery.register('(min-width: 492px)', 'wizard-min-desktop');
        }
      } catch (e) {
        errorLogging.logError(e, 'wizard', 'gc/core', 'reloadWizard');
      }
    },

    updateErrorLinks : function(context) {
      var $elError = $('.alert-error.validation-alert');
      if (! $elError) return;

      function linkDateErrorMessage(errorClass, startId, endId) {
        el = $(errorClass);
        if (el) {
          if ($(startId).hasClass('error')) el.attr('href', startId);
          else el.attr('href', endId);
        }
      }
      function linkErrorMessage(errorClass, field, isId) {
        el = $(errorClass);
        if (el) {
          var id = (isId) ? field : '#' + $(field).attr('id');
          el.attr('href', id);
        }
      }
      function setErrorMessageClickToFocus($elError) {
        $elError.find('ul > li > a').on('click', function(e) {
          e.preventDefault();
          var $target = $($(this).attr('href'));
          setTimeout(function() {
            $target.select();
            uitk.utils.focusElement($target);
          });
        });
      }

      var tab = context.tab;
      var el;
      if (tab == 'flight') {
        linkDateErrorMessage('.dateBlank', '#flight-departing', '#flight-returning');
        linkDateErrorMessage('.partialStayDatesOutOfRange', '#flight-hotel-checkin','#flight-hotel-checkout');
        linkErrorMessage('.numberOfTravellersMessage', '[data-wizard-owner=adults].error:first');
        linkErrorMessage('.childAgeMessage', '.children-fieldset select.error:first');
        linkErrorMessage('.multiDestDateError', '.calendar.departing.invalid:first input');
      }
      else if (tab == 'hotel') {
        linkDateErrorMessage('.dateBlank', '#hotel-checkin', '#hotel-checkout');
        linkErrorMessage('.numberOfTravellersMessage', '[data-wizard-owner=adults].error:first');
        linkErrorMessage('.childAgeMessage', '.children-fieldset select.error:first');
      }
      else if (tab == 'package') {
        linkDateErrorMessage('.partialStayDatesOutOfRange', '#package-checkin','#package-checkout');
        linkErrorMessage('.numberOfTravellersMessage', '[data-wizard-owner=adults].error:first');
        linkErrorMessage('.childAgeMessage', '.children-fieldset select.error:first');
      }
      else if (tab == 'car') {
        linkErrorMessage('.destinationError', '#car-pickup', true);
        linkDateErrorMessage('.dateBlank', '#car-pickup-date', '#car-dropoff-date');
      }
      else if (tab == 'activity') {
        linkDateErrorMessage('.dateBlank', '#activity-start', '#activity-end');
      }

      // fix accessibility out of focus issue
      setErrorMessageClickToFocus($elError);
    },

    trackLobClick: function (state) {
      var lob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

      var lobOmnitureMap = {
        'flight'          : 'HP.RB.FLIGHT',
        'hotel'           : 'HP.RB.HOTEL',
        'domesticHotel'   : 'HP.RB.DOMESTIC.HOTEL',
        'overseaHotel'    : 'HP.RB.OVERSEA.HOTEL',
        'flightHotel'     : 'HP.RB.FLIGHT:HOTEL',
        'flightHotelCar'  : 'HP.RB.FLIGHT:HOTEL:CAR',
        'flightCar'       : 'HP.RB.FLIGHT:CAR',
        'hotelCar'        : 'HP.RB.HOTEL:CAR',
        'car'             : 'HP.RB.CAR',
        'activity'        : 'HP.RB.LX',
        'cruise'          : 'HP.RB.CRUISE',
        'threePP'         : 'HP.RB.3P.FLIGHT:HOTEL',
        'buses'           : 'HP.RB.RedBus',
        'rentalCars'      : 'HP.RB.RENTAL:CAR',
        'airportRides'    : 'HP.RB.AIRPORT:RIDE ',
        'lxThingsTodo'    : 'HP.RB:LXTHINGSTODO',
        'lxAirportRides':   'HP.RB:LXAIRPORTRIDE',
        'vacationRentals' : 'HP.RB.VACATIONRENTAL',
        'openSearch'      : 'HP.RB.OPENSEARCH'
      };

      if (window.dctk && dctk.onReady) {
        dctk.onReady(function () {
          dctk.trackEvent('o', 'RFRR Action Link', { prop16: lobOmnitureMap[lob], eVar28: lobOmnitureMap[lob] });
        });
      }
    },

    trackLobClickDelayed: function() {
      setTimeout(_.bind(this.trackLobClick, this), 0);
    },

    handleKeyBoardFocus: function (model) {
      if (typeof uitk !== 'undefined') {
        var model = dataModels.model,
          tab = model.get('tab'),
          lastActiveElementId = dataModels.state._previousAttributes.activeElement,
          $lastActiveElement = $('#' + lastActiveElementId);

        if ($lastActiveElement.is('a')) {
          var activeElementHref = $lastActiveElement.attr('href');

          if (!$lastActiveElement.hasClass('open')) {
            uitk.utils.focusElement($lastActiveElement);
          } else {
            uitk.utils.focusElement($(activeElementHref.substring(activeElementHref.indexOf('#'))));
          }
        }

        if($('select' + lastActiveElementId)) {
          uitk.utils.focusElement($lastActiveElement);
        }

        if ( $lastActiveElement.attr('data-package-wrapper') ) {
          var packageWrapper = $lastActiveElement.attr('data-package-wrapper');
          uitk.utils.focusElement($lastActiveElement);
        }

      }

    },

    setTabStateOnWizardContainer : function() {
      var activeTab = getLob(dataModels.model.get('tab'), dataModels.model.get('packages')),
        wizardContainer = document.getElementById('new-homepage-search-wizard');
      $(wizardContainer).attr('data-active-tab', activeTab + '-tab-active');
    },//setTabStateOnWizardContainer

    tabOverrideLinksStopPropagation : function() {
      if (typeof corewizard.masterconfig.tabOverrideLinks == 'undefined') return;
      var lobs = _.keys(corewizard.masterconfig.tabOverrideLinks);
      $.each(lobs, function(index, value) {
        $("#tab-"+value+"-tab").click(function(e){
          e.stopPropagation();
        });
      });
    }, //tabOverrideLinksStopPropagation

    setNumberOfHotelNights: function(model) {
      var model = dataModels.model,
      hotelStartDate = model.get('startDate'),
      hotelEndDate = model.get('endDate')||'',
      dateDifference,
      daysToNights;

      if (hotelStartDate) {
        hotelStartDate = new XDate(hotelStartDate),
          hotelEndDate = new XDate(hotelEndDate),
          dateDifference = hotelStartDate.diffDays(hotelEndDate),
          daysToNights = dateDifference - 1;
        dataModels.state.set('hotelLengthOfStay', daysToNights);
      }
    },

    subscribeEvents : function() {
      $('#tab-package-tab').parent().hover(
        function() {
          if (!$('#tab-package-tab').hasClass('on')) {
            $('#pkg-tab-radio-btns').addClass('hover');
            $('#tab-package-tab').addClass('hover');
          }
        },
        function() {
          $('#pkg-tab-radio-btns').removeClass('hover');
          $('#tab-package-tab').removeClass('hover');
        }
      );
      $('#tab-package-tab').parent().click(
        function() {
          $('#pkg-tab-radio-btns').removeClass('hover');
          $('#tab-package-tab').removeClass('hover');
        }
      );
      this.tabOverrideLinksStopPropagation();

      $("body").on("change", "#car-pickup", _.bind(function() {
        dataModels.state.set('carSearchType', 4);
        //If pickup searchTerm changed, then remove searchParameters
        dataModels.state.set('originRegionId', null);
        dataModels.state.set('originLatitude', null);
        dataModels.state.set('originLongitude', null);
      }, this));

      $("body").on("change", "#car-dropoff", _.bind(function() {
        //If dropoff searchTerm changed, then remove searchParameters
        dataModels.state.set('destinationRegionId', null);
        dataModels.state.set('destinationLatitude', null);
        dataModels.state.set('destinationLongitude', null);
      }, this));


      dataModels.state.on('change:origin', function(state) {
        var model = dataModels.model;
        var value = model.get('origin');
        if (model.get('originFromFlightTA') && model.get('originFromFlightTA') != $.trim(value)) {
          state.set('originTLA', null);
          state.set('originFromFlightTA', null);
          state.set('OMOriginTA', false);
        }
        if (model.get('originFromTA') && (model.get('originFromTA') != $.trim(model.get('origin')))) {
          state.set('originTLA', null);
          state.set('originFromTA', null);
          state.set('OMOriginTA', false);
        }
      }, this);

      dataModels.state.on('change:destination', function(state) {

        var model = dataModels.model;
        var value = model.get('destination');

        if (model.get('OMDestinationTACompare') && model.get('OMDestinationTACompare') != $.trim(model.get('destination'))) {
          //null out TA
          state.set('OMDestinationTA', false);
        }

        state.set('regionName', null);
        if (!model.get('destinationFromTA') || (model.get('destinationFromTA') && model.get('destinationFromTA') != $.trim(model.get('destination')))) {
          state.set('destinationTLA', null);
          state.set('hotelId', null);
          state.set('multiCityRegion', null);
          state.set('regionId', null);
          state.set('latLong', null);
          state.set('destinationFromTA', null);
          state.set('OMDestinationTA', false);
          state.set('TASearchType', null);
        }
        if (model.get('originFromTA') && model.get('originFromTA') != $.trim(model.get('origin'))) {
          state.set('originTLA', null);
          state.set('originFromTA', null);
          state.set('OMOriginTA', false);
        }
      }, this);
    },//subscribeEvents

    bindEvents : function() {

      function clearField(fieldtype, flighttype, target, tab){
        fieldtype = fieldtype.toLowerCase();
        flighttype = flighttype.toLowerCase();
        target = target.toLowerCase();
        tab = tab.toLowerCase();
        function setNormalState(){
          dataModels.state.set(fieldtype,'');
          dataModels.state.set(fieldtype + 'FromTA','');
          dataModels.state.set(fieldtype + 'TLA','');
          if(flighttype === 'origin') dataModels.state.set('userTypedQuery','');
        }
        function setMultidestState(){
          var currentMultidest = dataModels.state.get('multiDest'),
              indexToRemove = parseInt(target.match(/\d/g)) - 2,
              newMultidestOrigin = [],
              newMultidestDestination = [];
          _.each(currentMultidest.origin, function (origin, index) {
            newMultidestOrigin[index] = origin;
          });
          _.each(currentMultidest.destination, function (destination, index) {
            newMultidestDestination[index] = destination;
          });
          if(fieldtype === 'origin'){
            newMultidestOrigin.splice(indexToRemove,1,'');
            dataModels.state.set('multiDest.origin' , newMultidestOrigin);
          }else if(fieldtype === 'destination'){
            newMultidestDestination.splice(indexToRemove,1,'');
            dataModels.state.set('multiDest.destination' , newMultidestDestination);
          }
        }
        if(tab != "flight"){
          return setNormalState();
        }
        if(flighttype === 'roundtrip' || flighttype === 'oneway') setNormalState();
        else if(flighttype === 'multi'){
          if(target === 'flight-origin' || target === 'flight-destination') setNormalState();
          else setMultidestState();
        }
      }

      this.$wizardWrapper.on(uitk.clickEvent, ".icon-close", _.bind(function(e) {
        var target      = $(e.currentTarget).parent().children('label').children('input').attr('id'),
            flighttype  = dataModels.model.get('flighttype'),
            tab         = dataModels.model.get('tab');
        if(target.indexOf('origin')>-1){
          clearField('origin', flighttype, target, tab);
        }else if(target.indexOf('car-pickup')>-1){
          dataModels.state.set('TASearchType','');
          dataModels.state.set('tla','');
          dataModels.state.set('carSearchType','');
          dataModels.state.set('carPickupValueFromTA','');
          dataModels.state.set('originRegionId','');
          dataModels.state.set('originLatitude','');
          dataModels.state.set('originLongitude','');
          dataModels.state.set('selectedTASuggestionPosition','');
          dataModels.state.set('destination','');
          dataModels.state.set('destinationFromTA','');
          dataModels.state.set('destinationTLA','');
        }else if(target.indexOf('car-dropoff')>-1){
          dataModels.state.set('destinationRegionId','');
          dataModels.state.set('destinationLatitude','');
          dataModels.state.set('destinationLongitude','');
          dataModels.state.set('TASearchType','');
          dataModels.state.set('carDropoffValueFromTA','');
          dataModels.state.set('selectedTASuggestionPosition','');
          dataModels.state.set('carReturn','');
        }else{
          clearField('destination', flighttype, target, tab);
        }
        this.reloadWizard();
      }, this));

      this.$wizardWrapper.on(uitk.clickEvent, '[data-wizard-action]', _.bind(function(e) {
        var target = $(e.target).attr('id');
        dataModels.state.set('activeElement', target);

        if($(e.target).val().length>0){
          $(e.target).parent().parent().children(".icon-close").removeClass("visuallyhidden");
        }
      }, this));

      //this.$wizardFormWrapper.on("keypress", function(e) {
      //  if (e.which === 13) {
      //    this.$wizardFormWrapper.find('input').each(function(index, element) {
      //      this.applyStateChangeToField($(element));
      //    });
      //    this.reloadTab();
      //    this.submit();
      //  }
      //});

      // re-initialize tooltip trigger event for help icons rendered within handlebars templates.
      this.$wizardWrapper.on(uitk.clickEvent, "[data-control=tooltip]", function(e) {
        $(this).uitk_tooltip('show');
      });

      // placeholder polyfill interferes with styling
      $('html.no-placeholder').find(this.$wizardFormWrapper).on('change', 'input[type=text]', function() {
        if ($(this).val() === "" ) {
          $(this).val($(this).attr("placeholder"));
          $(this).addClass("placeholderspolyfill").removeClass('updated');
        }
      });

      // The fix for the Accessibility bug WCAG-956 and WCAG-922 -- IE specific
      if ((window.navigator.userAgent.indexOf('MSIE ') > -1) || (window.navigator.userAgent.indexOf('Trident/') > -1)) {
        this.$wizardWrapper.on("keydown", '.calendar.departing input, .calendar.checkin input', function(e) {
          if (e.which === 9 && e.shiftKey == false) {
            e.preventDefault();
            var next = $(this).attr("data-end-date") || '#flight-adults';
            $(next).focus().select();
          }
        });
      }

      $(".site-content-wrap").on("focus", ".hero-form input", function() {
        var $this = $(this);

        //IE needs a timeout to select the text on focus
        if ($('html').hasClass('lt-ie10') || $('html').hasClass('ie10')) {
          //but it interferes with the uitk calendar widget
          if ($(this).data('control') !== 'calendar' ) {
            setTimeout(function() {
              $this.select();
            }, 0);
          }

        } else {
          $this.select();
        }


        // Fix issue where typeahead is re-triggered on input focus on mobile devices
        if(Modernizr.touch) {
          $(".uitk-tooltip.theme-typeahead").hide();
        }
        // Work around Chrome's little problem
        $this.mouseup(function() {
          // Prevent further mouseup intervention
          $this.unbind("mouseup");
          return false;
        });
      });
    },//bindEvents

    bindStateChangeEvents: function() {
      var self = this;
      function bindSingleEvent(key, value) {
        if (_.isString(value)) {
          var fn,
            scope = self,
            scopeSplit = value.split('.');
          //support for strings representing scoped functions.
          _.each(scopeSplit, function(value, i) {
            scope = scope[scopeSplit[i]];
            if (scope == undefined) return;
          });
          //if the scoped function exists, use this for binding.
          if (scope) fn = scope;
        } else if (_.isFunction(value)) {
          //support for function literals or anonymous functions.
          fn = value;
        }
        if (_.isFunction(fn)) {
          if (key === 'tab' || key === 'packages') {
            //need to add an argument to reloadWizard to check
            //for double rendering.
            dataModels.state.on('change:' + key, function (argument) {
              fn.call(self, argument, key);
            }, this);
          } else {
            dataModels.state.on('change:' + key, fn, this);
          }
        }
      }

      _.each(dataModels.config.get('events'), function (value, key) {
        //string support so you can define the binding before the function if necessary
        if (_.isArray(value)) {
          _.each(value, function(v) {
            bindSingleEvent.call(this, key, v);
          }, this);
        } else {
          bindSingleEvent.call(this, key, value);
        }

      }, this);
    },

    submit: function() {
      Submit.submit(dataModels.model);
      localStorage.saveLocalStorage(localStorage.localStorageKey, dataModels.model.toJSON());
    }
  }
});

define('gc/wizard-api', [
  'gc/confFun',
  'gc/Config',
  'gc/core',
  'gc/dataModels',
  'gc/defaultConfig',
  'gc/wizardConfigFun'
], function(
  confFun,
  Config,
  core,
  dataModels,
  defaultConfig,
  wizardConfigFun
){
  /**
   * Defines public APIs that can be called on the wizard.
   * @exports gc/wizard-api
   */
  return {
    /**
     * Updates the page level config on the wizard, clears the state and re-renders it.
     * @param {Object} pageConfig - The new config to initialize the wizard with.
     */
    reInit : function(pageConfig) {
      var conf = confFun(wizardConfigFun(pageConfig), defaultConfig);

      core.dataModels = core.dataModels.update(conf);

      core.reloadWizard();
    },
    /**
     * Sets the update object on the state.
     * @param {Object} update - An object with properties to update on the state.
     */
    updateState : function(update) {
      core.dataModels.state.set(update);
    },
    /**
     * Calls the callback and passes the model to it when a property on the state is updated.
     * @param {String} property - The name of the property to listen to.
     * @param {Function} callback - Is called with the model as the parameter.
     */
    onStateChange: function(property, callback) {
      dataModels.state.on('change:' + property, function() {
        try {
          callback(dataModels.model.toJSON());
        } catch (e) {}
      });
    },

    /**
     * Returns the Wizard Model
     */
    getModel: function() {
      return dataModels.model.toJSON();
    }
  }
});

define('gc/predicates', ['xdate'], function(XDate) {
  return {
    isNotBlank: function (field) {
      var isValid = (typeof field == 'string') && (field.length > 0);
      return {isValid: isValid};
    },

    isOriginDiffrentFromDestination: function (origin, destination) {
      var isValid = (this.isNotBlank(origin) || this.isNotBlank(destination)) ?
        origin !== destination :
        false;
      return {isValid: isValid};
    },

    isValidDate: function (date) {
      var isValid = (date != null && typeof date != "undefined") && (new XDate(date)[0].toString() !== "Invalid Date");
      return {isValid: isValid};
    },

    isValidDateOrBlank: function(date) {
      var isNotBlank = this.isNotBlank(date),
          isValidDate = this.isValidDate(date),
          isValid = (!isNotBlank.isValid || isValidDate.isValid);

      return {isValid: isValid};
    },

    isDateBeforeMaxDate: function (date, maxDate) {
      date = new XDate(date);
      maxDate = new XDate(maxDate);
      var isValid = date.diffDays(maxDate) > 0;
      return {isValid: isValid};
    },

    isPartialDateTest: function (firstDate, secondDate) {
      var firstXDate = new XDate(firstDate);
      var secondXDate = new XDate(secondDate);

      //ensure dates are valid before comparing.
      for (var i = 0; i < arguments.length; i++) {
        if (!this.isNotBlank(arguments[i])) return {isValid: true};
        if (!this.isValidDate(arguments[i])) return {isValid: true};
      }

      var isValid = firstXDate.diffDays(secondXDate) >= 0;
      return {isValid: isValid};
    },

    isPartialDateWithinRange: function (date, startDate, endDate) {
      var dateX = new XDate(date),
      startXDate = new XDate(startDate),
      endXDate = new XDate(endDate);
      //ensure dates are valid before comparing.
      for (var i = 0; i < arguments.length; i++) {
        if (!this.isNotBlank(arguments[i])) return {valid: true};
        if (!this.isValidDate(arguments[i])) return {valid: true};
      }
      var isValid = (startXDate.diffDays(dateX) >= 0) &&
                  (dateX.diffDays(endXDate) >= 0);

      return {isValid: isValid};
    },

    isDateBeforeMaxDaysOut: function (date, days) {
      var maxDate = new XDate();
      maxDate.addDays(days);
      return this.isDateBeforeMaxDate(date, maxDate);
    },

    isStartDateBeforeEndDate: function (startDate, endDate, minLength) {
      startDate = new XDate(startDate);
      endDate = new XDate(endDate);
      var isValid = (startDate.valid() && endDate.valid()) ?
        (startDate.diffDays(endDate) >= minLength) :
        true;
      return {isValid: isValid};
    },

    isDateAfterCurrentDate: function (date) {
      date = new XDate(date);
      var isValid = (XDate.today().diffDays(date) > 0);
      return {isValid: isValid};
    },

    isDatePriorToCurrentDate: function (date) {
      date = new XDate(date);
      var isValid = (XDate.today().diffDays(date) > -1);
      return {isValid: isValid};
    },

    isDateAfterCurrentDateOrBlank: function (date) {
      var isNotBlank = this.isNotBlank(date),
          isDateAfterCurrentDate = this.isDateAfterCurrentDate(date),
          isValid = (!isNotBlank.isValid || isDateAfterCurrentDate.isValid);

      return {isValid: isValid};
    },

    isTripValidLength: function (startDate, endDate, maxLength) {
      startDate = new XDate(startDate);
      endDate = new XDate(endDate);
      var isValid = (startDate.valid() && endDate.valid()) ?
        (startDate.diffDays(endDate) <= maxLength) :
        true;
      return {isValid: isValid};
    },

    isTripWithTimeValidLongEnough: function (startDate, startTime, endDate, endTime, minHours) {
      'use strict';
      if(startDate!=undefined && endDate!=undefined){
        startDate = new XDate(startDate);
        endDate = new XDate(endDate);
        var days = startDate.diffDays(endDate);
        if (days === 0) {
          startTime = _convertStrTimeToMins(startTime);
          endTime = _convertStrTimeToMins(endTime);
          if ((endTime - startTime) < (minHours * 60)) {
            return {isValid: false};
          }
        }
      }
      else{
        return {isValid: false};
      }
      return {isValid: true};
    },

    isValidPickupTime: function (startDate, startTime) {
      'use strict';
      var minHoursFromCurrentTime = 2;
      startDate = new XDate(startDate);
      startDate.addMinutes(_convertStrTimeToMins(startTime));
      var isValid = new XDate().diffHours(startDate) > minHoursFromCurrentTime;
      return {isValid: isValid};
    },

    isTotalTravelersLessThanMax: function (rooms, maxTravelers) {
      var fields = [];
      if (rooms && rooms.length) {
        var count = 0;
        for (var i = 0; i < rooms.length; i++) {
          var room = rooms[i];
          if (room) {
            var adults = parseInt(room.adults, 10);
            if (adults && adults > 0) {
              count += adults;
              fields.push(i + 'a');
            }

            var kids = parseInt(room.childCount, 10);
            if (kids && kids > 0) {
              count += kids;
              fields.push(i + 'c');
            }
          }
        }
        if (count > maxTravelers) {
          return {isValid: false, fields: fields};
        }
      }
      return {isValid: true};
    },

    isChildAlone: function (rooms) {
      if (rooms && rooms.length) {
        for (var i = 0; i < rooms.length; i++) {
          var room = rooms[i];
          var adults = parseInt(room.adults, 10);
          if (adults && adults > 0) {
            return {isValid: false};
          }
        }
      }
      return {isValid: true};
    },

    isChildAccompaniedByAdult: function (rooms) {
      return !this.isChildAlone(rooms);
    },

    isChildAgesAllProvided: function (rooms) {
      'use strict';
      var fields = [];
      var result = true;
      for (var i = 0; i < rooms.length; i++) {
        var room = rooms[i];
        for (var j = 0; j < room.childCount; j++) {
          if (room.children[j] !== 0 && !room.children[j]) {
            fields.push(i + ':' + j);
            result = false;
          }

        }
      }
      return {isValid: result, fields: fields};
    },

    areAllFlightsComplete: function (multiDest) {
      var result = true;
      var fields = [];
      var errors = [];
      for (var i = 0; i < 4; i++) {
        if (this.allFieldsAreEmpty(multiDest.destination[i], multiDest.origin[i], multiDest.startDate[i])) {
          //completely empty multiDest, so skip so that result
          //can't be false for this leg.

        } else {
          _.each(multiDest, function (value, key) {
            if (!value[i]) {
              //we're missing one field, this validation now fails.
              fields.push(key + ':' + (i + 2));
              switch (key) {
                case 'origin' :
                  errors.push('origin-blank');
                  break;
                case 'destination' :
                  errors.push('destination-blank');
                  break;
                case 'startDate' :
                  errors.push('date-blank');
                  break;
              }
              result = false;
            }
          });
        }
      }
      return {isValid: result, fields: fields, errors: errors};
    },

    allFieldsAreEmpty: function () {
      var result = true;
      _.each(arguments, function (argument) {
        if (argument) result = false;
      });
      return {isValid: result};
    },

    areAllDatesValid: function (multiDest, startDate) {
      var result = true;
      var fields = [];
      var errors = [];
      for (var i = 0; i < 4; i++) {
        if (this.allFieldsAreEmpty(multiDest.destination[i], multiDest.origin[i], multiDest.startDate[i]) || !this.isNotBlank(startDate)) {
          //completely empty multiDest, so skip so that result
          //can't be false for this leg.
        } else {
          var previousDate = i < 1 ? startDate : multiDest.startDate[i - 1],
          previousXDate = new XDate(previousDate),
          currentXDate = new XDate(multiDest.startDate[i]);
          if (!this.isNotBlank(multiDest.startDate[i])) {
            //check for valid date
            fields.push('startDate:' + (i + 2));
            errors.push('multi-dest-not-complete');
            result = false;
          } else if (!this.isValidDate(multiDest.startDate[i])) {
            fields.push('startDate:' + (i + 2));
            errors.push('date-format-invalid');
            result = false;
          } else if (currentXDate < previousXDate) {
            fields.push('startDate:' + (i + 2));
            errors.push('date-comes-before-previous');
            result = false;
          }

        }
      }
      return {isValid: result, fields: fields, errors: errors};
    },

    allOriginsAreDifferentFromDestinations: function (multiDest) {
      var result = true;
      var fields = [];
      for (var i = 0; i < 4; i++) {
        if (multiDest.origin[i] && multiDest.origin[i] === multiDest.destination[i]) {
          result = false;
          fields.push('origin:' + (i + 2));
          fields.push('destination:' + (i + 2));
        }
      }
      return {isValid: result, fields: fields};
    },

    areAllDatesValidOrBlank: function (startDate, endDate) {
      var isStartDateNotBlank = this.isNotBlank(startDate),
          isEndDateNotBlank = this.isNotBlank(endDate),
          isValidStartDate = this.isValidDate(startDate),
          isValidEndDate = this.isValidDate(endDate),
          isValid = (!isStartDateNotBlank.isValid && !isEndDateNotBlank.isValid) || (isValidStartDate.isValid && isValidEndDate.isValid);

      return {isValid: isValid};
    }
  };

  function _convertStrTimeToMins(time) {
    var pm = time.indexOf('PM') > -1;
    var min = parseInt(time.slice(-4, -2));
    var hour = parseInt(time.slice(0, -4));
    hour = (pm && hour != 12) ? hour + 12 : hour;
    return (hour * 60) + min;
  }
});

require(['gc/searchExperiments', 'handlebars.runtime', 'env'], function(searchExperiments, Handlebars, env) {
    var handlebarHelpers = {};
    var imagesPath = getPrefixPath(env) + 'images/';
    var wizardImagesPath = imagesPath + "wizard/";
    
    function getPrefixPath(env){
        var prefixPath = '';
        if (env.version == 'local') {
            prefixPath = "/content/local/";
        } else {
            prefixPath = env.prefix + '/content/' + env.version + '/';
        }
        
        return prefixPath;
    }

    //This returns the adjusted position for each item depending upon where the suggestion is placed in TA
    handlebarHelpers.getItemCount = function (i) {
        return parseInt(i);
    };

    //This function decides the placement of the icon and display text as per experiment variant
    handlebarHelpers.arrangeIconAndText = function (iconHtml, textHtml, rightFloatingTextHtml) {
        var value = iconHtml + textHtml;

        value = '<div class="option-text-primary">' + value + '</div>';
        if (_.isString(rightFloatingTextHtml)) {
            value = '<span class="option-text-secondary">' + rightFloatingTextHtml + '</span>' + value;
        }

        return value;
    };

    //This function defines the span element to be included in the <a> tag of TA suggestions
    handlebarHelpers.makeOption = function (index, icon, d, rightFloatingTextHtml) {
        var iconHtml = '<span data-tid="typeahead-icon'
          + index
          + '"class="icon icon-'
          + icon + ' '
          + '""'
          + '" aria-hidden="true"/>';
        return handlebarHelpers.arrangeIconAndText(iconHtml, d, rightFloatingTextHtml);
    };

    //This Handlebar helper returns corewizard.handlebarHelpers.getItemCount()
    Handlebars.registerHelper('getItemCount', function(i) {
        return handlebarHelpers.getItemCount(i);
    });

    //This Handlebar helper returns corewizard.handlebarHelpers.makeOption()
    Handlebars.registerHelper('makeOption', function(index, icon, d, rightFloatingTextHtml) {
        return handlebarHelpers.makeOption(index, icon, d, rightFloatingTextHtml);
    });

    // FROM https://gist.github.com/3902173
    //
    // HELPER: #each_with_key
    //
    // Usage: {{#each_with_key container key="myKey"}}...{{/each_with_key}}
    //
    // Iterate over an object containing other objects.
    // Each inner object will be used in turn, with an added key ("myKey")
    // set to the value of the inner object's key in the container.
    Handlebars.registerHelper("each_with_key", function (obj, options) {
        var context,
        buffer = "",
        key,
        keyName = options.hash.key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                context = obj[key];
                if (keyName) {
                    context[keyName] = key;
                }
                buffer += options.fn(context);
            }
        }
        return buffer;
    });

    //This Handlebar helper returns the HTML content for a child suggestion for TA where hierarchy is shown
    Handlebars.registerHelper('getChildSuggestionIcon', function (i) {
        var k = parseInt(i);
        return '<span data-tid="typeahead-icon' + k + '" class="icon icon-return" aria-hidden="true"></span>';
    });

    //This Handlebar helper returns corewizard.handlebarHelpers.arrangeIconAndText() with category in the textHtml for cross product suggestions
    Handlebars.registerHelper('makeOptionOpenSearch', function(index, icon, d, category) {
        var iconHtml = '<span data-tid="typeahead-icon'
            + index
            + '"class="icon icon-'
            + icon
            + '" aria-hidden="true"/>';
        var textHtml = d + '<span style="color:#1f1f1f"> - ' + category + '</span>';
        return handlebarHelpers.arrangeIconAndText(iconHtml, textHtml);
    });

    //This Handlebar helper returns just description for Gemma Autosuggest in the textHtml
    Handlebars.registerHelper('makeOptionGemmaSearch', function(index, icon, d) {
        var iconHtml = '<span data-tid="typeahead-icon'
            + index
            + '"class="icon icon-'
            + icon
            + '" aria-hidden="true"/>';
        var textHtml = '<div class="option-text-primary">' + d + '</div>';
        return textHtml;
    });

    //This Handlebar helper sets the showAsHierarchy flag as true for child or nearby TA suggestions in the context
    Handlebars.registerHelper('getShowAsHierarchyFlag', function (context, obj) {
        if (obj && (obj[0] == 'child' || obj[0] == 'nearby')) {
            //Set the flag to show as hierarchy option
            context.showAsHierarchy = true;
        }
    });

    //This Handlebar helper sets the showAsHierarchy flag as true for child or nearby TA suggestions in the context
    Handlebars.registerHelper('showDistanceFromNearbyAirport', function (obj) {
        if (searchExperiments.getVariant("NEARBY_AIRPORT") === 2 && obj) {
            return ". <b>" + parseInt(obj) + " miles</b> away";
        }
    });

    /**
     * Helper to get Scratchpad module loc strings
     * that are in scratchpad-header.tray.js
     */
    Handlebars.registerHelper('scratchpadLoc', function (context) {
        var loc = '';
        try {
            loc = window.Scratchpad.headerTray.locStrings[context];
        } catch (ex) {
        }
        return loc;
    });
});
var corewizard = corewizard || {};

define('gc/importedState', [
  'gc/modelHelpers',
  'gc/localStorage',
  'gc/dataModels',
  'gc/abTest',
  'gc/getLob'
], function(
  modelHelpers,
  localStorage,
  dataModels,
  abTest,
  getLob
) {

  function hasPackage(packages) {
      return packages.flight ||
             packages.hotel ||
             packages.car ||
             packages.train;
  };
  //returns raw data as javascript object
  var rawImportedState = {
    backButtonData: function () {
      var data = $('#back-button-model').val();
      return data ? $.parseJSON(data) : null;
    },

    setBackButtonData: function(model) {
      $('#back-button-model').val(JSON.stringify(model.toJSON()))
    },

    lastSearchData: function () {
      var data = $('#last-search-json-form-values');
      return data.length ? $.parseJSON(data.html()) : null;
    },

    deepLinkData: function () {
      var urlParams = window.location.search.substring(1);
      return deparam(urlParams);
    }
  };

  //takes url params as a string and converts to object
  function deparam(queryString) {
    var match,
      pl = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      urlParams = {};
    while (match = search.exec(queryString)) {
      var value = decode(match[2]);
      if (value === 'false') {
        value = false;
      } else if (parseInt(value)) {
        value = parseInt(value)
      }

      urlParams[decode(match[1])] = value;
    }
    return urlParams;
  }

  var importedState = {
    importData: function () {
      var ignoreLastSearch = dataModels.config.get('ignoreLastSearch');
      if (_.isUndefined(ignoreLastSearch)) {
        ignoreLastSearch = false;
      }

      var data = (!ignoreLastSearch && this.localStorageData()) ||
        this.backButtonData() ||
        (!ignoreLastSearch && this.lastSearchData()) ||
        this.deepLinkData();

      if (lobOverride())
        data = _.extend(data, lobOverride());

      delete data.validation; // remove any previous validation issues

      delete data.uitkVersion; // remove uitk data
      delete data.uitkAccessCal; // remove uitk data

      if (!_.isEmpty(data)) {
        data = this.adjustLob(data);
      }
      data.importedData = true;
      return data;
    },

    adjustLob: function(data) {
      if (data.tab && data.packages) {
        var propsedLob = getLob(data.tab, data.packages);
        var hasLob = _.find(dataModels.config.attributes.wizardconfig.lobs, function(lob) {
          var hasMatchingPackage;
          if (lob.lobs) {
            hasMatchingPackage = _.find(lob.lobs, function(pkg) {
              return propsedLob === pkg.id;
            });
          };
          return propsedLob === lob.id || hasMatchingPackage
        });

        //if the LOB from last search doesn't exist on this tab, use the specifed default.
        if (!hasLob || abTest.get(7846).value === '1') {
          if (hasPackage(dataModels.config.defaultPackages)) {
            data.tab = 'package';
          } else {
            data.packages = {
              flight: false,
              car: false,
              hotel: false,
              train: false
            };
            data.tab = dataModels.config.defaultTab;
          }
          data.packages = dataModels.config.defaultPackages;
        } else {
          if (hasLob.id !== data.tab) {
            data.tab = hasLob.id;
          }
        }
      }

      return data;
      //check to see if this wizard configuration contains the LOB defined
      //by last search
    },


    backButtonData: function () {
      var data = rawImportedState.backButtonData();
      if (!data) return null;

      return _.extend(data, savedStateOverride(data));
    },

    setBackButtonData: function(model) {
      rawImportedState.setBackButtonData(model);
    },

    lastSearchData: function () {
      var data = rawImportedState.lastSearchData();
      if (!data) return null;

      data = _.extend(data, savedStateOverride(data));

      if (abTest.get(5981).value === '1')
        if (isMobile() && data.tab === 'hotel')
          data = _.extend(data, lastSearchMobileOverride());

      return data;
    },

    deepLinkData: function () {
      var data = rawImportedState.deepLinkData();

      if (abTest.get(5981).value === '1')
        if (isMobile())
          data = _.extend(data, deepLinkMobileOverride());

      return data;
    },

    localStorageData: function() {
      return localStorage.getLocalStorage &&
        localStorage.localStorageKey &&
        localStorage.getLocalStorage(localStorage.localStorageKey);
    },

    hasImportData: function() {
      return !_.isEmpty(this.importData());
    }
  };

  function savedStateOverride(savedState) {
    var state = dataModels.state;
    var overrides = {};

    overrides.isChildInLap = savedState.lapSeat === 'lap';

    if (savedState.origin === '()')
      overrides.origin = '';

    if (savedState.departing)
      overrides.startDate = savedState.departing;

    if (savedState.returning)
      overrides.endDate = savedState.returning;

    if (state.get('tab') === 'flight' && state.get('flighttype') === 'oneway')
      overrides.endDate = savedState.departing;

    if (!(state.get('packages.flight') || state.get('packages.hotel'))) {
      overrides.checkin = null;
      overrides.checkout = null;
    }

    overrides = _.extend(overrides, roomsOverride(savedState));

    return overrides;
  }

  function roomsOverride(state) {
    var overrides = {
      roomCount: state.rooms && state.rooms.length ?
        state.rooms.length :
        1,
      rooms: state.rooms && state.rooms.length ?
        state.rooms :
        [{adults: 0, childCount: 0, guests: 0, children: []}]
    };

    _.each(overrides.rooms, function (room) {
      room.childCount = room.children.length;
      room.guests = room.children.length + room.adults;
    });

    return overrides;
  }

  function lastSearchMobileOverride() {
    var checkin = new XDate().toString(dataModel.config.get("dateFormat"));
    var checkout = new XDate().addDays(1).toString(dataModel.config.get("dateFormat"));

    return {
      checkin: checkin,
      checkout: checkout,
      departing: checkin,
      returning: checkout
    };
  }

  function deepLinkMobileOverride() {
    var checkin = new XDate().toString(dataModel.config.get("dateFormat"));
    var checkout = new XDate().addDays(1).toString(dataModel.config.get("dateFormat"));

    return {
      checkin: checkin,
      checkout: checkout,
      startDate: checkin,
      endDate: checkout,
      startDatePrefilled: true,
      endDatePrefilled: true
    };
  }

  function lobOverride() {
    var lobParam = rawImportedState.deepLinkData().lob;
    if (!lobParam) return null;

    var lobOverride = {};

    var packageSettings = dataModel.config.get(lobParam);
    if (packageSettings) {
      lobOverride.packages = {
        flight: packageSettings.packageSetting_flight,
        hotel: packageSettings.packageSetting_hotel,
        car: packageSettings.packageSetting_car
      };
    }

    if (_.contains(_.pluck(dataModels.config.attributes.wizardconfig.lobs, 'id'), lobParam))
      lobOverride.tab = lobParam;

    return lobOverride;
  }

  function isMobile() {
    return window.innerWidth <= 492;
  }

  return importedState;
});

/*********************************************************************************************/
/*                    Start of utility section to make Scratchpad API call                   */
/*********************************************************************************************/
require('jquery', (function($) {
    typeaheadUtilScratchpad = {};

    typeaheadUtilScratchpad.userHistoryEndpoint = '/userHistory/';

    typeaheadUtilScratchpad.lobFilter = {
        'hotel' : 'HOTEL_SEARCH',
        'flight' : 'AIR_SEARCH'
    };

    typeaheadUtilScratchpad.getUserDetails = function() {
        var userDetails = {};
        userDetails.tuid = $('#scratchpad-badge-tuid').attr('data-id') ? $('#scratchpad-badge-tuid').attr('data-id') : '-1';
        userDetails.guid = $('#scratchpad-badge-guid').attr('data-id') ? $('#scratchpad-badge-guid').attr('data-id') : '-1';
        userDetails.expuserid = $('#scratchpad-badge-expuserid').attr('data-id') ? $('#scratchpad-badge-expuserid').attr('data-id') : '-1';

        return userDetails;
    };

    typeaheadUtilScratchpad.scratchpadHistoryData = {};

    typeaheadUtilScratchpad.updateHistoryData = function(data) {
        typeaheadUtilScratchpad.scratchpadHistoryData = data;
    };

    typeaheadUtilScratchpad.userDetails = typeaheadUtilScratchpad.getUserDetails();

    typeaheadUtilScratchpad.getCompleteScratchpadHistoryData = function() {
        return typeaheadUtilScratchpad.scratchpadHistoryData;
    };

    //Util function to filter relevant lob entries from the user history retrieved 
    typeaheadUtilScratchpad.filterLobScratchpadHistory = function(lob) {
        var completeData = typeaheadUtilScratchpad.getCompleteScratchpadHistoryData(),
            filteredData;

        if(completeData && completeData.userhistory.length > 0) {
            filteredData = _.filter(completeData.userhistory, function(lob) {
                // `~` with `indexOf` means "contains"
                //return ~lob.product.indexOf(filterProduct);
                return _.contains(lob, filterProduct);
            });
        }
        else {
            console.log("No user history exists for LOB : "+lob);
        }

    };

      //LOB is only passed when we want to filter the user history in the request. A new request is made. By default lob is undefined 
    typeaheadUtilScratchpad.getCompleteScratchpadHistory = function(lob) {
        //Get the userHistoryUrl from the Scratchpad badge else default to prod
        var userHistoryServiceUrl = $('#scratchpad-badge-url').attr('data-id') ? $('#scratchpad-badge-url').attr('data-id') : 'https://userhistory-web.us-east-1.prod.expedia.com/service'
        var url = userHistoryServiceUrl+typeaheadUtilScratchpad.userHistoryEndpoint;

        url += _.compact([ 
            ( typeaheadUtilScratchpad.userDetails.tuid == -1 ?  'jsonp?guid='+typeaheadUtilScratchpad.userDetails.guid : 'jsonp?tuid='+typeaheadUtilScratchpad.userDetails.tuid ),   
            'expuserid='+typeaheadUtilScratchpad.userDetails.expuserid,
            'siteid='+window.site_id,
            'format=jsonp',
            (typeaheadUtilScratchpad.lobFilter[lob]?'lobs='+typeaheadUtilScratchpad.lobFilter[lob]:'')
        ]).join('&');

        var callback = typeaheadUtilScratchpad.updateHistoryData;

        // All HTML5 properties support CORS.
        if (typeof $ == 'function' && typeof $.ajax == 'function') {
            jqueryAjax('GET', url, 'jsonp', callback);
        }
        else {
            regularAjax('GET', url, 'jsonp', callback);
        }

    }

    //
    typeaheadUtilScratchpad.getCompleteScratchpadHistory();

    /**
     * Utility Function to create the XHR object. CORS request
     */
    function createCORSRequest(methodType, url, dataType) {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        
        if ("withCredentials" in xhr) {
            // XHR for Chrome/Firefox/Opera/Safari.
            xhr.open(methodType, url, true);
        }
        else if (typeof XDomainRequest != "undefined") {
            // XDomainRequest for IE.
            xhr = new XDomainRequest();
            xhr.open(methodType, url);
        }
        else if (typeof ActiveXObject != "undefined") {
            xhr = new ActiveXObject("Microsoft.XMLHTTP");  // code for IE6, IE5
            xhr.open(methodType, url, true);
        }
        else {
            // CORS not supported.
            xhr = null;
        }
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
        xhr.setRequestHeader('Accept', '*/*');
        return xhr;
    }

    /**
     * Function to make the actual CORS request.
     */
    function makeCorsRequest(methodType, url, dataType) {
        var xhr = createCORSRequest(methodType, url, dataType);
        if (!xhr) {
            console.log('CORS not supported');
            return;
        }

        xhr.send();

        // Response handlers.
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 400) {
                    if (xmlhttp.responseText) {
                        var response = xhr.responseText;
                        console.log('Response from CORS request to ' + url + ': ' + response);
                        callback(response);
                    }
                }
                else {
                    console.log('Response returned with non-OK status '+xhr.status);
                    callback(xhr.responseText);
                }
            }
        };

        //  Report errors if they happen
        xhr.onerror = function (e) {
            console.log('Woops, there was an error making the request to '+url);
        };
    }

    //vmohapatra : Utility function to make ajax calls provided a given URL when jquery ajax is not available
    function regularAjax(methodType, url, dataType, callback) {
        makeCorsRequest(methodType, url, dataType, callback);
    }

    //vmohapatra : Utility function to make ajax calls provided a given URL when jquery ajax is available
    function jqueryAjax(methodType, url, dataType, callback) {
        var jqxhr = $.ajax({
            method: methodType,
            dataType: dataType,
            url: url,
            xhrFields: {
                withCredentials: true
            },
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Accept": "*/*"
            },
            error: function (err) {
                console.log("An error occured while getting getting data from the requested URl");
                console.log(err);
                callback(err);
            },
            success: function (response) {
                //console.log("successful jquery ajax");
                //console.log(response);
                callback(response);
            },
            cache: false,
            crossDomain: true
        }).
        complete(function(response){
            //console.log('ajax call complete');
            //console.log(response);
        });
    }
}));
/*********************************************************************************************/
/*                     End of utility section to make Scratchpad API call                    */
/*********************************************************************************************/


// This object contains details about all the search experiments along with the LOBs in which they are to run
// It has the following public API:
//
//     experimentDetails - contains the list of experiments by abacus ID. Meant to be private but exposed for unit tests
//     getAbacusId - helper function to get an abacus ID based on map property such as 'ESS_V4_CARS' or 'TRENDING_NOW'
//     getSearchExperimentVariantIfParticipating - helper method to get the search variant
//     getSearchExperimentVariant - helper method to get the search variant
//     getVariant - gets the variant based on name
//     isOriginField - boolean value true if field is the origin, false if it's the destination aka anything other than origin
//     getFreeSearchTextDetails - function that returns an object with {top:XXX, bottom:YYYY} properties
//     flighttypeChanged - placeholder event handler for flightTypeChanged events
//     parseUrl - converts a string URL into an object with URL info
//     getUserSearchHistory - pulls scratchpad search history data.
//
define('gc/searchExperiments', ['gc/abTest', 'gc/getLob', 'gc/dataModels'],  function (abTest, getLob, dataModels) {
    "use strict";

// polyfill for string.prototype.trim (ES5.1) for IE8 and other old javascript implementations.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}

    var searchExperimentNameIdMapping = {
            TRIGGER_WITH_FEWER_CHARACTERS       : '6739', //1-2 char typeahead trigger experiment
            AUTO_HIGHLIGHT_TOP_OPTION           : '7198', //automatically highlight the top Typeahead suggestion
            NEARBY_AIRPORT                      : '8075', //Show nearby airport in typeahead suggestions
            CAR_RENTAL                          : '8206', //Show Car rental locations in typeahead in CARs LOB
            TUNE_DISPLAY_TEXT                   : '8071', //Streamline display text in TA for Flights LOB
            BEST_DEALS_OPTION                   : '8445', //Cheap Hotels and/or Best Deals in Hotels LOB
            HIGH_LEVEL_REGION                   : '8664', //Expose High Level region in Hotels LOB
            RECENT_HISTORY_HOTEL                : '8773', //Expose Recent history from Scratchpad in Hotels LOB
            RECENT_HISTORY_FLIGHT               : '8774', //Expose Recent history from Scratchpad in Flights LOB
            POSTCODE_HOTEL_CAR                  : '8889', //Support postcode in Typeahead for Cars & Hotels LOB
            ALWAYS_SEND_GAIA_ID_AND_LAT_LONG    : '9027', // Modify HSR Submitted Search URL to send GAIA and Lat/Long (for All Types)
            BCOM_TRIPADVISOR_CITIES_IN_HOTEL    : '8812', // Expose BCOM and TRIPADVISOR cities in HOTEL LOB
            TRIGGER_1_2_CHAR                    : '9110',  //1-2 char typeahead trigger for TW, CN, HK in all LOBs
            HOTEL_INPUT_HINT                    : '9109', //Including Hotel name in Hotel LOB
            REMOVING_FLIGHTS_ICON               : '9241', //Removing flights icon in Flights LOB
            TRENDING_SEARCHES_NEAR_YOU          : '9305', //Suggest destinations based on IP sniff and recommendations service
            CONSUME_ESS_V4_FOR_ACTIVITIES       : '9432', //Consuming ESS v4 for activities LOB
            CONSUME_ESS_V4_FOR_PACKAGES         : '9433', //Consuming ESS v4 for packages LOB
            BOLD_DESTINATION_TEXT               : '9242', //Bolding destination text in ESS v4 for hotel, flight & car LOB
            CURRENT_LOCATION                    : '8160', //Show current location as a suggestion in hotel LOB
            MEMBER_PRICE_HOTEL                  : '9598'  //Adding MER signup to the hotel tab
        },
        experimentDetails = {},
        searchUserHistoryUtil = (function () {
            // utility module that provides a simple interface(API) for extracting
            // data from scratchpad userhistory

            // helper function to extract the search property from a userhistory object
            function getSearchNode(item) {
                return _.isObject(item) &&
                       _.isObject(item.search) &&
                       _.property('search')(item);
            }

            // helper method that checks to see if this userhistory.search node
            // has a 'routetype' property thus indicating that it's a search object
            // result returned from an AIR_SEARCH
            function isFlightSearch(search) {
                return _.isObject(search) && ('routetype' in search);
            }

            // helper function that checks to see if this userhistory.search node
            // has a 'destination' property thus indicating that it's a search object
            // result returned from  an HOTEL_SEARCH
            function isHotelSearch(search) {
                return _.isObject(search) && ('destination' in search);
            }

            // helper function that determines whether or not given
            // a sentence and a searchTxt, the searchText matches the
            // start of any word in the sentence
            function prefixMatch(sentence, searchTxt){

                if(!_.isString(searchTxt)) {
                    searchTxt = '';
                }

                var words = sentence.match(/\S+\s*/g);

                // We want to compare the entire sentence for a match as well
                // any individual words contained with it it. So add it to the list.
                words.push(sentence);

                function startsWithIgnoreCase(str, prefix) {

                    if(_.isString(str) && _.isString(prefix)) {
                        str = str.toLocaleLowerCase();
                        prefix = prefix.toLocaleLowerCase();

                        return str.indexOf(prefix) === 0;
                    }

                    return false;
                }

                return _.any(words, function(word){
                    return startsWithIgnoreCase(word, searchTxt);
                });
            }

            // parseUrl(url)
            // given a URL string, extract out an object with URL properties including
            //    protocol
            //    host
            //    hostname
            //    pathname
            //    search (query string)
            //    searchObject (query string reified into an object)
            //    hash
            function parseUrl(url) {

                if(!_.isString(url)) {
                    throw new Error("Must call the parseUrl API with a string representation of a URL");
                }

                // Let the browser do the work
                var parser = document.createElement('a'),
                    searchObject = {},
                    queryParams = [],
                    split = [];

                parser.href = url;

                // TODO: leverage underscore-contrib - http://documentcloud.github.io/underscore-contrib/#fromquery
                // pull the query string off the URL
                // using the search API in the browser
                queryParams = parser.search
                    .replace(/^\?/, '') // strip the first character '?'
                    .split('&'); // split on the '&' character

                // Transform the decoded query params to an object
                _.each(queryParams, function(query) {
                    split = query.split("=");
                    searchObject[_.first(split)] = decodeURIComponent(_.last(split));
                });

                return {
                    protocol: parser.protocol,
                    host: parser.host,
                    hostname: parser.hostname,
                    pathname: parser.pathname,
                    search: parser.search,
                    searchObject: searchObject,
                    hash: parser.hash
                };
            }

            // given a list of scratchpad API response userhistory objects and a prefix string,
            // returns a list of flight search specific full userhistory objects filtered by the prefix string query.
            // An empty prefix will match all flight searches in the user history list. The list is compacted to
            // weed out any undefined objects.
            function getFlightTLAMatches(userhistory, prefix, inputId) {

                // defaults to looking in the origin field if not set
                inputId = inputId || 'flight-origin';

                var isDepartingFlight = ~inputId.indexOf('flight-origin');

                var matches = _.filter(userhistory, function (item){

                    var searchNode = getSearchNode(item),
                        searchString,
                        routedetails,
                        detail,
                        TLAs,
                        routedetails;

                    if (isFlightSearch(searchNode)) {

                        // pull out the routedetails node from the search object
                        // since that's where our TLAs to search live

                        // _.property(prop) is a nice little utility that will generate
                        // a function that when called will pull out the value of the
                        // named property. Here we create a extractRouteDetailsFrom() function
                        var extractRouteDetailsFrom = _.property('routedetails');

                        // then we pull out the value of search.routedetails
                        // which is an array
                        routedetails = extractRouteDetailsFrom(searchNode);

                        // For now, we're just grabbing the first routes details.
                        detail = _.first(routedetails);

                        if(_.isObject(detail)){

                            // grab out the the 'arrivalairport' and/or 'departureairport' fields as
                            // needed based on on whether or not the search is from the origin or the destination
                            // input in TA. NOTE: dangerous to be sending DOM element ID down as a flag
                            // to determine which field to use to grab a JSON value.
                            TLAs = _.pick(detail, isDepartingFlight ? 'departureairport': 'arrivalairport');

                            // squash the values down into a searchable string
                            searchString = _.values(TLAs).join(', ');

                            if (prefixMatch(searchString, prefix)) {
                                return item;
                            }

                        } else {

                            // If we didn't get any useful route detail be optimistic and add the item to the list
                            // because if we're in here, we should only be looking at flight searches in the userhistory.
                            return item;
                        }
                    }
                });

                return matches;
            }

            // given a list of scratchpad API response userhistory objects and a prefix string,
            // returns a list of hotel search specific full userhistory objects filtered by the prefix string query.
            // An empty prefix will match all hotel searches in the user history list. The list is compacted to
            // weed out any undefined objects.
            function getHotelDestinationMatches(userhistory, prefix) {

                var matches = _.filter(userhistory, function (item){

                    var searchNode = getSearchNode(item),
                        searchString;

                    if(isHotelSearch(searchNode) && _.has(searchNode.destination, 'regionname')){
                        searchString = _.property('regionname')(searchNode.destination);

                        if (prefixMatch(searchString, prefix)) {
                            return item;
                        }
                    }
                });

                return matches;
            }

            // the public API exposed by the searchUserHistoryUtil module
            return {
                getHotelDestinationMatches: getHotelDestinationMatches,
                getFlightTLAMatches: getFlightTLAMatches
            }
        })();

    function getAbacusId(experimentName) {
        return searchExperimentNameIdMapping[experimentName];
    }

    experimentDetails[getAbacusId("TRIGGER_WITH_FEWER_CHARACTERS")]     = ['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity'];
    experimentDetails[getAbacusId("AUTO_HIGHLIGHT_TOP_OPTION")]         = ['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity'];
    experimentDetails[getAbacusId("NEARBY_AIRPORT")]                    = ['flight'];
    experimentDetails[getAbacusId("CAR_RENTAL")]                        = ['car'];
    experimentDetails[getAbacusId("TUNE_DISPLAY_TEXT")]                 = ['flight'];
    experimentDetails[getAbacusId("BEST_DEALS_OPTION")]                 = ['hotel'];
    experimentDetails[getAbacusId("HIGH_LEVEL_REGION")]                 = ['hotel'];
    experimentDetails[getAbacusId("RECENT_HISTORY_HOTEL")]              = ['hotel'];
    experimentDetails[getAbacusId("RECENT_HISTORY_FLIGHT")]             = ['flight'];
    experimentDetails[getAbacusId("POSTCODE_HOTEL_CAR")]                = ['hotel', 'car'];
    experimentDetails[getAbacusId("ALWAYS_SEND_GAIA_ID_AND_LAT_LONG")]  = ['hotel'];
    experimentDetails[getAbacusId("BCOM_TRIPADVISOR_CITIES_IN_HOTEL")]  = ['hotel'];
    experimentDetails[getAbacusId("TRIGGER_1_2_CHAR")]                  = ['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity'];
    experimentDetails[getAbacusId("HOTEL_INPUT_HINT")]                  = ['hotel'];
    experimentDetails[getAbacusId("REMOVING_FLIGHTS_ICON")]             = ['flight'];
    experimentDetails[getAbacusId("TRENDING_SEARCHES_NEAR_YOU")]        = ['flight', 'hotel']; // flightHotel is excluded
    experimentDetails[getAbacusId("CONSUME_ESS_V4_FOR_ACTIVITIES")]     = ['activity'];
    experimentDetails[getAbacusId("CONSUME_ESS_V4_FOR_PACKAGES")]       = ['flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar'];
    experimentDetails[getAbacusId("BOLD_DESTINATION_TEXT")]             = ['flight', 'hotel', 'car'];
    experimentDetails[getAbacusId("CURRENT_LOCATION")]                  = ['hotel'];
    experimentDetails[getAbacusId("MEMBER_PRICE_HOTEL")]                = ['hotel', 'flightHotel', 'flightHotelCar', 'flightCar'];

    function getSearchExperimentVariantIfParticipating(abacusID) {
        var assignment, coreLob;
        if (!experimentDetails[abacusID]) {
            throw "The LOBs for experiment " + abacusID + " are undefined";
        }
        //AAG sites have null values for corewizard.core attributes
        coreLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));
        if (_.contains(experimentDetails[abacusID], coreLob)) {
            if (typeof callAbtestGetter === "function") {
                assignment = callAbtestGetter(abacusID);
                if (typeof assignment === "number") {
                    assignment = assignment.toString(10);
                }
            }
            return (assignment || "0");
        }
        else {
            return undefined;
        }
    }

    function getSearchExperimentVariant(abacusID) {
        var variant = getSearchExperimentVariantIfParticipating(abacusID);
        return (variant || "0");
    }

    function getVariant(experimentName) {
        var abacusId = getAbacusId(experimentName);
        if (!abacusId) {
            throw "The experiment name \"" + experimentName + "\" is unknown.";
        }
        return parseInt(getSearchExperimentVariant(abacusId), 10);
    };

    function isOriginField(contextId) {
       if (
            contextId === 'flight-origin' ||
            contextId === 'flight-2-origin' ||
            contextId === 'flight-3-origin' ||
            contextId === 'flight-4-origin' ||
            contextId === 'flight-5-origin' ||
            contextId === 'package-origin'
        ) {
            //From/Origin fields
            return true;
        }
        else {
            //To/Destination fields
            return false;
        }
    };

    function flighttypeChanged (state){
        genericTypeaheadStateReset(state);
    };

    function genericTypeaheadStateReset (state) {

        //Reset the typeahead related flags
        corewizard.OMTypeAheadRendered = false;
        //Info pertaining to latest interaction
        state.set('userTypedQuery', '');
        state.set('selectedTASuggestionPosition', null);
        state.set('TASearchType', null);
        state.set('suggestionType', null);//this holds 'child' info
        state.set('taTriggerElemId',null);
        state.set('essItemsTotal',0);
        state.set('activeESSTests',null);
        state.set('taMetadata',null);

        //Info persisted irrespective of Typeahead interaction
        state.set('destinationFromTA',null);
        state.set('originFromTA',null);
        state.set('TADestSearchType', null);
        state.set('TAOrigSearchType', null);
        state.set('destSuggestionTypeId',null);
        state.set('origSuggestionTypeId',null);
        state.set('destinationSourceInfo', null);
        state.set('originSourceInfo', null);
        state.set('multiFlightDestination',null);
        state.set('multiFlightOrigin',null);
        state.set('multiFlightDestSuggTypeId',null);
        state.set('multiFlightOrigSuggTypeId',null);
        state.set('multiFlightDestSrc',null);
        state.set('multiFlightOrigSrc',null);
        state.set('multiFlightDestSuggType',null);
        state.set('multiFlightOrigSuggType',null);

        //User history specific state variables
        if(getSearchExperimentVariant('8773') !== '0' || getSearchExperimentVariant('8774') !== '0') {
            state.set('userHistoryItemsTotal',0);
            state.set('userHistoryItemAge',null);
        }

        //Current location specific state variables
        if(getSearchExperimentVariant('8160') !== '0') {
            state.set('currentLocationShown', 0);
            state.set('currentLocationDetails',null);
        }

        //Trending Search specific state variables
        if(getSearchExperimentVariant('9305') !== '0') {
            state.set('recommenderOptionsRendered',0);
        }

    }

    function resetTypeaheadState (state) {
        genericTypeaheadStateReset(state);

        if (getVariant("BEST_DEALS_OPTION")) {
            state.set('sort', null);
        }

    };

    function updateCurrentLocationInModel (data, model) {
        model.set('currentLocationDetails', data);
    };

    function getCurrentLocation (callback) {
        var options =  {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(
            function (position) {
                var coordinates = {};
                coordinates.lat = position.coords.latitude;
                coordinates.lng = position.coords.longitude;
                if (typeof callback === "function") { callback(coordinates); }
            },
            function(error) {
                //TODO: Put logging indicating geoLocation Ended
                var errorMessage = "Unknown Error";
                switch (error.code) {
                    case error.PERMISSION_DENIED: errorMessage = "User denied the request for Geolocation.";break;
                    case error.POSITION_UNAVAILABLE: errorMessage = "Location information is unavailable.";break;
                    case error.TIMEOUT: errorMessage = "The request to get user location timed out.";break;
                    case error.UNKNOWN_ERROR: errorMessage = "An unknown error occurred.";break;
                }
                if (typeof callback === "function") { callback(errorMessage); }
            },
            options
        );
    };

    function resetMERSignupState (state) {
        if (getSearchExperimentVariant('9598') > 0) {
            state.set('merOptin',false);
            state.set('merEmail',undefined);
        }
    }

    // given user entered search data as userTypedText, an id for which field we're on
    // and the fligtType indicating which tab on the flight wizard the user is on (roundtrip,oneway, etc)
    // returns the list of matching search objects extracted
    // out of the scratchpad response userhistory data array
    // NOTE: all params are strings and required
    function getUserSearchHistory(userTypedtext, inputId, flightType) {
        if (arguments.length !== 3) {
            throw new Error("3 arguments required for getUserSearchHistory API");
        }
        if (!_.isString(userTypedtext)) {
            throw new Error("userTypedtext must be a string");
        }
        if (!_.isString(inputId)) {
            throw new Error("inputId must be a string");
        }
        if (!_.isString(flightType)) {
            throw new Error("flightType must be a string");
        }

        var userHistoryData,
            filterLOB,
            filteredSearchHistory = [],
            filterProduct = '',
            experimentLob,
            searches,
            hotels,
            flights,
            scratchpadProductLobMapping = {
                FLIGHT: 'AIR',
                HOTEL: 'HOTEL',
                PACKAGE: 'PACKAGE',
                CAR: 'CAR'
            },
            resultingHistoryData = [],
            filterRouteType = {
                roundtrip: "ROUND_TRIP",
                oneway: "ONE_WAY"
            }[flightType];
        // don't use it unless window.typeaheadUtilScratchpad has been loaded
        if(_.isObject(typeaheadUtilScratchpad)){
            //vmohapatra : Passing a 'type' as param is optional. We want to specifically filter data of type "SEARCH" for our experiment
            userHistoryData = typeaheadUtilScratchpad.getCompleteScratchpadHistoryData('SEARCH');
        }

        // filter down the userhistory data list based on current LOB
        if (_.isObject(userHistoryData.userhistory) && userHistoryData.userhistory.length > 0) {
            filterLOB = getLob(dataModels.model.get('tab'), dataModels.model.get('packages')).toUpperCase();

            if (scratchpadProductLobMapping[filterLOB]) {
                filterProduct = scratchpadProductLobMapping[filterLOB];
            }
            //Filter user history by product type
            if (filterProduct) {
                filteredSearchHistory = _.filter(userHistoryData.userhistory, function (historicalEvent) {
                    if (filterProduct === "AIR") {
                        return historicalEvent.product === filterProduct &&
                            historicalEvent.search.routetype === filterRouteType;
                    } else {
                        return historicalEvent.product === filterProduct;
                    }
                });
            }
        }

        // use that LOB based list to get the matches
        if (filteredSearchHistory && filteredSearchHistory.length > 0) {

            //Processing search history based on LOB and user typed text
            experimentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

            if (experimentLob == 'flight') {
                resultingHistoryData = searchUserHistoryUtil.getFlightTLAMatches(filteredSearchHistory, userTypedtext, inputId);
            } else if (experimentLob == 'hotel') {
                resultingHistoryData = searchUserHistoryUtil.getHotelDestinationMatches(filteredSearchHistory, userTypedtext);
            }
        }

        // return the first 5 hits
        return _.take(resultingHistoryData, 5);
    }

    // parseUrl(url)
    // given a URL string, extract out an object with URL properties including
    //    protocol
    //    host
    //    hostname
    //    pathname
    //    search (query string)
    //    searchObject (query string reified into an object)
    //    hash
    function parseUrl(url) {

        if(!_.isString(url)) {
            throw new Error("Must call the parseUrl API with a string representation of a URL");
        }

        // Let the browser do the work
        var parser = document.createElement('a'),
            searchObject = {},
            queryParams = [],
            split = [];

        parser.href = url;

        // TODO: leverage underscore-contrib - http://documentcloud.github.io/underscore-contrib/#fromquery
        // pull the query string off the URL
        // using the search API in the browser
        queryParams = parser.search
                            .replace(/^\?/, '') // strip the first character '?'
                            .split('&'); // split on the '&' character

        // Transform the decoded query params to an object
        _.each(queryParams, function(query) {
            split = query.split("=");
            searchObject[_.first(split)] = decodeURIComponent(_.last(split));
        });

        return {
            protocol: parser.protocol,
            host: parser.host,
            hostname: parser.hostname,
            pathname: parser.pathname,
            search: parser.search,
            searchObject: searchObject,
            hash: parser.hash
        };
    }

    function callAbtestGetter (abacusID) {
        return abTest.get(abacusID).value;
    };

    // This is the public API for the searchExperiments object
    return {
        experimentDetails: experimentDetails, // only public for unit tests
        getAbacusId: getAbacusId,
        getSearchExperimentVariantIfParticipating: getSearchExperimentVariantIfParticipating,
        getSearchExperimentVariant: getSearchExperimentVariant,
        getVariant: getVariant,
        isOriginField: isOriginField,
        flighttypeChanged: flighttypeChanged,
        resetTypeaheadState: resetTypeaheadState,
        updateCurrentLocationInModel: updateCurrentLocationInModel,
        getCurrentLocation: getCurrentLocation,
        resetMERSignupState: resetMERSignupState,
        parseUrl: parseUrl,
        getUserSearchHistory: getUserSearchHistory
    };

});

define('gc/inputDefaults', ['gc/loc'], function(loc) {
  return {
    cruises : {
      label : loc.cruise.destinationLabel,
      options : [
        { name : loc.cruise.showAll, value : ''},
        { name : loc.cruise.mostPopular,
          options : [
            { name : loc.cruise.optionCaribbean, value : 'caribbean' },
            { name : loc.cruise.optionBahamas, value : 'bahamas' },
            { name : loc.cruise.optionMexico, value : 'mexico' },
            { name : loc.cruise.optionAlaska, value : 'alaska' },
            { name : loc.cruise.optionEurope, value : 'europe' },
            { name : loc.cruise.optionBermuda, value : 'bermuda' },
            { name : loc.cruise.optionHawaii, value : 'hawaii' },
            { name : loc.cruise.optionCanadaNE, value : 'canada-new-england' }
          ]
        },//optionGroup,
        { name : loc.cruise.otherDestinationsLabel,
          options : [
            { name : loc.cruise.optionAfrica, value : 'africa'},
            { name : loc.cruise.optionArcticAntarctic, value : 'arctic-antarctic'},
            { name : loc.cruise.optionAsia, value : 'asia'},
            { name : loc.cruise.optionAustraliaNZ, value : 'australia-new-zealand'},
            { name : loc.cruise.optionCentralAmerica, value : 'central-america'},
            { name : loc.cruise.optionNowhere, value : 'cruise-to-nowhere'},
            { name : loc.cruise.optionGalapagos, value : 'galapagos'},
            { name : loc.cruise.optionGreenlandIceland, value : 'greenland-iceland'},
            { name : loc.cruise.optionMiddleEast, value : 'middle-east'},
            { name : loc.cruise.optionPacificCoastal, value : 'pacific-coastal'},
            { name : loc.cruise.optionPanamaCanal, value : 'panama-canal'},
            { name : loc.cruise.optionSouthAmerica, value : 'south-america'},
            { name : loc.cruise.optionSouthPacific, value : 'south-pacific'},
            { name : loc.cruise.optionTahiti, value : 'tahiti'},
            { name : loc.cruise.optionTransatlantic, value : 'transpacific'},
            { name : loc.cruise.optionWorldCruises, value : 'world-cruise'}
          ] //options
        }//optionGroup
      ]//optionGroups
    },
    preferredClass : {
      label : loc.perferredClassLabel,
      options : [
        { name : loc.preferredClassFirst, value : 'first'},
        { name : loc.preferredClassBusiness, value : 'business'},
        { name : loc.preferredClassEconomy, value : '', selected : 'selected'},
        { name : loc.preferredClassPremiumEconomy, value : 'premium'}
      ]
    },//preferredClass
    flightAdults : {
      label : loc.flightAdultsLabel,
      options : [
        { name : '1', value : '1', selected : 'selected' },
        { name : '2', value : '2' },
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ]
    },
    flightChildren : {
      label : loc.flightChildrenLabel,
      options : [
        { name : '0', value : '0', selected : 'selected' },
        { name : '1', value : '1' },
        { name : '2', value : '2' },
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ]
    },
    rooms : {
      label : loc.hotelRoomsCountLabel,
      options : [
        { name : '1', value : '1', selected : 'selected'},
        { name : '2', value : '2' },
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9+', value : '9' }
      ]
    },
    hotelAdults : {
      label : loc.flightAdultsLabel,
      options : [
        { name : '1', value : '1' },
        { name : '2', value : '2', selected : 'selected'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9', value : '9' },
        { name : '10', value : '10' },
        { name : '11', value : '11' },
        { name : '12', value : '12' },
        { name : '13', value : '13' },
        { name : '14', value : '14' }
      ]
    },
    hotelGuests : {
      label : 'Guests',
      options : [
        { name : '2 adults, 0 children', value : '2', selected : 'selected'},
        { name : '1 adult, 0 children', value : '1' },
        { name : 'More options', value : '99' }
      ]
    },
    hotelChildren : {
      label : loc.flightChildrenLabel,
      options : [
        { name : '0', value : '0', selected : 'selected' },
        { name : '1', value : '1'},
        { name : '2', value : '2'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ]
    },
    threePPAdults : {
      label : loc.flightAdultsLabel,
      options : [
        { name : '1', value : '1' },
        { name : '2', value : '2', selected : 'selected'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9', value : '9' },
        { name : '10', value : '10' },
        { name : '11', value : '11' },
        { name : '12', value : '12' },
        { name : '13', value : '13' },
        { name : '14', value : '14' }
      ]
    },
    threePPChildren : {
      label : loc.flightChildrenLabel,
      options : [
        { name : '0', value : '0', selected : 'selected' },
        { name : '1', value : '1'},
        { name : '2', value : '2'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ]
    },
    childAges : {
      label : loc.childAgesLabel,
      options : [
        { name : loc.childAgesDefault, value : 'null', selected : 'selected' },
        { name : loc.childUnder1, value : '0'},
        { name : '1', value : '1'},
        { name : '2', value : '2'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9', value : '9' },
        { name : '10', value : '10' },
        { name : '11', value : '11' },
        { name : '12', value : '12' },
        { name : '13', value : '13' },
        { name : '14', value : '14' },
        { name : '15', value : '15' },
        { name : '16', value : '16' },
        { name : '17', value : '17' }
      ]
    },
    threePPHotelSelect : {
      options : [
        { name : loc.threePP.hotelSelectLabel, value : '' }
      ]
    },
    threePPHotelQuality : {
      options : [
        { name : loc.threePP.hotelQualityLabel, value : '' }
      ]
    }

  };
});
define('gc/conf', ['gc/confFun', 'gc/wizardConfig', 'gc/defaultConfig'], function(confFun, wizardConfig, defaultConfig) {
  return confFun(wizardConfig, defaultConfig);
})

define('gc/confFun', [
  'gc/merge',
  'gc/activityConfig',
  'gc/carConfig',
  'gc/cruiseConfig',
  'gc/flightCarConfig',
  'gc/flightConfig',
  'gc/hotelCarConfig',
  'gc/hotelConfig',
  'gc/packageConfig',
  'gc/flightHotelConfig',
  'gc/flightHotelCarConfig',
  'gc/threePPConfig',
  'gc/wizardConfig',
  'gc/confOverride'
], function(
  merge,
  activityConfig,
  carConfig,
  cruiseConfig,
  flightCarConfig,
  flightConfig,
  hotelCarConfig,
  hotelConfig,
  packageConfig,
  flightHotelConfig,
  flightHotelCarConfig,
  threePPConfig,
  wizardConfig,
  confOverride
) {
  return function(wizardConfig, defaultConfig) {
    function extendWithWizardConfig(id, config) {
        return (wizardConfig[id] ? merge(config, wizardConfig[id]) : config);
    }
    var conf = {
        activity: extendWithWizardConfig('activity', activityConfig),
        car: extendWithWizardConfig('car', carConfig),
        cruise: extendWithWizardConfig('cruise', cruiseConfig),
        def: extendWithWizardConfig('def', defaultConfig),
        flightCar: extendWithWizardConfig('flightCar', flightCarConfig),
        flight: extendWithWizardConfig('flight', flightConfig),
        hotelCar: extendWithWizardConfig('hotelCar', hotelCarConfig),
        hotel: extendWithWizardConfig('hotel', hotelConfig),
        'package': extendWithWizardConfig('package', packageConfig),
        flightHotel: extendWithWizardConfig('flightHotel', flightHotelConfig),
        flightHotelCar: extendWithWizardConfig('flightHotelCar', flightHotelCarConfig),
        threePP: extendWithWizardConfig('threePP', threePPConfig),
        wizardconfig: wizardConfig
    };

    return merge(conf, confOverride);
  }
});

define('gc/defaultConstraints', [
  'gc/loc',
  'underscore',
  'gc/getLob'
], function(
  loc,
  _,
  getLob
) {
  return {
      'switches': loc.masterconfig && loc.masterconfig.switches,
      'tab': function(state, config) {
          if (!state.get('tab')) {
            return config.defaultTab;
          }
          return state.get('tab');
      },
      'showValueProp': function (state, config) {
          'use strict';
          return config.get('showValueProp');
      },
      'id': function (state) {
          'use strict';
          return state.get('tab');
      },
      "isHotelTabWithMaxThreeRooms":function(state, config) {
          'use strict';
          return !(state.get('roomCount') > 3) && state.get('tab') === 'hotel';
      },
      'lastValidDate': function (state, config) {
          'use strict';
          var date = new XDate();
          date.addDays(config.get('calendar.furthestBookingDayOut'));
          return date.toString(config.get('dateFormat'));
      },
      'firstValidDate': function (state, config) {
          'use strict';
          var date = new XDate();
          date.addDays(config.get('calendar.earliestBookingDay'));
          return date.toString(config.get('dateFormat'));
      },
      'minTripLength': function (state, config) {
          'use strict';
          return config.get('calendar.minTripLength');
      },
      'maxTripLength': function (state, config) {
          'use strict';
          return config.get('calendar.maxTripLength');
      },
      'destinationNotCuba': function (state, config) {
          'use strict';
          if(!corewizard.masterconfig.trivagoRedirectionEnabled) {
              return true;
          }
          var regionId = state.get('regionId');
          return !(state.get('tab') === 'hotel' && regionId <= -1000);
      },
      'lobs': function(state, config) {
          'use strict';
          var conf = config.attributes;
          return _.map(conf.wizardconfig.lobs, function(lob) {
              var packageData = (conf[lob.id].model && conf[lob.id].model.packages) || {};
              var carsData = (conf[lob.id].model && conf[lob.id].model.cars) || {};
              var activitiesData = (conf[lob.id].model && conf[lob.id].model.activities) || {};
              var isCurrentTab;
              // For bugfix eph_414
              if(state.get('tab') === 'package'){
                  // For package, make sure the right lob get highlighted correctly
                  isCurrentTab = (!this.get('isSoftPackage') && lob.id === this.get('lob')) || lob.id === state.get('tab') || lob.id === getLob(state.get('tab'), state.get('packages'));
              } else {
                  // For softPackage only, the tab will stay at the hotels and flights tab, we don't need use the getLob
                  isCurrentTab = (!this.get('isSoftPackage') && lob.id === this.get('lob')) || lob.id === state.get('tab');
              }
              return {
                  tab:            lob.isPackage ? 'package' : lob.id,
                  'tab-id':       lob.id,
                  link:           conf[lob.id].link || 'javascript:void(0)',
                  icon:           lob.icon || conf[lob.id].icon,
                  label:          lob.label || loc.tabLoc[lob.id],
                  isPackageTab:   lob.id == "package",
                  isCarsTab:      lob.id == "car",
                  isActivityTab:  lob.id == "activity",
                  isCurrentTab:   isCurrentTab,
                  flightsPackage: String(!!packageData.flight),
                  hotelsPackage:  String(!!packageData.hotel),
                  carsPackage:    String(!!packageData.car),
                  trainsPackage:  String(!!packageData.train),
                  rentalCars:     String(!!carsData.rentalCars),
                  airportRides:   String(!!carsData.airportRides),
                  lxThingsTodo:   String(!!activitiesData.lxThingsTodo),
                  lxAirportRides: String(!!activitiesData.lxAirportRides)
              };
          }, this);
      },
      'showTabs': function(state, config) {
          'use strict';
          var wizardconfig = config.attributes.wizardconfig;
          return wizardconfig.lobs.length > 1 || wizardconfig.lobs[0].id === 'package';
      }
  };
});

define('gc/defaultConfig', [
    'gc/defaultConfigOverride',
    'gc/modelHelpers',
    'gc/loc',
    'gc/abTest',
    'gc/searchExperiments',
    'gc/wizardConfig',
    'underscore',
    'gc/defaultConstraints',
    'gc/getLob'
], function(
    defaultConfigOverride,
    modelHelpers,
    loc,
    abTest,
    searchExperiments,
    wizardConfig,
    _,
    defaultConstraints,
    getLob
) {
    var defaultConfig = {
        defaultLob: (function(){
          return _.find(wizardConfig.lobs, function(lob) {
            return lob.defaultLob;
          }).id;
        })(),
        searchUrlGenerator: 'eapAspSearchUrl',
        masterconfig: loc.masterconfig,
        model: {
            tab : (function(){
              return _.find(wizardConfig.lobs, function(lob) {
                return lob.defaultLob;
              }).id;
            })(),
            isInitialized : false,
            isValidated : false,
            initConfigDone : false,
            hasFailedValidation : false,
            hasSuccessfullySubmitted : false,
            origin: "",
            //          region: "", // TODO: do we use this anywhere yet?
            validation:{isValid:true},
            destination: "",
            showFlightOptions: false,
            userDeniedGeoLocation: false,
            cruiseDestination:"",
            cruiseMonth:"",
            cruiseEarliestDepartureDate:"",
            cruiseLatestDepartureDate:"",
            departing: undefined,
            returning: undefined,  // if this is just "return" instead of "returning", the minify script breaks, despite being legal JS
            checkin: undefined, // TODO: is there a point to having these separate from departing/returning?
            checkout: undefined,
            //          pickupTime: "12:00 AM",
            //          dropoffTime: "12:00 AM",
            rooms: [{adults: -1, // -1 adults because flight and hotel have different defaults
                children: [], // age must be wrapped in an object because it will need an id etc. when it's made into context later
                childCount: 0}],
            roomCount: 1,
            isChildInLap: true,
            flighttype: "roundtrip", // if lob is flight this can have: "roundtrip", "oneway", or "multi"
            hotelId: null, // from type ahead we may get the hotel ID
            hotelNameFromTA: "",
            regionId: null, // from type ahead we may get the region
            tla: null, // from type ahead we may get the TLA
            noDate: false, // hotel "i don't know my dates" checkbox
            packages: {
                //allowFlightTabAddHotelOption: true,
                //allowFlightTabAddCarOption: true,
                hotel: false,
                car: false,
                flight: false
            }, // set a package to true if soft package add-on for that lob is being displayed.
            multiDest: {
                origin:      ["", "", "", ""],
                destination: ["", "", "", ""],
                startDate:   ["", "", "", ""]
            },
            carPickupValueFromTA: "",
            showCarOptions: false,
            startTime: "1030AM",
            endTime: "1030AM",
            carShowDropOff: true,
            carDiscountCode: "0",
            carVendor: "",
            carType: 1,
            carSearchType: 4,
            carSkirack: false,
            carInfantseat: false,
            carToddlerseat: false,
            carChains: false,
            carLefthand: false,
            carRighthand: false,
            carNavigation: false,
            carRateCode: "",
            carCouponCode: "",
            carOtherCode: "",
            carCorpCode: "",
            train: {
                departTime: "362",
                returnTime: "362"
            },
            showTabs: true
        },
        typeahead : {
            def: {
                minchar: 3,
                maxitems: 10,
                version: 'v1',
                locale: 'en_US',
                mask: 95,
                client: 'HOMEPAGE',
                closetext: 'Close',
                continuetext: 'Continue typing to refine search',
                tooltip: true,
                forceicon: false,
                template: 'default',
                regionid: 1,
                cheapHotelsText: 'Cheap hotels',
                cheapHotelsInText: 'Cheap hotels in',
                bestDealsText: 'Best deals',
                bestDealsInText: 'Best deals in'
            },
            origin : {
                dest: false
            },
            dest : {
                dest: true
            }
        },
        events : {
            'UI:packageLob': 'trackLobClick',
            'UI:tab': 'trackLobClickDelayed',
            'UI:softPackageCheckbox': 'trackLobClick',
            'tab': [searchExperiments.resetTypeaheadState, 'reloadWizard'],
            'flighttype': [searchExperiments.flighttypeChanged,'reloadWizard'],
            'packages': [searchExperiments.resetTypeaheadState, 'reloadWizard'],
            'children': 'reloadWizard',
            'showCarOptions': 'reloadWizard',
            'carDiscountCode': 'reloadWizard',
            'carVendor': 'reloadWizard',
            'carType': 'reloadWizard',
            '#rooms.count': 'reloadWizard',
            '#rooms.remove': 'reloadWizard',
            'changeTab': 'reloadWizard',
            'roomCount': 'reloadWizard',
            'rooms[0].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[1].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[2].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[3].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[4].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[5].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[6].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[7].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[0].children': 'reloadWizard',
            'rooms[1].children': 'reloadWizard',
            'rooms[2].children': 'reloadWizard',
            'rooms[3].children': 'reloadWizard',
            'rooms[4].children': 'reloadWizard',
            'rooms[5].children': 'reloadWizard',
            'rooms[6].children': 'reloadWizard',
            'rooms[7].children': 'reloadWizard',
            'guestMoreOptionsSelected' : [modelHelpers.guestsChanged, 'reloadWizard'],
            'noDate': 'reloadWizard',
            'isPartialStay': 'reloadWizard',
            'showFlightOptions':'reloadWizard',
            'isChildInLap' : 'reloadWizard',
            'showThreePPOptions' : 'reloadWizard',
            'showCruiseOptions' : 'reloadWizard',
            'userDeniedGeoLocation' : 'reloadWizard',
            'submit' : 'submit'
        },
        calendar: {
            'maxTripLength': 329,
            'minTripLength': 0,
            'earliestBookingDay': 0,
            'furthestBookingDayOut': 329,
            months: (typeof loc.calendar.months === 'string') ? loc.calendar.months.split(",") : loc.calendar.months,
            format : {
                date: loc.calendar.dateFormat || "mmddyy",
                delimiter : loc.calendar.dateSeparator || "/"
            },
            unit : {
                sow: parseInt(loc.calendar.startDayOfTheWeek),
                singleMonths: (typeof loc.calendar.singleMonths === 'string') ? loc.calendar.singleMonths.split(",") : loc.calendar.singleMonths,
                month: (typeof loc.calendar.shortMonths === 'string') ? loc.calendar.shortMonths.split(",") : loc.calendar.shortMonths,
                day: (typeof loc.calendar.daysOfTheWeek === 'string') ? loc.calendar.daysOfTheWeek.split(",") : loc.calendar.daysOfTheWeek,
                dayNames: (typeof loc.calendar.dayNames === 'string') ? loc.calendar.dayNames.split(",") : loc.calendar.dayNames,
                shortDays: (typeof loc.calendar.shortDays === 'string') ? loc.calendar.shortDays.split("#") : loc.calendar.shortDays
            },
            text: {
                close: loc.calendar.closeLink || "close",
                nights: (typeof loc.calendar.nightsTexts === 'string') ? loc.calendar.nightsTexts.split(",") : loc.calendar.nightsTexts
            }
        },
        travelers: {
            infantAge: 1,
            defaultChildAge: "",
            maxTravelers: 6,
            ninePlusRoomsAllowed : true,
            maxChildren : 6,
            defaultNumAdults : 2
        },
        dateFormat: loc.calendar.dateFormatWithSeparator || "MM/dd/yyyy",
        userVisibleDateFormat: loc.calendar.userVisibleDateFormat || "mm/dd/yyyy",
        validation: {},
        showPackageValueMessageLobs: ['flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar'],
        showPackageSavingsDisclaimer: false,
        airlineAgeRulesLink: '/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs',
        brand: 'Expedia',
        constraints : defaultConstraints,
        viewRules: {
            'formTitle' : function(model) {
                'use strict';
                // TODO Fix this, do not read for globals inside the viewRules
                return model.get('config.formTitleOverride') ||
                  ((loc.formTitle[getLob(model.get('tab'), model.get('packages'))]) ?
                    loc.formTitle[getLob(model.get('tab'), model.get('packages'))] :
                    '');
            },
            'wizardTitle': function (model) {
                'use strict';
                return model.get('wizardTitle') ||
                       model.get('config.wizardTitle') ||
                       "";
            },
            'getTitle':function(model){
                var lob = getLob(model.get('tab'), model.get('packages'));
                return loc.formTitle[lob];
            },
            'destinationError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'destination');
            },
            'openSearchError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'searchQuery');
            },
            'originError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'origin');
            },
            'startDateError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'startDate');
            },
            'startDateHotelError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'startDate');
            },
            'endDateError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endDate');
            },
            'endDateHotelError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endDate');
            },
            'startTimeError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'startTime');
            },
            'endTimeError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endTime');
            },
            'multiDestDateError': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-comes-before-previous');
            },

            'destinationErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'destination-blank');
            },
            'openSearchErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'search-query-blank');
            },
            'originErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-blank');
            },
            'originAndDestinationSameMessage': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-same');
            },

            'dateBlankMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-blank');
            },
            'dateFormatInvalidMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-format-invalid');
            },
            'dateRangeTooLongErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'trip-length-invalid');
            },
            'dateOutOfRangeMessage' : function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-range-long');
            },
            'dateBeforeCurrentDateMessage' : function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-before-today');
            },
            'childAgeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'child-ages-not-all-provided');
            },
            'numberOfTravellersMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'too-many-travelers');
            },
            'dateTimeRangeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'time-too-short');
            },
            'pickupDateTimeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'pickup-time-too-soon');
            },
            'partialStayDatesOutOfRange': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'checkin-checkout-range');
            },

            'dateRangeTooLongErrorMessageText':function(model){
              'use strict';
               var dateRangeCompile = Handlebars.compile(loc.dateRangeTooLongErrorMessageText);
               return dateRangeCompile({maxTripLength: model.get('maxTripLength')});
            },

            'dateFormatInvalidMessageText':function(model){
                'use strict';
                var dateFormatInvalid = Handlebars.compile(loc.dateFormatInvalidMessageText);
                return dateFormatInvalid({dateFormat: model.get('config.dateFormat')});
            },

            'showErrors': function (model) {
                'use strict';
                return !model.get('validation.isValid');
            },

            'isFlightTab': function (model) {
                'use strict';
                return model.get('tab') === 'flight';
            },
            'isHotelTab': function (model) {
                'use strict';
                return model.get('tab') === 'hotel';
            },

            'dateFormat': function (model) {
                'use strict';
                return model.get('config.userVisibleDateFormat');
            },
            'maxTripLength': function (model) {
                'use strict';
                return model.get('config.calendar.maxTripLength');
            },
            'maxNumberofTravellers' : function (model) {
                'use strict';
                return model.get('config.travelers.maxTravelers');
            },
            'minCalendarDate' :function (model) {
                'use strict';
                var days = model.get('config.calendar.earliestBookingDay'),
                  date = new XDate();
                date.addDays(days);
                return date.toString(model.get('config.dateFormat'));
            },
            'maxCalendarDate': function (model) {
                'use strict';
                var days = model.get('config.calendar.furthestBookingDayOut'),
                  date = new XDate();
                date.addDays(days);
                return date.toString(model.get('config.dateFormat'));
            },
            'allowHotelTabAddFlightOption': function (model) {
                if (modelHelpers.mobileSuppress()) return;
                return true;
            },
            'allowHotelTabAddCarOption': function (model) {
                'use strict';
                if (modelHelpers.mobileSuppress()) return;
                if (typeof corewizard.masterconfig.validPackages == "undefined") {
                    corewizard.masterconfig.validPackages = {};
                    var tmp = loc.masterconfig.packageOrder.split(',');
                    for (var i = 0; i < tmp.length; i++) {
                        corewizard.masterconfig.validPackages[tmp[i]] = true;
                    }
                }
                return corewizard.masterconfig.validPackages["hc"];
            },
            'addCarAction' : function(model) {
                'use strict';
                return modelHelpers.getSoftPackageAction('car', model);
            },
            'addFlightAction' : function(model) {
                'use strict';
                return modelHelpers.getSoftPackageAction('flight', model);
            },
            'addHotelAction' : function(model) {
                'use strict';
                return modelHelpers.getSoftPackageAction('hotel', model);

            },
            'useBestPriceGuaranteeLogo' : function(model) {
                'use strict';
                return loc.masterconfig.switches.useBestPriceGuaranteeLogo;
            },
            'isLobWithPackageSavingsEnabled': function(model) {
                'use strict';
                var lob = getLob(model.get('tab'), model.get('packages'));
                var bucket = abTest.get(7808).value;
                return (bucket && bucket !== "0" ? lob === 'hotel' || lob === 'overseaHotel' || lob === 'flight' : false);
            },
            'showPackageValueMessage': function(model) {
                'use strict';
                return _.contains(model.get('config.showPackageValueMessageLobs'), getLob(model.get('tab'), model.get('packages')));
            },
            'showPackageSavingsDisclaimer' : function(model) {
                'use strict';
                return model.get('config.showPackageSavingsDisclaimer');
            },
            'airlineAgeRulesLink' : function(model) {
                'use strict';
                return model.get('config.airlineAgeRulesLink');
            },
            'hotelDestinationLabel': function(model) {
                'use strict';
                return loc.hotelDestinationLabel;
            },
            'hotelDestinationPlaceholder': function(model) {
                'use strict';
                return loc.hotelDestinationPlaceholder;
            },
            'flightOriginLabel': function(model) {
                'use strict';
                return loc.flightOriginLabel;
            },
            'flightDestinationLabel': function(model) {
                'use strict';
                return loc.flightDestinationLabel;
            },
            'flightLocationPlaceholder': function(model) {
                //This function can be removed as now there are separate placeholders for flights origin and destination
                'use strict';
                return loc.flightLocationPlaceholder;
            },
            'flightOriginPlaceholder': function(model) {
                'use strict';
                return loc.flightLocationPlaceholder;
            },
            'flightDestinationPlaceholder': function(model) {
                'use strict';
                return loc.flightLocationPlaceholder;
            },
            'loc' : function(model) {
                'use strict';
                return loc;
            },
            'hotelTabletValueProp' : function(model) {
                'use strict';
                return modelHelpers.getHotelTabletValueProp();
            },
            'hotelLengthOfStayString' : function(model) {
                //under AB test 6070
                var hasCheckinCheckout = !!model.get('checkin') && !!model.get('checkout');

                if (model.get('importedData') &&
                  (model.get('tab') !== 'flight') && !model.get('isSoftPackage')) {
                    hasCheckinCheckout = false;
                }

                var hotelStartDate = hasCheckinCheckout ? model.get('checkin') : model.get('startDate'),
                  hotelEndDate = hasCheckinCheckout ? model.get('checkout') : model.get('endDate')||'',
                  dateDifference,
                  daysToNights;

                if (hotelStartDate && isNaN(hotelEndDate)) {
                    hotelStartDate = new XDate(hotelStartDate),
                      hotelEndDate = new XDate(hotelEndDate),
                      dateDifference = hotelStartDate.diffDays(hotelEndDate),
                      daysToNights = dateDifference;
                    if (daysToNights === 1)
                        return String(daysToNights + ' Night')
                    else
                        return String(daysToNights + ' Nights')
                }
            },
            'useHotelGroupBookingLink' : function(model) {
                //This function is to show the group booking link for hotel and its soft-packaging
                //https://jira/jira/browse/MAIN-135350
                'use strict';
                return abTest.get(7385).value === "1";
            },
            'allowFlightTabAddHotelOption': function (model) {
                if (site_id==1 && modelHelpers.mobileSuppress()) return;
                return true;
            },
            'allowFlightTabAddCarOption': function (model) {
                if (site_id==1 && modelHelpers.mobileSuppress()) return;
                return true;
            },
            'ab6555':function(){
                return abTest.get(6555).value;
            },
            'twoOrMoreRooms':function(model){
                return model.get('rooms') ? model.get('rooms').length > 1 : false;
            },
            'bpgModel': function(model) {
                return model.get('config.bpgModel');
            },
            'searchText' : loc.searchButtonText.defaultText
        },
        addEvent: function (event, additionalEvent) {
            var defined = this.events[event];
            var eventArray = [];

            if (_.isArray(additionalEvent)) {
                eventArray = _.union(eventArray, additionalEvent);
            } else {
                eventArray.push(additionalEvent);
            }

            if (_.isArray(defined)) {
                eventArray = _.union(eventArray, defined);
            } else if(!_.isUndefined(defined)) {
                eventArray.push(defined);
            }

            this.events[event] = eventArray;

        }
    };

    $.extend(true, defaultConfig, defaultConfigOverride);

    return defaultConfig;
});

define('gc/hotelConstraints', ['gc/modelHelpers', 'gc/loc'], function(modelHelpers, loc) {
  return {
      "main" : true,
      "id" : "hotel",
      "isHotelOnly" :  function (state, config) {
          'use strict';
          return !(state.get("packages.flight") || state.get("packages.car"));
      },
      "destination" : modelHelpers.getRegionNameOrDestination,
      "startDate" : function (state, config) {
          'use strict';
          return state.get("startDate") || state.get("checkin");
      },
      "endDate" : modelHelpers.getEndDate,
      "isDateless" : function (state, config) {
          'use strict';
          return state.get("noDate");
      },
      "useFlightDates" : true,
      "isNinePlusRoomRequest" : function (state, config) {
          'use strict';
          return ((state.get("roomCount") > config.get("travelers.maxRoomCount")) && config.get("travelers.ninePlusRoomsAllowed"));
      },
      "ninePlusRoomUrl" : function (state, config) {
          'use strict';
          return config.get("ninePlusRoomUrl");
      },
      "rooms" : function (state, config) {
          'use strict';
          return modelHelpers.getRoomsForModel(state, config);
      }
  }
});

define('gc/hotelValidationRules', [
  'gc/validationHelpers',
  'gc/json-path'
], function(
  validationHelpers,
  jsonPath
) {
  return {
    "destination" : [true,
                     [
                       ["isNotBlank", ["destination"], "destination-blank"]]],
    "startDate" : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) && !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ["isNotBlank", ["startDate"], "date-blank"],
        ["isValidDate", ["startDate"], "date-format-invalid"],
        ["isDateBeforeMaxDaysOut", ["startDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
        ["isDatePriorToCurrentDate", ["startDate"], "date-before-today"]]],
    "endDate" : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) && !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ["isNotBlank", ["endDate"], "date-blank"],
        ["isValidDate", ["endDate"], "date-format-invalid"],
        ["isDateBeforeMaxDaysOut", ["endDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
        ["isDatePriorToCurrentDate", ["endDate"], "date-before-today"],
        ["isDateAfterCurrentDate", ["endDate"], "date-range-long"]]],
    "bothDates" : [
      function (model, ruleSetResults) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(ruleSetResults.fields, "startDate") &&
          !_.contains(ruleSetResults.fields, 'endDate');
      },
      [
        ["isTripValidLength", ["startDate", "endDate", "config.calendar.maxTripLength"], "trip-length-invalid"],
        ["isStartDateBeforeEndDate", ["startDate", "endDate", 'config.calendar.minTripLength'], "date-order-invalid"]]],
    "childAges" : [function(model) { return jsonPath('rooms[0].childCount', model); },
                   [["isChildAgesAllProvided", ["rooms"], "child-ages-not-all-provided"]]]
  }
});

/*jslint nomen: true */
/*global _, typeaheadItemClickCallback */

define('gc/hotelConfig', [
  'gc/hotelConfigOverride',
  'gc/modelHelpers',
  'gc/loc',
  'gc/hotelValidationRules',
  'gc/hotelConstraints'
], function(
  hotelConfigOverride,
  modelHelpers,
  loc,
  hotelValidationRules,
  hotelConstraints
) {
    var hotelConfig = {
        icon: "hotels",
        template: 'corewizard/layouts/wizard-hbs-hotels',
        searchUrlGenerator: 'hotelSearchUrl',
        ninePlusRoomUrl: 'https://www.hotelplanner.com/Common/Services/Expedia/?',
        calendar : {
            furthestBookingDayOut: 500,
            maxTripLength: 28,
            minTripLength: 1
        },
        travelers: {
            maxRoomCount: 8,
            ninePlusRoomsAllowed: true
        },
        typeahead: {
            def: {
                lob: 'HOTELS',
                selectioncallback: function () {
                    'use strict';
                    typeaheadItemClickCallback();
                },
                mask: 223,
                version: 'v1'
            }
        },
        validation: hotelValidationRules,
        constraints : hotelConstraints,
        viewRules: {
            'hotelDestinationPlaceholderText' : loc.hotelDestinationPlaceholderText,
            'hideDestinationField': function (model) {
                'use strict';
                return !!model.get('packages.flight');
            },
            'disableAddFlightLink': function (model) {
                'use strict';
                return model.get('isNinePlusRoomRequest') || (model.get('packages.flight') || model.get('roomCount') > 3);
            },
            'disableAddCarLink': function (model) {
                'use strict';
                return model.get('isNinePlusRoomRequest') || (model.get('packages.car') || model.get('roomCount') > 3);
            },
            'showDisableAddFlightCarTips': function (model) {
                'use strict';
                return model.get('roomCount') > 3;
            },
            'isHotelDestinationVisible': function (model) {
                'use strict';
                return model.get('tab') === 'hotel';
            },
            'searchText' : function (model) {
                var text = loc.searchButtonText.defaultText;
                if (model.get('isHotelOnly') && model.get('isNinePlusRoomRequest')) {
                    text = loc.searchButtonText.hotel9Plus;
                }
                return text;
            },
            'nextRoomCount': function (model) {
                'use strict';
                return model.get('roomCount') + 1;
            },
            'flightAndCar': function (model) {
                'use strict';
                return model.get('packages.flight') && model.get('packages.car');
            },
            'hasFlight': function (model) {
                'use strict';
                return model.get('packages.flight');
            },
            'hasCar': function (model) {
                'use strict';
                return model.get('packages.car') === "true";
            },
            'rooms': function (model) {
                'use strict';
                return modelHelpers.getRoomsForHotels('hotel', model.get('rooms'));
            },
            'checkinAction': function (model) {
                return '{"startDate" : "$value1"}';
            },
            'checkinValue': function (model) {
                return model.get('startDate');
            },
            'checkoutAction': function (model) {
                return '{"endDate" : "$value1"}'
            },
            'checkoutValue': function (model) {
                return model.get('endDate');
            },
            'useHotelPromoMessage': function(model) {
                'use strict';
                return false;
            },
            'useOverseasHotelPromoMessage': function(model) {
                'use strict';
                return false;
            }
        }
    };

    $.extend(true, hotelConfig, hotelConfigOverride);

    return hotelConfig;
});

define('gc/flightConstraints', ['gc/modelHelpers'], function(modelHelpers) {
  return {
      'id': 'flight',
      'main': true,
      'isFlightOnly': true,
      'isRoundtrip': function (state) {
          'use strict';
          return state.get('flighttype') === 'roundtrip';
      },
      'isOneWay': function (state) {
          'use strict';
          return state.get('flighttype') === 'oneway';
      },
      'isMultiDest': function (state) {
          'use strict';
          return state.get('flighttype') === 'multi';
      },
      'multiDest': function (state) {
          'use strict';
          var out = {
                origin:      ['', '', '', ''],
                destination: ['', '', '', ''],
                startDate:   ['', '', '', '']},
            i;
          for (i = 0; i < 4; i ++) {
              out.origin[i] = state.get('multiDest.origin[' + i + ']') || '';
              out.destination[i] = state.get('multiDest.destination[' + i + ']') || '';
              out.startDate[i] = state.get('multiDest.startDate[' + i + ']') || '';
          }
          return out;
      },
      'startDate': function (state) {
          'use strict';
          return state.get('startDate') || state.get('checkin');
      },
      'endDate': modelHelpers.getEndDate,
      'adults': function (state) {
          'use strict';
          return state.get('rooms[0].adults');
      },
      'children': function (state) {
          'use strict';
          return state.get('rooms[0].childCount');
      },
      'ages': function (state, config) {
          'use strict';
          var result = [],
            i,
            childAge;
          for (i = 0; i < state.get('rooms[0].childCount'); i += 1) {
              childAge = state.get('rooms[0].children[' + i + ']');
              if (i === config.get('travelers.maxChildren')) break;
              if (typeof childAge === 'undefined') {
                  result.push(config.get('travelers.defaultChildAge'));
              } else {
                  result.push(childAge);
              }
          }
          return result;
      },
      'hasChildren': function (state) {
          'use strict';
          return state.get('rooms[0].childCount') > 0;
      },
      'rooms': function (state) {
          'use strict';
          return modelHelpers.getRoomsForModelFlights(state);
      },
      'lastValidDate': function (state, config) {
          'use strict';
          var date = new XDate();
          date.addDays(config.get('calendar.furthestBookingDayOut'));
          return date.toString(config.get('dateFormat'));
      }
  }
});

define('gc/flightValidationRules', ['underscore', 'gc/validationHelpers', 'gc/json-path'], function(_, validationHelpers, jsonPath) {
  return {
    'origin' : [true,
                [
                  ['isNotBlank', ['origin'], 'origin-blank'],
                  ['isOriginDiffrentFromDestination', ['origin', 'destination'], 'origin-same']]],
    'destination' : [true,
                     [
                       ['isNotBlank', ['destination'], 'destination-blank']]],
    'startDate' : [true,
                   [
                     ['isNotBlank', ['startDate'], 'date-blank'],
                     ['isValidDate', ['startDate'], 'date-format-invalid'],
                     ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
                     ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today']]],
    'endDate' : [
      function (model, ruleSetResults) {
        'use strict';
        return jsonPath('isRoundtrip', model);
      },
      [
        ['isNotBlank', ['endDate'], 'date-blank'],
        ['isValidDate', ['endDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today']]],
    'bothDates' : [
      function (model, ruleSetResults) {
        'use strict';
        return jsonPath('isRoundtrip', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(ruleSetResults.fields, "startDate") &&
          !_.contains(ruleSetResults.fields, 'endDate');
      },
      [
        ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid'],
        ['isTripValidLength', ['startDate', 'endDate', 'config.calendar.maxTripLength'], 'trip-length-invalid']]],
    'totalNumberOfTravellers' : [true,
                                 [
                                   ['isTotalTravelersLessThanMax', ['rooms', 'config.travelers.maxTravelers'], 'too-many-travelers']]],
    'childAges' : [
      function (model) {
        'use strict';
        return jsonPath('rooms[0].childCount', model);
      },
      [
        ['isChildAgesAllProvided', ['rooms'], 'child-ages-not-all-provided']]],
    'multiDest' : [
      function (model) {
        'use strict';
        return jsonPath('isMultiDest', model);
      },
      [   ['areAllDatesValid', ['multiDest', 'startDate'], 'some-dates-invalid', ['multiDest']],
          ['areAllFlightsComplete', ['multiDest'], 'multi-dest-not-complete'],
          ['allOriginsAreDifferentFromDestinations', ['multiDest'], 'origin-same']], true]
  }
});

/*jslint nomen: true */
/*global _, ab3227status, corewizard, XDate */

define('gc/flightConfig', [
    'gc/flightConfigOverride',
    'gc/modelHelpers',
    'gc/loc',
    'gc/inputDefaults',
    'gc/flightValidationRules',
    'gc/flightConstraints'
], function(
    flightConfigOverride,
    modelHelpers,
    loc,
    inputDefaults,
    flightValidationRules,
    flightConstraints
) {
    var flightConfig = {
        icon: "flights",
        template: 'corewizard/layouts/wizard-hbs-flights',
        searchUrlGenerator: 'flightSearchUrl',
        calendar: {
            'maxTripLength': 330,
            'minTripLength': 0,
            'furthestBookingDayOut': 330
        },
        travelers: {
            infantAge: 1,
            defaultChildAge: '',
            maxTravelers: 6
        },
        validation : flightValidationRules,
        constraints : flightConstraints,
        viewRules: {
            'showAddHotelLink': function (model) {
                'use strict';
                return model.get('flighttype') === 'roundtrip' &&
                  !model.get('packages.hotel');
            },
            'showAddCarLink': function (model) {
                'use strict';
                return model.get('flighttype') === 'roundtrip' &&
                  !model.get('packages.car');
            },
            'hidePassengerInfo': function (model) {
                'use strict';
                return typeof ab3227status !== 'undefined' ?
                ab3227status !== 2 && model.get('pacakge.hotel') :
                  model.get('pacakge.hotel');
            },
            'hideFlightOptions': function (model) {
                'use strict';
                return !model.get('showFlightOptions');
            },
            'multidest': function (model) {
                'use strict';
                var multidest = [];
                var md = model.get('multiDest');
                _.each(md.destination, function (legDestination, index) {
                    multidest.push({
                        destination: md.destination[index],
                        origin: md.origin[index],
                        departing: md.startDate[index],
                        number: index + 2,
                        id: 'flight',
                        originWizardAction: '{"multiDest.origin[' + index + ']": "$value1"}',
                        destinationWizardAction: '{"multiDest.destination[' + index + ']": "$value1"}',
                        dateWizardAction: '{"multiDest.startDate[' + index + ']": "$value1"}',
                        isRoundtrip: model.get('isRoundtrip'),
                        isOneWay: model.get('isOneWay'),
                        isMultiDest: model.get('isMultiDest'),
                        dateFormat: model.get('config.userVisibleDateFormat'),
                        uitkAccessCal : model.get("uitkAccessCal")
                    });
                });
                return multidest;
            },
            'hasMultiDestFlight': function (model) {
                'use strict';
                return true;
            },
            'enableAdvancedOptions': function (model) {
                'use strict';
                return true;
            },
            'ages': function (model) {
                'use strict';
                return modelHelpers.getChildrenForHotels(model.get('ages'), 0, 'flight');
            },
            'showLapOrSeat': function (model) {
                'use strict';
                return _.some(model.get('ages'), function (age) {
                    return !_.isNull(age) && age !== '' && age <= model.get('config.travelers.infantAge');
                });
            },
            'showPreferredAirline': function (model) {
                'use strict';
                return true;
            },
            'preferredAirlines' : function (model) {
                return model.get('config.preferredAirlines');
            },
            'preferredClass' : function () {
                return inputDefaults.preferredClass;
            },
            'useFlightPromoMessage': function(model) {
                'use strict';
                return false;
            },
            'multiFlightPlaceholder': function(model) {
                //This function can be removed as now there are separate placeholder texts for both origin and destination in multi flights
                'use strict';
                return loc.flightMultiPlaceholder;
            },
            'multiflightOriginPlaceholder': function(model) {
                'use strict';
                return loc.flightMultiOriginPlaceholder;
            },
            'multiflightDestinationPlaceholder': function(model) {
                'use strict';
                return loc.flightMultiDestinationPlaceholder;
            },
            'multiFlightOriginLabel': function(model) {
                'use strict';
                return loc.flightMultiOriginLabel;
            },
            'multiFlightDestinationLabel': function(model) {
                'use strict';
                return loc.flightMultiDestinationLabel;
            },
            'isFlightSelectEnabled': function(model) {
                'use strict';
                return false;
            },
            'isSwapOriginDestinationEnabled': function(model) {
                'use strict';
                return false;
            },
            "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, flightConfig, flightConfigOverride);

    return flightConfig;
});

define('gc/carValidationRules', [], function() {
  return {
    "pickUpLocation": [true,
                       [
                         ['isNotBlank', ['destination'], 'destination-blank']]],
    "pickUpDate": [true,
                   [
                     ["isNotBlank", ["startDate"], "date-blank"],
                     ["isValidDate", ["startDate"], "date-format-invalid"]]],
    "pickUpTime": [],
    "dropOffDate": [true,
                    [
                      ["isNotBlank", ["endDate"], "date-blank"],
                      ["isValidDate", ["endDate"], "date-format-invalid"]]],
    "tripLength": [
      ['startDate', 'endDate'],
      [
        ["isTripWithTimeValidLongEnough", ["startDate", "startTime", "endDate", "endTime", "config.calendar.minTripTime"], "time-too-short"]]]
  }
});

define('gc/carConstraints', ['gc/loc', 'gc/modelHelpers'], function(loc, modelHelpers) {
  return {
      "id": "car",
      "pickup": function (state, config) {
          'use strict';
          return state.get('destination');
      },
      "dropoff": function (state, config) {
          'use strict';
          return loc.masterconfig.switches.enableCarOffairportOnewaySearch ? state.get('carReturn') :
            !state.get('TASearchType') || state.get('TASearchType') === 'AIRPORT' ?
              state.get('carReturn') : '';
      },
      "carAllVendors": function (state, config) {
          'use strict';
          return state.get('carDiscountCode') === "0";
      },
      "carCorporateVendors": function (state, config) {
          'use strict';
          return state.get('carDiscountCode') === "1";
      },
      "carSpecialVendors": function (state, config) {
          'use strict';
          return state.get('carDiscountCode') === "2";
      },
      "startDate": function (state, config) {
          'use strict';
          return state.get('startDate') || state.get('checkin');
      },
      "endDate": function (state, config) {
          'use strict';
          return state.get('endDate') || state.get('checkout') || state.get('checkin') || modelHelpers.getEndDate(state, config);
      },
      "carTypes": function (state, config) {
          return [
              {key: loc.carOptionsLoc.typeNoPref, value: "1"},
              {key: loc.carOptionsLoc.typeEconomy, value: "2"},
              {key: loc.carOptionsLoc.typeCompact, value: "5"},
              {key: loc.carOptionsLoc.typeMidsize, value: "3"},
              {key: loc.carOptionsLoc.typeStandard, value: "6"},
              {key: loc.carOptionsLoc.typeFullsize, value: "4"},
              {key: loc.carOptionsLoc.typePremium, value: "9"},
              {key: loc.carOptionsLoc.typeLuxury, value: "7"},
              {key: loc.carOptionsLoc.typeConvertible, value: "12"},
              {key: loc.carOptionsLoc.typeMinivan, value: "8"},
              {key: loc.carOptionsLoc.typeSportUtilityVehicle, value: "11"},
              {key: loc.carOptionsLoc.typeSports, value: "15"}
          ];
      },
      "carVendors": function(state, config) {
          'use strict';
          if (state.get('carDiscountCode') === "0") {
              return [
                  {value: "", key: loc.carOptionsLoc.carRentalCompanyNoPreference},
                  {value: "AC", key: loc.carOptionsLoc.vendorAce},
                  {value: "AD", key: loc.carOptionsLoc.vendorAdvantage},
                  {value: "AL", key: loc.carOptionsLoc.vendorAlamo},
                  {value: "ZI", key: loc.carOptionsLoc.vendorAvis},
                  {value: "ZD", key: loc.carOptionsLoc.vendorBudget},
                  {value: "ZR", key: loc.carOptionsLoc.vendorDollar},
                  {value: "EY", key: loc.carOptionsLoc.vendorEconomy},
                  {value: "ET", key: loc.carOptionsLoc.vendorEnterprise},
                  {value: "EP", key: loc.carOptionsLoc.vendorEuropcar},
                  {value: "FX", key: loc.carOptionsLoc.vendorFox},
                  {value: "ZE", key: loc.carOptionsLoc.vendorHertz},
                  {value: "MW", key: loc.carOptionsLoc.vendorMidway},
                  {value: "ZL", key: loc.carOptionsLoc.vendorNational},
                  {value: "NU", key: loc.carOptionsLoc.vendorNu},
                  {value: "ZA", key: loc.carOptionsLoc.vendorPayless},
                  {value: "SX", key: loc.carOptionsLoc.vendorSixt},
                  {value: "ZT", key: loc.carOptionsLoc.vendorThrifty},
                  {value: "SV", key: loc.carOptionsLoc.vendorUSave}
              ];
          } else if (state.get('carDiscountCode') === "1") {
              return [
                  {value: "", key: '-- ' + loc.carOptionsLoc.carRentalCompanySelectFromList + ' --'},
                  {value: "ZI", key: loc.carOptionsLoc.vendorAvis},
                  {value: "ZD", key: loc.carOptionsLoc.vendorBudget},
                  {value: "ZR", key: loc.carOptionsLoc.vendorDollar},
                  {value: "ET", key: loc.carOptionsLoc.vendorEnterprise},
                  {value: "EP", key: loc.carOptionsLoc.vendorEuropcar},
                  {value: "ZE", key: loc.carOptionsLoc.vendorHertz},
                  {value: "ZA", key: loc.carOptionsLoc.vendorPayless},
                  {value: "ZT", key: loc.carOptionsLoc.vendorThrifty},
                  {value: "AC", key: loc.carOptionsLoc.vendorAce},
                  {value: "AD", key: loc.carOptionsLoc.vendorAdvantage},
                  {value: "AL", key: loc.carOptionsLoc.vendorAlamo},
                  {value: "EY", key: loc.carOptionsLoc.vendorEconomy},
                  {value: "ZL", key: loc.carOptionsLoc.vendorNational},
                  {value: "NU", key: loc.carOptionsLoc.vendorNu},
                  {value: "SX", key: loc.carOptionsLoc.vendorSixt}
              ];
          } else if (state.get('carDiscountCode') === "2") {
              return [
                  {value: "", key: '-- ' + loc.carOptionsLoc.carRentalCompanySelectFromList + ' --'},
                  {value: "ZI", key: loc.carOptionsLoc.vendorAvis},
                  {value: "ZD", key: loc.carOptionsLoc.vendorBudget},
                  {value: "ZR", key: loc.carOptionsLoc.vendorDollar},
                  {value: "ET", key: loc.carOptionsLoc.vendorEnterprise},
                  {value: "EP", key: loc.carOptionsLoc.vendorEuropcar},
                  {value: "ZE", key: loc.carOptionsLoc.vendorHertz},
                  {value: "ZA", key: loc.carOptionsLoc.vendorPayless},
                  {value: "ZT", key: loc.carOptionsLoc.vendorThrifty},
                  {value: "AC", key: loc.carOptionsLoc.vendorAce},
                  {value: "AD", key: loc.carOptionsLoc.vendorAdvantage},
                  {value: "AL", key: loc.carOptionsLoc.vendorAlamo},
                  {value: "EY", key: loc.carOptionsLoc.vendorEconomy},
                  {value: "ZL", key: loc.carOptionsLoc.vendorNational},
                  {value: "NU", key: loc.carOptionsLoc.vendorNu},
                  {value: "SX", key: loc.carOptionsLoc.vendorSixt},
                  {value: "SV", key: loc.carOptionsLoc.vendorUSave}
              ];
          }
      },
      "carDiscountCodes": [
          {value: 0, key: loc.carOptionsLoc.carNoCode},
          {value: 1, key: loc.carOptionsLoc.carCorporateContracted},
          {value: 2, key: loc.carOptionsLoc.carSpecialAdvertised}
      ],
      "timeValues": function (state, config) {
          return [
              {key: loc.carOptionsLoc.timeValue0000, value: "1200AM"}, {key: loc.carOptionsLoc.timeValue0030, value: "1230AM"}, {key: loc.carOptionsLoc.timeValue0100, value: "100AM"},  {key: loc.carOptionsLoc.timeValue0130, value: "130AM"},
              {key: loc.carOptionsLoc.timeValue0200, value: "200AM"},  {key: loc.carOptionsLoc.timeValue0230, value: "230AM"},  {key: loc.carOptionsLoc.timeValue0300, value: "300AM"},  {key: loc.carOptionsLoc.timeValue0330, value: "330AM"},
              {key: loc.carOptionsLoc.timeValue0400, value: "400AM"},  {key: loc.carOptionsLoc.timeValue0430, value: "430AM"},  {key: loc.carOptionsLoc.timeValue0500, value: "500AM"},  {key: loc.carOptionsLoc.timeValue0530, value: "530AM"},
              {key: loc.carOptionsLoc.timeValue0600, value: "600AM"},  {key: loc.carOptionsLoc.timeValue0630, value: "630AM"},  {key: loc.carOptionsLoc.timeValue0700, value: "700AM"},  {key: loc.carOptionsLoc.timeValue0730, value: "730AM"},
              {key: loc.carOptionsLoc.timeValue0800, value: "800AM"},  {key: loc.carOptionsLoc.timeValue0830, value: "830AM"},  {key: loc.carOptionsLoc.timeValue0900, value: "900AM"},  {key: loc.carOptionsLoc.timeValue0930, value: "930AM"},
              {key: loc.carOptionsLoc.timeValue1000, value: "1000AM"}, {key: loc.carOptionsLoc.timeValue1030, value: "1030AM"}, {key: loc.carOptionsLoc.timeValue1100, value: "1100AM"}, {key: loc.carOptionsLoc.timeValue1130, value: "1130AM"},
              {key: loc.carOptionsLoc.timeValue1200, value: "1200PM"}, {key: loc.carOptionsLoc.timeValue1230, value: "1230PM"}, {key: loc.carOptionsLoc.timeValue1300, value: "100PM"},  {key: loc.carOptionsLoc.timeValue1330, value: "130PM"},
              {key: loc.carOptionsLoc.timeValue1400, value: "200PM"},  {key: loc.carOptionsLoc.timeValue1430, value: "230PM"},  {key: loc.carOptionsLoc.timeValue1500, value: "300PM"},  {key: loc.carOptionsLoc.timeValue1530, value: "330PM"},
              {key: loc.carOptionsLoc.timeValue1600, value: "400PM"},  {key: loc.carOptionsLoc.timeValue1630, value: "430PM"},  {key: loc.carOptionsLoc.timeValue1700, value: "500PM"},  {key: loc.carOptionsLoc.timeValue1730, value: "530PM"},
              {key: loc.carOptionsLoc.timeValue1800, value: "600PM"},  {key: loc.carOptionsLoc.timeValue1830, value: "630PM"},  {key: loc.carOptionsLoc.timeValue1900, value: "700PM"},  {key: loc.carOptionsLoc.timeValue1930, value: "730PM"},
              {key: loc.carOptionsLoc.timeValue2000, value: "800PM"},  {key: loc.carOptionsLoc.timeValue2030, value: "830PM"},  {key: loc.carOptionsLoc.timeValue2100, value: "900PM"},  {key: loc.carOptionsLoc.timeValue2130, value: "930PM"},
              {key: loc.carOptionsLoc.timeValue2200, value: "1000PM"}, {key: loc.carOptionsLoc.timeValue2230, value: "1030PM"}, {key: loc.carOptionsLoc.timeValue2300, value: "1100PM"}, {key: loc.carOptionsLoc.timeValue2330, value: "1130PM"}
          ];
      },
      "isCarPackage" : function(state, config) {
          return state.get('tab') === 'car';
      }
  }
});

/*jslint nomen: true */
/*global _ */

define('gc/carConfig', [
  'gc/carConfigOverride',
  'gc/loc',
  'jquery',
  'gc/carValidationRules',
  'gc/carConstraints'
], function(
  carConfigOverride,
  loc,
  $,
  carValidationRules,
  carConstraints
) {
    var carConfig = {
        icon: "cars",
        template: 'corewizard/layouts/wizard-hbs-cars',
        searchUrlGenerator: 'carSearchUrl',
        calendar: {
            minTripTime: 2
        },
        vendorOptions : true,
        carOptions : ['type'],
        carsSpecialEquipment : [
            [ 'infantseat', 'toddlerseat'],
            ['skirack', 'chains'],
            ['navigation']
        ],
        specialVendorOptions : ['rateCode', 'couponCode', 'otherCode'],
        corporateVendorOptions: ['corpCode'],
        validation : carValidationRules,
        discountCodeConfig : {
            'AC' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: "Corporate Discount #"},
            'AD' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: "FASTSTART Org ID"},
            'AL' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Alamo Insiders #",  corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ZI' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Wizard #",          corpCodeLbl: "AWD #"},
            'ZD' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Fast Break #",      corpCodeLbl: "BCD #"},
            'ZR' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Dollar Express #",  corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'EY' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ET' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Enterprise Plus #", corpCodeLbl: "Customer #"},
            'EP' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Privilege #",       corpCodeLbl: "Contract #"},
            'FX' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode},
            'ZE' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Hertz #1 Club",     corpCodeLbl: "CDP"},
            'ZL' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Emerald Club ID:",  corpCodeLbl: "National Contract ID"},
            'NU' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: "Corporate Account"},
            'ZA' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Payless Perks #",   corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'SX' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ZT' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Blue Chip #",       corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'SV' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode}
        },
        constraints: carConstraints,
        viewRules: {
            "carShowDropOff": function (model) {
                'use strict';
                return loc.masterconfig.switches.enableCarOffairportOnewaySearch ? true :
                !model.get('TASearchType') || model.get('TASearchType') === "AIRPORT";
            },
            "carHideCarOptions": function (model) {
                'use strict';
                return !model.get('carShowCarOptions');
            },
            "showDiscountCodeFields": function (model) {
                'use strict';
                return model.get('carDiscountCode') !== "0";
            },
            "discountCodeConfig": function (model) {
                'use strict';
                return model.get('config.discountCodeConfig')[model.get('carVendor')];
            },
            "carOptions": function (model) {
                'use strict';
                function titlecase(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
                return _.map(model.get('config.carOptions'), function(option) {
                    var carOption = (option === 'discount' ? 'carDiscountCode' : 'car' + titlecase(option));
                    var optionsList = _.map(model.get(carOption + 's'), function(pair) {
                        return {name: pair.key, value: pair.value};
                    });
                    return {
                        namespace: 'options-' + option,
                        'wizard_action': '{"' + carOption + '" : "$value1"}',
                        'options-list': optionsList,
                        'ia-data-select-value': model.get(carOption),
                        'label-text': loc.carOptionsLoc[carOption]
                    }
                });
            },
            "carDiscountCodeOptions": function (model) {
                'use strict';
                function titlecase(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
                function getDiscountCodeLbl(codeLbl) {
                    if (model.get('carVendor')) {
                        return model.get('config.discountCodeConfig')[model.get('carVendor')][codeLbl]
                    } else {
                        return null;
                    }
                }
                function optionDetails(optionNames, showCondition) {
                    var namespace;
                    return _.map(optionNames, function (option) {
                        namespace = (option === 'otherCode') ? 'otherCodeLbl' : 'dis' + titlecase(option);
                        return {
                            'placeholder': loc.carDiscountEnterCodeLabel,
                            namespace: namespace,
                            'show-car-discount-options': showCondition && getDiscountCodeLbl(option + 'Lbl'),
                            'label-text': getDiscountCodeLbl(option + 'Lbl'),
                            'wizard_action': '{"car' + titlecase(option) + '" : "$value1"}',
                            'value': model.get('car' + titlecase(option))
                        };
                    });
                }
                return optionDetails(model.get('config.specialVendorOptions'), model.get('carSpecialVendors')).concat(
                  optionDetails(model.get('config.corporateVendorOptions'), model.get('carCorporateVendors'))
                );
            },
            "specialEquipmentOptions": function (model) {
                'use strict';
                function titlecase(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
                return _.map(model.get('config.carsSpecialEquipment'), function(column) {
                    return _.map(column, function(option) {
                        var carOption = 'car' + titlecase(option);
                        return {
                            namespace: 'car-options-equipment-' + option,
                            'wizard_action': '{"' + carOption + '": "$value1"}',
                            isChecked: model.get(carOption),
                            'label-text': loc.carOptionsLoc[carOption]
                        }
                    });
                });
            },
            "carPickupLabel": function(model) {
                'use strict';
                return loc.carPickupLabel;
            },

            "carPickupPlaceholder": function(model) {
                'use strict';
                return corewizard.locPickupPlaceholder;
            },
            "carDropoffLabel": function(model) {
                'use strict';
                return loc.carDropoffLabel;
            },
            'isCarAgeOptionEnabled': function(model) {
                'use strict';
                return true;
            },
            "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, carConfig, carConfigOverride);

    return carConfig;
});

define('gc/activityValidationRules', ['gc/validationHelpers'], function(validationHelpers) {
  return {
    "destination": [true,
                    [
                      ["isNotBlank", ["destination"], "destination-blank"]]],
    "startDate": [function (model) {
      'use strict';
      return !validationHelpers.startAndEndDateAreBlank(model);
    },
                  [
                    ["isNotBlank", ["startDate"], "date-blank"],
                    ["isValidDate", ["startDate"], "date-format-invalid"],
                    ["isDateBeforeMaxDaysOut", ["startDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
                    ["isDatePriorToCurrentDate", ["startDate"], "date-before-today"],
                    ["isStartDateBeforeEndDate", ["startDate", "endDate", 'config.calendar.minTripLength'], "date-order-invalid"]]],
    "endDate": [function (model) {
      'use strict';
      return !validationHelpers.startAndEndDateAreBlank(model);
    },
                [
                  ["isNotBlank", ["endDate"], "date-blank"],
                  ["isValidDate", ["endDate"], "date-format-invalid"],
                  ["isDateBeforeMaxDaysOut", ["endDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
                  ["isDatePriorToCurrentDate", ["endDate"], "date-before-today"]]],
    "bothDates": [
      ['startDate', 'endDate'],
      [
        ["isTripValidLength", ["startDate", "endDate", "config.calendar.maxTripLength"], "trip-length-invalid"]]]
  }
});

define('gc/activityConstraints', ['gc/modelHelpers'], function(modelHelpers) {
  return {
    "id": "activity",
    "main": true,
    "destination": modelHelpers.getRegionNameOrDestination,
    "startDate": function (state, config) {
        'use strict';
        var prefilled = state.get("startDatePrefilled") || state.get("endDatePrefilled");
        if (prefilled) return "";
        return state.get("startDate") || state.get("checkin");
    },
    "endDate": function (state, config) {
        'use strict';
        var prefilled = state.get("startDatePrefilled") || state.get("endDatePrefilled");
        if (prefilled) return "";
        return state.get("endDate") || state.get("checkout") || modelHelpers.getEndDate(state, config);
    },
    "isActivityPackage" : function(state, config) {
          return state.get('tab') === 'activity';
      }
  }
});

/*jslint nomen: true */
/*global _ */

define('gc/activityConfig', [
    'gc/activityConfigOverride',
    'gc/loc',
    'gc/activityValidationRules',
    'gc/activityConstraints'
], function(
    activityConfigOverride,
    loc,
    activityValidationRules,
    activityConstraints
) {
    var activityConfig = {
        icon: "activities",
        template: 'corewizard/field-groups/activity-hbs',
        searchUrlGenerator: 'activitySearchUrl',
        calendar: {
            furthestBookingDayOut: 328,
            maxTripLength: 14,
            minTripLength: 0
        },
        validation: activityValidationRules,
        constraints: activityConstraints,
        viewRules: {
            'useActivityPromoMessage': function (model) {
                'use strict';
                false;
            },
            'activityDestinationPlaceholder': function (model) {
                'use strict';
                return loc.activityDestinationPlaceholder;
            },
            'activityDestinationLabel': function (model) {
                'use strict';
                return loc.activityDestinationLabel;
            },
            "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, activityConfig, activityConfigOverride);

    return activityConfig;
});

define('gc/packageConstraints', ['underscore', 'gc/modelHelpers', 'gc/validate'], function(_, modelHelpers, validate) {
  return {
      'id': function (state) {
          'use strict';
          return state.get('tab');
      },
      'main': function (state) {
          'use strict';
          return state.get('tab') === 'package';
      },
      'isPackage': true,
      'packageType': function (state) {
          'use strict';
          return (state.get('packages.flight') ? 'F' : '') +
            (state.get('packages.train') ? 'T' : '') +
            (state.get('packages.hotel') ? 'H' : '') +
            (state.get('packages.car') ? 'C' : '');
      },
      'destination': modelHelpers.getRegionNameOrDestination,
      'destID': function (state) {
          'use strict';
          if (state.get('regionId') && state.get('destinationTLA')) {
              return state.get('regionId') + ':' + state.get('destinationTLA');
          } else {
              return null;
          }
      },
      'startDate': function (state) {
          'use strict';
          //https://jira/jira/browse/MAIN-122282 Special case: partial LS data doesn't apply for hotel soft packaging.
          if (state.get('packages.flight') &&
            state.get('tab') === 'hotel' &&
            state.get('isPartialStay')) return state.get('checkin') || state.get('startDate');


          return state.get('startDate');
      },
      'endDate': modelHelpers.getEndDate,
      'startDateHotfix': function(state) {
          return state.get('checkin') || state.get('startDate');
      },
      'endDateHotfix': function(state) {
          return state.get('checkout') || this.get('endDate');
      },
      'checkin': function (state, config) {
          'use strict';
          var validationResults = validate(config.validation, state.toJSON()),
            startDateIsValid;
          if (_.isUndefined(state.get('startDate'))) {
              startDateIsValid = false;
          } else {
              startDateIsValid = validationResults.isValid ? true : _contains(validationResults.fields, 'startDate');
          }
          return _.isUndefined(state.get('checkin')) ?
            startDateIsValid ? state.get('startDate') : ''
            : state.get('checkin');
      },
      'checkout': function (state, config) {
          'use strict';
          var validationResults = validate(config.validation, state.toJSON()),
            endDateIsValid;
          if (_.isUndefined(state.get('endDate'))) {
              endDateIsValid = false;
          } else {
              endDateIsValid = validationResults.isValid ? true : _contains(validationResults.fields, 'endDate');
          }
          return _.isUndefined(state.get('checkout')) ?
            endDateIsValid ? this.get('endDate') : ''
            : state.get('checkout');
      },
      'rooms': function (state, config) {
          'use strict';
          if (state.get('packages.hotel')) {
              return modelHelpers.getRoomsForModel.call(this, state, config);
          } else {
              return (state.get('rooms') && state.get('rooms').length > 0) ? [state.get('rooms')[0]] : [{adults: 1, childCount: 0, children: []}];
          }
      },
      'roomCount': function (state) {
          'use strict';
          return state.get('roomCount') > 3 ? 3 : state.get('roomCount');
      },
      'adults': function (state, config) {
          'use strict';
          return state.get('rooms[0].adults') === -1 ?
            config.get('travelers.defaultNumAdults') :
            state.get('rooms[0].adults')
      },
      'children': function (state) {
          'use strict';
          return state.get('rooms[0].childCount');
      },
      'ages': function (state, config) {
          'use strict';
          var result = [],
            i,
            childAge;
          for (i = 0; i < state.get('rooms[0].childCount'); i += 1) {
              childAge = state.get('rooms[0].children[' + i + ']');
              if (typeof childAge === 'undefined') {
                  result.push(config.get('travelers.defaultChildAge'));
              } else {
                  result.push(childAge);
              }
          }
          return result;
      },
      'isNinePlusRoomRequest' : function (state, config) {
          'use strict';
          //remove this from model if coming from another LOB for soft packaging scenarios.
          return false;
      },
      isSoftPackage : function(state, config) {
          return state.get('tab') !== 'package';
      },
      'subTab': function(state, config) {
          'use strict';
          var conf = config.attributes;
          var packageLob = _.find(conf.wizardconfig.lobs, function(lob) {return  lob.id == "package"});
          if (!packageLob) return null;

          var pkgLobs = ['flight', 'hotel', 'car', 'train'];
          var pkgState = _.pick(state.get('packages'), pkgLobs);
          var testIDdict = {
              'flightHotelCar' : 'fhc',
              'flightHotel' : 'fh',
              'flightCar' : 'fc',
              'hotelCar' : 'hc',
              'trainHotel' : 'th'
          };
          return {
              isPackageDefault: state.get('tab') === 'package',
              lobs: _.map(packageLob.lobs, function(lob) {
                  var pkgDefaults = _.pick(conf[lob.id].model.packages, pkgLobs);
                  return {
                      id: testIDdict[lob.id] || lob.id,
                      type: testIDdict[lob.id] || lob.id,
                      label: loc.tabLoc[lob.id],
                      value: _.map(pkgDefaults, String).join(':'),
                      selected: !this.get('isSoftPackage') && _.isEqual(pkgDefaults, pkgState),
                      action: '{"packages.flight" : $value1, "packages.hotel" : $value2, "packages.car" : $value3, "packages.train" : $value4}',
                      name: state.get('tab') + '-lob',
                      tracking:state.get('tab') + 'Lob'
                  }
              }, this)
          };
      }

  }
});

define('gc/packageValidationRules', [
  'underscore',
  'gc/validationHelpers',
  'gc/json-path'
], function(
  _,
  validationHelpers,
  jsonPath) {
  return {
    'origin' : [true,
                [
                  ['isNotBlank', ['origin'], 'origin-blank'],
                  ['isOriginDiffrentFromDestination', ['origin', 'destination'], 'origin-same']]],
    'destination' : [true,
                     [
                       ['isNotBlank', ['destination'], 'destination-blank']]],
    'startDate' : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ['isNotBlank', ['startDate'], 'date-blank'],
        ['isValidDate', ['startDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today']]],
    'endDate' : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ['isNotBlank', ['endDate'], 'date-blank'],
        ['isValidDate', ['endDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today'],
        ['isDateAfterCurrentDate', ['endDate'], 'date-range-long']]],
    'bothDates' : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(jsonPath('validation.fields', model), 'startDate') &&
          !_.contains(jsonPath('validation.fields', model), 'endDate');
      },
      [
        ['isTripValidLength', ['startDate', 'endDate', 'config.calendar.maxTripLength'], 'trip-length-invalid'],
        ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid']]],
    'totalNumberOfTravellers' : [true,
                                 [
                                   ['isTotalTravelersLessThanMax', ['rooms', 'config.travelers.maxTravelers'], 'too-many-travelers']]],
    'childAges' : [
      function (model) {
        'use strict';
        return jsonPath('rooms[0].childCount', model);
      },
      [
        ['isChildAgesAllProvided', ['rooms'], 'child-ages-not-all-provided']]],
    'partialStay': [
      function (model) {
        'use strict';
        return jsonPath('isPartialStay', model);
      },
      [
        ['isPartialDateWithinRange', ['checkin', 'startDate', 'endDate'], 'checkin-checkout-range', ['checkin']],
        ['isPartialDateWithinRange', ['checkout', 'startDate', 'endDate'], 'checkin-checkout-range', ['checkout']]], true],
    'checkin' : [
      function(model) {
        'use strict';
        return jsonPath('isPartialStay', model);
      },
      [
        ['isNotBlank', ['checkin'], 'date-blank'],
        ['isValidDate', ['checkin'], 'date-format-invalid'],
        ['isDatePriorToCurrentDate', ['checkin'], 'date-before-today']], false ],
    'checkout' : [
      function(model) {
        'use strict';
        return jsonPath('isPartialStay', model);
      },
      [
        ['isNotBlank', ['checkout'], 'date-blank'],
        ['isValidDate', ['checkout'], 'date-format-invalid'],
        ['isDatePriorToCurrentDate', ['checkout'], 'date-before-today']], false ]


  };
});

/*jslint nomen: true */
/*global _, corewizard, $ */

corewizard = corewizard || {};
corewizard.conf = corewizard.conf || {};
define('gc/packageConfig', [
  'gc/modelHelpers',
  'gc/loc',
  'gc/packageValidationRules',
  'gc/packageConstraints',
  'gc/getLob'
], function(
  modelHelpers,
  loc,
  packageValidationRules,
  packageConstraints,
  getLob
) {
    return {
        icon: "flightHotel",
        searchUrlGenerator: 'eapAspSearchUrl',
        template: function(model) {
            var tab = model.get('tab');
            if (tab === 'overseaHotel') tab = 'hotel';
            if (_.contains(['flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar'], tab)) {
                tab = 'package';
            }
            return 'corewizard/layouts/wizard-hbs-' + tab + 's';
        },
        travelers : {
            maxTravelers : 6,
            maxRoomCount: 3
        },
        calendar: {
            'maxTripLength': 26,
            'minTripLength': 1
        },
        showDirectFlightCheckbox: false,
        validation : packageValidationRules,
        constraints: packageConstraints,
        viewRules: {
            'endDateHotelError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endDate');
            },
            'showFlightOandD': function (model) {
                'use strict';
                return model.get('packages.flight');
            },
            'hasMultiDestFlight': function (model) {
                // because the flights soft package usecase goes through here
                'use strict';
                return true;
            },
            'showHotelDest': function (model) {
                'use strict';
                return !model.get('packages.flight');
            },
            'showRooms': function (model) {
                'use strict';
                return model.get('packages.hotel');
            },
            'noRooms': function (model) {
                'use strict';
                return !model.get('packages.hotel');
            },
            'showPartialStay': function (model) {
                'use strict';
                return model.get('packages.flight') && model.get('packages.hotel');
            },
            'showCarMessage': function (model) {
                'use strict';
                return model.get('packages.car');
            },
            'hasFlight': function (model) {
                'use strict';
                return model.get('packages.flight');
            },
            'hasCar': function (model) {
                'use strict';
                return model.get('packages.car') === "true" || model.get('packages.car') === true;
            },
            'rooms': function (model) {
                'use strict';
                var idString = 'package';
                if (model.get('packages.hotel')) {
                    if (model.get('tab') === 'flight') {
                        //automation expects flight-hotel for this suite of inputs.
                        idString = 'flight-hotel';
                    };
                    if (model.get('tab') === 'hotel') {
                        //automation expects hotel for this suite of inputs.
                        idString = 'hotel';
                    }
                    return modelHelpers.getRoomsForHotels(idString, model.get('rooms'));
                }
            },
            'isHotelDestinationVisible': function (model) {
                'use strict';
                var tab = model.get('tab');
                return tab === 'hotel' || tab === 'overseaHotel';
            },
            'hideFlightDestination': function (model) {
                'use strict';
                var tab = model.get('tab');
                return tab === 'hotel' || tab === 'overseaHotel';
            },
            'isRoundtrip': function () {
                'use strict';
                return true;
            },
            'hasChildren': function (model) {
                'use strict';
                return model.get('rooms[0].childCount') > 0 || (
                    getLob(model.get('tab'), model.get('packages')) !== 'flightCar' && (
                      (model.get('roomCount') > 1 && model.get('rooms[1].childCount') > 0) ||
                      (model.get('roomCount') > 2 && model.get('rooms[2].childCount') > 0)
                    )
                  )
            },
            'showAddHotelLink': function (model) {
                'use strict';
                return model.get('tab') === 'flight' &&
                  !model.get('packages.hotel');
            },
            'showAddCarLink': function (model) {
                'use strict';
                return (model.get('tab') === 'flight' || model.get('tab') === 'hotel') &&
                  !model.get('packages.car');
            },
            'hideChildrenFlightFields': function (model) {
                'use strict';
                return (model.get('packages.car') || model.get('packages.hotel')) &&
                  !model.get('packages.flight');
            },
            'ages': function (model) {
                'use strict';
                return modelHelpers.getChildrenForHotels(model.get('ages'), 0, model.get('tab'));
            },
            'showLapOrSeat': function (model) {
                'use strict';
                if (model.get('packages.hotel')) {
                    return _.some(model.get('rooms'), function(room) {
                        return _.some(room.children, function (age) {
                            return !_.isNull(age) && age !== '' && age <= model.get('config.travelers.infantAge');
                        });
                    });
                } else {
                    return _.some(model.get('rooms')[0].children, function (age) {
                        return !_.isNull(age) && age !== '' && age <= model.get('config.travelers.infantAge');
                    });
                }
            },
            'packageOrder': function (model) {
                'use strict';
                var hasFlight = model.get('packages.flight');
                var hasHotel = model.get('packages.hotel');
                var hasCar = model.get('packages.car');
                var hasTrain = model.get('packages.train');

                var isFH  = (hasFlight && hasHotel && !hasCar && !hasTrain) ? true : false; //force cast into boolean
                var isFHC = (hasFlight && hasHotel && hasCar && !hasTrain) ? true : false;
                var isFC  = (hasFlight && !hasHotel && hasCar && !hasTrain) ? true : false;
                var isHC  = (!hasFlight && hasHotel && hasCar && !hasTrain) ? true : false;
                var isTH  = (!hasFlight && hasHotel && !hasCar && hasTrain) ? true : false;

                var label = loc.tabLoc;
                var fh  = {id:'package-fh',  value:'true:true:false:false', checked:isFH,  display:label.flightHotel};
                var fhc = {id:'package-fhc', value:'true:true:true:false',  checked:isFHC, display:label.flightHotelCar};
                var fc  = {id:'package-fc',  value:'true:false:true:false', checked:isFC,  display:label.flightCar};
                var hc  = {id:'package-hc',  value:'false:true:true:false', checked:isHC,  display:label.hotelCar};
                var th  = {id:'package-th',  value:'false:true:false:true', checked:isTH,  display:label.trainHotel};
                var pkglobs = {'fh':fh, 'fhc':fhc, 'fc':fc, 'hc':hc, 'th':th};

                var packageOrder = [];
                $.each(model.get('config.masterconfig.packageOrder').split(','), function(index, value) {
                    packageOrder.push(pkglobs[value]);
                });
                return packageOrder;
            },

            'isMultiplePackageOrder': function(model) {
                return model.get('config.masterconfig.packageOrder').split(',').length > 1;
            },

            'checkinAction': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return '{"checkin" : "$value1"}';
                } else {
                    return '{"startDate" : "$value1"}';
                }
            },
            'checkinValue': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return model.get('checkin');
                } else {
                    return model.get('startDate') || model.get('checkin');
                }
            },
            'checkoutAction': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return '{"checkout" : "$value1"}';
                } else {
                    return '{"endDate" : "$value1"}';
                }
            },
            'checkoutValue': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return model.get('checkout');
                } else {
                    return model.get('endDate');
                }
            },
            'isPartialStay' : function(model) {
                //remove isPartialStay for hotel-car
                if (model.get('packages.hotel') && model.get('packages.car') && !model.get('packages.flight')) return false;
                else return model.get('isPartialStay');
            },
            'startDateHotelError' : function(model) {
                'use strict';
                if (model.get('isPartialStay')) return _.contains(model.get('validation.fields'), 'checkin');
                return _.contains(model.get('validation.fields'), 'startDate');

            },
            'showDirectFlightCheckbox' : function(model) {
                'use strict';
                return model.get('config.showDirectFlightCheckbox');
            },
            'showFlightHotelPackageUpsell' : function(model) {
                'use strict';
                var overseaHotelFlight = (model.get('packages.flight') && model.get('tab') === 'overseaHotel');
                return (model.get('packages.flight') &&
                  model.get('packages.hotel') &&
                  !model.get('packages.car') &&
                  !model.get('packages.train')) || overseaHotelFlight;
            },
            "searchText" : function (model) {
                var text = loc.searchButtonText.defaultText;
                var tab = model.get('tab');
                if (tab === 'hotel' || tab === 'overseaHotel') {
                    if (model.get('packages.flight') &&
                      model.get('packages.car')) {
                        text = loc.searchButtonText.hotelFlightCarText;
                    } else if (model.get('packages.flight')) {
                        text = loc.searchButtonText.hotelFlightText;
                    } else if (model.get('packages.car')) {
                        text = loc.searchButtonText.hotelCarText;
                    }
                }
                return text;
            },
            'isFlightSelectEnabled': function(model) {
                'use strict';
                return false;
            },
            'hideFlightOptions': function (model) {
                'use strict';
                return !model.get('showFlightOptions');
            }
        }
    };
});

define('gc/flightCarConstraints', ['gc/modelHelpers'], function(modelHelpers) {
  return {
      'rooms' : function (state, config) {
          return modelHelpers.getRoomsForModel.call(this, state, config).slice(0,1);
      }
  }
});

define('gc/flightCarValidationRules', [], function() {
  return {
    'startDate' : [
      true,
      [
        ['isNotBlank', ['startDate'], 'date-blank'],
        ['isValidDate', ['startDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today'],
        ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid']
      ]
    ],
    'endDate' : [
      true,
      [
        ['isNotBlank', ['endDate'], 'date-blank'],
        ['isValidDate', ['endDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today']
      ]
    ]
  }
});

/*jslint nomen: true */
/*global _, corewizard */

define('gc/flightCarConfig', ['gc/packageConfig', 'gc/flightCarValidationRules', 'gc/flightCarConstraints'] ,function(packageConfig, flightCarValidationRules, flightCarConstraints){
    return $.extend(true, {}, packageConfig, {
        'model' : {
            'packages' : {
                flight: true,
                hotel: false,
                car: true,
                train: false
            }
        },
        'constraints' : flightCarConstraints,
        'validation' : flightCarValidationRules,
        'calendar' : {
            'minTripLength' : 0
        }
    });
});

define('gc/hotelCarValidationRules', ['gc/hotelValidationRules', 'gc/merge'], function(hotelValidationRules, merge) {
  var rules =  merge(hotelValidationRules, {}); // this will clone hotelValidationRules
  delete rules.origin;
  return rules;
});

/*jslint nomen: true */
/*global _, corewizard */

define('gc/hotelCarConfig', [
  'gc/hotelConfig',
  'gc/packageConfig',
  'gc/loc'
], function (
  hotelConfig,
  packageConfig,
  loc
) {
  var HC = $.extend(true, {}, packageConfig, {
    'validation': $.extend(true, {}, hotelConfig.validation),
    'model': {
      'packages': {
        flight: false,
        hotel: true,
        car: true,
        train: false
      }
    },
    'calendar': {
      'minTripLength': 1
    },
    'viewRules': {
      'hotelCarDestinationLabel': function (model) {
        return loc.hotelCarDestinationLabel;
      },
      'hotelCarDestinationPlaceholder': function (model) {
        return loc.hotelCarDestinationPlaceholder;
      }
    }
  });

  delete HC.validation.origin;
  return HC;
});

/*jslint nomen: true */
/*global _, corewizard */

define('gc/flightHotelConfig', ['gc/packageConfig', 'gc/packageConfigOverride'], function(packageConfig, packageConfigOverride){
    return $.extend(true, packageConfig, packageConfigOverride, {
        'packageSetting_flight' : true,
        'packageSetting_hotel' : true,
        'packageSetting_car' : false,
        'model' : {
            'packages' : {
                flight: true,
                hotel: true,
                car: false,
                train: false
            }
        },
        'calendar': {
            'maxTripLength': 26,
            'minTripLength': 1
        }
    });
});



/*jslint nomen: true */
/*global _, corewizard */

define('gc/flightHotelCarConfig', ['gc/packageConfig'], function(packageConfig){
    return $.extend(true, {}, packageConfig, {
        'packageSetting_flight' : true,
        'packageSetting_hotel' : true,
        'packageSetting_car' : true,
        'model' : {
            'packages' : {
                flight: true,
                hotel: true,
                car: true,
                train: false
            }
        },
        'calendar': {
          'minTripLength': 1
        }
    });
});

define('gc/cruiseValidationRules', [], function() {
    return {
        'cruiseEarliestDepartureDate' : [true,
            [
                ['isValidDateOrBlank', ['cruiseEarliestDepartureDate'], 'date-format-invalid'],
                ['isDateAfterCurrentDateOrBlank', ['cruiseEarliestDepartureDate'], 'date-before-today']]],
        'cruiseLatestDepartureDate' : [true,
            [
                ['isValidDateOrBlank', ['cruiseLatestDepartureDate'], 'date-format-invalid'],
                ['isDateAfterCurrentDateOrBlank', ['cruiseLatestDepartureDate'], 'date-before-today']]],
        'bothDates' : [
            ['cruiseEarliestDepartureDate', 'cruiseLatestDepartureDate'],
            [
                ['areAllDatesValidOrBlank', ['cruiseEarliestDepartureDate', 'cruiseLatestDepartureDate'], 'date-format-invalid']]]
    }
});

define('gc/cruiseConstraints', [], function() {
  return {
      "id": "cruise",
      "main": true,
      "destination": function (state, config) {
          'use strict';
          return state.get("cruiseDestination");
      },
      "cruiseMonth": function (state, config) {
          'use strict';
          return state.get("cruiseMonth");
      },
      "months": function (state, config) {
          'use strict';
          if (typeof this.monthValues === 'undefined') {
              var numberOfMonths,
                months,
                currDate,
                currMonth,
                currYear,
                monthValues,
                i;

              numberOfMonths = config.get("calendar.numberOfCruiseMonths");
              months = config.get("calendar.months");

              currDate = new Date();
              currMonth = currDate.getMonth();
              currYear = currDate.getFullYear();
              monthValues = [{display: "Show All", value: "4501-1-1"}];

              for (i = 0; i < numberOfMonths; i += 1) {
                var monthVal = ((currMonth % 12) + 1);
                  monthValues.push({display: months[currMonth % 12] + currYear,
                      value: currYear + "-" + monthVal + "-" + "01" });
                  currMonth += 1;
                  if (currMonth % 12 === 0) {
                      currYear += 1;
                  }
              }

              this.monthValues = monthValues;
          }
          return this.monthValues;
      },
      "cruiseEarliestDepartureDate": function (state, config) {
          'use strict';
          return state.get("cruiseEarliestDepartureDate");
      },
      "cruiseLatestDepartureDate": function (state, config) {
          'use strict';
          return state.get("cruiseLatestDepartureDate");
      }
  }
});

/*jslint nomen: true */
/*global _ */

define('gc/cruiseConfig', [
    'gc/cruiseConfigOverride',
    'gc/loc',
    'jquery',
    'gc/cruiseConstraints',
    'gc/abTest',
    'gc/cruiseValidationRules',
    'gc/defaultConfig',
    'gc/inputDefaults',
    'env',
    'uitk',
    'gc/dataModels'
], function(
    cruiseConfigOverride,
    loc,
    $,
    cruiseConstraints,
    abTest,
    cruiseValidationRules,
    defaultConfig,
    inputDefaults,
    env,
    uitk,
    dataModels
) {
    var NEW_DEFAULT_DEST_LABEL = loc.cruise.selectDestinationLabel;
    var NEW_DEFAULT_MONTH_LABEL = loc.cruise.selectDateLabel;
    var NO_FILTER = "---";

    var cruiseConfig = {
        icon: "cruise",
        template: 'corewizard/field-groups/cruise-hbs',
        searchUrlGenerator: 'cruiseSearchUrl',
        calendar: {
            numberOfCruiseMonths: 18,
            months: [ "January ", "February ", "March ", "April ", "May ", "June ",
                "July ", "August ", "September ", "October ", "November ", "December " ]
        },
        validation : cruiseValidationRules,
        constraints : cruiseConstraints,
        viewRules : {
            "searchText" : loc.searchButtonText.defaultText,
            "cruiseStorefrontDateBasedSearch": function (model) {
                'use strict';
                return abTest.get(10120).value === 1;
            }
        },
        model : {}
    };


    langCheck = function(langid) {
        if (env.locale === 'en_US') {
            inputDefaults.cruises.options[0].name = NEW_DEFAULT_DEST_LABEL;

            cruiseConfig.expLogged = false;
            cruiseConfig.filterControls = {
                destination: {
                    name: 'destination',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (typeof value !== 'undefined') {
                            if (value) {
                                queryParam = {
                                    "destination": value
                                };
                            }
                        } else {
                            var selectedDest = state.get("cruiseDestination");
                            if (selectedDest) queryParam = {"destination": selectedDest};
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        if (data && data.destinations) {
                            var items = {};
                            for (var i in data.destinations) {
                                var dest = data.destinations[i];
                                if (_.isUndefined(items[dest.groupName])) {
                                    items[dest.groupName] = [];
                                }
                                items[dest.groupName].push({
                                    name: dest.optionText,
                                    value: dest.optionValue,
                                    selected: dest.selected,
                                    index: dest.index
                                });
                            }
                            inputDefaults.cruises.options = [{name: NEW_DEFAULT_DEST_LABEL, value: ''}];
                            for (var groupName in items) {
                                inputDefaults.cruises.options.push({name: groupName, options: items[groupName]});
                            }
                        }
                    }
                },
                departureMonth: {
                    name: 'departureMonth',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (!cruiseConfig.datePickerEnabled(state)) {
                            if (typeof value !== 'undefined') {
                                if (value) {
                                    var earliest = new Date(value);
                                    var latest = new Date(earliest.getFullYear(), earliest.getMonth() + 2, 0);
                                    queryParam = {
                                        "earliest-departure-date": cruiseConfig.getFormattedDate(earliest),
                                        "latest-departure-date": cruiseConfig.getFormattedDate(latest)
                                    };
                                }
                            } else {
                                var selectedMonth = state.get("cruiseMonth");
                                if (selectedMonth) {
                                    var earliest = new Date(selectedMonth);
                                    var latest = new Date(earliest.getFullYear(), earliest.getMonth() + 2, 0);
                                    queryParam = {
                                        "earliest-departure-date": cruiseConfig.getFormattedDate(earliest),
                                        "latest-departure-date": cruiseConfig.getFormattedDate(latest)
                                    };
                                }
                            }
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        if (data && data.departureMonths && !cruiseConfig.datePickerEnabled(state)) {
                            var items = [{name: NEW_DEFAULT_MONTH_LABEL, value: ""}];
                            for (var i in data.departureMonths) {
                                var month = data.departureMonths[i];
                                if (month.index === 1) {
                                    items.push({
                                        name: month.optionText,
                                        value: month.optionValue,
                                        selected: month.selected,
                                        index: month.index
                                    });
                                }
                            }
                            state.set('cruiseDepartureMonthOptions', items);
                        }
                    }
                },
                earliestDepartureDate: {
                    name: 'earliestDepartureDate',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (cruiseConfig.datePickerEnabled(state)) {
                            if (value) {
                                queryParam = {
                                    "earliest-departure-date": cruiseConfig.getFormattedDate(value)
                                };
                            } else {
                                var startDate = state.get("cruiseEarliestDepartureDate");
                                if (startDate) {
                                    var earliest = new Date(startDate);
                                    queryParam = {
                                        "earliest-departure-date": cruiseConfig.getFormattedDate(earliest)
                                    };
                                }
                            }
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        if (data && cruiseConfig.datePickerEnabled(state)) {
                            var whitelistedDates = '{"dates":' + data['jsonDepartureDateWhitelist'] + ',"blackoutDatesFlag":false}',
                                cruiseSailingDates = {
                                    whitelistedDates: whitelistedDates,
                                    earliestDepartureDate: state.get('cruiseEarliestDepartureDate'),
                                    latestDepartureDate: state.get('cruiseLatestDepartureDate')
                                };

                            state.set('cruiseSailingDates', cruiseSailingDates);
                        }
                    }
                },
                latestDepartureDate: {
                    name: 'latestDepartureDate',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (cruiseConfig.datePickerEnabled(state)) {
                            if (value) {
                                queryParam = {
                                    "latest-departure-date": cruiseConfig.getFormattedDate(value)
                                };
                            } else {
                                var endDate = state.get("cruiseLatestDepartureDate");
                                if (endDate) {
                                    var latest = new Date(endDate);
                                    queryParam = {
                                        "latest-departure-date": cruiseConfig.getFormattedDate(latest)
                                    };
                                }
                            }
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        if (data && cruiseConfig.datePickerEnabled(state)) {
                            var whitelistedDates = '{"dates":' + data['jsonDepartureDateWhitelist'] + ',"blackoutDatesFlag":false}',
                                cruiseSailingDates = {
                                    whitelistedDates: whitelistedDates,
                                    earliestDepartureDate: state.get('cruiseEarliestDepartureDate'),
                                    latestDepartureDate: state.get('cruiseLatestDepartureDate')
                                };

                            state.set('cruiseSailingDates', cruiseSailingDates);
                        }
                    }
                }
                /*
                 ,
                 cruiseLine: {
                 getQueryParam: function(state) {'cruise-line'},
                 update: function(data, state) {}
                 },
                 departurePort: {
                 getQueryParam: function(state) {'cruise-line'},
                 update: function(data, state) {}
                 },
                 cruiseLength:  {
                 getQueryParam: function(state) {'departure-port'},
                 update: function(data, state) {}
                 },
                 */
            };

            cruiseConfig.viewRules.BEXAsiaAdditionalCruiseFilters = true;

            cruiseConfig.model.cruiseDepartureMonthOptions = [{name: NEW_DEFAULT_MONTH_LABEL, value: ""}];
            cruiseConfig.model.cruiseLineOptions = [{name: "", value: ""}];
            cruiseConfig.model.cruisePortOptions = [{name: "", value: ""}];
            cruiseConfig.model.cruiseLengthOptions = [{name: "", value: ""}];

            cruiseConfig.constraints.cruiseFiltersEvar47 = function (model) {
                return [
                    "CRUISE",
                    model.get("cruiseDestination") ? "CDES" : NO_FILTER,
                    model.get("cruiseLine") ? "CLIN" : NO_FILTER,
                    model.get("cruisePort") ? "DPOR" : NO_FILTER,
                    model.get("cruiseMonth") ? "DMON" : NO_FILTER,
                    model.get("cruiseLength") ? "CLEN" : NO_FILTER
                ].join("|");
            };

            cruiseConfig.getSearchOptions = function (searchParameters, doneCallback, alwaysCallback) {
                var cruiseSelectBoxes = $("#tab-cruise").find("select");
                var cruiseInput = $("#tab-cruise").find("input");
                cruiseSelectBoxes.prop('disabled', true);
                cruiseInput.prop('disabled', true);
                $.ajax(
                    {
                        method: 'POST', // jQuery >= 1.9.0
                        type: 'POST', // jQuery < 1.9.0
                        url: env.cruiseEndpoint,
                        data: searchParameters,
                        dataType: 'json',
                        timeout: 10000
                    })
                    .done(doneCallback)
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        console.error("Failed to retrieve wizard data from /cruiseSearchCriteria/getSearchOptionsV2", jqXHR, textStatus, errorThrown);
                    })
                    .always(function (data) {
                        alwaysCallback(data);
                        cruiseSelectBoxes.prop('disabled', false);
                        cruiseInput.prop('disabled', false);
                    });
            };

            cruiseConfig.initialiseFilterOptions = function (state) {
                state.set('cruiseEarliestDepartureDate', '');
                state.set('cruiseLatestDepartureDate', '');

                var searchParameters = {},
                    destination = state.get('cruiseDestination');
                if (destination && destination.length > 0) {
                    searchParameters['destination'] = destination;
                }
                cruiseConfig.getSearchOptions(searchParameters,
                    function (data) {
                        for (var i in cruiseConfig.filterControls) {
                            var ctrl = cruiseConfig.filterControls[i];
                            ctrl.update(data, state);
                        }
                    },
                    function () {
                    }
                );
            };

            cruiseConfig.filterChange = function (filter, state, value) {
                cruiseConfig.getSearchOptions(cruiseConfig.getQueryParams(filter, state, value),
                    function (data) {
                        for (var i in cruiseConfig.filterControls) {
                            var ctrl = cruiseConfig.filterControls[i];
                            ctrl.update(data, state);
                        }
                    },
                    function () {
                        state.trigger('reloadWizard');
                    }
                );
            };

            /*
             {
             'destination': 'caribbean',
             'earliest-departure-date': '2016-1-1',
             'latest-departure-date': '2016-2-28'
             }
             */
            cruiseConfig.getQueryParams = function (filter, state, value) {
                var queryParams = {};
                for (var i in cruiseConfig.filterControls) {
                    var ctrl = cruiseConfig.filterControls[i];
                    if (i === filter.name) {
                        queryParams = $.extend(true, {}, queryParams, ctrl.getQueryParam(state, value));
                    } else {
                        queryParams = $.extend(true, {}, queryParams, ctrl.getQueryParam(state));
                    }
                }

                if (cruiseConfig.datePickerEnabled(state)) {
                    if (queryParams['earliest-departure-date'] && !queryParams['latest-departure-date']) {
                        queryParams['latest-departure-date'] = queryParams['earliest-departure-date'];
                        state.set('latest-departure-date', cruiseConfig.getCalendarFormattedDateFromString(queryParams['latest-departure-date']));
                    } else if (!queryParams['earliest-departure-date'] && queryParams['latest-departure-date']) {
                        queryParams['earliest-departure-date'] = queryParams['latest-departure-date'];
                        state.set('earliest-departure-date', cruiseConfig.getCalendarFormattedDateFromString(queryParams['earliest-departure-date']));
                    }
                }

                return queryParams;
            };

            cruiseConfig.getFormattedDate = function (date) {
                var result = "";
                if (date) {
                    var curr_date = date.getUTCDate(),
                        curr_month = date.getUTCMonth() + 1,
                        curr_year = date.getUTCFullYear();
                    result = curr_year + "-" + curr_month + "-" + curr_date;
                }
                return result;
            };

            cruiseConfig.getCalendarFormattedDateFromString = function (date) {
                if (date) {
                    var datePieces = date.split("-"),
                        year = datePieces[0],
                        month = datePieces[1],
                        day = datePieces[2];

                    return month + "/" + day + "/" + year;
                }

                return "";
            };

            cruiseConfig.track = function (tag) {
                if (window.dctk && dctk.onReady) {
                    dctk.onReady(function () {
                        dctk.trackAction(tag);
                    });
                }
            };

            cruiseConfig.datePickerEnabled = function (state) {
                return state.get('uitkAccessCal') && cruiseConfig.viewRules.cruiseStorefrontDateBasedSearch();
            };

            defaultConfig.addEvent('cruiseDestination', function (state, value) {
                cruiseConfig.track('CRU.SF.Filter.Destination');
                cruiseConfig.filterChange(cruiseConfig.filterControls.destination, state, value);
            });
            defaultConfig.addEvent('cruiseMonth', function (state, value) {
                cruiseConfig.track('CRU.SF.Filter.Month');
                cruiseConfig.filterChange(cruiseConfig.filterControls.departureMonth, state, value);
            });
            //      defaultConfig.addEvent('cruiseLine', function(state, value) {cruiseConfig.filterChange(cruiseConfig.filterControls.cruiseLine, state, value);});
            //      defaultConfig.addEvent('cruisePort', function(state, value) {cruiseConfig.filterChange(cruiseConfig.filterControls.departurePort, state, value);});
            //      defaultConfig.addEvent('cruiseLength', function(state, value) {cruiseConfig.filterChange(cruiseConfig.filterControls.cruiseLength, state, value);});

            uitk.subscribe('datepicker.selectDate', function (topic, data) {
                var id = data.element.context.id;

                if (id === 'earliestDepartureDateParent') {
                    cruiseConfig.track('CRU.SF.Filter.Start.Date');
                    cruiseConfig.filterChange(cruiseConfig.filterControls.earliestDepartureDate, dataModels.state, data.date);
                } else if (id === 'latestDepartureDateParent') {
                    cruiseConfig.track('CRU.SF.Filter.End.Date');
                    cruiseConfig.filterChange(cruiseConfig.filterControls.latestDepartureDate, dataModels.state, data.date);
                }
            });
        }
        else {

        }
    };
    langCheck();
    if (env.locale === 'en_US') {
        cruiseConfig.initialiseFilterOptions(dataModels.state);
    }

    $.extend(true, cruiseConfig, cruiseConfigOverride);

    return cruiseConfig;
});

define('gc/threePPConfig', ['gc/defaultConfig', 'gc/threePPConfigOverride'], function(defaultConfig, threePPConfigOverride) {
    var threePP = {
        enabled: false,
        icon: "packages",
        template: 'corewizard/layouts/wizard-hbs-threepp',
        searchUrlGenerator: 'threePPSearchUrl',
        eventsToAdd: {}
    };

    $.extend(true, threePP, threePPConfigOverride);

    if(threePP.enabled && Object.keys(threePP.eventsToAdd).length > 0 ) {
        Object.keys(threePP.eventsToAdd).forEach(function(key) {
            defaultConfig.addEvent(key, threePP.eventsToAdd[key]);
        });
    }

    return threePP;
});
define('gc/vacationRentalsConfig', [
    'jquery',
    'gc/vacationRentalsConfigOverride'
], function(
    $,
    vacationRentalsConfigOverride
) {
    var vacationRentalsConfig = {
        icon: 'vacation-rentals',
        isEnabled: function() {
            return true;
        }
    };

    $.extend(true, vacationRentalsConfig, vacationRentalsConfigOverride);

    return vacationRentalsConfig;
});

define('gc/openSearchConfig', [
    'jquery',
    'gc/loc',
    'gc/openSearchConfigOverride',
    'gc/openSearchValidationRules'
], function(
    $,
    loc,
    openSearchConfigOverride,
    openSearchValidationRules
) {
    var openSearchConfig = {
        icon: 'search',
        template: 'corewizard/field-groups/open-search-hbs',
        searchUrlGenerator: 'openSearchUrl',
        validation: openSearchValidationRules,
        isEnabled: function() {
            return false;
        },
        viewRules: {
            'openSearchLabel': function(model){
                'use strict';
                return loc.openSearchLabel;
             },
              "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, openSearchConfig, openSearchConfigOverride);

    return openSearchConfig;
});
define('gc/openSearchValidationRules', [], function() {
  return {
  "searchQuery": [true,
                     [
                       ['isNotBlank', ['searchQuery'], 'search-query-blank']]]
  }
});
define('gc/wizardConfig', ['pageConfigOverride', 'gc/wizardConfigFun'], function(pageConfigOverride, wizardConfigFun) {
    return wizardConfigFun(pageConfigOverride);
});

define('gc/wizardConfigFun', ['jquery', 'gc/wizardConfigOverride', 'gc/merge'],
  function($, wizardConfigOverride,  merge) {
    return function(pageConfigOverride) {
      var wizardConfig = merge(wizardConfigOverride, pageConfigOverride);

      // total replacement of lobs
      if(pageConfigOverride && pageConfigOverride.lobs) {
        wizardConfig.lobs = pageConfigOverride.lobs;
      }

      return wizardConfig;
    }
});

/*jslint nomen: true */
/*global Backbone, corewizard */

define('gc/Config', [
  'gc/merge',
  'gc/getLob',
  'gc/getDefaultTabAndPackages',
  'jquery'
], function(
  merge,
  getLob,
  getDefaultTabAndPackages,
  $
) {
    return Backbone.NestedModel.extend({
        constructor : function(attributes, options) {
            'use strict';
            this.state = options.state;
            this.defaultLob = options.defaultLob;
            XDate.prototype.setParseDateFormat(attributes.def.dateFormat);
            this.on('change:flight.preferredAirlines', function() {
                this.state.trigger('reloadWizard');
            });
            var defaultTabAndPackages = getDefaultTabAndPackages(arguments[0]);
            this.defaultTab = defaultTabAndPackages.tab;
            this.defaultPackages = defaultTabAndPackages.packages;
            Backbone.NestedModel.apply(this, arguments);
        },
        get : function(key) {
            'use strict';
            var get = Backbone.NestedModel.prototype.get;
            var lobSpecificConfig = get.call(this, this.getCurrentLob() + '.' + key);
            var defaultConfig = get.call(this, 'def.' + key);
            if (_.isObject(lobSpecificConfig) && _.isObject(defaultConfig)) {
                return $.extend(true, {}, defaultConfig, lobSpecificConfig);
            } else {
                return lobSpecificConfig || defaultConfig;
            }
        },
        getCurrentLob : function() {
          var tab = this.state.get('tab');
          var pkg = this.state.get('packages');
          if (!tab) {
            tab = this.defaultTab;
          }
          if (!pkg) {
            pkg = this.defaultPackages;
          }
          return getLob(tab, pkg);
        },
        toJSON : function() {
            'use strict';
            var json = Backbone.NestedModel.prototype.toJSON.call(this);
            var tab = this.state.get('tab');
            var pkg = this.state.get('packages');
            return merge(json['def'], json[this.getCurrentLob()]);
        }
    });
});

define('gc/validationHelpers', ['gc/predicates', 'gc/json-path'],
       function(predicates, jsonPath) {
  return {
    startAndEndDateAreBlank: function (model) {
      return (!predicates.isNotBlank(jsonPath('startDate', model)).isValid) &&
        (!predicates.isNotBlank(jsonPath('endDate', model)).isValid)
    }
  }
});

/*
Validator is used mainly in submit.js to validate model data on form submission,
but can also be used in other places. Validation data consists of a:

"ruleSet", which is a javascript object that consists of
  - "ruleGroups", which is an array that contains
    - "rules"
 */

define('gc/validate', ['gc/predicates', 'gc/json-path', 'underscore'], function(predicates, jsonPath, _) {
  var defaults = {
    'isValid' : true,
    'fields' : [],
    'errors' : []
  };

  function validate(ruleSet, model) {
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var validationResults = runRuleSet(ruleSet, model);
    return validationResults;
  }

  function runRuleSet(ruleSet, model) {
    // ruleSet: {ruleGroup1: RuleGroup, ruleGroup2: RuleGroup}
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var ruleSetResult = _.clone(defaults);

    _.each(ruleSet, function(ruleGroup) {
      if (shouldRunRuleGroup(ruleSet, model, ruleGroup, ruleSetResult)) {
        ruleSetResult = mergeResult(ruleSetResult, runRuleGroup(ruleGroup, model));
      }
    });

    return ruleSetResult;
  }

  function runRuleGroup(ruleGroup, model) {
    // ruleGroup: [[String]|Function|Boolean, [Rule], (Boolean)]
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var ruleList = _.isFunction(ruleGroup[1]) ?
        ruleGroup[1].call(this, model) :
        ruleGroup[1];
    // set to true if you want the tests to continue after finding an error
    var failFast = !ruleGroup[2];
    var ruleGroupResult = _.clone(defaults);

    //using find so we can break out of the loop
    _.find(ruleList, function (rule) {
      var ruleResult = runRule(rule, model);
      ruleGroupResult = mergeResult(ruleGroupResult, ruleResult);
      if (failFast && !ruleResult.isValid) {
        return true; //break
      }
    });

    return ruleGroupResult;
  }

  function runRule(rule, model) {
    // rule: [String, [String], String, ([String])]
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var validationFnName = rule[0];
    var propertiesToValidate = rule[1];
    var errorName = rule[2];
    var errorProperties = rule[3];
    var validationFn = predicates[validationFnName];
    var propertyValues = _.map(propertiesToValidate,
                               function(property) {
                                 return jsonPath(property, model);
                               });
    var result = validationFn.apply(predicates, propertyValues);

    if (!result.isValid) {
      result = mergeResult(result, {
        fields:  errorProperties ? errorProperties : propertiesToValidate,
        errors: [errorName]
      });
    }

    return result;
  }

  function mergeResult(result1, result2) {
    // result1, result2, and return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    result1 = _.clone(result1);

    if (!result2.isValid) result1.isValid = false;
    result1.fields = _.union(result1.fields, result2.fields);
    result1.errors = _.union(result1.errors, result2.errors);

    return result1;
  }

  function shouldRunRuleGroup(ruleSet, model, ruleGroup, ruleSetResult) {
    'use strict';
    var runCond = ruleGroup[0];
    if (_.isArray(runCond)) {
      // this should be a list of field names which must be valid to run
      var rules = [];
      _.each(runCond, function(rule) {
        var ruleGroup = ruleSet[rule]
        if (ruleGroup) {
          rules.push(ruleGroup);
        }
      });
      var results = runRuleSet(rules, model);
      return _.intersection(results.fields, runCond).length === 0;
    } else if (_.isFunction(runCond)) {
      return runCond.call(this, model, ruleSetResult);
    }else{
      return runCond;
    }
  }

  return validate;
});

define('gc/State', ['jquery', 'uitk'], function($) {

  var uitkMajorVersion = "";
  var uitkAccessCal = false;

  if (typeof uitk != "undefined") {
    uitkMajorVersion = parseFloat(uitk.version.substring(1, uitk.version.lastIndexOf('.')))
    uitkAccessCal = (uitkMajorVersion >= 2.58);
  }
  
  return Backbone.NestedModel.extend({
    // need to bootstrap the rooms array or it get's turned into an object
    // bug https://jira/jira/browse/MAIN-120543
    defaults: {
      rooms: [{
        adults: 0,
        childCount: 0,
        guests: 0,
        children: []
      }],
      uitkVersion: uitkMajorVersion,
      uitkAccessCal: uitkAccessCal
    },
    clear: function(options) {
      Backbone.NestedModel.prototype.clear.call(this, options);
      this.set(this.defaults, options);
    }
  });
});
/*jslint nomen: true */
/*global Backbone, corewizard, $ */

define('gc/DefaultState', ['jquery'], function($) {
    return Backbone.NestedModel.extend({
        constructor : function (attributes, options) {
            'use strict';
            this.state = options.state;
            this.config = options.config;
            Backbone.NestedModel.apply(this, arguments);
        },
        get : function (key) {
            'use strict';
            var result;

            result = this.state.get(key);
            if (typeof result === 'undefined') {
                result = this.config.get('model.' + key);
            }

            return result;
        },
        toJSON: function () {
            'use strict';
            var stateJSON,
              defaultJSON;

            stateJSON = this.state.toJSON();
            defaultJSON = this.config.get('model');

            return $.extend(true, {}, defaultJSON, stateJSON);
        }
    });
});
/*jslint nomen: true */
/*global Backbone, _, corewizard, $ */

define('gc/ConstraintModel', ['jquery'], function($) {
    return Backbone.NestedModel.extend({
        constructor : function (attributes, options) {
            'use strict';
            this.state = options.state;
            this.config = options.config;
            Backbone.NestedModel.apply(this, arguments);
        },
        get : function (key) {
            'use strict';
            var result,
              constraints,
              con;
            if (key.indexOf('config.') === 0) {
                result = this.config.get(key.replace('config.', ''));
            } else {
                constraints = this.config.get('constraints');
                con = constraints[key];

                if (con) {
                    if (typeof con === 'function') {
                        result = con.call(this, this.state, this.config);
                    } else {
                        result = con;
                    }
                } else {
                    result = this.state.get(key);

                    if (typeof result === 'undefined' || result === null) {
                        result = this.config.get('model.' + key);
                    }
                }
            }

            return result;
        },
        toJSON: function () {
            'use strict';
            var tempModel,
              constraints;

            constraints = this.config.get('constraints');
            tempModel = this.state.toJSON();

            _.each(constraints, function (value, key) {
                if (typeof value === 'function') {
                    tempModel[key] = value.call(this, this.state, this.config);
                } else {
                    tempModel[key] = value;
                }
            }, this);

            tempModel.config = this.config.toJSON();

            return tempModel;
        }
    });
});
/*global Backbone, _ */

define('gc/ViewModel', ['jquery'], function($) {
    return Backbone.NestedModel.extend({
        constructor: function (attributes, options) {
            'use strict';

            this.model = options.model;

            Backbone.NestedModel.apply(this, arguments);
        },
        get: function (key) {
            'use strict';

            var viewRules,
              rule,
              value;

            viewRules = this.model.get('config.viewRules');
            rule = viewRules[key];

            if (rule) {
                if (typeof rule === 'function') {
                    value = rule.call(this, this.model, this.model.state);
                } else {
                    value = rule;
                }
            } else {
                value = this.model.get(key);
            }

            return value;
        },
        toJSON: function () {
            'use strict';

            var tempModel,
              viewRules;

            viewRules = this.model.get('config.viewRules');
            tempModel = this.model.toJSON();

            _.each(viewRules, function (value, key) {
                if (typeof value === 'function') {
                    tempModel[key] = value.call(this, this.model);
                } else {
                    tempModel[key] = value;
                }
            }, this);

            return tempModel;
        }
    });
});

define('gc/dataModels', [
  'gc/State',
  'gc/Config',
  'gc/ViewModel',
  'gc/DefaultState',
  'gc/ConstraintModel'
], function(
  State,
  Config,
  ViewModel,
  DefaultState,
  ConstraintModel
) {
  var dm = {
    state: new State()
  };
  dm.update = function(c) {
    dm.state.clear({silent:true});
    dm.config = new Config(c, {state : dm.state});
    dm.defaultState = new DefaultState({}, {state: dm.state, config: dm.config});
    dm.model = new ConstraintModel({}, {state: dm.defaultState, config: dm.config});
    dm.viewModel = new ViewModel({}, {model: dm.model });
    return dm;
  }

  return dm;
});

define('gc/preferredAirlines', ['gc/loc', 'gc/dataModels', 'env'], function(loc, dataModels, env) {
  return {
    setPreferredAirlines: function () {
      $.ajax({
        url: '//' + window.location.host + '/api/flight/getairlines',
        timeout: env.airlinesTimeout,
        success: getPreferredAirlinesSuccess,
        error: function() {console.warn('failed to get preferred airlines');}
      });
    }
  };

  function getPreferredAirlinesSuccess(airlineData) {
    airlineData = parseAirlineData(airlineData);
    dataModels.config.set('flight.preferredAirlines', airlineData);
  }

  function parseAirlineData(airlineData) {
    airlineData = _.map(airlineData, function(airline) {
      return { name: airline.name, value: airline.code };
    });
    airlineData.unshift({
      name : loc.preferredAirlineDefault,
      value : '',
      selected : 'selected'
    });
    return airlineData;
  }
});

/*
 * Dependencies:
 * jQuery
 * corewizard.logger
 * JSON (needs to be added with trunk/content/static_content/default/default/scripts/external/json/json2.js for older browsers)
 */
define('gc/config', ['gc/Logger'], function(Logger) {
	return function(json) {
		var logger = new Logger('corewizard.model');
		var addJSON = logger.returnLoggingFunction('addJSON', function (json) {
			for (var component in json) {
				if (_data[component]) {
					for (var context in json[component]) {
							if (_data[component][context]) {
								for (var property in json[component][context]) {
									_data[component][context][property] = json[component][context][property];
								}
							} else {
								_data[component][context] = json[component][context];

							}
					}
				} else {
					_data[component] = json[component];
				}
			}
		});
		var getContexts = logger.returnLoggingFunction('getContexts', function (context) {
			if (context instanceof Array) {
				context.push('def');
			} else if (typeof context == 'string') {
				context = [context, 'def'];
			} else {
				context = ['def'];
			}
			return context;
		});
		logger.attacheLoggingFunction(this, 'get', function(component, property, context, field) {
			var result = undefined;
			if (field) {
				if (field.is('[data-wizard-type="' + property + '"]')) {
					result = field.attr('data-' + component);
				} else {
					result = field.attr('data-' + component + '-' + property);
				}
				if (result) {
					if (result == 'true')
						return true;
					if (result == 'false')
						return false;
					return result;
				}
			}
			if (!_data[component])
				return undefined;
			context = getContexts(context);
			var i = 0;
			while (typeof result == 'undefined' && i < context.length) {
				if (!_data[component][context[i]]) {
					i ++;
					continue;
				}
					result = _data[component][context[i]][property];
				i ++;
			}
			return result;
		});
		logger.attacheLoggingFunction(this, 'getAll', function(context) {
			'use strict';
			var component, property, currentContext, data = {};
			for (component in _data) {
				context = getContexts(context);
				for (var i = context.length - 1; i >= 0; i --) {
					currentContext = context[i];
						for (property in _data[component][currentContext]) {
							if (!data[component])
								data[component] = {};
							data[component][property] = _data[component][currentContext][property];
						}
				}
			}
			return data;
		});
		this.add = addJSON;
		var _data = {model:{}};
		addJSON(json);
	}
	
});
/*
 * Dependencies:
 * expClientLogging
 */
define('gc/Logger', function () {
	var doLogging = false;
	return function(filename) {
		var _filename = filename;
		function logError(functionName, e) {
			if (doLogging && window['expClientLogging']) {
				expClientLogging.logMessage(functionName + 'Error',
						['errorName=' + e.name, 'errorMessage=' + e.message, 'stackTrace=' + e.stack,
				          'file=' + _filename, 'module=coreWizard', 'function=' + functionName]);
				}
				throw e;
		}
		this.attacheLoggingFunction = function(obj, name, fun) {
			if (doLogging) {
				obj[name] = logingFunction(name, fun, obj);
			} else {
				obj[name] = fun;
			}
		};
		function logingFunction(name, fun, obj) {
			if (doLogging) {
				obj = obj || null;
				return function() {
					try {
						fun.call(obj, arguments);
					} catch (e) {
						logError(name, e)
					}
				};
			} else {
				return fun;
			}
		}
		this.returnLoggingFunction = logingFunction;
		this.log = logError;
		this.setDoLogging = function(value) {
			doLogging = value;
		};
		this.getDoLogging = function() {
			return doLogging;
		}
	}
});
define('gc/date', ['gc/config'], function (config) {
	var configJSON = {date:{def:{format:'mm/dd/yyyy',
								 seporator:'/',
								 normalizedFormat:'mmddyyyy'}}};
	var _config = new config(configJSON);
	var _millasecondsInADay = (1000 * 60 * 60 * 24);
	var dateFormatAndIndices = {
		"mmddyy":{day:1,month:0, year:2, regex:'^(?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])(?:[- /.](?:20)*\\d\\d)*$'},
		"mmddyyyy":{day:1,month:0, year:2, regex:'^(?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])(?:[- /.](?:20)*\\d\\d)*$'},
		"ddmmyy":{day:0,month:1, year:2, regex:'^(?:0*[1-9]|[12][0-9]|3[01])[- /.](?:0*[1-9]|1[012])(?:[- /.](?:20)*\\d\\d)*$'},
		"ddmmyyyy":{day:0,month:1, year:2, regex:'^(?:0*[1-9]|[12][0-9]|3[01])[- /.](?:0*[1-9]|1[012])(?:[- /.](?:20)*\\d\\d)*$'},
		"yymmdd":{day:2,month:1, year:0, regex:'^(?:(?:20)*\\d\\d)[- /.](?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])*$'},
		"yyyymmdd":{day:2,month:1, year:0, regex:'^(?:(?:20)*\\d\\d)[- /.](?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])*$'}
	};
	return {
		isValidDate: function(value) {
			var regex = new RegExp(dateFormatAndIndices[_config.get('date', 'normalizedFormat')].regex);
			return regex.test(value);
		},
		fromString: function(value) {
			if (!value) {
		        return null;
		    }
		    var parsed = this.splitDate(value);
		    var date = new Date(parsed.year, parsed.month - 1, parsed.day); // month goes by index 0
		    if (isNaN(date.getTime())) {
		        return null
		    }
		    return date;
		},
        toString: function(date) {

            function monthAsString() {
                return date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            }

            function dateAsString() {
                return date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            }

            function yearAsString() {
                return date.getFullYear();
            }

            function format(format) {
                var result = format.toUpperCase().replace("MM", monthAsString());
                result = result.replace("DD", dateAsString());
                result = result.replace("YYYY", yearAsString());
                result = result.replace("YY", (yearAsString() % 2000));
                return result;
            };
            return format(_config.get('date', 'format'));
        },
		splitDate: function(value) {
			if (!value || value == "") {
		        return null;
		    }
		    var parts =  value.split(_config.get('date', 'seporator'));
		    var indices = dateFormatAndIndices[_config.get('date', 'normalizedFormat')];
		    if (indices == undefined) return [];
		    var parsedDate = {
		        day:parseInt(parts[indices.day], 10),
		        month:parseInt(parts[indices.month], 10),
		        year:parseInt(parts[indices.year], 10)
		    };
		    if (parsedDate.year < 100) parsedDate.year = 2000 + parsedDate.year;
		    return parsedDate;
		},
		compare: function(date1, date2) {
			date1 = this.getDate(date1);
			date2 = this.getDate(date2);
			if (!date1 || !date2) {
				return null;
			}
			if (date1 > date2) {
				return 1;
			} else if (date1 < date2) {
				return -1;
			} else {
				return 0;
			}
		},
		compareWithoutTime: function(date1, date2) {
			date1 = this.dropTimeInDate(this.getDate(date1));
			date2 = this.dropTimeInDate(this.getDate(date2));
			return this.compare(date1, date2);
		},
		addDaysToDate: function(date, days) {
			date = this.getDate(date);
			return new Date(date.getTime() + (_millasecondsInADay * days));
		},
		dropTimeInDate: function(date) {
			return new Date(date.getFullYear(), date.getMonth(), date.getDate());
		},
		getDate: function(date) {
			if (date instanceof Date) {
				return date;
			} else if (typeof date === 'number') {
				return new Date(date);
			} else if (typeof date === 'string') {
				return new Date(this.fromString(date));
			} else {
				return null;
			}
		},
		setConfig: function(config){
			_config = config;
		}
	};
});
define('gc/wizardHelpers', ['uitk', 'gc/loc', 'gc/inputDefaults', 'gc/dataModels', 'handlebars.runtime', 'gc/abTest'], function(uitk, loc, inputDefaults, dataModels, Handlebars, abTest) {
  var hbr_helpers = {
    extractAttributes : function(hash) {
      var ia = [];
      for (var key in hash) {
        //take all ia- attributes declared and put in an ia array.
        if (key.substr(0, 2) === 'ia') ia.push({
          name: [key.substr(3)],
          value: hash[key]
        });
      }
      return ia;
    },

    commonAttributes : function(data, options) {
      'use strict';
      data.wizard_action = options['wizard-action'];
      data.hasError = options['has-error'];

    },

    extractInputAttributes : function(hash){
      var inputAttributes = [];
      for (var key in hash) {
        //take just attributes declared needed for the input and put in an inputAttributes array.
        if (key.substr(0, 8) === 'ia-value' || key.substr(0, 16) === 'ia-aria-required') inputAttributes.push({
          name: [key.substr(3)],
          value: hash[key]
        });
      }
      return inputAttributes;
    }
  };

  Handlebars.registerHelper('is-valid', function() {
    'use strict';
    return dataModel.model.get('validation.isValid');
  });
  Handlebars.registerHelper('is-error-field', function(field) {
    'use strict';
    return _.contains(dataModel.model.get('validation.fields'), field);
  });
  Handlebars.registerHelper('is-error', function(key) {
    'use strict';
    return _.contains(dataModel.model.get('validation.errors'), key);
  });
  Handlebars.registerHelper('config', function(key) {
    'use strict';
    return dataModels.config.get(key);
  });

  Handlebars.registerHelper('log', function (data) {
    console.log(data);
  });

  Handlebars.registerHelper('assign', function (scope, key, operand, comparator, options) {
    if (scope && key && operand) {

      switch (operand) {
        case '!' :
          scope[key] = !comparator;
          break;
        default :
          scope[key] = comparator;
      }

    }

  });

  Handlebars.registerHelper('row', function(data, options) {
    var attributes = [],
      thisData = data,
      options = arguments[arguments.length - 1];
    options.hash['class'] = options.hash['class'] ? options.hash['class'] + ' cols-nested' : 'cols-nested';

    for (var attributeName in options.hash) {
      attributes.push(attributeName + '="' + options.hash[attributeName] + '"');
    }
    return '<fieldset ' + attributes.join(' ') + '>' + options.fn(this) + '</fieldset>';
  });

  Handlebars.registerHelper('input-calendar', function(data, namespace, options) {
    var attributes = [],
      thisData = data,
      options = arguments[arguments.length - 1],
      companionLookup = {
        departing: 'returning',
        returning: 'departing',
        checkin: 'checkout',
        checkout: 'checkin'
      },
      companionAttrLookup = {
        departing: 'data-end-date',
        returning: 'data-start-date',
        checkin: 'data-end-date',
        checkout: 'data-start-date'
      },
      hotelFlightLookup = {
        checkin : 'departing',
        checkout : 'returning'
      };

    //remove value for dateless.
    if (options.hash['ia-value'] && data.isDateless) delete options.hash['ia-value'];

    thisData = $.extend({}, data, options.hash);

    var extension = {
      ia : hbr_helpers.extractAttributes(options.hash),
      namespace : namespace,
      companion : companionLookup[namespace],
      isDisabled : thisData.isDateless,
      inputAttributes : hbr_helpers.extractInputAttributes(options.hash),
      hasError : function() {
        if (thisData.id === 'hotel') {
          //lookup correct error keys for each situation.
          if (thisData.useFlightDates && typeof thisData.errTypes === 'object' && thisData.errTypes[hotelFlightLookup[namespace]])
            return true;
          if (thisData.useHotelDates && typeof thisData.errTypes === 'object' && thisData.errTypes[namespace])
            return true;
        }
        if (thisData.namespace === 'start') return thisData.errTypes && thisData.errTypes.departing;
        if (thisData.namespace === 'end') return thisData.errTypes && thisData.errTypes.returning;
        var hasError = thisData.errTypes && typeof thisData.errTypes === 'object' && thisData.errTypes[namespace];
        if (!hasError) return false; //no errors.
        return hasError;
      }
    };

    hbr_helpers.commonAttributes(extension, options.hash);

    //apply min/max for hotels for 'hotel', 'flight-hotel', and 'hotel-flight'.
    var maxBooking = thisData.isHotelOnly ? 60 : 26;
    extension.ia.push({ name : 'data-max-booking-length', value : maxBooking});
    extension.ia.push({ name : 'data-max-range-length', value : maxBooking});

    if (thisData.id && thisData.id.indexOf('hotel') > -1) {
      extension.ia.push(
        //some default hotel calendar settings.
        { name : 'data-min-booking-length', value : '1' },
        { name : 'data-default-booking-length', value : '1' },
        { name : 'data-min-range-length', value : '1' },
        { name : 'data-default-range-length', value : '1' },
        { name : 'data-wizard-owner', value : thisData.id}
      );
    }

    //if there's an index, we're a multi destination field.
    //if () thisData.isMultiDest = true;
    if (thisData.index || thisData.index === 0) {
      if (!extension.wizard_action)
        extension['wizard_action'] = '{"multiDest.' + namespace + '[' + thisData.index + ']" : "$value1"}';
      thisData.isMultiDest = true;

    } else {
      if (!extension.wizard_action)
        extension['wizard_action'] = '{"' + (thisData.useFlightDates ? hotelFlightLookup[namespace] : namespace) + '" : "$value1"}';
    }
    //workaround for multiDest error states
    if (_.contains(dataModels.model.get('validation.fields'), 'multiDest')) {
      if (_.contains(dataModels.model.get('validation.fields'), 'startDate:' + thisData.number)) {
        thisData.hasError = true;
      }
    }

    $.extend(thisData, extension);

    if (!thisData.isMultiDest && !thisData.isOneWay) thisData['companion-attr'] = companionAttrLookup[namespace];
    return new Handlebars.SafeString(Handlebars.partials['corewizard/components/input-calendar-hbs'](thisData));
  });

  Handlebars.registerHelper('input-TA', function(data, namespace, options) {

    var options = arguments[arguments.length - 1],
      thisData = data;
    thisData = $.extend({}, data, options.hash);


    var extension = {
      namespace : namespace,
      ia : hbr_helpers.extractAttributes(options.hash),
      ta_key : function() {
        if (options.hash['ta-key']) return options.hash['ta-key'];
        var string = '', suffix;
        if (thisData.packages.flight && thisData.packages.car && (!thisData.packages.hotel) && namespace === 'destination') string += 'package_FC_';
        else if (thisData.packages.flight) string += 'package_';
        else string += 'flight_';
        suffix = (namespace === 'destination') ? 'dest' : namespace;
        return string + suffix;
      }
    };

    //workaround for multiDest error states
    if (_.contains(dataModels.model.get('validation.fields'), 'multiDest')) {
      if (_.contains(dataModels.model.get('validation.fields'), namespace + ':' + thisData.number)) {
        thisData.hasError = true;
      }
    }

    hbr_helpers.commonAttributes(extension, options.hash);

    if (thisData.index || thisData.index === 0) {
      thisData.index = '' + thisData.index;
      if (!extension.wizard_action)
        extension['wizard_action'] = '{"multiDest.' + namespace + '.[' + thisData.index + ']" : "$value1"}';

    }

    $.extend(thisData, extension);
    return new Handlebars.SafeString(Handlebars.partials['corewizard/components/input-ta-hbs'](thisData));
  });

  Handlebars.registerHelper('input', function(data, type, namespace, bool, options) {
    function swapIdAndNamespace(data) {
      var id = data.id;
      data.id = data.namespace;
      data.namespace = id;
      return data;
    }
    var options = arguments[arguments.length - 1],
      thisData = data;
    thisData = $.extend({}, data, options.hash);
    var extension = {
      namespace : namespace,
      ia : hbr_helpers.extractAttributes(options.hash),
      hasError : typeof thisData.errTypes === 'object' && thisData.errTypes[namespace],
      isChecked : bool
    };

    hbr_helpers.commonAttributes(extension, options.hash);

    switch (type) {
      case 'radio' :
        if (options.hash['ia-name'] === 'flight-type' && !thisData.isFlightOnly) {
          thisData.isDisabled = true;
          thisData['class'] = 'disabled col';
        }
    }
    $.extend(thisData, extension);

    //Allen Kim: Package radio buttons need to have id in the format "package-{{id}}"
    if (type === 'radio' && namespace === 'package') {
      thisData = swapIdAndNamespace(_.clone(thisData));
    }

    var templateName = Handlebars.partials['corewizard/components/input-' + type + '-hbs'];
    if (templateName)
      return new Handlebars.SafeString(templateName(thisData));
  });

  Handlebars.registerHelper('select', function(data, namespace, dataKey, options) {

    var options = arguments[arguments.length - 1],
      thisData = data;
    thisData = $.extend({}, data, options.hash);

    var optionsList = thisData['options-list'] ||
      inputDefaults[dataKey] && inputDefaults[dataKey].options
      || [];

    var label_text = typeof thisData['label-text'] !== 'undefined' ?
      thisData['label-text'] :
      inputDefaults[dataKey] ?
        inputDefaults[dataKey].label :
        '';
    if (thisData['no-label'] && thisData['no-label'] == true)
    {
      label_text = '';
    }

    var extension = {
      namespace : namespace,
      ia : hbr_helpers.extractAttributes(options.hash),
      hasError : (typeof thisData.errTypes === 'object' && thisData.errTypes[namespace]) || thisData.error,
      options : optionsList,
      'label-text' : label_text
    };

    hbr_helpers.commonAttributes(extension, options.hash);

    if (!options['ia-data-wizard-owner']) {
      extension.ia.push({
        name : 'data-wizard-owner',
        value : namespace
      });
    }
    extension.namespace = thisData.id + '-' + extension.namespace;
    var indexForRoom = thisData.index || 0;
    switch (dataKey) {
      case 'childAges' :
        var childAgeErrorIndex = thisData.roomIndex + ':' + thisData.index;
        thisData.hasError = _.contains(dataModels.model.get('validation.fields'), childAgeErrorIndex);
        extension['label-text'] = thisData['label-text'];
        if (!extension.wizard_action)
          extension['wizard_action'] = '{"rooms[' + indexForRoom + '].children[' + thisData.index + ']" : $value1}';
        extension.namespace = thisData.id;
        thisData['label-class'] = 'child-number-' + thisData.childNumber;
        break;
      case 'flightChildren' :
      case 'hotelChildren' :
        var childErrorIndex = indexForRoom + 'c';
        thisData.hasError = _.contains(dataModels.model.get('validation.fields'), childErrorIndex);
        if (!extension.wizard_action)
          extension['wizard_action'] = '{"rooms[' + thisData.index + '].childCount" : $value1}';
        break;
      case 'hotelAdults' :
        var adultErrorIndex = indexForRoom + 'a';
        thisData.hasError = _.contains(dataModels.model.get('validation.fields'), adultErrorIndex);
        if (!extension.wizard_action) {
          extension['wizard_action'] = '{"rooms[' + thisData.index + '].adults" : $value1}';
          if (thisData.ownerId === 'package' || 'flight-hotel') {
            extension.options = inputDefaults[dataKey].options.slice(0, 6);
          }
        }
        if (dataModels.state.get('oneGuestSelected')) {
          extension.ia[0].value = 1;
          dataModels.state.unset('oneGuestSelected', {'silent' : true});
        }
        break;

      case 'hotelGuests' :
        var guestErrorIndex = indexForRoom + 'g';
        thisData.hasError = _.contains(dataModels.model.get('validation.fields'), guestErrorIndex);
        if (!extension.wizard_action)
        {
          extension['wizard_action'] = '{"rooms[' + thisData.index + '].guests" : $value1}';
        }
        break;

      case 'flightAdults' :
        var adultErrorIndex = '0a';
        thisData.hasError = _.contains(dataModels.model.get('validation.fields'), adultErrorIndex);
        break;
    }

    if (!thisData.isHotelOnly && namespace === 'rooms') {
      extension.options = extension.options.slice(0,3);
    }
    $.extend(thisData, extension);
    return new Handlebars.SafeString(Handlebars.partials['corewizard/components/select-hbs'](thisData));
  });

  Handlebars.registerHelper('more-than-one', function(size, options) {
    'use strict';
    if(size > 1)
    {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  Handlebars.registerHelper('wizard-form',
    function(context) {
      var templateName = dataModels.model.get('config.template');
      if (typeof templateName === 'function') templateName = templateName(dataModels.model);
      return Handlebars.partials[templateName](context);
    });

  Handlebars.registerHelper('uitk-icon',
    function(options) {
      return window.Handlebars.partials["icon-tag.hbs"](options.hash);
    });

  Handlebars.registerHelper('uitk-lobIcon',
    function(iconType) {
      return Handlebars.partials['corewizard/components/icon-' + iconType]();
  });

  Handlebars.registerHelper('soft-package', function(options) {
    return Handlebars.partials['corewizard/components/soft-package-checkbox-hbs'](options.hash);
  });

  Handlebars.registerHelper('loc', function(id) {
    return loc[id];
  });

  Handlebars.registerHelper('abtest', function(testId, variant, options) {
    var testIdValue = abTest.get(testId).value;
    if (variant === testIdValue)
      return options.fn(this);
    else
      return options.inverse(this);
  });
});

/*
 *  Project: UITKv2 Global Footer
 *  Description: Core wizard responsive JS logic
 *  Author: v-bnordwall@expedia.com
 */

// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
require(['uitk'], function(uitk) {

    "use strict";

    var toggleCoreWizardTheme = function( topic, data ) {
      var wizardContainer = $('#wizard-theme-wrapper');

      if (data.key === 'wizard-not-desktop') {
        $(wizardContainer)
          .removeClass('theme-inverse-pills')
          .addClass('theme-pills');
      }

      if (data.key === 'wizard-min-desktop') {
        $(wizardContainer)
          .removeClass('theme-pills')
          .addClass('theme-inverse-pills');
      }
    }

    var collapseMobileFooterMenus = function( topic, data ) {
      var footerToggleMenus = $('#site-footer-wrap').find('.toggle-trigger');

      if (data.key === 'wizard-not-desktop') {
        $(footerToggleMenus).uitk_toggle('close');
      }
    }

    uitk.subscribe('mediaquery.matched', toggleCoreWizardTheme, collapseMobileFooterMenus);
    uitk.mediaquery.publishAgain();

  });

define('gc/SearchUrl', function() {
    var SearchUrl = function(baseUrl, div, equ) {
        this.baseURL = baseUrl || '';
        this.div = div || '&';
        this.equ = equ || '=';
    };
    SearchUrl.prototype = [];
    SearchUrl.prototype.addParameter = function(name, value, required, def) {
        if (value) {
            this.push(name + this.equ + value);
        } else if (required) {
            var defaultValue = '';
            if (def || def === 0) {
                defaultValue = def;
            }
            this.push(name + this.equ + defaultValue);
        }
    };
    SearchUrl.prototype.toString = function() {
        var url = this.baseURL + this.join(this.div);
        return url.replace('?' + this.div, '?').replace(this.div + '#' + this.div, '#');
    };
    SearchUrl.prototype.beginQuery = function() {
        this.push('?');
    };
    SearchUrl.prototype.beginHash = function() {
        this.push('#');
    };

    return SearchUrl;
});

define('gc/activitySearchUrl', ['gc/SearchUrl'], function(SearchUrl) {
  return function(model) {
    var url;
    var prefilledDates = model.startDatePrefilled || model.endDatePrefilled;

    // Activities wants to use the /go url, see https://jira/jira/browse/MAIN-117523
    // http://www.expedia.com/go?type=lx&LocationName=Rome&StartDate=05/14/2014&EndDate=05/17/2014
    url = new SearchUrl('/things-to-do/');
    url.beginQuery();

    var location = model.destination;

    if (model.hotelId) {
        location = model.city;
    }

    url.addParameter('location', location, true);

    if (!prefilledDates && model.startDate && model.endDate) {
        url.addParameter('startDate', model.startDate, true);
        url.addParameter('endDate', model.endDate, true);
    }

    return url.toString();
  };
});

define('gc/carSearchUrl', ['gc/SearchUrl', 'gc/abTest'], function(SearchUrl, abTest) {
    return function (model) {
        var url;

        url = new SearchUrl('/carsearch');

        // abacus#10341 Cars_E3PrimeShoppingPage_GC
        // enabling E3 Prime based car shopping for non IE8 browsers
        if (abTest.get(10341, null, true).value === 1 && !$('html').hasClass('lt-ie9')) {
            url = new SearchUrl('/carsearch/app');
        }

        url.beginQuery();

        url.addParameter('dagv', 1, true);
        url.addParameter('subm', 1, true);
        url.addParameter('fdrp', 0, true);

        url.addParameter('styp', model.carSearchType, true, 4);

        url.addParameter('locn', model.pickup, true);
        url.addParameter('loc2', model.dropoff);

        url.addParameter('date1', model.startDate, true);
        url.addParameter('date2', model.endDate, true);

        url.addParameter('vend', model.carVendor, true);
        url.addParameter('kind', model.carType, true);

        url.addParameter('time1', model.startTime, true);
        url.addParameter('time2', model.endTime, true);

        url.addParameter('sesr', model.carSkirack === 'true' ? 1 : 0);
        url.addParameter('seis', model.carInfantseat === 'true' ? 1 : 0);
        url.addParameter('sets', model.carToddlerseat === 'true' ? 1 : 0);
        url.addParameter('sesc', model.carChains === 'true' ? 1 : 0);
        url.addParameter('selh', model.carLefthand === 'true' ? 1 : 0);
        url.addParameter('serh', model.carRighthand === 'true' ? 1 : 0);
        url.addParameter('sens', model.carNavigation === 'true' ? 1 : 0);

        url.addParameter('rtcd', model.carRateCode);
        url.addParameter('cpcd', model.carCouponCode);
        url.addParameter('odcd', model.carOtherCode);
        url.addParameter('cdnu', model.carCorpCode);

        url.addParameter('ttyp', 2, true);
        url.addParameter('acop', 2, true);
        url.addParameter('rdus', 10, true);
        url.addParameter('rdct', 1, true);

        url.addParameter('dpln', model.originRegionId);
        url.addParameter('drid1', model.destinationRegionId);
        url.addParameter('olat', model.originLatitude);
        url.addParameter('olon', model.originLongitude);
        url.addParameter('dlat', model.destinationLatitude);
        url.addParameter('dlon', model.destinationLongitude);

        return url.toString();
    }
});

define('gc/cruiseSearchUrl', ['jquery', 'gc/SearchUrl', 'gc/cruiseSearchUrlOverride', 'gc/abTest'], function($, SearchUrl, cruiseSearchUrlOverride, abTest) {

    var cruiseSearchUrl = {
        searchUrlGenerator: function(model) {
            var url;

            url = new SearchUrl('/Cruise-Search');
            url.beginQuery();

            url.addParameter('destination', model.cruiseDestination);

            if (model.uitkAccessCal && abTest.get(10120).value === 1) {
                url.addParameter('earliest-departure-date', cruiseSearchUrl.getFormattedDate(model.cruiseEarliestDepartureDate));
                url.addParameter('latest-departure-date', cruiseSearchUrl.getFormattedDate(model.cruiseLatestDepartureDate));
            } else if (model.cruiseMonth && model.cruiseMonth != "4501-1-1") {
                url.addParameter('earliest-departure-date', model.cruiseMonth);
            }

            return url.toString();
        },
        getFormattedDate: function (dateString) {
            var result = "";
            if (dateString) {
                var date = new Date(dateString),
                    curr_date = date.getUTCDate(),
                    curr_month = date.getUTCMonth() + 1,
                    curr_year = date.getUTCFullYear();
                result = curr_year + "-" + curr_month + "-" + curr_date;
            }
            return result;
        }
    };
    $.extend(true, cruiseSearchUrl, cruiseSearchUrlOverride);

    return cruiseSearchUrl.searchUrlGenerator;
});

define('gc/openSearchUrl', ['gc/SearchUrl','gc/abTest'], function(SearchUrl , abTest) {
    return function(model) {
    
        var urlTemplateConfig = {
            HOTEL:{
                urlTemplate:'/go/hotel/info/[id]'
            },
            GEO:{
                urlTemplate:'/d[id].Destination-Travel-Guides'
            },
            HOTELS:{
                urlTemplate:'/Hotel-Search?#&destination=[id]'
            },
            FLIGHTS:{
                urlTemplate:'/d[id].Travel-Guide-Flights'
            },
            PACKAGES:{
                urlTemplate:'/d[id].Destination-Travel-Guides'
            },
            CARS:{
                urlTemplate:'/d[id].Car-Rental-Guide'
            },
            ACTIVITIES:{
                urlTemplate:'/pubspec/scripts/eap.asp'
            },
            ALL:{
                urlTemplate:'/d[id].Destination-Travel-Guides'
            }
        };
        var regionTypesWithLandingPage = ['CITY', 'MULTICITY', 'NEIGHBORHOOD', 'POI', 'HOTEL']; 
        
        //
        // Helper methods
        //
        function getUrlTemplate(category, id) {
            var template = urlTemplateConfig[category].urlTemplate;
            if (template != null && id != null) {
                return template.replace('[id]', id);
            }

            return template;
        }

        function getVariant() {
            return abTest.get(10406).value;
        }

        function getOpenSearchUrl(query) {
            var url = new SearchUrl('/Search-Results');
            url.beginQuery();
            url.addParameter('q', encodeURIComponent(query), true);
            url.addParameter('ref', 'aws-corewizard-' + getVariant());
            return url.toString();
        }

        function getHotelUrl(model) {
            var url = new SearchUrl(getUrlTemplate('HOTEL', model.openSearchQueryData.hotelId));
            return url.toString();
        }

        function getHotelSearchUrl(model) {
            var url = new SearchUrl(getUrlTemplate('HOTELS', model.openSearchQueryData.gaiaId));
            return url.toString();
        }
        
        function getActivitiesUrl(model) {
            var url = new SearchUrl(getUrlTemplate('ACTIVITIES'));
            url.beginQuery();
            url.addParameter('GOTO','TSHOPSSEARCH');
            url.addParameter('LocationID', model.openSearchQueryData.gaiaId);
            return url.toString();
        }

        function getTravelGuidesUrl(model, category) {
            var url = new SearchUrl(getUrlTemplate(category, model.openSearchQueryData.gaiaId));
            return url.toString();
        }

        //
        // Main code
        //
        var data = model.openSearchQueryData;
        if(model.selectedTASuggestionPosition && data && data.lob != 'GEMMA') {

            var category = data.regionType == 'HOTEL' ? data.regionType : data.lob;

            if(category == 'HOTEL') {
                return getHotelUrl(model);
            }
            else if(category == 'ACTIVITIES') {
                return getActivitiesUrl(model);
            }
            else if(category == 'HOTELS') {
                return getHotelSearchUrl(model);
            }
            else if(regionTypesWithLandingPage.indexOf(data.regionType) >= 0) {
                return getTravelGuidesUrl(model, category);
            }
            else {
                return getOpenSearchUrl(data.regionNames.displayName);
            }
        }
        else if(model.searchQuery) {
            return getOpenSearchUrl(model.searchQuery);
        }
};

});

define('gc/flightSearchUrl', ['gc/SearchUrl'], function(SearchUrl) {
    return function(model) {
        // Helper functions
        function getLegUrl(leg) {
            var legUrl = new SearchUrl('', ',', ':');
            legUrl.addParameter('from', leg.origin, true);
            legUrl.addParameter('to', leg.destination, true);
            legUrl.addParameter('departure', leg.start + 'TANYT', true);
            return legUrl.toString();
        }

        function getPassengers(model) {
            var passUrl = new SearchUrl('', ',', ':');
            passUrl.addParameter('children', getChildren(model.ages), true, 0);
            passUrl.addParameter('adults', model.adults, true, 0);
            passUrl.addParameter('seniors', "0", true, 0);
            passUrl.addParameter('infantinlap', (model.isChildInLap ? 'Y' : 'N'), true, 'Y');
            return passUrl.toString();
        }

        function getChildren(children) {
            if (children && children.length) {
                var s = "";
                var i = 0;
                s += children.length + '[';
                for (i = 0; i < children.length; i ++) {
                    s += children[i].age || children[i];
                    if (i !== children.length - 1) {
                        s += ";";
                    }
                }
                s += ']';
                return s;
            }
        }

        var url = new SearchUrl('/Flights-Search');
        url.beginQuery();

        url.addParameter('trip', model.flighttype, true, 'roundtrip');
        url.addParameter('leg1', getLegUrl({origin:model.originTLA || model.origin, destination:model.destinationTLA || model.destination, start:model.startDate}), true);

        if (model.isRoundtrip) {
            url.addParameter('leg2', getLegUrl({origin:model.destinationTLA|| model.destination, destination:model.originTLA || model.origin, start:model.endDate}), true);
        }
        else if (model.isMultiDest) {
            for (var i = 0; i < 4; i++) {
                var leg;
                if (!model.multiDest.destination[i]) {
                    break;
                }
                leg = {
                    origin :      model.multiDest.origin[i],
                    destination : model.multiDest.destination[i],
                    start :       model.multiDest.startDate[i]
                };

                url.addParameter('leg' + (i + 2), getLegUrl(leg), true);

            }
        }

        url.addParameter('passengers', getPassengers(model), true, 0);

        addAdditionalOptions(model, url);

        url.addParameter('mode', 'search');

        return url.toString();

        function addAdditionalOptions(model, url) {
            'use strict';
            //cabinclass:business,maxhops:0,nopenalty:Y,carrier:AS
            var additionalOptions = new SearchUrl('', ',', ':');
            additionalOptions.addParameter('cabinclass', model.cabinClass, false);

            if (model.nonStop) {
                additionalOptions.addParameter('maxhops', "0", true);
            }

            if (model.noPenalty) {
                additionalOptions.addParameter('nopenalty', "Y", true);
            }

            additionalOptions.addParameter('carrier', model.carrier, false);

            url.addParameter('options', encodeURIComponent(additionalOptions.toString()), false);
        }
    }

});

define('gc/hotelInfoSiteUrl', ['gc/SearchUrl'], function(SearchUrl) {
    return function(model) {
        var url;
        url = new SearchUrl('/h' + model.hotelId + '.Hotel-Information');
        url.beginQuery();

        if (!model.isDateless) {
            url.addParameter('chkin', model.startDate, true);
            url.addParameter('chkout', model.endDate, true);
        }

        for(var i = 0; i < model.rooms.length; i++) {
            var room = model.rooms[i];
            var travlers = [];
            travlers.push('a' + (room && room.adults ? room.adults : 2));
            var childCount = (room && room.children ? room.children.length : 0);
        for (var j = 0; j < childCount; j++) {
            travlers.push('c' + room.children[j]);
        }
        var roomnum = i+1;
            url.addParameter('rm' + roomnum, travlers.join(':'));
        }
        return url.toString();
    };
});

define('gc/hotelSearchUrl', [
    'gc/SearchUrl',
    'gc/searchExperiments',
    'env'
], function(
    SearchUrl,
    searchExperiments,
    env
) {

    function addAdultsAndChildrenParams(model, url){
        var adults = [];
        var children = [];
        for (var i = 0; i < model.rooms.length; i ++) {
            var room = model.rooms[i];
            adults[i] = (room && room.adults ? room.adults : 2);
            var childCount = (room && room.children ? room.children.length : 0);
            for (var j = 0; j < childCount; j++) {
                children.push((i + 1) + '_' + room.children[j]);
            }
        }
        url.addParameter('adults', adults.join(','));
        url.addParameter('children', children.join(','));
    }

    function handlePOIIdsAndGaiaIds(model,url){

        //if TA suggestion type is POI send latLong to hotel search
        if(model.TASearchType == "POI" || model.TASearchType == "BCOMCITY" || model.TASearchType == "TRIPADVISORCITY")
        {
            url.addParameter('latLong',model.latLong, true);
        }
        else if(searchExperiments.getSearchExperimentVariant('8889') !=="0" &&
                model.TASearchType == "POSTALCODE")
        {
            url.addParameter('latLong',model.latLong, true);
        }
        else
        {
            handleGaiaIds(model,url);
        }
    }

    function handleGaiaIds(model,url){
        var regionORGaiaId = parseInt(model.regionId);

        //if the gaiaid is greater than 32 bit maxint, do not add regionId parameter to url, instead add latLong

        if(regionORGaiaId <= 4294967295){
            url.addParameter('regionId', model.regionId, true);
        }
        else{
            url.addParameter('latLong',model.latLong, true);
        }
    }

    function getBrand(siteId){
      var brand = 'Expedia';
      siteId = parseInt(siteId);
      var brands = {
        Hotels        : [1170],
        Wotif         : [70125,70129,70152],
        Travelocity   : [80001, 80004],
        Orbitz        : [70201,70203,70205,70206,70221,70222,70223,70224,70225,
                        702010001,702010002,702010003,702010004,702010005,702010006],
        Venere        : [],
        AARP          : [],
        Hotwire       : [30031,30044],
        Egencia       : [],
        HotelClub     : [],
        CheapTickets  : [70301,703010001,703010003,703010004,703010005],
        LastMinute    : [70150,70151],
        Trivago       : [],
        Travelnow     : [],
        Ebookers      : [70403,70406,70420,70463,70472,70473],
        TAAP          : [],
        Mrjet         : [70465]
      }
      _.mapObject(brands, function(siteIdList, brandName) {
        if(_.contains(siteIdList, siteId)) return brand = brandName;
      });
      return brand;
    }

    return function (model) {
      if (searchExperiments.getVariant("HIGH_LEVEL_REGION") === 2 &&
          model.regionId &&
          model.TASearchType == "MULTIREGION") {
          var trvGudUrlStr = '/d'+model.regionId+'.Travel-Guide-Hotels';
          var redirectUrl = new corewizard.search.SearchUrl(trvGudUrlStr);
          return redirectUrl.toString();
      }


      if (model.isHotelOnly && model.isNinePlusRoomRequest) {
          var ninePlusRoomsUrl = model.ninePlusRoomUrl || "http://groups.expedia.com/GroupForm.cfm?"; //retain backwards compatibility with old new wizard and hotel launch pubwiz
          ninePlusRoomsUrl += "Brand=" + getBrand(env.siteId);
          ninePlusRoomsUrl += "&Loc=" + env.locale;
          ninePlusRoomsUrl += "&City=" + encodeURIComponent(model.destination);
          ninePlusRoomsUrl += "&InDate=" + model.startDate;
          ninePlusRoomsUrl += "&OutDate=" + model.endDate;
          return ninePlusRoomsUrl;
      }

      var url = new SearchUrl('/Hotel-Search'),
          sort = model.sort;

      url.beginQuery();
      if (!model.isHashlessURLneeded) url.beginHash();

      if (model.latLong && model.latLong.indexOf("undefined") < 0 && model.trainOrMetroStationDestination) {
          url.addParameter('destination', model.trainOrMetroStationDestination, true);
      } else {
          if (model.hotelId) {
              url.addParameter('destination', model.city, true);
          }else{
              url.addParameter('destination', model.destination, true);
          }
      }

      if (!model.isDateless) {
          url.addParameter('startDate', model.startDate, true);
          url.addParameter('endDate', model.endDate, true);
      }

      url.addParameter('group', model.group);

      if(searchExperiments.getVariant("ALWAYS_SEND_GAIA_ID_AND_LAT_LONG"))
      {
          // Workaround for the bug https://jira/jira/browse/ECOMSVC-1545
          // Currently (December 2015), hotel search results page do not support any such region ID as an URL parameter
          // that is introduced with experiment 8812. Such a region ID is yet to be integrated into GAIA. As a workaround,
          // the region ID is excluded from the URL.
          // For details on experiment 8812, see the following Mingle card:
          // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1518
          if (! _.contains(Typeahead.unintegratedCityTypes, model.TASearchType)) {
              // Checking model.regionId !== "0" is a workaround for the bug https://jira/jira/browse/ECOMSVC-1488, filed on
              // 2015-10-21. Ideally, when there is no GAIA ID for a certain location, model.regionId, which is from ESS,
              // should be undefined, not an invalid value in the correct format.
              url.addParameter('regionId', model.regionId && model.regionId !== "0" ? model.regionId : "", true);
          }
          url.addParameter('latLong', model.latLong ? model.latLong : "");
      }
      else {
          handlePOIIdsAndGaiaIds(model, url);
      }

      addAdultsAndChildrenParams(model, url);

      // if (model.SOME_EXTRA_MODEL_VALUE_FOR_USE_ON_THE_URL_GENERATOR) {
      //     url.addParameter('bar', model.SOME_EXTRA_MODEL_VALUE_FOR_USE_ON_THE_URL_GENERATOR);
      // }

      if (model.hotelId) {
          url.addParameter('selected', model.hotelId);
      }
      if (searchExperiments.getVariant("BEST_DEALS_OPTION") &&
          typeof model.sort === "string")
      {
          url.addParameter('sort', sort);
      }

      if (model.membersOnly) {
          url.addParameter('mctc', model.membersOnly);
      }
      if(model.packageRates){
          url.addParameter('packageRates',model.packageRates);
      }
      return url.toString();
  }

});

define('gc/packageInfoSiteUrl', ['gc/SearchUrl'], function(SearchUrl) {
  return function(model) {
    var url;

          url = new SearchUrl('/h' + model.hotelId + '.Hotel-Information');
          url.beginQuery();


  url.addParameter('packageType', 2);

  url.addParameter('origin', model.origin, true);
  url.addParameter('destination', model.destinationTLA, true);

  url.addParameter('fromDate', encodeURIComponent(model.startDate), true);
  url.addParameter('toDate', encodeURIComponent(model.endDate), true);

  var rooms = model.rooms.length;
  url.addParameter('numberOfRooms', rooms > 3 ? 3 : rooms, true);
  for(var i = 1; i <= rooms && i <= 3; i++) {
      var room = model.rooms[i-1];
      url.addParameter('adultsPerRoom['+i+']', (room && room.adults ? room.adults : 2));
      var childCount = (room && room.children ? room.children.length : 0);
      url.addParameter('childrenPerRoom['+i+']', childCount);
      for (var j = 1; j <= childCount; j++) {
          url.addParameter('childAges['+i+']['+j+']', room.children[j-1]);
      }
  }

  return url.toString();
};

});

/*
 *  Documentation for eap.asp package search found here:
 *  https://confluence/display/SEMPPC/Deeplink+Resource+Guide#DeeplinkResourceGuide-PackageSearch
*/

define('gc/eapAspSearchUrl', ['gc/SearchUrl'], function(SearchUrl) {
    return function (model,lob) {
        var url = new SearchUrl('/pubspec/scripts/eap.asp'),
            i,
            roomNum,
            j,
            childNum;

        url.beginQuery();

        if (model.isPackage) {
//        if (model.hotelId) {
//            return corewizard.search.packageInfoSiteUrl(model);
//        }
            url.addParameter('GOTO', 'PACKAGEWIZ');
            if (model.packageType === "FHC") {
                url.addParameter('PackageType', '1');
            }
            else if (model.packageType === "FH" || (model.packageType === "TH")) {
                url.addParameter('PackageType', '2');
            }
            else if (model.packageType === "HC") {
                url.addParameter('PackageType', '3');

                // temporary hack for MAIN-113987: hard-coding times into search params to prevent rental car search from failing
                url.addParameter('FromTime', '630');
                url.addParameter('ToTime', '630');

            }
            else if (model.packageType === "FC") {
                url.addParameter('PackageType', '5');
            }
        }


        if (lob === 'flight') {
            //this is supposed to be deprecated by March 2014
            url.addParameter('GOTO', 'EXPFLTWIZ');

            //url.addParameter('TripType', model.flighttype || 'RoundTrip');
            switch (model.flighttype) {
                case 'multi' :
                    url.addParameter('TripType', 'Multicity');
                    url.addParameter('FrAirport1', model.origin);
                    url.addParameter('ToAirport1', model.destination);
                    url.addParameter('Date1', model.startDate);
                    url.addParameter('Time1', model.startTime);
                    for (var i = 0; i < model.multidest.length; i++) {
                        url.addParameter('FrAirport' + (i + 2), model.multidest[i].origin);
                        url.addParameter('ToAirport' + (i + 2), model.multidest[i].destination);
                        url.addParameter('Date' + (i + 2), model.multidest[i].departing);
                        url.addParameter('Time' + (i + 2), model.multidest[i]['time' + (i + 2)]);
                    };
                    break;
                case 'roundtrip' :
                case 'oneway' :
                    (model.flighttype === 'roundtrip') ? url.addParameter('TripType', 'roundtrip') : url.addParameter('TripType', 'oneway');
                    url.addParameter('ToAirport', model.destinationTLA);
                    url.addParameter('FromDate', model.startDate);
                    url.addParameter('ToDate', model.endDate);
                    url.addParameter('FrAirport', model.originTLA);
                    break;
            }

            url.addParameter('NumAdult', model.adults);
            url.addParameter('NumSenior', model.numSeniors);
            url.addParameter('NumChild', model.children);
            url.addParameter('InfantInSeat', model.lapSeat === "lap" ? 0 : 1);
            url.addParameter('NoChangePen', model.noPenalty ? 1 : 0);
            url.addParameter('Direct', model.nonStop ? 1 : 0);
            url.addParameter('Airline', model.carrier);
            url.addParameter('Class', model.cabinClassLegacy);

            for (var i = 0; i < model.ages.length; i++) {
                url.addParameter('Age' + (i + 1), model.ages[i]);
            };

            return url.toString();
        }

        if (lob === "hotel") {
            //this is supposed to be deprecated by March 2014
            url.addParameter('GOTO', 'HOTSEARCH');
            url.addParameter('CityName', model.destination);
            url.addParameter('InDate', model.startDate);
            url.addParameter('OutDate', model.endDate);
            url.addParameter('Class', model.star);
            url.addParameter('ChainName', model.hotelName);
            url.addParameter('LodgingType', model.lodging);
            url.addParameter('NumRoom', model.rooms.length);
            var adults = [];
            var children = [];

            for (var i = 0; i < model.rooms.length; i ++) {
                var room = model.rooms[i];
                url.addParameter('NumAdult' + (i + 1 === 1 ? '' : (i + 1)), room.adults);
                adults[i] = (room && room.adults ? room.adults : 2);
                var childCount = (room && room.children ? room.children.length : 0);
                for (var j = 0; j < childCount; j++) {
                    url.addParameter((i + 1 === 1 ? '' : 'Rm' + (i + 1)) + 'Child' + (j + 1) + 'Age', '' + room.children[j]);
                }
            }
            //corewizard.search.hotelSearchUrl.addAdultsAndChildrenParams(model, url);
            return url.toString();
        }

        if (model.originTLA) {
            url.addParameter('FrAirport', model.originTLA, true, '');
        } else {
            url.addParameter('FrAirport', model.origin, true, '');
        }
        if (!(model.isPackage && model.hotelId)) {
            url.addParameter('DestName', model.destination, true, '');

        }
        if (model.hotelId) {
            url.addParameter('DestID', model.multiCityRegion + ':' + model.destinationTLA);
        } else {
            url.addParameter('DestID', model.destID);
        }

        url.addParameter('FromDate', model.startDate);
        if (model.packageType === "TH") {
            url.addParameter('FromTime', model.train.departTime);
        }
        url.addParameter('ToDate', model.endDate);
        if (model.packageType === "TH") {
            url.addParameter('ToTime', model.train.returnTime);
        }
        if (model.isPartialStay) {
            url.addParameter('FlexFromDate', model.checkin);
            url.addParameter('FlexToDate', model.checkout);
        }

        if (model.rooms) {
            url.addParameter('NumRoom', model.roomCount);
            for (i = 0; i < model.rooms.length; i ++) {
                roomNum = i + 1;
                var adults = (model.rooms[i] && model.rooms[i].adults && (model.rooms[i].adults>=0)) ? model.rooms[i].adults : 2;
                var children = (model.rooms[i] && model.rooms[i].childCount ? model.rooms[i].childCount : '0');
                url.addParameter('NumAdult' + roomNum, adults, true, '2');
                url.addParameter('NumChild' + roomNum, children, true, '0');
                for (j = 0; j < children; j ++) {
                    childNum = j + 1;
                    url.addParameter('Rm' + roomNum + 'Child' + childNum + 'Age', model.rooms[i].children[j], true, '0');
                }
            }
        }
        url.addParameter('NumSenior', model.numSeniors);
        url.addParameter('InfantInSeat', model.isChildInLap ? "0" : "1");
        if (model.packageType === "TH") {
            url.addParameter('TransportationSearchType', 'TRAIN');
        }
        url.addParameter('needUTF8Decode', 'true');
        // url.addParameter('lang', model.lang, true, '1033'); // set default lang is 1033. Each POS should configure it with its language.
        // lang should be handled already and shouldn't need to be explicitly set.
        
        var cabinClass = model.cabinClassLegacy || model.cabinClass;
        if(cabinClass) {
            url.addParameter('cabinClass', cabinClass);
        }

        url.addParameter('Direct', model.isDirectFlight ? "1" : "0");

        return url.toString();
    }
});

define('gc/search',[
    'gc/flightSearchUrl',
    'gc/activitySearchUrl',
    'gc/cruiseSearchUrl',
    'gc/openSearchUrl',
    'gc/carSearchUrl',
    'gc/hotelInfoSiteUrl',
    'gc/hotelSearchUrl',
    'gc/packageInfoSiteUrl',
    'gc/eapAspSearchUrl',
    'gc/threePPSearchUrl'
],function(
    flightSearchUrl,
    activitySearchUrl,
    cruiseSearchUrl,
    openSearchUrl,
    carSearchUrl,
    hotelInfoSiteUrl,
    hotelSearchUrl,
    packageInfoSiteUrl,
    eapAspSearchUrl,
    threePPSearchUrl
){
    return {
      addSearchType : function(id, searchFunction) {
        this[id] = searchFunction;
      },
      flightSearchUrl: flightSearchUrl,
      activitySearchUrl: activitySearchUrl,
      cruiseSearchUrl: cruiseSearchUrl,
      openSearchUrl: openSearchUrl,
      carSearchUrl: carSearchUrl,
      hotelInfoSiteUrl: hotelInfoSiteUrl,
      hotelSearchUrl: hotelSearchUrl,
      packageInfoSiteUrl: packageInfoSiteUrl,
      eapAspSearchUrl: eapAspSearchUrl,
      threePPSearchUrl: threePPSearchUrl
    }
});

define('gc/threePPSearchUrl', ['jquery', 'gc/SearchUrl', 'gc/threePPSearchUrlOverride'], function($, SearchUrl, threePPSearchUrlOverride) {
    var threePPSearchUrl = {
        searchUrlGenerator: function(model) {
        }
    };

    $.extend(true, threePPSearchUrl, threePPSearchUrlOverride);

    return threePPSearchUrl.searchUrlGenerator;
});
/*global ab3291status, corewizard */

define('gc/typeaheadCallbacks', [
    'gc/abTest',
    'gc/dataModels',
    'gc/searchExperiments',
    'gc/loc',
    'gc/getLob'
], function(
    abTest,
    dataModels,
    searchExperiments,
    loc,
    getLob
) {
    var ab3291status = abTest.get(3291).value;

    function typeaheadUpdateModel(data, model, hasChild) {
        //If no hierarchy info present, by default classify it as parent
        model.set('suggestionType', data.hierarchyInfo ? (data.hierarchyInfo.isChild === 'true' ? 'child' : 'parent') : 'parent');
        model.set('hasChild', hasChild ? true : false);
    }

    // isNotMultiFlight
    // Helper method to verify we're not on a multi-flight scenario
    function isNotMultiFlight() {
        var result = true;
        var currentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

        // if we're on the test wizard, add test button
        if (currentLob === 'flight') {
            result = $('input[name="flight-type"]:checked').val() !== 'multi';
        }

        return result;
    }

    // setCoreWizardFields
    // @param {data} - data is the corewizard.core.state object to send to corewizard.core.state.set(data) API.
    // This call sets the corewizard.core.state.attributes object fields
    // @param {currentLob} - what LOB is active
    //
    // NOTE:
    // These are the minimum set of corewizard.core.state properties
    // that affect the visible UI fields that need populating. From
    // there you can add on whatever else is needed by the non-UI parts
    // of the model.
    function setCoreWizardFields(data, currentLob) {
        var viewModel = corewizard.core.state;

        if (currentLob === 'hotel' || (currentLob === 'flight' && isNotMultiFlight())) {

            // set all the wizard fields with one call
            // passing an object with all the data
            viewModel.set(data);

            // once the typeahead tooltip window closes, then it's safe to
            // reset focus/select to last focused typeahead control.
            uitk.subscribe('typeaheadTooltip.closed', function(topic, lastFocusedElementId){
                uitk.unsubscribe('typeaheadTooltip.closed');

                // reset focus and fire the assistive technogies to happen on the next turn of the event loop
                var lastActiveElement = document.getElementById(lastFocusedElementId);
                setTimeout(function(){
                    // User has made a selection and the typeahead popup has closed
                    // Set the flag to track that so that when focus is restored to
                    // the input control, we can avoid rendering another typeahead popup
                    Typeahead.taItemChosen = true;
                    lastActiveElement.select();
                    uitk.utils.liveAnnounce("All fields have been updated");
                }, 0);
            });

            // Trigger an "updateLayout" on the wizard
            // This will trigger a broadcast corewizard.wizardReloaded event
            corewizard.core.reloadWizard();
        }
    }

    function getAirportCode(data, isEssV4) {
        return isEssV4 ? (data.hierarchyInfo ? (data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport) : data.hierarchyInfo) : data.a;

    }

    function getDataType(data, isEssV4) {
        return isEssV4 ? data.type : data.t;
    }

    function getGaiaId(data, isEssV4) {
        return isEssV4
            ? (
            data.essId && data.essId.sourceName === "GAI" && _.isString(data.essId.sourceId)
                ? data.essId.sourceId
                :undefined
        )
            : data.id;
    }

    function getHotelId(data) {
        return data.essId &&  data.essId.sourceName === "PRC"
            ? data.essId.sourceId
            : undefined;
    }

    function getSuggestionTypeId(data) {
        return data.essId && data.essId.sourceId
            ? data.essId.sourceId
            : '-';
    }

    function getFullName(data, isEssV4) {
        return isEssV4 ? (data.regionNames ? data.regionNames.fullName : '') : data.f;
    }

    function getLastSearchName(data, isEssV4) {
        return isEssV4 ? (data.regionNames ? data.regionNames.lastSearchName : '' ): data.l;
    }

    // Returns the value suitable for calling corewizard.core.state.set("destinationFromTA", value) with.
    function getDestinationFromTAForPackageDestination(data, isEssV4) {
        return isEssV4 ? (data.regionNames ? data.regionNames.lastSearchName : '') : data.f;
    }

    function getIndex(data, isEssV4) {
        return isEssV4 ? data.index : data.i;
    }

    //hotel callback for the typeahead (added extra param to indicate if it has child)
    function typeaheadItemClickCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data={};

        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        if (searchExperiments.getSearchExperimentVariant('8160') !== "0") {
            //Check for geo location only if the User has requested current location
            if(data.type == 'GEOLOCATION')
            {
                //Reset the geoLocation value for every geoLocation request
                model.set('currentLocationDetails', null);
                //console.log("User selected current locn. Trying to enable geolocation...");
                //Check if geolocation is supported in the browser
                if (navigator.geolocation) {
                    //var geoLocationStartTime = new Date();
                    //model.set('geoLocnStartTime', geoLocationStartTime);
                    searchExperiments.getCurrentLocation(function(obj){
                        //var geoLocationEndTime = new Date();
                        //model.set('geoLocnEndTime', geoLocationEndTime);
                        //console.log("in call back for getGeoLocation");
                        searchExperiments.updateCurrentLocationInModel(obj, model);
                    });
                }
                else {
                    var errorMsg = "Geolocation is not supported by this browser.";
                    searchExperiments.updateGeoLocationInModel(errorMsg, model);
                }
            }
        }


        if(data.type == 'HOTEL') {
            model.set('hotelId', getHotelId(data));
            model.set('destSuggestionTypeId', getSuggestionTypeId(data));

            model.set('city',data.hotelAddress.city);
            if(data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
                model.set('multiCityRegion', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.multicity : data.hierarchyInfo.multicity);
            }
        }
        else if (data.type === "RECENTHISTORY") {
            setCoreWizardFields(
                RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForHotel(data.history),
                getLob(dataModels.model.get('tab'), dataModels.model.get('packages'))
            );
        }
        else{
            model.set('hotelId', null);
            model.set('destSuggestionTypeId', getSuggestionTypeId(data));
        }

        if(searchExperiments.getSearchExperimentVariant('8889') !== '0' && data.type=='ADDRESS')
        {
            model.set('TASearchType', data.subtype ? data.subtype : data.type);
            model.set('TADestSearchType', data.subtype ? data.subtype : data.type);
        }
        else if(searchExperiments.getSearchExperimentVariant('8812') !== '0' && data.type=='POI')
        {
            if(data.subtype && _.contains(['BCOMCITY', 'TRIPADVISORCITY'], data.subtype )) {
                model.set('TASearchType', data.subtype);
                model.set('TADestSearchType', data.subtype);
            }
            else {
                model.set('TASearchType', data.type);
                model.set('TADestSearchType', data.type);
            }
        }
        else
        {
            model.set('TASearchType', data.type);
            model.set('TADestSearchType', data.type);
        }

        model.set('OMHotelTA', true);
        //vmohapatra : gaiaId/hotelId is going to be deprecated from ESS response.
        //model.set('regionId', data.gaiaId);
        if(model.get('hotelId') != undefined) {
            model.set('regionId', undefined);
        }
        else {
            model.set('regionId', getGaiaId(data, true));
        }

        //For Themes since they don't have coordinate information, don't set it in the model
        if(data.coordinates)
        {
            //vmohapatra: HSRP requires latLong param to be sent in lat,long format. Domain can handle both comma and space
            model.set('latLong', data.coordinates.lat + ',' + data.coordinates['long']);
        }
        if(data.regionNames) {
            //model.set('destinationFromTA', data.regionNames.fullName);
            //vmohapatra : Since lastSearchName is used as searchText :
            //in order to keep destination and destinationFromTA in sync always use lastSearchName to populate destinationFromTA
            model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            if (searchExperiments.getVariant("BEST_DEALS_OPTION") && data.type === "DEALS") {
                model.set('destination', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            }
        }
        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        if(data.regionMetadata) {
            if (data.regionMetadata.redirect && corewizard.masterconfig.trivagoRedirectionEnabled) {
                model.set('redirectionURL', data.regionMetadata.redirect);
                if (dctk) {
                    var linkID = 'LTC.NHP.ItemSelected';
                    dctk.trackAction(linkID, item, {prop16:linkID,eVar28:linkID,eVar18:'Homepage'});
                }
            }
        }

        typeaheadUpdateModel(data, model, hasChild);

        if (ab3291status.value === 1) {
            if (!model.get('noDate')) {
                corewizard.helpers.openCalendarField('startDate');
            }
        }

        if (searchExperiments.getVariant("BEST_DEALS_OPTION") && data.sort) {
            model.set('sort', data.sort);
        }

        if(
            (searchExperiments.getSearchExperimentVariant('8773') !== '0' ||
            searchExperiments.getSearchExperimentVariant('8774') !== '0') &&
            data.type === "RECENTHISTORY"
        ) {
            var  currTimestamp = new Date();
            var timeData = data.history && data.history.timestamp ? data.history.timestamp : '-';
            if(!isNaN(timeData)) {
                var age = currTimestamp - new Date(timeData);
                model.set('userHistoryItemAge',age);
            }
        }

    }

    //cars pickup callback for the typeahead
    function typeaheadCarPickUpCallback(item) {
        require(['gc/dataModels', 'gc/loc'], function(dataModels, loc) {
            'use strict';
            var model = dataModels.state,
                data = {},
                alwaysEnableCarDropoff = loc.masterconfig.switches.enableCarOffairportOnewaySearch;

            if (typeof item.attr === 'function') {
                data = JSON.parse(item.attr('data-data'));
            }
            else {
                data = item;
            }

            //Set the source info for each Typeahead selection. Default is null / undefined
            model.set('destinationSourceInfo', data.essId);

            if(data.hierarchyInfo) {
                model.set('tla', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }

            if (data.type === "AIRPORT") {
                model.set('carSearchType', 1);
            }
            else {
                model.set('carSearchType', 2);
            }

            if(data.regionNames) {
                model.set('carPickupValueFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
            }

            if(data.subtype && _.contains(['RENTALLOCATION', 'POSTALCODE'], data.subtype)) {
                model.set('originRegionId', '0');
            }
            else {
                model.set('originRegionId', getGaiaId(data, true));
            }

            if(data.coordinates){
                model.set('originLatitude', data.coordinates.lat);
                model.set('originLongitude', data.coordinates['long']);
            }

            model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

            model.set('destSuggestionTypeId', getSuggestionTypeId(data));

            if(data.type=='ADDRESS')
            {
                model.set('TASearchType', data.subtype ? data.subtype : data.type);
                model.set('TADestSearchType', data.subtype ? data.subtype : data.type);

                if(searchExperiments.getSearchExperimentVariant('8206') !== '0' && data.subtype=="CARRENTALADDRESS") {
                    model.set('TASearchType', 'RENTALLOCATION');
                    model.set('TADestSearchType', 'RENTALLOCATION');
                }
            }
            else
            {
                model.set('TASearchType', data.type);
                model.set('TADestSearchType', data.type);
            }
            setTimeout(function() {
                if(!alwaysEnableCarDropoff) {
                    dataModels.state.trigger('reloadWizard');
                }
            }, 100);

            //uitk.utils.focusElement($('#car-pickup-label'));

        });
    }

    //Cars dropoff callback for the typeahead
    function typeaheadCarDropOffCallback(item) {
        'use strict';
        var model = dataModels.state;
        var data = {};

        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('originSourceInfo', data.essId);

        //vmohapatra : gaiaId/hotelId is going to be deprecated from ESS response.
        //model.set('destinationRegionId', data.gaiaId);
        if(data.subtype && _.contains(['RENTALLOCATION', 'POSTALCODE'], data.subtype)) {
            model.set('destinationRegionId', '0');
        }
        else {
            model.set('destinationRegionId', getGaiaId(data, true));
        }

        if(data.coordinates){
            model.set('destinationLatitude', data.coordinates.lat);
            model.set('destinationLongitude', data.coordinates['long']);
        }

        if(data.regionNames) {
            model.set('carDropoffValueFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
        }
        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        model.set('origSuggestionTypeId', getSuggestionTypeId(data));

        if(data.type=='ADDRESS')
        {
            model.set('TASearchType', data.subtype ? data.subtype : data.type);
            model.set('TAOrigSearchType', data.subtype ? data.subtype : data.type);

            if(searchExperiments.getSearchExperimentVariant('8206') !== '0' && data.subtype=="CARRENTALADDRESS") {
                model.set('TASearchType', 'RENTALLOCATION');
                model.set('TAOrigSearchType', 'RENTALLOCATION');
            }
        }
        else
        {
            model.set('TASearchType', data.type);
            model.set('TAOrigSearchType', data.type);
        }

    }

    //flight origin callback for the typeahead
    function typeaheadFlightOriginCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data={};
        model.set('OMOriginTA', true);
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('originSourceInfo', data.essId);

        if(data.hierarchyInfo) {
            model.set('originTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
        }

        if(data.regionNames) {
            model.set('originFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
        }

        //POS with static Typeahead will not have hierarchyInfo in Flight LOB
        if(data.hierarchyInfo) {
            if (data.hierarchyInfo.relation && data.hierarchyInfo.relation[0]==="nearby") {
                model.set('TASearchType', "NEARBY"+data.type);
                model.set('TAOrigSearchType', "NEARBY"+data.type);
            }
            else {
                model.set('TASearchType', data.type);
                model.set('TAOrigSearchType', data.type);
            }
        }
        else {
            model.set('TASearchType', data.type);
            model.set('TAOrigSearchType', data.type);
        }

        if (data.type === "RECENTHISTORY") {
            setCoreWizardFields(RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForFlight(data.history),
                getLob(dataModels.model.get('tab'), dataModels.model.get('packages')));
            //Clean up sourceName:sourceId, suggestionType, for the field updated for destination
            model.set('TADestSearchType', null);
            model.set('destinationSourceInfo', null);
        }
        else {
            model.set('origSuggestionTypeId', getSuggestionTypeId(data));
        }

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        typeaheadUpdateModel(data, model, hasChild);

        if (ab3291status.value === 1) {
            dataModels.shiftFocus(corewizard.helpers.getWizardFieldByType('destination'));
        }

        if(
            (searchExperiments.getSearchExperimentVariant('8773') !== '0' ||
            searchExperiments.getSearchExperimentVariant('8774') !== '0') &&
            data.type === "RECENTHISTORY"
        ) {
            var  currTimestamp = new Date();
            var timeData = data.history && data.history.timestamp ? data.history.timestamp : '-';
            if(!isNaN(timeData)) {
                var age = currTimestamp - new Date(timeData);
                model.set('userHistoryItemAge',age);
            }
        }

    }

    function typeaheadFlightDestinationCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data = {};
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        model.set('OMDestinationTA', true);

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        //need to compare string for omniture logic.
        if(data.regionNames) {
            model.set('OMDestinationTACompare', data.regionNames.lastSearchName);
        }
        if (data.type == 'AIRPORT') {
            model.set('regionId', getGaiaId(data, true));

            if(data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }
            if(data.regionNames) {
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            }
        }
        else if(_.contains(['TRENDINGSEARCH'], data.type))
        {
            //fullName should be used for custom data types
            if(data.regionNames) {
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
            }
            if(data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }
        }
        else if (data.type === "RECENTHISTORY") {
            setCoreWizardFields(RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForFlight(data.history),
                getLob(dataModels.model.get('tab'), dataModels.model.get('packages')));
            //Clean up sourceName:sourceId, suggestionType, for the field updated for origin
            model.set('TAOrigSearchType', null);
            model.set('originSourceInfo', null);
        }
        else
        {
            if(data.regionNames) {
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            }
            if(data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }
        }

        //POS with static Typeahead will not have hierarchyInfo in Flight LOB
        if(data.hierarchyInfo) {
            if (data.hierarchyInfo.relation && data.hierarchyInfo.relation[0]==="nearby") {
                model.set('TASearchType', "NEARBY"+data.type);
                model.set('TADestSearchType', "NEARBY"+data.type);
            }
            else {
                model.set('TASearchType', data.type);
                model.set('TADestSearchType', data.type);
            }
            if (data.hierarchyInfo.airport && data.hierarchyInfo.airport.multicity) {
                model.set('regionId', data.hierarchyInfo.airport.multicity);
                getMulticityRegionName(data.hierarchyInfo.airport.multicity);
            }
        }
        else {
            model.set('TASearchType', data.type);
            model.set('TADestSearchType', data.type);
        }

        model.set('destSuggestionTypeId', getSuggestionTypeId(data));

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        if (ab3291status.value === 1) {
            dataModels.shiftFocus(corewizard.helpers.getWizardFieldByType('departing'));
        }

        //Set values pertaining to Geo-hierarchy experiment in the model
        typeaheadUpdateModel(data, model, hasChild);

        if(
            (searchExperiments.getSearchExperimentVariant('8773') !== '0' ||
            searchExperiments.getSearchExperimentVariant('8774') !== '0') &&
            data.type === "RECENTHISTORY"
        ) {
            var  currTimestamp = new Date();
            var timeData = data.history && data.history.timestamp ? data.history.timestamp : '-';
            if(!isNaN(timeData)) {
                var age = currTimestamp - new Date(timeData);
                model.set('userHistoryItemAge',age);
            }
        }
    }

    function getMulticityRegionName(multicityRegionId) {
        require(['gc/typeaheadConfig'], function(taConfig) {
            var locale = taConfig.typeahead.def.locale || 'en_US';
            $.ajax({
                dataType: 'jsonp',
                url: 'https://suggestch.expedia.com/api/v4/list/region/?gaiaid='+multicityRegionId+'&locale='+locale,
                success: function (data) {
                    require(['gc/dataModels'], function(model) {
                        if (data && data.sr && data.sr[0] && data.sr[0].regionNames && data.sr[0].regionNames.lastSearchName) {
                            model.state.set('regionName', data.sr[0].regionNames.lastSearchName);
                        }
                    });
                },
                error: function (d, text, errThrown) {
                    console.log("error", text, "-----", errThrown);
                }
            });
        });
    }

    function typeaheadPackageOriginCallback(item) {
        'use strict';
        var model = dataModels.state, data={};
        var essv4exp = (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_PACKAGES") !== 0);
        model.set('OMOriginTA', true);
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('originSourceInfo', data.essId);

        model.set('originTLA', getAirportCode(data, essv4exp));
        model.set('originFromTA', Typeahead.decodeHtmlCharacterEntities(getLastSearchName(data, essv4exp)));
        model.set('TASearchType', getDataType(data, essv4exp));
        model.set('TAOrigSearchType', getDataType(data, essv4exp));
        model.set('origSuggestionTypeId', getSuggestionTypeId(data));
        model.set('selectedTASuggestionPosition',parseInt(getIndex(data, essv4exp)) + 1);
    }

    function typeaheadPackageDestinationCallback(item) {
        'use strict';
        var model = dataModels.state, data = {};
        var essv4exp = (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_PACKAGES") !== 0);
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        model.set('TASearchType', getDataType(data, essv4exp));
        model.set('TADestSearchType', getDataType(data, essv4exp));
        model.set('OMDestinationTA', true);

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        model.set('regionId', getGaiaId(data, essv4exp));
        model.set('destinationTLA', getAirportCode(data, essv4exp));
        model.set('destinationFromTA',
            Typeahead.decodeHtmlCharacterEntities(getDestinationFromTAForPackageDestination(data, essv4exp)));

        if (ab3291status.value === 1) {
            corewizard.helpers.openCalendarField('departing');
        }

        model.set('destSuggestionTypeId', getSuggestionTypeId(data));

        model.set('selectedTASuggestionPosition',parseInt(getIndex(data, essv4exp))+1);

    }

    function typeaheadActivityCallback(item) {
        'use strict';
        var essv4exp = (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_ACTIVITIES") !== 0);
        var model = dataModels.state, data = {};
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        model.set('TASearchType', getDataType(data, essv4exp));
        model.set('TADestSearchType', getDataType(data, essv4exp));
        model.set('destinationTLA', getAirportCode(data, essv4exp));
        model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(getFullName(data, essv4exp)));
        model.set('selectedTASuggestionPosition', parseInt(getIndex(data, essv4exp)) + 1);
        model.set('destSuggestionTypeId', getSuggestionTypeId(data));
    }

    function typeaheadOpenSearchCallback(item) {
        'use strict';
        var model = dataModels.state, data = {};
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);
        model.set('TASearchType', data.lob);
        model.set('openSearchQueryData', data);

    }

    function typeaheadMultiFlightDestinationCallback (item, hasChild) {
        'use strict';
        var model = dataModels.state, data = {}, multiFlightInput;
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
            multiFlightInput = item.attr('data-multiFlightInputId');
        }
        else {
            data = item;
            multiFlightInput = item;
        }

        //Default capturing of multi flight origin and destination information

        //Multi Flight field texts
        var multiFlightDestinations = model.get('multiFlightDestination') || {};
        var multiFlightOrigins = model.get('multiFlightOrigin') || {};
        //Multi Flight sourceIds
        var multiFlightDestSuggTypeIds = model.get('multiFlightDestSuggTypeId') || {};
        var multiFlightOrigSuggTypeIds = model.get('multiFlightOrigSuggTypeId') || {};
        //Multi Flight source info
        var multiFlightDestSrcInfo = model.get('multiFlightDestSrc') || {};
        var multiFlightOrigSrcInfo = model.get('multiFlightOrigSrc') || {};
        //Multi Flight Suggestion Type
        var multiFlightDestSuggTypes = model.get('multiFlightDestSuggType') || {};
        var multiFlightOrigSuggTypes = model.get('multiFlightOrigSuggType') || {};

        if(
            _.contains(['flight-2-destination', 'flight-3-destination', 'flight-4-destination', 'flight-5-destination'], multiFlightInput)
        )
        {
            //Destination fields
            multiFlightDestinations = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestinations, 'input');
            multiFlightDestSuggTypeIds = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestSuggTypeIds, 'suggestionId');
            multiFlightDestSrcInfo = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestSrcInfo, 'sourceInfo');
            multiFlightDestSuggTypes = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestSuggTypes, 'suggestionType');
        }
        else if(
            _.contains(['flight-2-origin', 'flight-3-origin', 'flight-4-origin', 'flight-5-origin'], multiFlightInput)
        )
        {
            //Origin fields
            multiFlightOrigins = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigins, 'input');
            multiFlightOrigSuggTypeIds = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigSuggTypeIds, 'suggestionId');
            multiFlightOrigSrcInfo = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigSrcInfo, 'sourceInfo');
            multiFlightOrigSuggTypes = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigSuggTypes, 'suggestionType');
        }

        //Set Multi Flight field texts
        model.set('multiFlightDestination',multiFlightDestinations);
        model.set('multiFlightOrigin',multiFlightOrigins);
        //Set Multi Flight sourceIds
        model.set('multiFlightDestSuggTypeId',multiFlightDestSuggTypeIds);
        model.set('multiFlightOrigSuggTypeId',multiFlightOrigSuggTypeIds);
        // Set Multi Flight source info
        model.set('multiFlightDestSrc',multiFlightDestSrcInfo);
        model.set('multiFlightOrigSrc',multiFlightOrigSrcInfo);
        //Multi Flight Suggestion Type
        model.set('multiFlightDestSuggType',multiFlightDestSuggTypes);
        model.set('multiFlightOrigSuggType',multiFlightOrigSuggTypes);

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);
        model.set('TASearchType', data.type);
        typeaheadUpdateModel(data, model, hasChild);

    }

    function multiFlightHelper(data, type, multiFlightInput, multiFlightObject, typeOfLogging) {
        var regex = new RegExp("flight-([2345])-" + type);
        var matchResults = regex.exec(multiFlightInput);
        var index;
        if (! matchResults) {
            return;
        }
        index = matchResults[1] - 2; // For example, index === 0 for multiFlightInput === flight-2-<type>
        if(typeOfLogging == 'input') { multiFlightObject[index]= data.regionNames ? data.regionNames.fullName : '-'; }
        else if(typeOfLogging == 'suggestionId') { multiFlightObject[index]= data.essId ? (data.essId.sourceId ? data.essId.sourceId : '-') : '-'; }
        else if(typeOfLogging == 'sourceInfo') { multiFlightObject[index]= data.essId ? data.essId : {}; }
        else if(typeOfLogging == 'suggestionType') { multiFlightObject[index]= data.type ? data.type : data.t; }
        else if(typeOfLogging == 'reset') { multiFlightObject[index]= data; }
        return multiFlightObject;
    }

    return {
        typeaheadItemClickCallback: typeaheadItemClickCallback,
        typeaheadCarPickUpCallback: typeaheadCarPickUpCallback,
        typeaheadCarDropOffCallback: typeaheadCarDropOffCallback,
        typeaheadFlightOriginCallback: typeaheadFlightOriginCallback,
        typeaheadFlightDestinationCallback: typeaheadFlightDestinationCallback,
        typeaheadPackageOriginCallback: typeaheadPackageOriginCallback,
        typeaheadPackageDestinationCallback: typeaheadPackageDestinationCallback,
        typeaheadActivityCallback: typeaheadActivityCallback,
        typeaheadOpenSearchCallback: typeaheadOpenSearchCallback,
        typeaheadMultiFlightDestinationCallback: typeaheadMultiFlightDestinationCallback,
        multiFlightHelper: multiFlightHelper
    }
});

/*global $, _, Modernizr, ab3291status, uitk */

;var corewizard = corewizard || {};

require(['gc/dataModels'], function(dataModels) {
    'use strict';

    $.extend(corewizard, {
        helpers : {
            unCheckNoDates : function() {
                var target = $('[data-wizard-type="noDate"]');
                if ($(target) && $(target).is(':checked')) {
                  $(target).prop('checked', false);
                }
            },
            isHotelsOnly : function() {
                var model = dataModels.state;
                return model.get('tab') == 'hotel' &&
                    !(model.get('packages.flight') || model.get('packages.car'));
            },
            elementIsHotelDepartingField : function(el) {
                return el.attr('data-wizard-action').indexOf('"startDate"') > -1 && this.shouldOpenCalendar('endDate');
            },
            shouldOpenCalendar : function(fieldType) {
                return this.isHotelsOnly() && this.isCalendarFieldValueDefault(fieldType);
            },
            isCalendarFieldValueDefault : function(fieldType) {
                var value = dataModels.model.get(fieldType);
                return typeof value === 'undefined' || value === null || value === '';
            },
            getWizardFieldByType : function(type) {
                var actionFields = $('[data-wizard-action]:visible');
                return _.find(actionFields, function(item) {
                    var field = $(item);
                    if (field.attr('data-wizard-action').indexOf('"' + type + '"') > -1) {
                        return true;
                    }
                });
            },

            openCalendarField : function(fieldType) {
                var hasTouch = Modernizr.touch,
                    hasWin8Touch = Modernizr.win8touch;
                if (hasTouch || hasWin8Touch) {
                    shiftFocus(this.getWizardFieldByType(fieldType), 100);
                } else {
                    shiftFocus(this.getWizardFieldByType(fieldType));
                }
            }

        }
    });
});

//uncheck "I don't know my dates" checkbox if a user types something into a date field or chooses a date from the calendar picker



var corewizard = corewizard || {};
corewizard.searchTracking = corewizard.searchTracking || {};

require([
  'gc/importedState',
  'gc/searchExperiments',
  'gc/conf',
  'env',
  'gc/getLob'
], function (
  importedState,
  searchExperiments,
  conf,
  env,
  getLob
) {
    //Default function to track valid search submit
    corewizard.searchTracking.trackValidSearch = function (model) {
        var isMultiOrOneWay = model.get('flighttype') === 'multi' || model.get('flighttype') === 'oneway';
        var organicPackageIsOpen = $('[data-tid="hotel-added-flight"]').is(':visible');

        var detailedTrackingData = getDetailedTrackingData(model, true);
        var evtStr = getEvtStr(model);
        if (!isMultiOrOneWay && !organicPackageIsOpen) {
            trackEvent(detailedTrackingData.trackingData, evtStr, detailedTrackingData.staticExperimentData);
        }

        //This is to add instrumentation for one way or multi destination flights
        if(isMultiOrOneWay){
            trackEvent(detailedTrackingData.trackingData, evtStr, detailedTrackingData.staticExperimentData);
        }
    };

    //Default function to track invalid search submit
    corewizard.searchTracking.trackInvalidSearch = function (model) {
        trackEvent(getDetailedTrackingData(model, false));
    };

    //Default function to send dctk track event function for core wizard
    //Optional param : svcExperimentData
    function trackEvent(trackingData, eventStr, svcExperimentData) {
        var staticExperimentData = {
            exposedExperiments: svcExperimentData
        };
        try {
            if(staticExperimentData.exposedExperiments && staticExperimentData.exposedExperiments != null) {
                dctk.addExperiments(staticExperimentData.exposedExperiments);
            }
            dctk.trackEvent('o', 'wizard-submit', trackingData, eventStr);
        } catch (e) {}
    }

//****************************************************************************************
//***********************************Default Submit Logging*******************************
//****************************************************************************************

    //Function to capture basic referrer data in the format "LaunchView.SrchWzd.Tab.LOB.Locale.SiteId"
    function getBasicTrackingData(model) {
        var basicInfo = getBasicReport(model);
        return {
            prop16: basicInfo,
            eVar28: basicInfo
        };
    }

    //Function used to capture detailed search data ie. Typeahead related
    function getDetailedTrackingData(model, valid) {
        var detailedInfo = getDetailedReport(model, valid);
        var trackingData = {
            prop16: detailedInfo,
            eVar28: detailedInfo
        };

        var staticExperimentData = model.get('activeESSTests') ? model.get('activeESSTests') : null;

        if (valid) {
            //Record the timestamp at which a valid search was determined
            var currTimestamp = new Date();
            //Set the user typed text    in prop74
            trackingData.prop74 = '"' + ( model.get('userTypedQuery') || '' ) + '"' ;

            //vmohapatra : Preserve sourceName:sourceID|suggestionType|destination for multiflights
            if(getLob(model.get('tab'), model.get('packages'))=='flight' && model.get('flighttype') === 'multi')
            {
                //Enable default logging for origin and destination flights in Multi flight type
                //Add multiFlightDestinations to eVar48
                var multiFlightDestinations = model.get('multiDest').destination || model.get('multiFlightDestination');
                //Add multiFlightOrigins to prop73
                var multiFlightOrigins = model.get('multiDest').origin || model.get('multiFlightOrigin');

                var multiFlightDestSuggIds = model.get('multiFlightDestSuggTypeId');
                var multiFlightOrigSuggIds = model.get('multiFlightOrigSuggTypeId');

                var multiDestFieldInfo = model.get('multiFlightDestSrc');
                var multiOrigFieldInfo = model.get('multiFlightOrigSrc');
                var multiDestFieldType = model.get('multiFlightDestSuggType');
                var multiOrigFieldtype = model.get('multiFlightOrigSuggType');

                var destCount = 0, 
                    destStr = [], 
                    origCount = 0, 
                    origStr = [], 
                    destIDStr = ['-','-','-','-'], 
                    origIDStr = ['-','-','-','-'],
                    destSrcStr = ['-:-', '-:-', '-:-', '-:-'],
                    origSrcStr = ['-:-', '-:-', '-:-', '-:-'],
                    destTypeStr = ['-','-','-','-'],
                    origTypeStr = ['-','-','-','-'],
                    multiDestTrackStr = '',
                    multiOrigTrackStr = '',
                    dest1Str = '',//First destination in multi flights sub LOB
                    orig1Str = '';//First origin in multi flights sub LOB

                for(key in multiFlightDestinations)
                {
                    destStr[destCount] = multiFlightDestinations[key];
                    destCount++;
                }

                for(key in multiFlightOrigins)
                {
                    origStr[origCount] = multiFlightOrigins[key];
                    origCount++;
                }

                for(key in multiFlightDestSuggIds)
                {
                    destIDStr[key] = multiFlightDestSuggIds[key];
                }

                for(key in multiFlightOrigSuggIds)
                {
                    origIDStr[key] = multiFlightOrigSuggIds[key];
                }

                for(key in multiDestFieldInfo)
                {
                    destSrcStr[key] = formatSourceInfo (multiDestFieldInfo[key]);
                }

                for(key in multiOrigFieldInfo)
                {
                    origSrcStr[key] = formatSourceInfo (multiOrigFieldInfo[key]);
                }

                for(key in multiDestFieldType)
                {
                    destTypeStr[key] = multiDestFieldType[key] ? multiDestFieldType[key] : '-';
                }

                for(key in multiOrigFieldtype)
                {
                    origTypeStr[key] = multiOrigFieldtype[key] ? multiOrigFieldtype[key] : '-';
                }

                //Create the multi destination tracking str
                for(destCount = 0; destCount <= 3; destCount++ ) {
                    if(multiDestTrackStr == '') {
                        multiDestTrackStr = destSrcStr[destCount]+'|'+destTypeStr[destCount];
                    }
                    else {
                        multiDestTrackStr += '#'+destSrcStr[destCount]+'|'+destTypeStr[destCount];
                    }
                }

                //Create the multi origin tracking str
                for(origCount = 0; origCount <= 3; origCount++ ) {
                    if(multiOrigTrackStr == '') {
                        multiOrigTrackStr = origSrcStr[origCount]+'|'+origTypeStr[origCount];
                    }
                    else {
                        multiOrigTrackStr += '#'+origSrcStr[origCount]+'|'+origTypeStr[origCount];
                    }
                }

                dest1Str = _.compact([

                    //Set the sourceName:sourceId for destination field info variable
                    formatSourceInfo (model.get('destinationSourceInfo')),

                    //Set the suggestion type for destination field info variable
                    model.get('TADestSearchType') ?
                            model.get('TADestSearchType')
                            : '-'

                ]).join('|');

                orig1Str = _.compact([

                    //Set the sourceName:sourceId for origin field info variable
                    formatSourceInfo (model.get('originSourceInfo')),

                    //Set the suggestion type for origin field info variable
                    model.get('TAOrigSearchType') ?
                            model.get('TAOrigSearchType')
                            : '-'

                ]).join('|');

                multiDestTrackStr = _.compact([
                    dest1Str,
                    multiDestTrackStr
                ]).join('#');

                multiOrigTrackStr = _.compact([
                    orig1Str,
                    multiOrigTrackStr
                ]).join('#');

                //Track the sourceName:sourceId|suggestionType info delimited by '#' for multi destination flights
                trackingData.eVar48 = multiDestTrackStr;
                trackingData.prop73 = multiOrigTrackStr;

                //Special case :Track the multi origin and destination field strings in prop74
                trackingData.prop74 += '.'+ _.compact([
                                                model.get('originFromTA') || model.get('origin'),
                                                origStr.join('#')
                                            ]).join('#') + '.'
                                        + _.compact([
                                                model.get('destinationFromTA') || model.get('destination'),
                                                destStr.join('#')
                                            ]).join('#');

            }
            else
            {
                var lineOfBiz = getLob(model.get('tab'), model.get('packages'));
                var destFieldInfo = '';
                var origFieldInfo = '';

                destFieldInfo = _.compact([

                    //Set the sourceName:sourceId for destination field info variable
                    formatSourceInfo (model.get('destinationSourceInfo')),

                    //Set the suggestion type for destination field info variable
                    model.get('TADestSearchType') ?
                            model.get('TADestSearchType')
                            : '-',

                    //Set the destination field text value in the info variable
                    lineOfBiz=='car'?
                            model.get('carPickupValueFromTA') || model.get('pickup') || 'TANoneSelected'
                            : model.get('destinationFromTA') || model.get('destination') || 'TANoneSelected'

                ]).join('|');

                origFieldInfo = _.compact([

                    //Set the sourceName:sourceId for origin field info variable
                    formatSourceInfo (model.get('originSourceInfo')),

                    //Set the suggestion type for origin field info variable
                    model.get('TAOrigSearchType') ?
                            model.get('TAOrigSearchType')
                            : '-',

                    //Set the destination field text value in the info variable
                    lineOfBiz=='car'?
                            (
                                model.get('selectedTASuggestionPosition') && model.get('carReturn') ?
                                    model.get('carDropoffValueFromTA')
                                    : model.get('carReturn')
                            ) || 'TANoneSelected'
                            : lineOfBiz=='hotel' || lineOfBiz=='activity' || lineOfBiz=='hotelCar' ?
                                    'OriginNotApplicable' :
                                    model.get('originFromTA') || model.get('origin') || 'TANoneSelected'
                ]).join('|');

                trackingData.eVar48 = destFieldInfo;
                trackingData.prop73 = origFieldInfo;

                //Add the search by user timestamp of the selected typeahead item to prop74,if user history experiments are on
                //if age data is available from Scratchpad response
                //irrespective of whether User history suggestions shown
                if(
                    ( searchExperiments.getSearchExperimentVariant('8773') !== '0'
                    || searchExperiments.getSearchExperimentVariant('8774') !== '0' )
                ) {
                    var metaData = model.get('taMetadata');
                    var timeData;

                    //userHistoryOldestTimestamp is included in metadata 
                    //if we have info from recent history injector getOldestTimeStampInfo()
                    //It exposes the age of the entire user history retrieved from Scratchpad
                    //For "Hotel" and "Flight" LOB

                    if(lineOfBiz == 'hotel') {
                        timeData = metaData ?
                                        (metaData.userHistoryOldestTimestamp ? metaData.userHistoryOldestTimestamp['hotel'] : '-')
                                        : '-';
                    }
                    else if(lineOfBiz == 'flight') {
                        timeData = metaData ?
                                        (metaData.userHistoryOldestTimestamp ?
                                            (metaData.userHistoryOldestTimestamp['flight'] ? metaData.userHistoryOldestTimestamp['flight'][model.get('flighttype')] : '-')
                                            : '-'
                                        )
                                        : '-';
                    }

                    //Add to prop74 only if the timeData is a number
                    if(!isNaN(timeData)) {
                        var durationData = getDuration(currTimestamp - new Date(timeData));
                        //Add the age of the user history for the LOB
                        trackingData.prop74 += '.'+durationData;
                    }

                }

                //Add the cruise filters (CRUISE|CDES|CLIN|DPOR|DMON|CLEN) to evar47
                var cruiseFiltersEvar47 = model.get("cruiseFiltersEvar47");
                if(cruiseFiltersEvar47) trackingData.eVar47 = cruiseFiltersEvar47;

            }
        }
        return {'trackingData' : trackingData, 'staticExperimentData' : staticExperimentData };
    }

    //Function to generate Typeahead related event string
    function getEvtStr(model) {
        if (getTAShow(model) !== 'TANoShow') {
            var selectedItemPosition = model.get('selectedTASuggestionPosition');
            var userTypedQuery = model.get('userTypedQuery');
            var eventStr = "event45";

            if(userTypedQuery && userTypedQuery.toString() != 'NaN') {
                eventStr = 'event46=' + userTypedQuery.length + ',' + eventStr;
            }
            else {
                eventStr = 'event46=0,' + eventStr;
            }

            if (selectedItemPosition && selectedItemPosition.toString() != 'NaN') {
                eventStr = 'event44=' + selectedItemPosition + ',' + eventStr;
            }
            return eventStr;
        }
    }

    //Util function to get basic submit data for search wizard
    function getBasicReport(model) {
        var parts = [
            getLaunchView(),
            'SrchWzd',
            getTab(model),
            getShortLob(model),
            env.locale,
            site_id
        ];
        return _.compact(parts).join('.');
    }

    //Util function to get detailed submit data for search wizard
    //Adds typeahead related data only for valid search submission
    function getDetailedReport(model, valid) {
        return [
            getBasicReport(model),
            valid ? getTADetails(model) : 'Form-Invalid'
        ].join('.');
    }

    //Util function to get launch view
    function getLaunchView() {
        var LOBMap = {
            hotel: 'HTL',
            flight: 'FLT',
            'package': 'PKG',
            car: 'CAR',
            activity: 'LX',
            cruise: 'CRU'
        };
        var omnitureSubmitCode = conf.wizardconfig && conf.wizardconfig.omnitureSubmitCode;
        return omnitureSubmitCode && LOBMap[omnitureSubmitCode] ?
            LOBMap[conf.wizardconfig.omnitureSubmitCode] :
            'Home';
    }

    //Util function to get wizard tab
    function getTab(model) {
        var tabMap = {
            flight: 'Flights',
            hotel: 'Hotel',
            'package': 'Package',
            car: 'Car',
            cruise: 'Cruise',
            activity: 'Activity',
            buses: 'Bus'
        };
        return tabMap[model.get('tab')];
    }

    //Util function to get LOB in search wizard
    function getShortLob(model) {
        var lobMap = {
            flight: 'F',
            flightHotel: 'FH',
            flightCar: 'FC',
            flightHotelCar: 'FHC',
            hotel: 'H',
            hotelCar: 'HC',
            car: 'C',
            cruise: null,
            activity: 'LX',
            buses: 'RedBus'
            };

        var flightTypeMap = {
                roundtrip: 'RT',
                oneway: 'OW',
                multi: 'MD'
        };

        var lineOfBiz = getLob(model.get('tab'), model.get('packages'));
        return lineOfBiz == 'flight' ?
                _.compact([ lobMap[lineOfBiz], flightTypeMap[model.get('flighttype')] ]).join('.') :
                lobMap[lineOfBiz] ;

    }

    //Function to get Typeahead related details eg: Typeahead trigger and instrumentation
    function getTADetails(model) {
        var TAShow = getTAShow(model);
        var customInstrumentation = getInstrumentationValue(model);
        var instrumentationValue = TAShow !== 'TANoShow' ?
            customInstrumentation :
            importedState.hasImportData() ?
                'TAPrevSearch' :
                '';

        if(instrumentationValue == 'TAPrevSearch')
        {
            instrumentationValue += customInstrumentation ? '.'+customInstrumentation : '';
        }

        var parts = [
            TAShow,
            instrumentationValue
        ];
        return _.compact(parts).join('.');
    }

    //Util function to capture the Typeahead triggers
    function getTAShow(model) {
        var renderedTA = !!corewizard.OMTypeAheadRendered;

        if (!renderedTA)
        {
            return 'TANoShow';
        }
        else
        {
        //TAShow.TAFocus : If Typeahead is shown and a particular TASearchType is selected from the suggestions
        //TODO : TAShow.TAPrevSearch : If Typeahead is shown, but the user submitted previously populated search text without selection
        //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
        //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
        //TODO : Include check for whether matches with importedStateData

            var trigger = 'TAShow';

            if(
                _.contains(['TRENDINGSEARCH', 'RECENTHISTORY'], model.get('TASearchType'))
                && model.get('selectedTASuggestionPosition')
            )
            {
                //TAShow.TAFocus : If Typeahead is shown and a particular TASearchType is selected from the suggestions
                trigger += '.TAFocus';
            }
            else if(model.get('selectedTASuggestionPosition'))
            {
                //If a typeahead item was selected, we would have selected item position
                //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
                trigger += '.TASelection';
            }
            else
            {
                //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
                trigger += '.TANoSelection';
            }

            return trigger;
        }

    }

    //Util function to get custom instrumentation for Typeahead
    function getInstrumentationValue(model) {
        var metaData = model.get('taMetadata');

        return _.compact([

            //Vijayalaxmi Mohapatra (vmohapatra) : Abbreviate the tag names as per below
            //ST = Selected Suggestion Type
            //L = Level of selection
            //ESS = Number of suggestions sent by ESS, This is always present as ESS is the primary service provider for TA
            //UH = Number of suggestions from user history
            //UHA = Selected user history item's age

            //Hierarchy info or Level of selection from the suggestions shown for LOBs other than hotel or flight
            _.contains(['flight', 'hotel'], getLob(model.get('tab'), model.get('packages'))) ?
                instrumentHierarchicalDisplay(model) :
                'L#' + (model.get('selectedTASuggestionPosition') ? model.get('selectedTASuggestionPosition') : '-'),

            //Search Type
            //'ST#' + (model.get('TASearchType') ? model.get('TASearchType') : '-'),

            //ESS Suggestions shown
            'ESS#' + (model.get('essItemsTotal') ? model.get('essItemsTotal') : '0'),

            //User history suggestions shown if user history experiments are on
            (searchExperiments.getSearchExperimentVariant('8773') !== '0' || searchExperiments.getSearchExperimentVariant('8774') !== '0') ?
            'UH#' + (model.get('userHistoryItemsTotal') ? model.get('userHistoryItemsTotal') : '0') :
            '',

            //Capture selected User History Item Age if the experiment is ON
            (searchExperiments.getSearchExperimentVariant('8773') !== '0' || searchExperiments.getSearchExperimentVariant('8774') !== '0') ?
            'UHA#' + (model.get('userHistoryItemAge') ? (getDuration(model.get('userHistoryItemAge')) ? getDuration(model.get('userHistoryItemAge')) : '-') : '-') :
            '',

            //Trending Search suggestions shown if experiment is ON
            (searchExperiments.getSearchExperimentVariant('9305') !== '0') ?
            'RX#'+(metaData ? (metaData.recommenderOptionsRendered ? metaData.recommenderOptionsRendered : '0') : '0') :
            ''
        ]).join('.');
    }

    //Util function to capture hierarchy related data
    function instrumentHierarchicalDisplay(model) {
        //Send the new instrumentation only for hotel LOB
        //C0 indicates item is parent
        //C1 indicates item is child
        //P0 indicates item has no child
        //P1 indicates item has child
        //L indicates level of item selected
        var hierarchyCode = '';
        if (model.get('suggestionType') === 'child')
        {
            // a child cannot have children
            hierarchyCode = 'P0C1';
        }
        else if (model.get('suggestionType') === 'parent' && model.get('hasChild'))
        {
            hierarchyCode = 'P1C0';
        }
        else
        {
            //Default hierarchy code : has no Children, is a parent
            hierarchyCode = 'P0C0';
        }

        var positionInfo = model.get('selectedTASuggestionPosition') ? model.get('selectedTASuggestionPosition') : '-';
        return hierarchyCode + 'L' + positionInfo;
    }

    //Utility function to convert milliseconds into readable format of days:hours:minutes:seconds:milliseconds
    function getDuration(ms) {
        //return undefined if a non-number or a null param is passed
        if(ms && isNaN(ms)) { return; }

        var days = Math.floor(ms / (24*60*60*1000)); //86,400,000ms
        var daysms=ms % (24*60*60*1000);

        var hours = Math.floor((daysms)/(60*60*1000));//3,600,000ms
        var hoursms=ms % (60*60*1000);

        var minutes = Math.floor((hoursms)/(60*1000));//6,000ms
        var minutesms=ms % (60*1000);

        var sec = Math.floor((minutesms)/(1000));//1,000ms
        var secms = ms % 1000;

        var millis = Math.floor((secms)/(1));

        return days+"d:"+hours+"h:"+minutes+"m:"+sec+"s:"+millis+"ms";
    }

    //Utility function to set the string with info sourceName:SourceID
    function formatSourceInfo(obj) {
        var returnStr = obj ? 
                            (
                                ( obj.sourceName ? obj.sourceName : '-') 
                                + ':'
                                + ( obj.sourceId ? obj.sourceId : '-')
                            )
                            : '-:-' ;
        return returnStr;
    }
//****************************************************************************************
//***********************************Default Submit Logging*******************************
//****************************************************************************************

});

var corewizard = corewizard || {};
corewizard.searchTracking = corewizard.searchTracking || {};

require([
         'gc/importedState',
         'gc/searchExperiments',
         'gc/conf',
         'env',
         'gc/getLob',
         'gc/abTest'
       ], function (
         importedState,
         searchExperiments,
         conf,
         env,
         getLob,
         abTest
       ) {
    //Default function to track valid search submit
    corewizard.searchTracking.trackValidOpenSearch = function (model) {
     var trackingData = getDetailedTrackingDataForOpenSearch(model, true);
     var eventStr = getOpenSearchEvtStr(model);
     dctk.trackEvent('o', 'wizard-submit', trackingData, eventStr);
    }
    //Function to generate Open search Typeahead related event string
    // Use event145 : user typed query ,
    // event146 : query length ,
    // event 144 : selected item position
    function getOpenSearchEvtStr(model) {
        if (!!corewizard.OMTypeAheadRendered) {    // was typeahead rendered
            var selectedItemPosition = model.get('selectedTASuggestionPosition');
            var userTypedQuery = model.get('userTypedQuery');
            var eventStr = "event145";

            if (userTypedQuery && userTypedQuery.toString() != 'NaN') {
                eventStr = 'event146=' + userTypedQuery.length + ',' + eventStr;
            } else {
                eventStr = 'event146=0,' + eventStr;
            }

            if (selectedItemPosition && selectedItemPosition.toString() != 'NaN') {
                eventStr = 'event144=' + selectedItemPosition + ',' + eventStr;
            }

            return eventStr;
        }
    }

    //Function used to capture detailed open search typeahead data
    function getDetailedTrackingDataForOpenSearch(model, valid) {

        var parts = [
                    'Home',
                    'SrchWzd',
                    "OpenSearch",
                    "OS",
                    corewizard.masterconfig.locale,
                    site_id
                    ];

        var basicReport = _.compact(parts).join('.');
        var detailedReport = getOpenSearchTADetails(model);

        var detailedInfo = basicReport +'.' + detailedReport ;

        var trackingData = {
            prop16: detailedInfo,
            eVar28: detailedInfo
        };

        //set LOB of entry selected in eVar48
        trackingData.eVar48 = model.get('TASearchType');
        //Set the user typed text    in prop74
        trackingData.prop74 = '"' + ( model.get('userTypedQuery') || '' ) + '"' ;

        return trackingData;
    }

    //Function to get Open search Typeahead related details
    function getOpenSearchTADetails(model) {
        var TAShow = getOpenSearchTAShow(model);
        var instrumentationValue = getOpenSearchInstrumentationValue(model) ;

        var parts = [
            TAShow,
            instrumentationValue
        ];
        return _.compact(parts).join('.');
    }

    //Function to capture if Open Search Typeadhead was shown
    function getOpenSearchTAShow(model) {
        var renderedTA = !!corewizard.OMTypeAheadRendered;
        var typeaheadService = (abTest.get(10406).value == "2") ? 'Gemma' : 'TA' ;

        if (!renderedTA)
        {
            return typeaheadService+'NoShow';
        }
        else
        {
        //TAShow.TAFocus : If Typeahead is shown and a particular TASearchType is selected from the suggestions
        //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
        //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
            var trigger = typeaheadService+'Show';

            if(model.get('selectedTASuggestionPosition'))
            {
                //If a typeahead item was selected, we would have selected item position
                //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
                trigger += '.'+typeaheadService+'Selection';
            }
            else
            {
                //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
                trigger += '.'+typeaheadService+'NoSelection';
            }
            return trigger;
        }
    }

    //Util function to get custom instrumentation for Open Search Typeahead
    function getOpenSearchInstrumentationValue(model) {

        var data = model.get('openSearchQueryData') || {} ;
        return _.compact([

            //ST = SearchType, region type of the entry selected
            'ST#' + (data.regionType)? data.regionType : '-',

            //QL = User typed query length
            'QL#' +    (model.get('userTypedQuery') ? model.get('userTypedQuery').length : '0'),

            //SS = Number of suggestions sent by SS - suggest service
            'SS#' + (model.get('essItemsTotal') ? model.get('essItemsTotal') : '0'),

            //LOB = Line of business of the entry selected as sent back by suggest service
            //For Gemma always gemma , for ESS if something was choosen by user that LOB otherwise -

            'LOB#' + (model.get('TASearchType') ? model.get('TASearchType') : '-')

        ]).join('.');
    }
});
/*
In core.js, corewizard.core.submit calls Submit.submit from this file. Handles form submit logic.
deps: corewizard, corewizard.validator, SubmitTracking, jQuery, uitk, dctk
*/

function setDefaultForRoomOneAdults() {
  'use strict';

  require(['gc/dataModels', 'gc/getLob'], function(dataModels, getLob) {
    var model = dataModels.model;
    var state = dataModels.state;
    // applies the desired default (2 for searches involving hotels, 1 for others) to the wizardModel unless the value has already been set by the user
    if (!model.get('rooms[0].adults') || model.get('rooms[0].adults') < 0) {
      if (model.get('tab') === 'hotel' ||
        model.get('packages.hotel') ||
        model.get('tab') === 'threePP') {
        state.set('rooms[0].adults', 2);
      } else {
        state.set('rooms[0].adults', 1);
      }
    }
  });
}

define('gc/Submit', [
  'gc/importedState',
  'gc/search',
  'gc/dataModels',
  'gc/validate',
  'gc/getLob',
  'uitk'
], function(
  importedState,
  search,
  dataModels,
  validate,
  getLob,
  uitk
) {
  var Submit = {};

  Submit.submit = function(model) {
    // TODO: this should be in the model
    setDefaultForRoomOneAdults();
    var validationResults = validate(dataModels.model.get('config.validation'), dataModels.model.toJSON());
    dataModels.state.set('validation', validationResults);
    if (validationResults.isValid) {
      Submit.validSubmit(model);
    } else {
      Submit.invalidRetry(model);
    }
  };

  Submit.validSubmit = function(model) {
    importedState.setBackButtonData(model); // saving back button
    if(getLob(model.get('tab'), model.get('packages')) == 'openSearch'){
     corewizard.searchTracking.trackValidOpenSearch(model);
    } else {
    corewizard.searchTracking.trackValidSearch(model);
    }
    uitk.publish("corewizard.validSubmit", getLob(model.get('tab'), model.get('packages')));
    Submit.goToSearchUrl(model);
  };

  Submit.goToSearchUrl = function(model) {
    var url = Submit.getSearchUrl(model.toJSON());
    url.indexOf('/Trivago-Redirection') > -1||url.indexOf('12go.asia') > -1? window.open(url, '_blank') : window.location = url;
  };

  Submit.getSearchUrl = function(model, lob, searchUrlGenerator) {
    lob = lob || getLob(model.tab, model.packages);
    if (Submit.trivagoRedirectionUrl && Submit.trivagoRedirectionUrl.shouldRedirect(model, lob)) {
      return Submit.trivagoRedirectionUrl(model);
    }
    else if (model.isMobileDevice && !model.isMultiDest && !model.isHashlessURLneeded) {
      return search.eapAspSearchUrl(model, lob);
    } else {
        var generator = searchUrlGenerator || dataModels.config.get('searchUrlGenerator');
        if(typeof generator === 'function') {
          return generator(model, lob, dataModels.state);
        }
        else {
          return search[generator](model, lob, dataModels.state);
        }
    }
  };

  Submit.invalidRetry = function(model) {
    // render errors
    dataModels.state.trigger('reloadWizard');

    //set focus
    $('div[data-wizard-action=search-wrapper]').find('.alert-container')
      .attr('tabindex', -1)
      .focus();

    // omniture track failure
    corewizard.searchTracking.trackInvalidSearch(model);
  };

  return Submit;
});

define('gc/wizardActionBinder', function() {
  return {
    bindActions: function (wrapperEl, state) {
      var key = '[data-wizard-action]';
      var defaultHandler = _.partial(handleStateChangeEvent, state);
      var accessibilityHandler = _.partial(handlePlaceholderEvent, state);
      var listenerList = [
        { eventType: 'blur',          selector: 'input[type=text]' + key,     handler: defaultHandler },
        { eventType: 'input',          selector: 'input[data-js-theme=typeahead]' + key,     handler: accessibilityHandler },
        { eventType: 'focus',         selector: 'input[type=text]' + key,     handler: defaultHandler },
        { eventType: 'change',        selector: 'select' + key,               handler: defaultHandler },
        { eventType: 'change',        selector: 'input[type=checkbox]' + key, handler: defaultHandler },
        { eventType: 'keydown',       selector: 'input[type=radio]' + key,    handler: accessibilityHandler },
        { eventType: uitk.clickEvent, selector: 'input[type=radio]' + key,    handler: defaultHandler },
        { eventType: uitk.clickEvent, selector: 'a' + key,                    handler: defaultHandler },
        { eventType: uitk.clickEvent, selector: 'a[data-tab=package]',        handler: _.partial(packageDealsClick, state) }
      ];

      _.each(listenerList, function (listener) {
        wrapperEl.on(listener.eventType, listener.selector, listener.handler);
      }, this);
    } ,
    bindOpenSearchSubmitAction : function (wrapperEI, state) { 
      //Open Search can not select first input from typeahead and should
      //pass on only entered text to validation
      if (state.get('tab') == "openSearch") {
            wrapperEI.find('input').each(function(index, element) {
            applyStateChangeToField(state,$(element));
          });
       }
    }
  };


  function handlePlaceholderEvent(state, evt){
    var $target = $(evt.currentTarget);
    var groups = [];
    var thisGroup

    // Fix the accessibility bug for WCAG-789
    if($target.data('wizard-action').hasOwnProperty('carReturn')){
      var $value = $target.val();
      var $placeholder = $target.attr('placeholder') || 'Same as Pick-up';
      if($value === ""){
        $target.prop('title', $placeholder);
      // Fix the accessibility bug for WCAG-987
        $target.attr('placeholder', $placeholder);
      }else {
        $target.prop('title', "");
      // Fix the accessibility bug for WCAG-987
        $target.attr('placeholder', "");
      }
    }

    // Fix for the accessbility bug WCAG-1032 and WCAG-1035
    if(evt.type === 'keydown'){
      // Disable the default behavior of the up and down arrow key
      evt.preventDefault();
      var $radioButtonGroup = $target.parent().parent().find("input[type='radio']");
      // group the radio button inputs field by name
      $radioButtonGroup.each(function (i,elem) {
        thisGroup = groups[elem.name] = (groups[elem.name] || []);
        thisGroup.push(elem);
      });

      setTimeout(function (){
        var el = evt.currentTarget;
        // Getting the radio buttons group matches the name of the current active radio button
        var thisGroup = groups[el.name] = (groups[el.name] || []),
            indexOfTarget = thisGroup.indexOf(el),
            active,
            $firstInput,
            $lastTab;

        if (evt.keyCode === 40 && indexOfTarget < (thisGroup.length - 1)) {
          //Setting the next radio button to be the active element after pressing downarrow key.
          active = thisGroup[indexOfTarget + 1];
          //Changing the state of the radio buttons to be the active one
          applyStateChangeToField(state, $(active));
          //Setting the focus on the active radio button
          document.getElementById(active.id).focus();

        }else if (evt.keyCode === 38 && indexOfTarget > 0) {
          //Setting the former radio button to be the active element after pressing uparrow key.
          active = thisGroup[indexOfTarget - 1];
          //Changing the state of the radio buttons to be the active one
          applyStateChangeToField(state, $(active));
          //Setting the focus on the active radio button
          document.getElementById(active.id).focus();
        }
        if(evt.keyCode === 9){
          if(!evt.shiftKey){
            //Pressing the tab key, the focus go to the next element
            $firstInput = $('.forms').find('input[type="text"]').first();
            $firstInput.focus().select();
          }else {
            //Pressing the tab + Shift, moving the focus back the former element
            $lastTab = $('.tabs').find('li').last();
            uitk.utils.focusElement($lastTab);
          }
        }
      });
    }
  }

  function packageDealsClick(state) {
    var packages = state.get('packages');
    var atLeastOnePackage = packages && (packages.flight || packages.hotel || packages.car || packages.train);
    var packageTabIsAlreadySelected = state.get('tab') === 'package';
    var isPackage = packageTabIsAlreadySelected || atLeastOnePackage;

    var update = {
      tab: 'package',
      packages: isPackage ? packages : {flight: true, hotel: true, car: false, train: false}
    };

    state.set(update);
  }

  function handleStateChangeEvent(state, evt) {
    var $target = $(evt.currentTarget);

    // fix the accessibility bug WCAG-943
    if(window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      $target.select();
    }

    if ($target.attr('role') === 'button') evt.preventDefault();
    if (evt.type === 'change') {
      state.set('activeElement', $target.attr('id'));
      evt.stopPropagation(); //this stops an error being thrown in IE8
    }
    applyStateChangeToField(state, $target);
    state.trigger('change:UI:' + $target.attr('data-tracking'), state);
  }

  function applyStateChangeToField(state, $field) {
    var values = getWizardActionValues($field);
    var properties = $field.attr('data-wizard-action');

    _.each(values, function(value, i) {
      var re = new RegExp('\\$value' + (i + 1), 'g');
      properties = properties.replace(re, value);
    });

    state.set(JSON.parse(properties));
  }

  function getWizardActionValues($field) {
    if ($field.attr('type') == 'checkbox') {
      return [$field.is(':checked').toString()];
    }
    else if ($field.val()) {
      return $field.val().split(':');
    }
    else {
      return [''];
    }
  }
});

/**
 * This file is intended to be a module that encapsulates the generation of the URLs for the requests to Expedia Suggest
 * Service (ESS).
 */
"use strict";

/**
 * A generator of the URLs for requests to Expedia Suggest Service (ESS).
 * @class
 * @param {Array} essAbacusIds - an array of Abacus IDs for which the variant assignments should be passed to ESS.
 * @param {function} variantAssigner - a function that, for any given abacus ID, returns the variant assignment for
 *        it, or returns undefined if the session should be excluded from the experiment.
 * @param {function} pageIdGetter - a function that returns the page ID of the web page.
 */
define('gc/ExpediaSuggestServiceRequestGenerator', ['gc/searchExperiments'], function(searchExperiments) {

    function ExpediaSuggestServiceRequestGenerator(essAbacusIds, variantAssigner, pageIdGetter) {
        this.__essAbacusIds = essAbacusIds;
        this.__variantAssigner = variantAssigner;
        this.__pageIdGetter = pageIdGetter;
        this.siteId = this.__getSiteId();
        this.guid = this.__getGuid();
    }

    ExpediaSuggestServiceRequestGenerator.prototype.ESS_ABACUS_IDS = [];

    ExpediaSuggestServiceRequestGenerator.prototype.clientIdByPageId = {
        "aws_Homepage": "AWSHomepage",
        "Homepage": "Homepage",
        "page.Flights": "FlightsLandingPage",
        "page.Hotels": "HotelsLandingPage",
        "page.Cars" : "CarsLandingPage",
        "page.Activities" : "LXLandingPage",
        "page.Packages": "PackageLandingPage"
    };

    ExpediaSuggestServiceRequestGenerator.prototype.defaultPageIdGetter = function () {
        var pageIdElement = $("#pageId"),
            pageId = pageIdElement.size() === 1 ? pageIdElement.val() : "";
        return pageId ? pageId : "";
    };

    ExpediaSuggestServiceRequestGenerator.prototype.getClientId = function () {
        var pageId = typeof this.__pageIdGetter === "function" && this.__pageIdGetter(),
            clientId = pageId && ExpediaSuggestServiceRequestGenerator.prototype.clientIdByPageId[pageId];
        return clientId ? clientId : "Unknown";
    };

    ExpediaSuggestServiceRequestGenerator.prototype.__getVariantAssignment = function (abacusId) {
        if(typeof this.__variantAssigner !== 'function') { return; }
        var variant = this.__variantAssigner(abacusId);
        return variant === undefined ? undefined : "".concat(abacusId, ".", variant);
    };

    /**
     * Generates the Abacus parameter of ESS request URL.
     * @returns {string}
     */
    ExpediaSuggestServiceRequestGenerator.prototype.generateAbacusParameter = function () {
        var self = this,
            abFieldValue = [];
        function getVariantAssignment (abacusId) {
            if(typeof self.__getVariantAssignment === 'function') {
                return self.__getVariantAssignment(abacusId);
            }
            else {
                return undefined;
            }
        }
    
        $(this.__essAbacusIds).each(function(index, abId){
            var variantAssignment = getVariantAssignment(abId);
            if(variantAssignment) { abFieldValue.push(variantAssignment) }
        });

        var varAssignment9241 = getVariantAssignment('9241');
        if(varAssignment9241){
            if(searchExperiments) {
                var variant9241 = searchExperiments.getSearchExperimentVariant('9241');
                switch(variant9241) {
                    case "0"  : abFieldValue.push(getVariantAssignment('8071')); break;
                    case "1"  : abFieldValue.push('8071.2'); break;
                    default : abFieldValue.push(getVariantAssignment('8071'));
                }
            }
        }
        else {
            var varAssignment8071 = getVariantAssignment('8071');
            if(varAssignment8071) {
                abFieldValue.push(varAssignment8071);
            }
        }

        return abFieldValue.length > 0 ? abFieldValue.join("|") : "";
    };

    ExpediaSuggestServiceRequestGenerator.prototype.__getSiteId = function () {
        /*
         window.site_id is defined on home page (both Expweb and cloud versions), and on launch pages. It is undefined on
         hotel search results page. Once we decide on a client-side error logging mechanism, we should log errors properly.
         */
        return window.site_id ? window.site_id : '';
    };

    ExpediaSuggestServiceRequestGenerator.prototype.__getCookie = function (name) {
        var value = "; " + document.cookie,
            parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    };

    ExpediaSuggestServiceRequestGenerator.prototype.__getGuid = function () {
        var mc1Cookie = this.__getCookie("MC1"),
            pair = mc1Cookie && mc1Cookie.split("=");
        return $.isArray(pair) && pair.length === 2 ? pair[1] : "";
    };

    ExpediaSuggestServiceRequestGenerator.prototype.defaultVariantAssigner = function() {
        if(searchExperiments){
            return searchExperiments.getSearchExperimentVariantIfParticipating;
        }
        return undefined;
    };

    ExpediaSuggestServiceRequestGenerator.defaultGenerator = new ExpediaSuggestServiceRequestGenerator(
      ExpediaSuggestServiceRequestGenerator.prototype.ESS_ABACUS_IDS,
      ExpediaSuggestServiceRequestGenerator.prototype.defaultVariantAssigner ? ExpediaSuggestServiceRequestGenerator.prototype.defaultVariantAssigner() : undefined,
      ExpediaSuggestServiceRequestGenerator.prototype.defaultPageIdGetter);

    return ExpediaSuggestServiceRequestGenerator;
});
define('gc/TypeaheadMetricsLogger', ['gc/searchExperiments'], function(searchExperiments) {

var TypeaheadMetricsLogger = function(name, locale, guid) {
    "use strict";
    function getCookie(name) {
        var value = "; " + document.cookie,
            parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function getGuid() {
        var mc1Cookie = getCookie("MC1"),
            pair = mc1Cookie && mc1Cookie.split("=");
        return $.isArray(pair) && pair.length === 2 ? pair[1] : "";
    };

    this.name = name;
    this.timestamps = {};
    this.selections = [];
    this.focuses = [];
    this.submission = undefined;
    this.guid = guid || getGuid();
    this.suggestionEngagement = new TypeaheadMetricsLogger.SuggestionEngagementMetric(name, this.guid, locale);
}

TypeaheadMetricsLogger.prototype.TimestampCategories = {
    FOCUS: "FOCUS",
    ESS_REQUEST: "ESS_REQUEST",
    ESS_RESPONSE: "ESS_RESPONSE",
    KEY_UP: "KEY_UP",
    RENDER: "RENDER"
};

TypeaheadMetricsLogger.prototype.MetricCategory = function(name, beginTimestampCategory, endTimestampCategory) {
    "use strict";
    this.name = name;
    this.beginTimestampCategory = beginTimestampCategory;
    this.endTimestampCategory = endTimestampCategory;
};

TypeaheadMetricsLogger.prototype.SelectionMetric = function(index, text, guid, optionalTimestampValue) {
    "use strict";
    this.index = index;
    this.text = text;
    this.length = text.length;
    this.pointOfSale = window.location.hostname;
    this.guid = guid;
    this.type = "selection";
    this.timestamp = optionalTimestampValue || new Date().getTime();
};

TypeaheadMetricsLogger.prototype.SubmissionMetric = function(text, guid, isValid, optionalTimestampValue) {
    "use strict";
    this.text = text;
    this.length = text.length;
    this.pointOfSale = window.location.hostname;
    this.guid = guid;
    this.type = isValid ? "validSearchSubmission" : "invalidSearchSubmission";
    this.timestamp = optionalTimestampValue || new Date().getTime();
}

TypeaheadMetricsLogger.prototype.FocusMetric = function(guid, optionalTimestampValue) {
    "use strict";
    this.pointOfSale = window.location.hostname;
    this.guid = guid;
    this.type = "focus";
    this.timestamp = optionalTimestampValue || new Date().getTime();
};

TypeaheadMetricsLogger.prototype.MetricCategories = {
    KeyUpToEssRequest: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "KeyUpToEssRequest",
        TypeaheadMetricsLogger.prototype.TimestampCategories.KEY_UP,
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_REQUEST),
    EssRequestToResponse: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "EssRequestToResponse",
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_REQUEST,
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_RESPONSE),
    EssResponseToRender: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "EssResponseToRender",
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_RESPONSE,
        TypeaheadMetricsLogger.prototype.TimestampCategories.RENDER),
    KeyUpToRenderNotCallingEss: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "KeyUpToRenderNotCallingEss",
        TypeaheadMetricsLogger.prototype.TimestampCategories.KEY_UP,
        TypeaheadMetricsLogger.prototype.TimestampCategories.RENDER)
};

TypeaheadMetricsLogger.SuggestionEngagementMetric = function(elementId, guid, locale) {
    this.type = "SuggestionEngagement";
    this.pointOfSale = window.location.hostname;
    this.siteId = window.site_id;
    this.locale = locale;
    this.suggestionShown = false;
    this.suggestionSelected = false;
    this.textInputElementId = elementId;
    this.guid = guid;
};

TypeaheadMetricsLogger.prototype.emitSuggestionEngagementMetric =
    function(isSuggestionSelected, userTypedQuery, text, lob, pageId, variants)
{
    "use strict";
    this.suggestionEngagement.suggestionSelected = isSuggestionSelected;
    this.suggestionEngagement.userTypedQuery = userTypedQuery;
    this.suggestionEngagement.text = text;
    this.suggestionEngagement.lob = lob;
    this.suggestionEngagement.pageId = pageId;
    // TODO Remove the flag contentFlavor once various implementations of typeahead widget are unified.
    //
    // contentFlavor is a temporary flavor to indicate the implementation of typeahead widget that the customer
    // interacts with, at a time when there are multiple implementations (Expweb, Global Controls, uTA) all serving live
    // traffic.
    this.suggestionEngagement.contentFlavor = "global-controls";
    this.suggestionEngagement.variants = variants;
    this.suggestionEngagement.timestamp = new Date().getTime();
    this.sendToCollector([this.suggestionEngagement]);
};

TypeaheadMetricsLogger.prototype.timestamp = function (timestampCategory, query, optionalTimestampValue) {
    "use strict";
    this.timestamps[timestampCategory] = this.timestamps[timestampCategory] || {};
    this.timestamps[timestampCategory][query] = this.timestamps[timestampCategory][query] ||[];
    this.timestamps[timestampCategory][query].push(optionalTimestampValue || new Date().getTime());
};

TypeaheadMetricsLogger.prototype.logFocus = function () {
    "use strict";
    this.focuses.push(new this.FocusMetric(this.guid));
};

TypeaheadMetricsLogger.prototype.logSelection = function (index, text) {
    "use strict";
    this.selections.push(new this.SelectionMetric(index, text, this.guid));
};

TypeaheadMetricsLogger.prototype.logSubmission = function (text, isValid) {
    "use strict";
    this.submission = new TypeaheadMetricsLogger.prototype.SubmissionMetric(text, this.guid, isValid);
};

TypeaheadMetricsLogger.prototype.computePerformanceMetrics = function() {
    "use strict";
    var self = this,
        mCat = this.MetricCategories,
        rv = [],
        guid = this.guid;

    function computeMetricsForQuery(query, metricCategories) {
        var metrics = {};
        var finalTimestampCategory;
        _.forEach(metricCategories, function (metricCategory) {
            self._extendWithMetric(metrics, metricCategory, query);
        });
        if ($.isEmptyObject(metrics)) {
            return null;
        } else {
            finalTimestampCategory = metricCategories[metricCategories.length - 1].endTimestampCategory;
            self.timestamps[finalTimestampCategory][query].shift();
            metrics['pointOfSale'] = window.location.hostname;
            metrics['guid'] = guid;
            metrics['type'] = "latency";
            return metrics;
        }
    }

    function computeMetricsForQueryCallingEss(query) {
        return computeMetricsForQuery(query, [mCat.KeyUpToEssRequest, mCat.EssRequestToResponse, mCat.EssResponseToRender]);
    }

    function computeMetricsForQueryNotCallingEss(query) {
        return computeMetricsForQuery(query, [mCat.KeyUpToRenderNotCallingEss]);
    }

    _.forEach(_.keys(this.timestamps[this.TimestampCategories.RENDER]), function (query) {
        var metrics;
        do {
            metrics = computeMetricsForQueryCallingEss(query) || computeMetricsForQueryNotCallingEss(query);
            if (metrics) {
                rv.push(metrics);
            }
        } while (metrics);
    });
    return rv;
};

TypeaheadMetricsLogger.prototype.sendToCollector = function (object) {
    "use strict";
    var url = "//"
            + window.location.hostname
            + (window.location.port ? ':' + window.location.port : '')
            + "/cl/data"
            + "/typeahead_client_metrics.json?stream=true&persist=true&batch=true";
    $.ajax({
            contentType: "application/json; charset=UTF-8",
            url: url,
            data: JSON.stringify(object),
            dataType: "json",
            type: "POST"
        }
    );
};

TypeaheadMetricsLogger.prototype.emitMetrics = function() {
    "use strict";
    var performanceMetrics = this.computePerformanceMetrics();
    if (performanceMetrics.length > 0) {
        this.sendToCollector(performanceMetrics);
    }
    if (this.selections.length > 0) {
        this.sendToCollector(this.selections);
        this.selections = [];
    }
    if (this.focuses.length > 0) {
        this.sendToCollector(this.focuses);
        this.focuses = [];
    }
    if (this.submission) {
        this.sendToCollector([this.submission]);
        this.submission = undefined;
    }
};

TypeaheadMetricsLogger.prototype._hasTimestamp = function(timestampCategory, query) {
    "use strict";
    return this.timestamps[timestampCategory]
        && $.isArray(this.timestamps[timestampCategory][query])
        && this.timestamps[timestampCategory][query].length > 0
};

TypeaheadMetricsLogger.prototype._extendWithMetric = function(object, metricCategory, query) {
    "use strict";
    if (this._hasTimestamp(metricCategory.endTimestampCategory, query)
        && this._hasTimestamp(metricCategory.beginTimestampCategory, query))
    {
        object[metricCategory.name] = this.timestamps[metricCategory.endTimestampCategory][query][0]
            - this.timestamps[metricCategory.beginTimestampCategory][query].shift();
    }
    if (!_.isEmpty(object)) {
        object.text = query;
    }
    return object;
};

return TypeaheadMetricsLogger;
});

/* global $, _, corewizard */

var searchExperimentsGlobal;
require(['gc/abTest', 'gc/dataModels', 'gc/searchExperiments'], function(abTest, dataModels, searchExperiments) {
    searchExperimentsGlobal = searchExperiments;
});

function BestDealsOptionInjector(typeahead) {
    "use strict";
    var variant = searchExperimentsGlobal.getVariant("BEST_DEALS_OPTION");
    this.displayName = ["", typeahead.opts.bestDealsText, typeahead.opts.cheapHotelsText][variant] || "";
    this.lastSearchNamePostfix = [
                "",
                " - " + typeahead.opts.bestDealsText.toLowerCase(),
                " - " + typeahead.opts.cheapHotelsText.toLowerCase()
            ][variant] || "";
    this.sort = [undefined, "deals", "price"][variant] || undefined;
}

BestDealsOptionInjector.prototype = {};

BestDealsOptionInjector.prototype.__isChild = function (result) {
    "use strict";
    return result &&
        result.hierarchyInfo &&
        result.hierarchyInfo.relation &&
        _.contains(result.hierarchyInfo.relation, "child");
};

BestDealsOptionInjector.prototype.shouldInject = function (results) {
    "use strict";
    return _.isObject(results)
        && results.length >= 2
        && this.__isChild(results[1]);
};

BestDealsOptionInjector.prototype.deleteLeastImportantOption = function (results) {
    "use strict";
    var childrenCount;
    if (results.length < 10) {
        return;
    }
    childrenCount = this.countChildren(results);
    if (childrenCount >= 6) {
        results.splice(childrenCount, 1);
    } else {
        results.splice(results.length - 1, 1);
    }
};

BestDealsOptionInjector.prototype.countChildren = function (results) {
    "use strict";
    return _.filter(results, BestDealsOptionInjector.prototype.__isChild).length;
};

BestDealsOptionInjector.prototype.makeNewOption = function (baseOption) {
    "use strict";
    var newOption = {};
    $.extend(true, newOption, baseOption);
    newOption.regionNames = newOption.regionNames || {};
    newOption.regionNames.lastSearchName =
        $($.parseHTML(baseOption.regionNames.displayName)).text() + this.lastSearchNamePostfix;
    newOption.regionNames.displayName = this.displayName;
    newOption.hierarchyInfo = newOption.hierarchyInfo || {};
    newOption.hierarchyInfo.isChild = "true";
    newOption.hierarchyInfo.relation = newOption.hierarchyInfo.relation || [];
    newOption.hierarchyInfo.relation.push("child");
    newOption.type = "DEALS";
    newOption.sort = this.sort;
    return newOption;
};

BestDealsOptionInjector.prototype.inject = function (results) {
    "use strict";
    var newOption,
        i,
        optionsCount;
    if (!this.shouldInject(results)) {
        return;
    }
    this.deleteLeastImportantOption(results);
    newOption = this.makeNewOption(results[0]);
    results.splice(1, 0, newOption);
    optionsCount = results.length;
    for (i = 0; i < optionsCount; ++i) {
        results[i].index = i.toString(10);
    }
};

(function() {
    "use strict";

    // here the intention is to cache both the index value for each item in the combined array as
    // well as preserve the original incoming array index in the essIndex property.
    function renumberOptions(results) {
        var optionsCount = results.length;
        var result;
        var i;
        for (i = 0; i < optionsCount; ++i) {
            result = results[i];
            if (_.isObject(result)) {
                if (!_.isUndefined(result.index) && _.isUndefined(result.essIndex)) {
                    // if the incoming item already had a .index property, then it's part of the
                    // original list. Store it off in the essIndex property
                    result.essIndex = result.index;
                }

                // now store(or update) the actual index
                result.index = i.toString(10);
            }
        }
    }

    function injectSuggestions(preexistingSuggestions, additionalSuggestions, maxTotalOptions) {
        Array.prototype.splice.apply(preexistingSuggestions, [0, 0].concat(additionalSuggestions));
        preexistingSuggestions.splice(maxTotalOptions, Number.MAX_VALUE);
        renumberOptions(preexistingSuggestions);
    }

    window.TypeaheadUtils = window.TypeaheadUtils || {};
    window.TypeaheadUtils.injectSuggestions = injectSuggestions;
})();

/* global _, console, corewizard, uitk */

(function() {
    require(['uitk', 'searchExperiments'], function(uitk, searchExperiments) {
        "use strict";

        // match omniture string for logging
        var recentHistoryType = "RECENTHISTORY";

        // simple console logger for
        // debug traces
        function logError(error) {
            console && console.error && console.error(error);
        }

        function verify(value, verifier, errorMessage) {
            if (!verifier(value)) {
                throw new Error(errorMessage);
            }
            return value;
        }

        function verifyPredicate(predicate, errorMessage) {
            if (!predicate) {
                throw new Error(errorMessage);
            }
        }

        function getLocale() {
            // window.locale is defined on homepage (Expweb) but currently not supported on E3 Prime Homepage.
            return window.locale || 'en_US';
        }

        function getRouteDetails(history) {
            verify(history, _.isObject);
            var searchSearch = verify(history.search, _.isObject),
                routeDetails = searchSearch.routedetails;
            verify(routeDetails, _.isArray);
            verifyPredicate(routeDetails.length === 1);
            return routeDetails[0];
        }

        function getLocationAndTimeStringsForRouteDetails(history, flightType) {
            var routeDetails = verify(getRouteDetails(history), _.isObject),
                location = routeDetails.departureairport + " - " + routeDetails.arrivalairport,
                time;
            if (flightType === "oneway") {
                time = formatDate(routeDetails.departuredate);
            } else if (flightType === "roundtrip") {
                time = formatDate(routeDetails.departuredate) + " - " + formatDate(routeDetails.returndate);
            } else {
                throw new Error("unexpected flight type " + flightType);
            }
            return {
                location: location,
                time: time
            };
        }

        function getLocationAndTimeStringsForHotelSearchHistory(history) {
            var searchSearch = verify(history.search, _.isObject);
            verify(searchSearch.destination, _.isObject);
            return {
                location: searchSearch.destination.regionname,
                time: formatDate(searchSearch.checkindate) + " - " + formatDate(searchSearch.checkoutdate)
            };
        }

        function formatDate(millisSinceUnixEpoch) {
            verify(millisSinceUnixEpoch, _.isNumber);
            return uitk.utils.createLocalizedDate(new Date(millisSinceUnixEpoch), window.locale).fullDate();
        }

        function makeRecentHistoryHotelOption(history) {
            var locationTime = getLocationAndTimeStringsForHotelSearchHistory(history),
                search = history.search;
            return {
                type: recentHistoryType,
                regionNames: {
                    displayName: locationTime.location,
                    lastSearchName: search.destination.regionname,
                    fullName: search.destination.regionname
                },
                gaiaId: search.destination.regionid,
                history: history,
                rightFloatingTextHtml: locationTime.time
            };
        }

        function makeRecentHistoryFlightOption(history, flightType, elementId) {
            var locationTime = getLocationAndTimeStringsForRouteDetails(history, flightType),
                routeDetail = history.search.routedetails[0],
                airport;
            switch (elementId) {
                case "flight-origin":
                    airport = routeDetail.departureairport;
                    break;
                case "flight-destination":
                    airport = routeDetail.arrivalairport;
                    break;
                default:
                    throw new Error("unexpected element id " + elementId);
            }
            return {
                type: recentHistoryType,
                regionNames: {
                    displayName: locationTime.location,
                    lastSearchName: airport,
                    fullName: airport
                },
                history: history,
                rightFloatingTextHtml: locationTime.time
            };
        }

        function makeOptionalRecentHistoryOption(history, lineOfBusiness, flightType, elementId) {
            var option;
            try {
                switch (lineOfBusiness) {
                    case "flight":
                        option = makeRecentHistoryFlightOption(history, flightType, elementId);
                        break;
                    case "hotel":
                        option = makeRecentHistoryHotelOption(history);
                        break;
                    default:
                        throw new Error("unexpected line of business: " + lineOfBusiness);
                }
                option.displayGroup = corewizard.masterconfig.taCategories.recent;
                return option;
            } catch (error) {
                logError(error);
            }
        }

        // given an array of history items that have been filtered by LOB and flighttype
        // store off our oldest timestamp info for logging
        // Returns: an object hash to store oldest timestamp per LOB and as in the
        // case of a flight LOB, per flight type. The values are the actual
        // unix timestamp values in ticks.
        // So, it might look something like this for a flight LOB:
        //
        //    {
        //        flight: {
        //            oneway: 1444795294158
        //        }
        //    }
        //
        // or for other LOBs like hotel, the timestamp value as a property
        //
        //    {
        //        hotel: 1444795294158
        //    }
        function extractOldestTimestampInfo(resultOptions, lineOfBusiness, flightType) {
            'use strict';

            verify(resultOptions, _.isArray);
            verify(lineOfBusiness, _.isString);
            // flightType is optional

            var flightTypeTimestamp = {},
                oldestTimestamp = {};

            if (_.isArray(resultOptions) && resultOptions.length > 0) {
                if (lineOfBusiness == 'flight' && _.isString(flightType)) {
                    // for flight LOB, we want to store off the oldest timestamp based on flight type
                    flightTypeTimestamp[flightType] = _.last(resultOptions).history.timestamp;
                    oldestTimestamp[lineOfBusiness] = flightTypeTimestamp;
                } else {
                    // hotel or some other LOB
                    oldestTimestamp[lineOfBusiness] = _.last(resultOptions).history.timestamp;
                }

                return oldestTimestamp;
            }
        }

        function createRecentHistoryOptions(srchText, elementId, lineOfBusiness, flightType) {
            verify(srchText, _.isString);
            verify(elementId, _.isString);

            var histories = verify(
                    searchExperiments.getUserSearchHistory(srchText, elementId, flightType),
                    _.isArray),
                options = _.reduce(
                    histories,
                    function(memo, history) {
                        memo.push(makeOptionalRecentHistoryOption(history, lineOfBusiness, flightType, elementId));
                        return memo;
                    }, []);
            return _.compact(options);
        }

        //
        // NOTE:
        // extractCoreWizardStateFromHistoryForHotel and extractCoreWizardStateFromHistoryForFlight
        // are helper functions to map a history to a JS object that contains
        // the view model properties used by the corewizard to populate the
        // UI elements. The way this works is that each DOM element in the corewizard
        // has a 'data-wizard-action' attribute that looks something like this
        //
        //     data-wizard-action="{"endDate" : "$value1"}"
        //
        // The "endData" is the property key and the "#value1" is what gets put
        // into the UI when it renders. So, each of the keys in the wizardProps
        // object matches one of the keys the wizard uses to populate the data
        // in the UI.
        //

        function extractCoreWizardStateFromHistoryForHotel(history) {
            var search = history.search,
                destination = search.destination,
                locale = getLocale(),
                rooms = search.rooms,
                // These are the properties that map to the 'data-wizard-action' property
                // in the core wizard DOM for the element being populated.
                wizardProps = {
                    destination: destination.regionname,
                    destinationFromTA: destination.regionname,
                    endDate: uitk.utils.createLocalizedDate(new Date(search.checkoutdate), locale).shortDate(),
                    startDate: uitk.utils.createLocalizedDate(new Date(search.checkindate), locale).shortDate(),
                    regionId: search.regionId,
                    roomCount: _.isArray(rooms) && rooms.length
                };

            if (_.isArray(rooms)) {
                _.each(rooms, function(room, index) {
                    var numChildren = room.noofchildren,
                        ages = room.agesofchildren,
                        numAdults = room.numadults,
                        currentRoom = "rooms[" + index + "]";

                    wizardProps[currentRoom + ".adults"] = numAdults;
                    wizardProps[currentRoom + ".childCount"] = numChildren;

                    if (numChildren > 0) {
                        _.each(ages, function(childsAge, index) {
                            wizardProps[currentRoom + ".children[" + index + "]"] = childsAge;
                        });
                    }
                });
            }

            return wizardProps;
        }

        function extractCoreWizardStateFromHistoryForFlight(history) {

            var search = history.search,
                passengers = search.passengers,
                routeDetail = search.routedetails[0],
                origin = routeDetail.departureairport,
                destination = routeDetail.arrivalairport,
                locale = getLocale(),
                numAdults = passengers.numberofadults,
                children = passengers.children,
                numChildren = _.isArray(children) && children.length || 0,
                // These are the properties that map to the 'data-wizard-action' property
                // in the core wizard DOM for the element being populated.
                wizardProps = {
                    destination: destination,
                    destinationFromTA: destination,
                    destinationTLA: destination,
                    endDate: uitk.utils.createLocalizedDate(new Date(routeDetail.returndate), locale).shortDate(),
                    startDate: uitk.utils.createLocalizedDate(new Date(routeDetail.departuredate), locale).shortDate(),
                    origin: origin,
                    originFromTA: origin,
                    originTLA: origin,
                    carrier: search.preferredairline,
                    nonStop: search.nonstop,
                    cabinClass: search.travelclass,
                    noPenalty: search.refundable,
                    isChildInLap: passengers.infantsinlap
                };

            wizardProps["rooms[0].adults"] = numAdults;
            wizardProps["rooms[0].childCount"] = numChildren;

            if (numChildren > 0) {
                _.each(children, function(childsAge, index) {
                    wizardProps["rooms[0].children[" + index + "]"] = childsAge;
                });
            }

            return wizardProps;
        }

        // Select as many options from ESS as available, up to 7. Fill the remaining spaces with recent history options. Then
        // fill the remaining spaces with ESS options.
        function selectRecentHistoryOptions(recentHistoryOptions, numEssResults, maxTotalOptions) {
            var x = recentHistoryOptions.length; // number of available recent history options
            var minRecentHistoryOptions = 3;
            var numSelectedRecentHistoryOptions =
                Math.min(x,
                    Math.max(minRecentHistoryOptions,
                        Math.min(x, maxTotalOptions - numEssResults)));
            return recentHistoryOptions.slice(0, numSelectedRecentHistoryOptions);
        }

        function RecentHistoryOptionsInjector() {
            this.injectedOptionsCount = 0;
        }

        RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForHotel = extractCoreWizardStateFromHistoryForHotel;
        RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForFlight = extractCoreWizardStateFromHistoryForFlight;

        RecentHistoryOptionsInjector.prototype.inject = function(results, options) {
            var defaultValues = {
                srchText: '',
                elementId: '',
                lineOfBusiness: '',
                flightType: '',
                maxTotalOptions: 0
            };

            // set reasonable default options
            options = _.defaults(options || {}, defaultValues);

            var filteredHistories;
            var srchText = options.srchText;
            var elementId = options.elementId;
            var lineOfBusiness = options.lineOfBusiness;
            var flightType = options.flightType;
            var maxTotalOptions = options.maxTotalOptions;

            try {
                filteredHistories = selectRecentHistoryOptions(
                    createRecentHistoryOptions(srchText, elementId, lineOfBusiness, flightType),
                    results.length,
                    maxTotalOptions);

                // ensure the list is sorted by timestamp in descending order
                // oldest === smallest timestamp value
                filteredHistories = _.sortBy(filteredHistories, function(historyItem) {
                    // default is ascending, take the negative for descending
                    return 0 - historyItem.history.timestamp;
                });

                // save our taMetadata
                this.injectedOptionsCount = filteredHistories.length;
                this.oldestTimestampInfo = extractOldestTimestampInfo(filteredHistories, lineOfBusiness, flightType);
                TypeaheadUtils.injectSuggestions(results, filteredHistories, maxTotalOptions);
            } catch (error) {
                logError(error);
            }
        };

        RecentHistoryOptionsInjector.prototype.countInjectedOptions = function() {
            return this.injectedOptionsCount;
        };

        RecentHistoryOptionsInjector.prototype.getOldestTimestampInfo = function getOldestTimestampInfo() {
            return this.oldestTimestampInfo;
        };

        verify(uitk, _.isObject, "must have uitk to use this module");
        verify(uitk.utils, _.isObject, "must have uitk.utils to use this module");

        window.RecentHistoryOptionsInjector = RecentHistoryOptionsInjector;
    });
}());


define('TypeaheadUtils', function() {
    // add to the TypeaheadUtils global namespace
    window.TypeaheadUtils = window.TypeaheadUtils || {};

    // ******************************************** IMPORTANT *******************************************************
    // vmohapatra : currentLocationInfo / ipSniff module is not yet ready to be implemented.
    // vmohapatra : Initializing an empty currentLocationInfo object

    window.TypeaheadUtils.currentLocationInfo = {
        // currentCityName: "${currentCityName}",
        // currentStateName: "${currentStateName}",
        // currentRegionName: "${currentRegionName}",
        // currentCountryName: "${currentCountryName}",
        // currentAirportTLA: "${currentAirportTLA}"
    };

    return TypeaheadUtils;
});

(function () {

require(['TypeaheadUtils', 'TypeaheadMetricsLogger'], function(TypeaheadUtils, TypeaheadMetricsLogger) {
    'use strict';

    // ******************************************** IMPORTANT *******************************************************
    // vmohapatra : Trending Search module is not yet ready to be implemented.

    // Recommender service related documentation
    // Hotel search
    // https://confluence/display/POS/Recommender+Data+Model+-+Top+DestinationsByOrigin-+Region+to+Region+-+Multicity+to+MultiCity
    // http://wwwexpediacom.trunk.sb.karmalab.net/Region-Recommender-Ajax?action=getProductRecommendations&scenario=deals&rule=top-destinations-point-of-origin&id=Seattle&itemType=2&maxCount=10&startDate=&endDate=&reqRetIType=2&code=4&travellersInfo=2&feature=-1
    // Flight search
    // https://confluence/display/POS/Recommender+Data+Model+-+Top+DestinationsByOrigin+-+Region+to+Region+-+TLA+to+TLA
    // http://wwwexpediacom.trunk.sb.karmalab.net/Region-Recommender-Ajax?action=getProductRecommendations&scenario=deals&rule=top-destinations-point-of-origin&id=SEA&itemType=1&maxCount=10&startDate=&endDate=&reqRetIType=1&code=4&travellersInfo=2&feature=-1

    if (_.isUndefined(window.TypeaheadUtils) ||
        _.isUndefined(window.TypeaheadUtils.currentLocationInfo)) {
        throw new Error("Must have window.TypeaheadUtils and window.TypeaheadUtils.currentLocationInfo defined before using this module");
    }

    var hotelItemType = 2;
    var hotelRecItemType = 2;
    var flightItemType = 1;
    var flightRecItemType = 1;
    var flightDestinationRegex = /flight-.*destination/;
    var logger = new TypeaheadMetricsLogger("trendingSearchesDataProvider");

    // local promise "caches",
    // used as part of a singleton
    // pattern for the fetchFlightData()
    // and fetchHotelData() APIs
    var hotelsPromise;
    var hotelRegionModels;
    var flightsPromise;
    var flightsRegionModels;

    var recommenderOptions = {
        trendingSearchesDataProvider: {

            // returns a list of hotel searches trending near the callers nearest major airport.
            // Returns a Promise() object.
            fetchHotelData: fetchHotelData,

            // returns a list of hotel searches trending near the callers current city.
            // Returns a Promise() object.
            fetchFlightData: fetchFlightData,

            // required for unit testing
            fetchData: fetchData
        }
    };

    // add the trendingSearchesDataProvider to the TypeaheadUtils namespace
    _.extend(window.TypeaheadUtils, recommenderOptions);

    function recommenderUrl(id, itemType, reqRetIType) {
        var url = "/Region-Recommender-Ajax?action=getProductRecommendations&scenario=ESS&rule=top-destinations-point-of-origin&id=" + id +
            "&itemType=" + itemType +
            "&maxCount=10&reqRetIType=" + reqRetIType +
            "&code=4&travellersInfo=2&feature=-1";
        return url;

    }

    function wasIpSniffSuccessful() {
        return (
            window.TypeaheadUtils.currentLocationInfo.currentCityName 
            && (window.TypeaheadUtils.currentLocationInfo.currentCityName !== "noCityName" || window.TypeaheadUtils.currentLocationInfo.currentCityName !== "nodata")
        );
    }

    function getId() {
        var locInfo = window.TypeaheadUtils.currentLocationInfo;
        var city = '';
        var state = '';
        var country = '';
        var id = '';

        if (wasIpSniffSuccessful()) {
            city = locInfo.currentCityName;
            state = locInfo.currentStateName != 'noStateName' ? locInfo.currentStateName : state;
            country = locInfo.currentCountryName != 'noCountryName' ? locInfo.currentCountryName : country;
            logIpSniffSuccess(locInfo);
            id = _.compact([city,state,country]).join(",");
        } else {
            // then default the settings to Seattle, WA, USA
            id = 'Seattle,WA,USA';
        }

        return id;
    }

    function fetchData(url) {
        var ajaxOptions = {
            dataType: "json",
            url: url,
            timeout: 4000
        };
        return $.ajax(ajaxOptions).promise();
    }

    function fetchHotelData() {
        if(_.isUndefined(hotelsPromise)){
            hotelsPromise =  fetchData(recommenderUrl(getId(), hotelItemType, hotelRecItemType));
        }

        return hotelsPromise;
    }

    function fetchFlightData() {
        if(_.isUndefined(flightsPromise)){
            flightsPromise =  fetchData(recommenderUrl(getId(), flightItemType, flightRecItemType));
        }

        return flightsPromise;
    }

    function getRegionModels(lineOfBusiness, elementId) {
        var model;
        switch(lineOfBusiness) {
            case "hotel":
                model = hotelRegionModels;break;
            case "flight":
                if (_.isNull(flightDestinationRegex.exec(elementId))) {
                    model = [];
                } else {
                    model = flightsRegionModels;
                }
                break;
            default:
                model = [];
        }
        return model;
    }

    function logRegionRecommenderFailure(errorText) {
        logger.sendToCollector([{
            type: "RegionRecommenderFailure",
            errorText: errorText,
            guid: logger.guid
        }]);
    }

    function logIpSniffSuccess(currentLocationInfo) {
        logger.sendToCollector([{
            type: "IpSniffDataSuccess",
            city: currentLocationInfo.currentCityName,
            state: currentLocationInfo.currentStateName,
            country: currentLocationInfo.currentCountryName,
            guid: logger.guid
        }]);
    }

    function logIpSniffFailure() {
        logger.sendToCollector([{
            type: "IpSniffDataFailure",
            guid: logger.guid
        }]);
    }

    TypeaheadUtils.trendingSearchesDataProvider.getRegionModels = getRegionModels;

    // prefetch the regionModels arrays and stash them
    // on the trendingSearchesDataProvider object.
    fetchHotelData()
        .done(function(hotelsData){
            if(hotelsData.errorCode){
                logRegionRecommenderFailure(hotelsData.errorDesc);
            } else {
                hotelRegionModels = hotelsData.regionModels;
            }
        })
        .fail(function(response, status, statusDescription) {
            logRegionRecommenderFailure(statusDescription);
        });

    fetchFlightData()
        .done(function(flightsData){
            if(flightsData.errorCode){
                logRegionRecommenderFailure(flightsData.errorDesc);
            } else {
                flightsRegionModels = flightsData.regionModels;
            }
        })
        .fail(function(response, status, statusDescription) {
            logRegionRecommenderFailure(statusDescription);
        });

    (function logIpSniff() {
        if (wasIpSniffSuccessful()) {
            logIpSniffSuccess(window.TypeaheadUtils.currentLocationInfo);
        } else {
            logIpSniffFailure();
        }
    })();

});

})();
/* global _, console, corewizard */

(function() {
    "use strict";

    // match omniture string for logging
    var trendingSearchesNearYouType = "TRENDINGSEARCH";
    var corewizard = corewizard || undefined;
    var displayGroup = (
            _.isObject(corewizard) &&
            _.isObject(corewizard.masterconfig) &&
            _.isObject(corewizard.masterconfig.taCategories) &&
            _.isString(corewizard.masterconfig.taCategories.trending) &&
            corewizard.masterconfig.taCategories.trending
        ) || "Trending searches near you";

    function logError(error){
        console && console.error && console.error(error);
    }

    function TrendingSearchesNearYouInjector() {
    }

    function makeTrendingSearchesNearOption(regionModel, displayKey) {
        return {
            regionNames: {
                displayName: regionModel[displayKey],
                lastSearchName: regionModel.longName,
                fullName: regionModel.longName
            },
            hierarchyInfo: {
                airport: regionModel.TLA
            },
            gaiaId: regionModel.id,
            type: trendingSearchesNearYouType,
            displayGroup: displayGroup
        };
    }

    function createTrendingSearchesNearOptions(regionModels, displayKey) {
        return _.reduce(
            regionModels,
            function (memo, regionModel) {
                memo.push(makeTrendingSearchesNearOption(regionModel, displayKey));
                return memo;
            },
            []);
    }

    TrendingSearchesNearYouInjector.prototype.inject = function (results, regionModels, options) {
        try {
            options = _.defaults(options || {}, {
                maxTotalOptions: 0
            });
            var maxTotalOptions = options.maxTotalOptions;
            var displayKey = options.displayKey;
            var trendingSearchesSuggestions = createTrendingSearchesNearOptions(regionModels, displayKey);
            //This is to determine number of trending suggestions based on # results sent from service/s
            var desiredNumberOfTrendingSearchesSuggestions = 0;
            //var desiredNumberOfTrendingSearchesSuggestions = Math.max(1, maxTotalOptions - results.length);
            if(results.length > 0) {
                desiredNumberOfTrendingSearchesSuggestions = 0;
            }
            else {
                desiredNumberOfTrendingSearchesSuggestions = maxTotalOptions;
            }
            trendingSearchesSuggestions.splice(desiredNumberOfTrendingSearchesSuggestions, Number.MAX_VALUE);
            TypeaheadUtils.injectSuggestions(results, trendingSearchesSuggestions, maxTotalOptions);
        } catch (error) {
            logError(error);
        }
    };

    window.TypeaheadUtils = window.TypeaheadUtils || {};
    window.TypeaheadUtils.TrendingSearchesNearYouInjector = TrendingSearchesNearYouInjector;
})();

define('gc/typeaheadConfig', ['gc/loc', 'gc/typeaheadCallbacks', 'env'], function(loc, TACallbacks, env) {
    return {
        typeahead: {
            def: {
                minchar: 3,
                maxresults: 10,
                version: 'v1',
                locale: env.locale ? env.locale : 'en_US',
                mask: 95,
                client: 'HOMEPAGE',
                lob: 'FLIGHTS',
                dest: false,
                closetext: loc.typeAhead.closetext,
                continuetext: loc.typeAhead.continuetext,
                tooltip: true,
                forceicon: false,
                template: 'default',
                cheapHotelsText: loc.typeAhead.cheapHotelsText,
                cheapHotelsInText: loc.typeAhead.cheapHotelsInText,
                bestDealsText: loc.typeAhead.bestDealsText,
                bestDealsInText: loc.typeAhead.bestDealsInText
            },
            flight_origin: {
                forceicon: 'flights',
                selectioncallback:TACallbacks.typeaheadFlightOriginCallback
            },
            flight_dest: {
                forceicon: 'flights',
                dest: true,
                selectioncallback:TACallbacks.typeaheadFlightDestinationCallback
            },
            // multi-dest flight fields
            flight_multi: {
                forceicon: 'flights',
                selectioncallback:TACallbacks.typeaheadMultiFlightDestinationCallback
            },
            hotel: {
                lob: 'HOTELS',
                dest: true,
                selectioncallback:TACallbacks.typeaheadItemClickCallback,
                mask:1759,
                version: 'v1'
            },
            package_origin: {
                forceicon: 'flights',
                lob: 'PACKAGES',
                selectioncallback: TACallbacks.typeaheadPackageOriginCallback
            },
            package_dest: {
                dest: true,
                lob: 'PACKAGES',
                selectioncallback: TACallbacks.typeaheadPackageDestinationCallback
            },
            package_FC_dest : {
                forceicon: 'flights',
                lob: 'PACKAGES',
                dest: false,
                selectioncallback: TACallbacks.typeaheadPackageDestinationCallback
            },
            package_hotel_car: {
                lob: 'HOTELS',
                selectioncallback: TACallbacks.typeaheadItemClickCallback
            },
            car_origin: {
                lob: 'CARS',
                selectioncallback: TACallbacks.typeaheadCarPickUpCallback,
                mask:31,
                version: 'v3',
                template: 'category'
            },
            car_dest: {
                lob: 'CARS',
                selectioncallback: TACallbacks.typeaheadCarDropOffCallback,
                forceicon: loc.masterconfig.switches.enableCarOffairportOnewaySearch ? false : 'flights',
                dest: true,
                mask: loc.masterconfig.switches.enableCarOffairportOnewaySearch ? 31 : 1,
                version: 'v3',
                template: 'category'
            },
            activity: {
                lob: 'ACTIVITIES',
                dest: true,
                mask:14,
                selectioncallback: TACallbacks.typeaheadActivityCallback
            },
            openSearch: {
            	lob: 'OPENSEARCH',
                selectioncallback: TACallbacks.typeaheadOpenSearchCallback,
                template: 'open-search-ta'
            }
        }
    };
});
//
// typeahead/core.js - a wrapper for the
//
// Documentation: http://confluence/display/POS/Typeahead+Javascript
// API documentation: http://confluence/display/POS/Expedia+Suggest+%28Type+Ahead%29+API+Family
//

define('gc/typeaheadWizard', [
    'gc/loc',
    'gc/config',
    'gc/dataModels',
    'gc/searchExperiments',
    'gc/ExpediaSuggestServiceRequestGenerator',
    'gc/TypeaheadMetricsLogger',
    'handlebars.runtime',
    'jquery',
    'gc/abTest',
    'gc/getLob',
    'gc/typeaheadCallbacks',
    'env'
], function (
    loc,
    configObj,
    dataModels,
    searchExperiments,
    ExpediaSuggestServiceRequestGenerator,
    TypeaheadMetricsLogger,
    Handlebars,
    $,
    abTest,
    getLob,
    typeaheadCallbacks,
    env
) {
    "use strict";
    var tooltipPlugin = 'uitk_tooltip',
        hammerManager;

    //Util function to determine if recent history experiments are on
    function isRecentHistoryExperiment(){
        return searchExperiments.getVariant("RECENT_HISTORY_HOTEL") ||
            searchExperiments.getVariant("RECENT_HISTORY_FLIGHT");
    }

    //Util function to determine if trending search experiment is on
    function isTrendingSearchesNearYouExperiment(){
        return searchExperiments.getVariant("TRENDING_SEARCHES_NEAR_YOU");
    }

    //Util function to determine if geolocation experiment is on
    function isCurrentLocationExperiment() {
        return searchExperiments.getVariant("CURRENT_LOCATION");
    }

    //Util function to show the typeahead popup with proper instance associated
    function showTaPopup($taContainer, taInstance){
        if($taContainer && $taContainer.is(':hidden')){
            // bind mouse handlers to this instance of the Typeahead input control
            $taContainer
                .on('mousedown', $.proxy(taInstance.clickOn, taInstance))
                .on('mouseup', $.proxy(taInstance.clickOff, taInstance))
                .on('click', $.proxy(taInstance.click, taInstance))
                .on('mouseenter', 'a', $.proxy(taInstance.mouseEnter, taInstance));

            if(Modernizr.touch){
                require('hammer', function(Hammer){
                    if(!hammerManager){
                        hammerManager = new Hammer.Manager($taContainer[0], {recognizers: []});
                    }

                    hammerManager.add(new Hammer.Tap());
                    hammerManager.on('tap', $.proxy(taInstance.hammerTapHandler, taInstance));
                });
            }

            if (taInstance.opts.tooltip) {
                // show the extra stuff that's hiding out
                // with the uitk_tooltip class
                taInstance.$element[tooltipPlugin]('show');

                taInstance.$element[tooltipPlugin]('checkPos', true, true);
            }

            // show the popup div
            $taContainer.show();
        }
    }

    //Util function to hide the typeahead popup with proper instance associated
    function hideTaPopup($taContainer, taInstance) {
        if($taContainer){
            // unbind mouse handlers for this instance of the Typeahead input control
            $taContainer
                .off('mousedown', $.proxy(taInstance.clickOn, taInstance))
                .off('mouseup', $.proxy(taInstance.clickOff, taInstance))
                .off('click', $.proxy(taInstance.click, taInstance))
                .off('mouseenter', 'a', $.proxy(taInstance.mouseEnter, taInstance));

            if(Modernizr.touch){
                if(hammerManager) {
                    hammerManager.destroy();
                    hammerManager = null;
                }
            }

            if (taInstance.opts.tooltip) {
                // hide the extra stuff that's hiding out
                // with the uitk_tooltip class
                taInstance.$element[tooltipPlugin]('hide');

                taInstance.$ta.closest('.uitk-tooltip').remove();
            }

            // hide the popup div
            $taContainer.hide();
        }
    }

    function getClientsideExperiments() {
        function getAssignmentString(abacusId) {
            var experimentInfo = abTest.get(abacusId);
            var assignment = experimentInfo ? experimentInfo.value : undefined;
            return assignment ? String(abacusId) + "." +  assignment : undefined;
        }
        return _.compact(_.map(_.keys(searchExperiments.experimentDetails), getAssignmentString))
            .join("|");
    }

    // Returns the ID of the page if available, or undefined otherwise.
    function getPageId() {
        return $("#pageId").val();
    }

    function getCurrentLob() {
        return getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));
    }

    //Util function to set TA related state attributes at starting of a request in TA
    function resetStateAtStart(taTriggerElemId) {

        var wizardState = dataModels.state;

        //If multi destination flights, reset the properties with the interacted TA instance
        if(getCurrentLob()=='flight' && wizardState.get('flighttype') === 'multi') {

            if(taTriggerElemId=='flight-destination') {
                wizardState.set('destinationFromTA',null);
                wizardState.set('TADestSearchType', null);
                wizardState.set('destSuggestionTypeId', null);
                wizardState.set('destinationSourceInfo', null);
            }
            else if(taTriggerElemId=='flight-origin') {
                wizardState.set('originFromTA',null);
                wizardState.set('TAOrigSearchType', null);
                wizardState.set('origSuggestionTypeId', null);
                wizardState.set('originSourceInfo', null);
            }

            if(
                _.contains(['flight-2-destination', 'flight-3-destination', 'flight-4-destination', 'flight-5-destination'], taTriggerElemId)
            ) {
                var multiFlightDestinations = wizardState.get('multiFlightDestination') || {};
                var multiFlightDestSuggTypeIds = wizardState.get('multiFlightDestSuggTypeId') || {};
                var multiFlightDestSrcInfo = wizardState.get('multiFlightDestSrc') || {};
                var multiFlightDestSuggTypes = wizardState.get('multiFlightDestSuggType') || {};
                wizardState.set('multiFlightDestination', typeaheadCallbacks.multiFlightHelper('', 'destination', taTriggerElemId, multiFlightDestinations, true, 'reset'));
                wizardState.set('multiFlightDestSuggTypeId', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestSuggTypeIds, true, 'reset'));
                wizardState.set('multiFlightDestSrc', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestSrcInfo, true, 'reset'));
                wizardState.set('multiFlightDestSuggType', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestSuggTypes, true, 'reset'));
            }
            else if(
                _.contains(['flight-2-origin', 'flight-3-origin', 'flight-4-origin', 'flight-5-origin'], taTriggerElemId)
            ){
                var multiFlightOrigins = wizardState.get('multiFlightOrigin') || {};
                var multiFlightOrigSuggTypeIds = wizardState.get('multiFlightOrigSuggTypeId') || {};
                var multiFlightOrigSrcInfo = wizardState.get('multiFlightOrigSrc') || {};
                var multiFlightOrigSuggTypes = wizardState.get('multiFlightOrigSuggType') || {};
                wizardState.set('multiFlightOrigin',typeaheadCallbacks.multiFlightHelper('', 'origin', taTriggerElemId, multiFlightOrigins, true, 'reset'));
                wizardState.set('multiFlightOrigSuggTypeId',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigSuggTypeIds, true, 'reset'));
                wizardState.set('multiFlightOrigSrc',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigSrcInfo, true, 'reset'));
                wizardState.set('multiFlightOrigSuggType',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigSuggTypes, true, 'reset'));
            }

        }
        else if(
            _.contains(['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity'],getCurrentLob())
        ){

            //For LOBs with multiple TA trigger fields,
            //reset the state attributes associated with only
            //that field on interaction
            //Else reset per field for rest of LOBs ie hotel, hotelCar, activity
            // vmohapatra : String.indexOf works in IE8 : https://msdn.microsoft.com/en-us/library/53xtt423(v=vs.94).aspx
            if(taTriggerElemId.indexOf("destination") != -1) {
                //Reset only destination fields
                wizardState.set('destinationFromTA', null);
                wizardState.set('TADestSearchType', null);
                wizardState.set('destSuggestionTypeId',null);
                wizardState.set('destinationSourceInfo', null);
            }
            else if(taTriggerElemId.indexOf("origin") != -1) {
                //Reset only origin state fields
                wizardState.set('originFromTA', null);
                wizardState.set('TAOrigSearchType', null);
                wizardState.set('origSuggestionTypeId',null);
                wizardState.set('originSourceInfo', null);
            }

        }

    }

    //
    // Typeahead Constructor
    //
    window.Typeahead = function (opts) {
        // True if and only if a suggestions for this input element has been selected and it has not been inputted since
        // the most recent selection.
        this.selectedSuggestionIsInEffect = false;

        // Accessibility
        this.firstItemFlag = true;

        // Get the config value per key (LOB or TAB value)
        this.opts = opts;

        this.template = Handlebars.partials['default/typeahead/' + this.opts.template];

        // State:
        this.searchType = null;
        this.cache = {};
        this.requestsOut = {};
        this.ignoreNext = false; // ???
        this.isClickOn = false;
        this.bodyClick = false;
        this.metricsLogger = null;
        this.renderFromFocus = false;

        // Typeahead dialog and its listeners:
        this.$ta = $('<div class="typeahead" role="presentation">');

        if (! this.opts.tooltip) {
            this.$ta.appendTo(document.body);

            if (!uitk.isTouchDevice) {
                this.$ta
                    .on('mousedown', $.proxy(this.clickOn, this))
                    .on('mouseup', $.proxy(this.clickOff, this))
                    .on('click', $.proxy(this.click, this))
                    .on('mouseenter', 'a', $.proxy(this.mouseEnter, this));
            } else {
                this.$ta.on('click', function (e) {
                    e.preventDefault()
                });
            }
        }
    };

    //
    // Prototype: defined with an IIFE
    //
    Typeahead.prototype = function () {
        // private helper methods can be defined between the opening brace and the return statement.
        function getIcon(resultType, category, forceIcon) {
            if (forceIcon && resultType !== "RECENTHISTORY") {
                if(searchExperiments.getSearchExperimentVariant('9241') !== "0") {
                    return '';
                }
                else {
                    return forceIcon;
                }
            }
            else {
                return category ? category.icon : 'location';
            }
        }

        function highlightOption(typeahead, $anchor) {
            var primaryText;
            var secondaryText;
            var announcement;
            $anchor.addClass('highlight');
            typeahead.$element.attr('aria-activedescendant', $anchor.attr("id"));
            $anchor.attr('aria-selected', 'true');

            primaryText = $anchor.attr('data-value')? $anchor.attr('data-value') : ($anchor.children(".option-text-primary")[0] ? $anchor.children(".option-text-primary")[0].text() : '');

            secondaryText = $anchor.children(".option-text-secondary");
            if (! _.isEmpty(secondaryText)) {
                secondaryText = $(secondaryText[0]).text();
            }
            announcement = _.compact([primaryText, secondaryText]).join(" ");
            if (! _.isEmpty(announcement)) {
                uitk.utils.liveAnnounce(announcement, 'polite');
            }
        }

        // "statically" track which element received focus last. This is
        // the id of the latest interactive typeahead element that the the user was
        // interacting with. This piece of state is shared by all instances of
        // Typeahead which share this common prototype.
        var lastFocusedElementId;

        // return the prototype definition object and assign to Typeahead.prototype
        return {
            constructor: Typeahead,
            shouldBeOpen: false,
            startRequest: function () {
                var text = this.$element.val();
                var wizardState = dataModels.state;
                if (searchExperiments.getVariant("BEST_DEALS_OPTION")) {
                    wizardState.set('sort', null);
                }
                //Set the user typed text which triggers the typeahead request in corewizard state for latest instance
                wizardState.set('userTypedQuery', text);

                var taTriggerElemId = this.$element.attr('id');
                //Every time typeahead request starts set the triggering element ID in state
                wizardState.set('taTriggerElemId', taTriggerElemId);

                //Reset the field specific states at the start of the request
                resetStateAtStart(taTriggerElemId);

                //vmohapatra: Everytime TA request is sent reset the following attributes
                //which are tied to latest interaction only
                wizardState.set('selectedTASuggestionPosition', null);
                wizardState.set('TASearchType', null);
                wizardState.set('suggestionType', null);//holds 'child' info
                wizardState.set('essItemsTotal', 0);
                wizardState.set('taMetadata',null);
                wizardState.set('activeESSTests',null);


                //Reset user history specific state variables if the experiment is on
                if(isRecentHistoryExperiment()) {
                    wizardState.set('userHistoryItemsTotal',0);
                    wizardState.set('userHistoryItemAge',null);
                }

                //Reset Trending Suggestions specific state variables if the experiment is on
                if(isTrendingSearchesNearYouExperiment()) {
                    wizardState.set('recommenderOptionsRendered', 0);
                }

                //Reset Geo Location suggestion specific state variables if the experiment is on
                if(isCurrentLocationExperiment()) {
                    wizardState.set('currentLocationShown', 0);
                    wizardState.set('currentLocationDetails', null);
                }

                //if Experiment 6739 is on && is across all lobs
                if (searchExperiments.getSearchExperimentVariant('6739') !== "0" || searchExperiments.getSearchExperimentVariant('9110') !== "0") {
                    if ( searchExperiments.getSearchExperimentVariant('6739') == "1" ||
                         (window.site_id && _.contains([18, 62, 75], window.site_id) && searchExperiments.getSearchExperimentVariant('9110') == "1")
                    ) {
                        this.opts.minchar = 1;
                    }
                    else if (searchExperiments.getSearchExperimentVariant('6739') == "2" ||
                         (window.site_id && _.contains([18, 62, 75], window.site_id) && searchExperiments.getSearchExperimentVariant('9110') == "2")) {
                        this.opts.minchar = 2;
                    }
                }

                if (isRecentHistoryExperiment() || isTrendingSearchesNearYouExperiment() || isCurrentLocationExperiment()){
                    this.opts.minchar = 0;
                }

                //vmohapatra : compare of the text length is greater or equal to the min char trigger
                if (text.length >= this.opts.minchar) {
                    if ((!this.cache[text] && !this.requestsOut[text]) || text.length === 0) {
                        this.request(text);
                    }
                    else if (this.cache[text]) {
                        this.render(text, this.cache[text]);
                    }
                }

                if(text.length > 0){
                    //show
                    this.$element.parent().parent().children(".icon-close").removeClass("visuallyhidden");
                }
                else if(text.length == 0){
                    //hide
                    this.$element.parent().parent().children(".icon-close").addClass("visuallyhidden");
                }
            },

            request: function (text) {
                this.requestsOut[text] = true;
                Typeahead.request(text, this, this.opts, this.callback);
            },

            callback: function (json) {
                var wizardState = dataModels.state;

                var q = '',  // default search query string
                    results = []; // default empty results array

                //Set the active AB tests running in service typeahead request in corewizard state
                var activeESSTests = json && json.activeABTests ? json.activeABTests : null;
                wizardState.set('activeESSTests', activeESSTests);

                this.getMetricsLogger().timestamp(
                    this.getMetricsLogger().TimestampCategories.ESS_RESPONSE, json ? json.q : null);

                if (getCurrentLob() === 'openSearch') {
                    results = json.opensearchresult ? json.opensearchresult : json.r;
                }
                else {
                    if(json){
                        results = json.sr ? json.sr : (json.r ? json.r : []);
                    }
                    if (searchExperiments.getVariant("BEST_DEALS_OPTION")) {
                        this.getBestDealsOptionInjector().inject(results);
                    }
                }

                if(json && _.isString(json.q)) {
                    q = json.q;
                }

                this.requestsOut[q] = false;
                if (results && this.shouldBeOpen) {
                    if (lastFocusedElementId === this.$element.attr('id')) {
                        // the user is still interacting with the same typeahead element now that was
                        // active when this HTTP request that went out to fetch ESS search results
                        // so we can go ahead and render those results now. This avoids rendering stale
                        // data in a control that is no longer the active typeahead control.
                        if(results.length > 0){
                            // only cache results when we actually have some.
                            this.cache[q] = results;
                            this.render(q, this.cache[q]);
                        }
                        else {
                            this.render(q, results);
                        }
                    }
                }
                else {
                    this.cache[q] = [];
                    this.close();
                }
            },

            // given input parameters of search text (prefix any word) and a reference to
            // external search results, either from a fresh ESS Ajax request or a previously cached
            // array, render the results into the typeahead tooltip window.
            // NOTE: the incoming results array is a reference to data that exists elsewhere
            // and is expected to only contain external service search results or a cached version thereof
            render: function (srchText, serviceResults) {

                var wizardState = dataModels.state;

                var essv4exp = _.reduce(
                        [
                            "9432", // consuming ESS v4 for activities LOB
                            "9433"  // consuming ESS v4 for packages LOB
                        ],
                        function (memo, abacusId) {
                            //memo is the previous value (implements if else if logic) false is initial value for memo
                            return memo || (searchExperiments.getSearchExperimentVariant(abacusId) !== "0")
                        },
                        false
                    ),
                    bestDealsOptionVariant = searchExperiments.getVariant("BEST_DEALS_OPTION"),
                    currentLob = getCurrentLob(),
                    recentHistoryOptionsInjector = this.getRecentHistoryOptionsInjector(),
                    trendingSearchesNearYouInjector = this.getTrendingSearchesNearYouInjector(),
                    // default our search term and results array to empty
                    text = '',
                    // pull the existing text out of the input field one time
                    $inputFieldText = $.trim(this.$element.val()),
                    results = [],
                    recentHistoryOptions = {
                        srchText: '',
                        elementId: '',
                        lineOfBusiness: '',
                        flightType: '',
                        maxTotalOptions: 0
                    },
                    trendingSearchesNearYouOptions = {
                        maxTotalOptions: 0
                    },
                    content,
                    that,
                    resultsLengthAnnouncement = ' results displayed for your search. Use the arrow keys to browse them.',
                    taMetadata = {};

                var taTriggerElemId = this.$element.attr('id');

                if (_.isArray(serviceResults)) {
                    // Fix for ECOMSVC-1532
                    // Create a deep clone of the incoming ESS search results
                    // thus treating the incoming results as an immutable array.
                    // This incoming array may in fact be a reference to this.cache[srchText]
                    // Further down we actually alter and extend the items in the results array
                    // in order to send the data on to the Handlebars template. We don't want
                    // this alteration to leak back into the cache.
                    results = JSON.parse(JSON.stringify(serviceResults));
                    //Get the number of suggestions returned by ESS
                    taMetadata.essItemsTotal = results.length;
                    wizardState.set('essItemsTotal', taMetadata.essItemsTotal);
                }

                if(_.isString(srchText)){
                    // default to passed in search term
                    text = $.trim(srchText);
                } else {
                    // or search on the existing text (which might be an empty string)
                    text = $inputFieldText;
                }

                //Set up for User History experiment if the experiment is ON and user is bucketed in
                if(recentHistoryOptionsInjector){
                    // If we are in the recent histories experiment, then we have the recentHistoryOptionsInjector
                    // Setup to make the inject() call
                    recentHistoryOptions.elementId = this.$element.attr('id');
                    recentHistoryOptions.lineOfBusiness = getCurrentLob();
                    recentHistoryOptions.flightType = dataModels.model.get('flighttype');
                    recentHistoryOptions.maxTotalOptions = this.opts.maxresults;

                    // there's a requirement to handle render differently when it is initiated from a
                    // focus event. In that case, don't use existing search text for the recent
                    // history list, we get the full list without filtering.
                    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1986
                    recentHistoryOptions.srchText = this.renderFromFocus ? '' : text;
                    this.renderFromFocus = false; // turn off this flag
                }

                //Set up for Trending Search experiment is ON and user is bucketed in
                if (trendingSearchesNearYouInjector) {
                    trendingSearchesNearYouOptions.maxTotalOptions = this.opts.maxresults;
                    var trendingVariant = searchExperiments.getVariant('TRENDING_SEARCHES_NEAR_YOU');
                    switch(trendingVariant) {
                        case 1: trendingSearchesNearYouOptions.displayKey = "city" ; break;
                        case 2: trendingSearchesNearYouOptions.displayKey = "longName" ; break;
                        default: trendingSearchesNearYouOptions.displayKey = "longName" ;
                    }
                }

                var isOpenSearch = (currentLob === 'openSearch');
                var isGemmaActive = (abTest.get(10406).value == "2");
                //Global rollout of ESS v4 for hotel, flight, opensearch LOB
                if (_.contains(['flight', 'hotel', 'car', 'openSearch'], currentLob)) {
                    essv4exp = true;
                }

                var model = {};

                //vmohapatra: Include the logic to indicate origin / destination fields for Flight LOB
                if (getCurrentLob() == 'flight') {
                    var contextID = this.$element.context.id;
                    //Add the context for both Origin and destination fields
                    model.multiFlightInputId = contextID;
                }

                // does this have ESS results, and has the typeahead changed?
                if (results.length > 0 && $inputFieldText == text) {

                    corewizard.OMTypeAheadRendered = true;
                    var typeAheadContainer = $('.theme-typeahead');
                    this.$element.removeAttr('aria-describedby');

                    $(typeAheadContainer).removeAttr('role', 'tooltip');
                    $(typeAheadContainer).attr('role', 'presentation');

                    //Inject user history suggestions in the results if the experiment is ON
                    if (recentHistoryOptionsInjector) {
                        recentHistoryOptionsInjector.inject(results, recentHistoryOptions);

                        // Get the number of userHistory suggestions injected
                        taMetadata.userHistoryItemsTotal = recentHistoryOptionsInjector ? recentHistoryOptionsInjector.countInjectedOptions() : 0;
                        // Get the oldest timestamp of userHistory suggestions retrieved for the LOB
                        taMetadata.userHistoryOldestTimestamp = recentHistoryOptionsInjector ? recentHistoryOptionsInjector.getOldestTimestampInfo() : null;

                        //Reset the number of ess items shown if userHistoryItems are shown
                        // Assumption is we never mix Scratchpad and Recommender and Scratchpad options
                        if(taMetadata.userHistoryItemsTotal > 0 && taMetadata.essItemsTotal >= 10) {
                            taMetadata.essItemsTotal = taMetadata.essItemsTotal - taMetadata.userHistoryItemsTotal;
                        }

                        wizardState.set('essItemsTotal', taMetadata.essItemsTotal);
                        wizardState.set('userHistoryItemsTotal',taMetadata.userHistoryItemsTotal);

                    }

                    //vmohapatra : Assumption is Scratchpad and Trending Search experiments would never be on at the same time
                    //Inject trending search suggestions in the results if the experiment is ON
                    if (trendingSearchesNearYouInjector) {
                        //If there has been no user input wipe out suggestions from ESS from results
                        if (! this.beenInputed()) {
                            results = [];
                            //Resetting essItemsTotal to 0 as we would not display them in this case
                            taMetadata.essItemsTotal = 0;
                            wizardState.set('essItemsTotal', 0);

                            trendingSearchesNearYouInjector.inject(
                                results,
                                TypeaheadUtils.trendingSearchesDataProvider.getRegionModels(
                                    getCurrentLob(), this.$element.attr("id")),
                                trendingSearchesNearYouOptions);

                            // since we never mix "Trending searches near you" entries with ess entries
                            // at this point, the number of items in the results list is the count of
                            // recommender options we're showing to the user
                            taMetadata.recommenderOptionsRendered = results.length;
                            wizardState.set('recommenderOptionsRendered', taMetadata.recommenderOptionsRendered);
                        }
                        else {
                            //Since there has been user input no recommender suggestions were shown
                            taMetadata.recommenderOptionsRendered = 0;
                            wizardState.set('recommenderOptionsRendered', 0);
                        }
                    }

                    // Sort the results:
                    results.sort(function (a, b) {
                        var sortedResult = essv4exp ? (a.index - b.index) : (a.i - b.i);
                        return sortedResult;
                    });

                    var opts = this.opts;

                    if (bestDealsOptionVariant && !Typeahead.CATEGORIES.DEALS.name) {
                        Typeahead.CATEGORIES.DEALS.name =
                            ['', this.opts.bestDealsText, this.opts.cheapHotelsText][bestDealsOptionVariant];
                    }
                    var categoriesPresent = {};
                    $.each(results, function (i, result) {
                        var category = essv4exp ?
                            ((isOpenSearch && !isGemmaActive)?
                                ((result.regionType == 'HOTEL') ? result.regionType : result.lob) : result.type) : result.rt;
                        if (typeof categoriesPresent[category] === 'undefined') {
                            categoriesPresent[category] = true;
                        }
                    });

                    // Create a mapping from category to results:
                    var resultsByCategory = {};
                    if (this.opts.lob == 'HOTELS') {
                        if (categoriesPresent['CITY']) resultsByCategory[Typeahead.CATEGORIES.CITY.name] = [];
                        if (categoriesPresent['ATTRACTION']) resultsByCategory[Typeahead.CATEGORIES.ATTRACTION.name] = [];
                        if (categoriesPresent['AIRPORT']) resultsByCategory[Typeahead.CATEGORIES.AIRPORT.name] = [];
                        if (categoriesPresent['HOTEL']) resultsByCategory[Typeahead.CATEGORIES.HOTEL.name] = [];
                        if (categoriesPresent['TRAINSTATION']) resultsByCategory[Typeahead.CATEGORIES.TRAINSTATION.name] = [];
                        if (categoriesPresent['METROSTATION']) resultsByCategory[Typeahead.CATEGORIES.METROSTATION.name] = [];
                        if (categoriesPresent['MULTICITY']) resultsByCategory[Typeahead.CATEGORIES.MULTICITY.name] = [];
                        if (categoriesPresent['NEIGHBORHOOD']) resultsByCategory[Typeahead.CATEGORIES.NEIGHBORHOOD.name] = [];
                        if (categoriesPresent['METROCODE']) resultsByCategory[Typeahead.CATEGORIES.METROCODE.name] = [];
                        if (categoriesPresent['POI']) resultsByCategory[Typeahead.CATEGORIES.POI.name] = [];
                    }
                    else if (this.opts.lob == 'CARS') {
                        if (categoriesPresent['AIRPORT']) resultsByCategory[Typeahead.CATEGORIES.AIRPORT.name] = [];
                        if (categoriesPresent['CITY']) resultsByCategory[Typeahead.CATEGORIES.CITY.name] = [];
                        if (categoriesPresent['ATTRACTION']) resultsByCategory[Typeahead.CATEGORIES.ATTRACTION.name] = [];
                    }
                    else if (this.opts.lob == 'OPENSEARCH') {
                        if (categoriesPresent['HOTEL_NAME']) resultsByCategory[Typeahead.CATEGORIES.HOTEL_NAME.name] = [];
                        if (categoriesPresent['HOTELS']) resultsByCategory[Typeahead.CATEGORIES.HOTELS.name] = [];
                        if (categoriesPresent['FLIGHTS']) resultsByCategory[Typeahead.CATEGORIES.FLIGHTS.name] = [];
                        if (categoriesPresent['PACKAGES']) resultsByCategory[Typeahead.CATEGORIES.PACKAGES.name] = [];
                        if (categoriesPresent['CARS']) resultsByCategory[Typeahead.CATEGORIES.CARS.name] = [];
                        if (categoriesPresent['ACTIVITIES']) resultsByCategory[Typeahead.CATEGORIES.ACTIVITIES.name] = [];
                        if (categoriesPresent['CRUISES']) resultsByCategory[Typeahead.CATEGORIES.CRUISES.name] = [];
                    }

                    if (essv4exp) {
                        $.each(results, function (i, result) {
                            //Allen Kim: Not sure why but BE POS is returning multiregion types which don't appear to be
                            //a recognized type. Just going to skip on multiregion type since we are still using v1 TA which
                            //is deprecated now.
                            if (searchExperiments.getSearchExperimentVariant('8664') === "0" && result.type == "MULTIREGION") {
                                //Return only if MULTIREGION are not exposed
                                return;
                            }

                            var category = undefined;

                            if (result.type == "ADDRESS") {
                                var subtype = result.subtype;
                                switch (subtype) {
                                    case 'RENTALLOCATION' :
                                        subtype = 'RENTAL';
                                        break;
                                    case 'CARRENTALADDRESS' :
                                        subtype = 'RENTAL';
                                        break;
                                    case 'POSTALCODE' :
                                        subtype = 'POSTCODE';
                                        break;
                                    default :
                                        subtype = result.subtype;
                                }

                                category = result.subtype ? Typeahead.CATEGORIES[subtype] : Typeahead.CATEGORIES[result.type];
                            }
                            else if (isOpenSearch) {
                                if(isGemmaActive){
                                    category = 'GEMMA' ;
                                }
                                else {
                                    category = result.regionType == 'HOTEL' ?
                                        Typeahead.CATEGORIES['HOTEL_NAME'] :
                                        Typeahead.CATEGORIES[result.lob];
                                }
                            }
                            else {
                                category = Typeahead.CATEGORIES[result.type];
                            }

                            var categoryName = category ? category.name : 'Other'; // TODO : does this case exist? can we move the string to config?

                            if (typeof resultsByCategory[categoryName] === 'undefined') {
                                resultsByCategory[categoryName] = [];
                            }
                            result.categoryName = categoryName;
                            resultsByCategory[categoryName].push(result);

                            result.icon = getIcon(result.type, category, opts.forceicon);

                            if (typeof result.regionNames.lastSearchName != "undefined") {
                                result.regionNames.lastSearchName = Typeahead.encodeHtmlCharacterReferences(result.regionNames.lastSearchName);
                            }
                            else {
                                result.regionNames.lastSearchName = Typeahead.encodeHtmlCharacterReferences(result.regionNames.fullName);
                            }

                            //Add typeahead metadata to each item
                            result.taMetadata = taMetadata;
                            //Set the metadata in the wizard state
                            wizardState.set('taMetadata',taMetadata);

                            result.data =  JSON.stringify(result);
                        });

                    }
                    else {
                        $.each(results, function (i, result) {
                            //Allen Kim: Not sure why but BE POS is returning multiregion types which don't appear to be
                            //a recognized type. Just going to skip on multiregion type since we are still using v1 TA which
                            //is deprecated now.

                            if (result.t === "MULTIREGION") return;

                            var category = undefined;

                            if (searchExperiments.getSearchExperimentVariant('8206') !== "0" && result.rt === "ADDRESS") {
                                category = Typeahead.CATEGORIES['RENTAL'];
                            }
                            else {
                                category = Typeahead.CATEGORIES[result.rt];
                            }

                            var categoryName = category ? category.name : 'Other'; // TODO : does this case exist? can we move the string to config?

                            if (typeof resultsByCategory[categoryName] === 'undefined') {
                                resultsByCategory[categoryName] = [];
                            }
                            result.categoryName = categoryName;
                            resultsByCategory[categoryName].push(result);

                            result.icon = getIcon(result.type, category, opts.forceicon);

                            if (typeof result.l != "undefined")
                                result.l = Typeahead.encodeHtmlCharacterReferences(result.l);
                            else
                                result.l = Typeahead.encodeHtmlCharacterReferences(result.f);

                            //Add typeahead metadata to each item
                            result.taMetadata = taMetadata;
                            //Set the metadata in the wizard state
                            wizardState.set('taMetadata',taMetadata);

                            result.data = JSON.stringify(result);
                        });
                    }

                    // Create an object to pass to the template:
                    //Add necessary variables to pass to existing model as needed for Geo-Hierarchy experiment
                    //eg : experiment variation

                    model.continueText = this.opts.continuetext;
                    model.closeText = this.opts.closetext;
                    model.results = results;
                    model.resultsByCategory = resultsByCategory;
                    model.ariaOwns = this.ariaOwns;
                    model.isV4 = essv4exp;

                    model.resultsByDisplayGroup = _.groupBy(results, function(result){
                        return result.displayGroup ? result.displayGroup : "";
                    });

                    if (!_.isEmpty(model.results)) {
                        this.getMetricsLogger().suggestionEngagement.suggestionShown = true;
                    }

                    content = this.template(model);
                    this.$ta.html(content);

                    this.$label.addClass('focused');

                    if (this.opts.tooltip) {

                        if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                            // bind 'this' for use in the uitk.clickEvent and focusin callback
                            that = this;

                            // Using feature detection we can diff between IE 11 and IE 10.
                            // Pointer events were added in IE10 (window.PointerEvent).
                            // The syntax changed in IE 11 (vendor prefix was removed).
                            // If pointer events are supported - and - the new syntax is supported, we know it is IE 11.
                            // If pointer events supported and the new syntax is not supported -- then we know it is IE 10.

                            $('body').on(uitk.clickEvent + ' focusin.' + tooltipPlugin, function (e) {
                                if (e.type === 'focusin' && !uitk.utils.isFocusableElement($(e.target))) {
                                    return;
                                }
                                //don't close if clicked on $ta
                                if (e.target === that.$element[0]) {
                                    return;
                                }

                                that.close();
                            });
                        }

                        //If it is a touch device (ipad) Do not announce number of results displayed
                        if (!$('html').hasClass('appleios')) {
                            uitk.utils.liveAnnounce(results.length + resultsLengthAnnouncement, 'polite');
                        }
                    }
                    else {
                        var height = parseInt(this.$element.css('height'), 10);

                        var offset = this.$element.offset();
                        this.$ta.css({
                            top: offset.top + height + 'px',
                            left: offset.left + 'px'
                        });
                    }

                    if(results.length > 0){
                        // only show popup when we have something
                        // to actually render
                        showTaPopup(this.$ta, this);
                    }
                }
                else if (results.length == 0) {
                    // even though there's an empty results array to inject into,
                    // we still want to match any recent histories no matter what the
                    // state of the input text is, empty or otherwise...

                    //Inject user history suggestions in the results if the experiment is ON
                    if (recentHistoryOptionsInjector) {
                        recentHistoryOptionsInjector.inject(results, recentHistoryOptions);

                        // Get the number of userHistory suggestions injected
                        taMetadata.userHistoryItemsTotal = recentHistoryOptionsInjector ? recentHistoryOptionsInjector.countInjectedOptions() : 0;
                        // Get the oldest timestamp of userHistory suggestions retrieved for the LOB
                        taMetadata.userHistoryOldestTimestamp = recentHistoryOptionsInjector ? recentHistoryOptionsInjector.getOldestTimestampInfo() : null;

                        wizardState.set('userHistoryItemsTotal',taMetadata.userHistoryItemsTotal);
                    }

                    //Inject trending search suggestions in the results if the experiment is ON
                    if (trendingSearchesNearYouInjector) {

                        trendingSearchesNearYouInjector.inject(
                            results,
                            TypeaheadUtils.trendingSearchesDataProvider.getRegionModels(
                                getCurrentLob(), this.$element.attr("id")),
                            trendingSearchesNearYouOptions);

                        // since we never mix "Trending searches near you" entries with ess entries
                        // at this point, the number of items in the results list is the count of
                        // recommender options we're showing to the user
                        taMetadata.recommenderOptionsRendered = results.length;
                        wizardState.set('recommenderOptionsRendered', taMetadata.recommenderOptionsRendered);

                    }

                    if (results.length > 0) {
                        // we picked up some recent history searches with the inject
                        // add to the model
                        model.results = results;
                    }

                    //Set the number of ESS items retrieved ie 0
                    wizardState.set('essItemsTotal', taMetadata.essItemsTotal);
                    wizardState.set('taMetadata',taMetadata);

                    //vmohapatra NOTE: never pass a string object to isEmptyObject() as gives wrong result in IE8
                    // in order to render, we need a list that will be rendered so we check the results array.
                    // The extra check makes it so we never see an empty typeahead popup dialog
                    if ($.isEmptyObject(model) == false && model.results && model.results.length > 0) {
                        this.getMetricsLogger().suggestionEngagement.suggestionShown = true;
                        //Add indication if its ESS V4 response
                        model.isV4 = essv4exp;
                        model.closeText = this.opts.closetext;

                        _.each(results, function (result) {

                            $.extend(result, {
                                taMetadata: taMetadata,
                                icon: getIcon(result.type, Typeahead.CATEGORIES[result.type], this.opts.forceIcon)
                            });

                            // now, update the data-data string for the template with the updated result as JSON
                            result.data =  JSON.stringify(result);
                        }, this);

                        model.resultsByDisplayGroup = _.groupBy(results, function(result){
                            return result.displayGroup ? result.displayGroup : "";
                        });

                        // now we're ready to render the template
                        content = this.template(model);

                        this.$ta.html(content);

                        this.$label.addClass('focused');

                        if (this.opts.tooltip) {

                            if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                                // bind 'this' for use in the uitk.clickEvent and focusin callback
                                that = this;

                                // Using feature detection we can diff between IE 11 and IE 10.
                                // Pointer events were added in IE10 (window.PointerEvent).
                                // The syntax changed in IE 11 (vendor prefix was removed).
                                // If pointer events are supported - and - the new syntax is supported, we know it is IE 11.
                                // If pointer events supported and the new syntax is not supported -- then we know it is IE 10.

                                $('body').on(uitk.clickEvent + ' focusin.' + tooltipPlugin, function (e) {
                                    if (e.type === 'focusin' && !uitk.utils.isFocusableElement($(e.target))) {
                                        return;
                                    }
                                    //don't close if clicked on $ta
                                    if (e.target === that.$element[0]) {
                                        return;
                                    }

                                    that.close();
                                });
                            }
                        }
                        else {
                            var height = parseInt(this.$element.css('height'), 10);

                            var offset = this.$element.offset();
                            this.$ta.css({
                                top: offset.top + height + 'px',
                                left: offset.left + 'px'
                            });
                        }

                        //If it is a touch device (ipad) Do not announce number of results displayed
                        if (!$('html').hasClass('appleios')) {
                            if (results && results.length) {
                                uitk.utils.liveAnnounce(results.length + resultsLengthAnnouncement, 'polite');
                            }
                        }
                    }

                    if(results.length > 0){
                        corewizard.OMTypeAheadRendered = true;
                        // only show popup when we actually have something
                        // to render in the popup list
                        showTaPopup(this.$ta, this);
                    }
                }
                else {
                    this.close();
                }

                this.experimentAutomaticallyHighlightTopTypeaheadSuggestion();

                this.getMetricsLogger().timestamp(this.getMetricsLogger().TimestampCategories.RENDER, text);
            },

            close: function () {
                this.$label.removeClass('focused');

                hideTaPopup(this.$ta, this);
                this.$ta.html('');

                if (this.bodyClick) {
                    this.$ta.unbind('mousedown', $.proxy(this.cancelEvent, this));
                    $(document.body).unbind('mousedown', $.proxy(this.close, this));
                    this.bodyClick = false;
                }

                // for any code that needs to know when
                // the typeahead window has been closed
                uitk.publish('typeaheadTooltip.closed', lastFocusedElementId);
            },

            prev: function () {
                var links = this.$ta.find('a'),
                    current = this.$ta.find('.highlight').removeClass('highlight'),
                    i = links.index(current),
                    prev = links[i - 1],
                    $prev = $(prev);

                $(current).attr('aria-selected', 'false');

                if (prev) {
                    highlightOption(this, $prev);
                }
                else {
                    // 'reset' by removing attributes
                    this.$element.removeAttr('aria-activedescendant');
                    $('[aria-selected="true"]').attr('aria-selected', 'false');
                    // Accessibility: when user navigates back to input, read the value (Toby)
                    uitk.utils.liveAnnounce(this.$element.val(), 'polite');
                }
            },

            next: function () {
                var links = this.$ta.find('a'),
                    current = this.$ta.find('.highlight').removeClass('highlight'),
                    i = links.index(current),
                    next = links[i + 1],
                    $next = $(next),
                    item,
                    accyText = '';

                $(current).attr('aria-selected', 'false');

                // Accessibility: announce 'close' button as selection moves to it.
                // (this is not the same as announcing it has been selected.)
                // (Aria roles and labels didn't work on Safari/VO)
                if ($(links[i + 1]).hasClass('close')) {
                    uitk.utils.liveAnnounce('close', 'assertive');
                }

                // There is a 'bug' in screen readers other than Safari/VoiceOver where
                // they will not read the first option the second (and following) time they access it,
                // especially after navigating back to the input.
                // It has to do with the way screen readers view ULs (Stack).
                // This work around will explicitly call out the value after first access.
                if (!$('html').hasClass('safari')) {
                    if (this.firstItemFlag === true) {
                        this.firstItemFlag = false;
                    } else {
                        if (typeof links[i] === 'undefined') {
                            // only over ride for the first item, not the rest
                            item = $('.active-tooltip').find('a')[0];
                            accyText = $(item).attr('data-value');
                            uitk.utils.liveAnnounce(accyText, 'polite');
                        }
                    }
                }

                if (next) {
                    highlightOption(this, $next);
                }
                else {
                    // Accessibility: navigated to input, read the value (Toby)
                    uitk.utils.liveAnnounce(this.$element.val(), 'polite');
                }
            },

            removeHighlights: function () {
                this.$ta.find('.highlight').removeClass('highlight');
            },

            // Choose the currently selected item:
            selectHighlighted: function (e) {
                var closeFlag = this.$ta.find('.highlight').hasClass('close');
                if (! closeFlag) {
                    this.selectedSuggestionIsInEffect = true;
                }
                // User has selected one of the items in the list
                // Setting this flag here since code that follows
                // has the side effect of setting focus and the handler
                // for focus is precisely where this flag is used
                Typeahead.taItemChosen = true;

                var $item = this.$ta.find('.highlight'),
                    $nextItem = $item.parent().next(),
                    index,
                    itemTextFull = $item.text(),
                    itemText, closeText, $html = $('html');

                index = this.$ta.find('a').index($item);
                if (index >= 0) {
                    this.getMetricsLogger().logSelection(this.$ta.find('a').index($item), this.$element.val());
                }

                // this trims whitespace off ends of the string
                itemText = itemTextFull.replace(/(^\s+|\s+$)/g, '');

                //NOTE : The following condition might be true for non-touch devices as well.
                //To be on the safe side set the item and other data again.
                //used for touch devices as they don't have hover and therefore don't highlight
                if (e && $item.length === 0) {
                    $item = $(e.target).closest('.results-item').find('a');
                    $nextItem = $item.parent().next();
                }
                if (Typeahead.isHierarchyEnabled(this.opts)) {
                    this.updateTextField($item, $nextItem);
                }
                else {
                    this.updateTextField($item);
                }

                $item.removeClass('highlight');

                // Accessibility
                // Announces that a selection has been made and the value selected,
                // or that the user closed the menu with the close button.
                // NOTE: once the sentences have been localized, we can simplify this logic below.
                if (closeFlag === true) {
                    // the close button was selected, so
                    // get the potentially localized 'close' text
                    closeText = $item.text().replace(/(^\s+|\s+$)/g, '');
                    if (this.$element.attr('locale') === 'en_US' || $html.attr('data-language') === 'en_US') {
                        // it is US English, read the complete sentence
                        uitk.utils.liveAnnounce('Close button is selected and the menu has closed', 'assertive');
                    } else {
                        // just read the localized 'close' text (until the full sentence is localized)
                        uitk.utils.liveAnnounce(closeText, 'assertive');
                    }
                } else {
                    // NOTE: NVDA and JAWs read the selection, VO does not.
                    if ($html.hasClass('safari')) {
                        if (this.$element.attr('locale') === 'en_US' || $html.attr('data-language') === 'en_US') {
                            // it is US English, read the complete sentence
                            uitk.utils.liveAnnounce('You selected ' + itemText + ' and the menu has closed', 'assertive');
                        } else {
                            // just read the localized 'item' text (until the full sentence is localized)
                            uitk.utils.liveAnnounce(itemText, 'assertive');
                        }
                    }
                }

                // Publish select element event on typeahead select
                var data = {element: $item};
                uitk.publish('typeahead.resultSelected', data);

                if(Modernizr.touch){
                    // When on a touch device like a phone, the popup can be
                    // quite long. This is here to animate the highlighted input
                    // into view after an item has been selected and a value added to the
                    // the associated input field. The setTimeout() call is to ensure
                    // this happens after this function has completed.
                    var self = this; // not using bind() for compatibility with old IE8
                    setTimeout(function(){
                        // slide the highlighted input into view
                        $('html, body')
                            .animate({
                                scrollTop: self.$element.offset().top - 24,
                                easing: "easeOutQuart"
                            }, 300);
                        }, 0);
                 }
            },

            updateTextField: function ($item, $nextItem) {

                if ($item) {
                    var value = $item.attr('data-value');
                    if (value) {
                        value = Typeahead.decodeHtmlCharacterEntities(value);
                        this.$element.val(value);

                        //There is no selectioncallback for activities LOB, hence typeOfSearch always shows as undefined
                        if (this.opts.selectioncallback) {

                            var childData;
                            //If hierarchical display is off nextItem would be undefined.
                            if ($nextItem != undefined) {
                                //childData should be populated only if nextItem is available
                                childData = $nextItem.closest('.results-item').find('a').attr('data-data');
                            }

                            var hasChildFlag = -1;
                            if (childData != undefined) {
                                //Assumption : Currently relation node has only one value at a time
                                //Looking for value "child" in ESS response
                                hasChildFlag = childData.search(/"child"/i);
                            }

                            var hasChild = false;
                            if (childData != undefined && hasChildFlag != -1) {
                                hasChild = true;
                            }

                            if (typeof this.opts.selectioncallback == 'function') {
                                this.opts.selectioncallback($item, hasChild);
                            } else if (typeof this.opts.selectioncallback == 'string') {
                                window[this.opts.selectioncallback]($item, hasChild);
                            }
                        }
                    }
                    this.close();
                    this.$element.parent().parent().children(".icon-close").addClass("visuallyhidden");

                    this.$element.select();
                }
            },

            focus: function (evt) {
                if(evt && evt.currentTarget) {
                    // keeping track of the id of the element that got the focus
                    // so we pass it on to the 'typeaheadTooltip.closed' subscribers
                    lastFocusedElementId = evt.currentTarget.getAttribute("id");
                }

                if(Typeahead.taItemChosen){
                    // if this is the focus call right after the user has picked an item
                    // from the list, we don't want to fire off another render sequence
                    // so we just get out now and flip the flag back.
                    Typeahead.taItemChosen = false;
                    return;
                }

                this.getMetricsLogger().timestamp(this.getMetricsLogger().TimestampCategories.FOCUS, this.$element.val());
                this.getMetricsLogger().logFocus();
                if (!evt) {
                    evt = window.event;
                }

                //Zero typehead trigger display and no character in focused input field
                // is a valid case for the recent history experiments
                if (isRecentHistoryExperiment() || isTrendingSearchesNearYouExperiment()) {

                    var elemValue = $.trim(this.$element.val());
                    var inputElemPlaceholderFlag;

                    //For browsers that support placeholder text
                    // in HTML input controls. Best practice is to use Modernizr
                    if (Modernizr.input.placeholder) {
                        inputElemPlaceholderFlag = elemValue;
                    }
                    else {
                        //For IE8 which does not support placeholder
                        if (elemValue == $.trim(this.$element.attr("placeholder"))) {
                            this.$element.val("");
                            inputElemPlaceholderFlag = "";
                        }
                        else {
                            this.$element.val(elemValue);
                            inputElemPlaceholderFlag = elemValue;
                            $(this.$element).removeClass("placeholderspolyfill");
                        }
                    }

                    //If the input element has no previous value, show trending now options on focus
                    if (inputElemPlaceholderFlag == '' || isRecentHistoryExperiment() || isTrendingSearchesNearYouExperiment()) {
                        this.shouldBeOpen = true;
                        this.renderFromFocus = true;
                        this.startRequest();
                    }

                }

            },

            keyDown: function (evt) {
                var keyCode;

                if (!evt) evt = window.event;

                keyCode = evt.keyCode;

                switch (keyCode) {
                    case 27: // Escape
                        this.close();
                        evt.stopPropagation();
                        break;

                    case 13: // Enter
                        evt.stopPropagation();
                        if (this.$ta.is(":visible")) {
                          if(getCurrentLob() === 'openSearch') {
                            if (this.$ta.find('.highlight').length) {
                              evt.preventDefault();
                              this.selectHighlighted(evt);
                            }
                          }
                          else {
                            // if there is no highlighted element select the first
                            if (!this.$ta.find('.highlight').length) {
                              this.$ta.find('a:first').addClass('highlight');
                            }
                            evt.preventDefault();
                            this.selectHighlighted(evt);
                          }
                        }
                        break;

                    case 32: // space
                        if (this.$ta.find('.highlight').hasClass('close')) {
                            evt.stopPropagation();
                            evt.preventDefault();
                        }
                        break;

                    case 39: // Right
                        if (this.$ta.find('.highlight').length) {
                            this.ignoreNext = true;
                            evt.stopPropagation();
                            this.selectHighlighted(evt);
                        }
                        break;
                    case 38: // Up
                    case 40: // Down
                        evt.stopPropagation();
                        evt.preventDefault();
                        break;
                }
            },

            keyPress: function (evt) {
                if (!evt) {
                    evt = window.event;
                }
                if (evt.keyCode == 13 /* Enter/Return */) {
                    this.close();
                }
            },

            keyUp: function (evt) {
                // prevents a key up after an item has been selected by the key board
                if (this.ignoreNext) {
                    this.ignoreNext = false;
                    return;
                }

                if (!evt) evt = window.event;
                switch (evt.keyCode) {
                    case 27: // Escape
                        break;

                    case 37: // Left
                        this.removeHighlights();
                        break;

                    case 38: // Up
                        this.prev();
                        break;

                    case 40: // Down
                        this.next();
                        break;

                    case 9: // TAB
                    case 16: // Shift
                    case 17: // Ctrl
                    case 18: // Alt
                        // when you TAB into a control, like an input field, that control gets the keyup
                        // it doesn't get the key down. When the input control gets a focus event, it will
                        // render if it needs to. No need to let TAB fall through and trigger render again.
                        break;
                    case 13: // Enter/Return
                        this.shouldBeOpen = false;
                        break;

                    case 32: // space
                        if (this.$ta.find('.highlight').hasClass('close')) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            this.selectHighlighted(evt);
                        }
                        break;
                    default:
                        this.shouldBeOpen = true;
                        this.getMetricsLogger().timestamp(
                            this.getMetricsLogger().TimestampCategories.KEY_UP, this.$element.val());

                        this.startRequest();
                        break;
                }
            },

            blur: function (event) {
                function emitSuggestionEngagementMetricIfApplicable(
                    typeahead, serversideVariantAssignments, clientsideVariantAssignments, clientId, userTypedQuery,
                    lobType)
                {
                    function isInteractionWithInputElementCompleted(event) {
                        var typeaheadResultsDomElement = $(".typeahead")[0];
                        // A blur caused by focusing on a typeahead suggestion doesn't indicate the completion of
                        // interaction with the input element.
                        return event.type === "blur" &&
                            ! (typeaheadResultsDomElement && $.contains(typeaheadResultsDomElement, event.relatedTarget));
                    }
                    var variantAssignments;
                    if (isInteractionWithInputElementCompleted(event)) {
                        typeahead.getMetricsLogger().emitSuggestionEngagementMetric(
                            typeahead.selectedSuggestionIsInEffect,
                            userTypedQuery,
                            typeahead.$element.val(),
                            lobType,
                            clientId,
                            _.compact([serversideVariantAssignments, clientsideVariantAssignments]).join("|"));
                    }
                }
                setTimeout(emitSuggestionEngagementMetricIfApplicable, 0,
                    this, dataModels.model.get("activeESSTests"), getClientsideExperiments(), getPageId(),
                    dataModels.model.get("userTypedQuery"), dataModels.model.get('tab'));
                this.getMetricsLogger().emitMetrics();

                // IE10 Win8 fix
                if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                    return;
                }

                // need a delay so we can cancel if the ta is being clicked on
                if (!this.isClickOn) {
                    this.close();
                } else {
                    this.$ta.bind('mousedown', $.proxy(this.cancelEvent, this));
                    $(document.body).bind('mousedown', $.proxy(this.close, this));
                    this.bodyClick = true;
                }
                // Binding the 'x' hiding function to this so it can delay a little and stay *just* long enough for the click to register.
                // Otherwise, the loss of focus on the input element when you click on the 'x' causes it disappear and not register the click.
                var boundHide = (function() {this.$element.parent().parent().children(".icon-close").addClass("visuallyhidden");}).bind(this);
                window.setTimeout(boundHide, 100);

            },

            hammerTapHandler: function(hammerEvent){
                // The Hammer.js library emits "tap" events for touch devices
                // and sends a Hammer event object to the handler.
                // See: http://hammerjs.github.io/api/#event-object
                var srcEvent = _.isObject(hammerEvent) && hammerEvent.srcEvent;
                if(_.isObject(srcEvent)){
                    this.click(srcEvent);
                }
            },

            clickOn: function () {
                this.isClickOn = true;
            },

            clickOff: function () {
                this.isClickOn = false;
            },

            click: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.selectHighlighted(e);
            },

            onClick: function(){
                // when user clicks into the input field, select any existing text
                // This makes mouse click focus and keyboard TAB focus
                // behave in the same way providing a consistent user experience no
                // matter how the control is focused
                this.$element.select();
            },

            mouseEnter: function (e) {
                this.removeHighlights();
                $(e.currentTarget).addClass('highlight');
            },

            cancelEvent: function (evt) {
                evt.cancelBubble = true;
                if (evt.stopPropagation) evt.stopPropagation();
                if (evt.preventDefault) evt.preventDefault();
                evt.cancel = true;
                evt.returnValue = false;
            },

            // TODO - is this method necessary?
            remove: function () {
                this.$element.autocomplete = 'on';
                this.$element.closest('form').attr('autocomplete', 'on');

                this.$element
                    .off('focus', $.proxy(this.focus, this))
                    .off('keydown', $.proxy(this.keyDown, this))
                    .off('keyup', $.proxy(this.keyUp, this))
                    .off('keypress', $.proxy(this.keyPress, this))
                    .off('blur', $.proxy(this.blur, this));
                this.$ta
                    .off('mousedown', $.proxy(this.mouseDown, this))
                    .off('mouseup', $.proxy(this.mouseUp, this))
                    .off('click', $.proxy(this.click, this))
                    .off('mouseenter', 'a', $.proxy(this.mouseEnter, this))
                    .remove();
            },

            // Experiment 7198, Automatically highlight the top Typeahead suggestion
            // <https://trackit/browse/STOR-5>
            experimentAutomaticallyHighlightTopTypeaheadSuggestion: function () {
                var abacusID = '7198',
                    suggestions,
                    topSuggestion;
                if (searchExperiments.getSearchExperimentVariant(abacusID) !== "0") {
                    suggestions = this.$ta.find('.results-item a');
                    if (suggestions.length > 0) {
                        topSuggestion = $(suggestions[0]);
                        topSuggestion.addClass('highlight');
                        this.$element.attr('aria-activedescendant', topSuggestion.attr('id'));
                    }
                }
            },

            getMetricsLogger: function () {
                if (!this.metricsLogger) {
                    this.metricsLogger = new TypeaheadMetricsLogger(this.$element.attr("id"), this.opts.locale);
                }
                return this.metricsLogger;
            },

            getBestDealsOptionInjector: function () {
                if (!this.bestDealsOptionInjector &&
                    searchExperiments.getVariant("BEST_DEALS_OPTION") &&
                    _.isFunction(BestDealsOptionInjector)) {
                    this.bestDealsOptionInjector = new BestDealsOptionInjector(this);
                }
                return this.bestDealsOptionInjector;
            },

            getRecentHistoryOptionsInjector: function () {
                var isBucketedIn = searchExperiments.getVariant("RECENT_HISTORY_HOTEL") ||
                    searchExperiments.getVariant("RECENT_HISTORY_FLIGHT")
                if (!this.recentHistoryOptionsInjector &&
                    isBucketedIn &&
                    _.isFunction(RecentHistoryOptionsInjector)) {
                    this.recentHistoryOptionsInjector = new RecentHistoryOptionsInjector();
                }
                return this.recentHistoryOptionsInjector;
            },

            getTrendingSearchesNearYouInjector: function () {
                if (!this.trendingSearchesNearYouInjector &&
                    isTrendingSearchesNearYouExperiment() &&
                    _.isFunction(TypeaheadUtils.TrendingSearchesNearYouInjector)) {
                    this.trendingSearchesNearYouInjector = new TypeaheadUtils.TrendingSearchesNearYouInjector();
                }
                return this.trendingSearchesNearYouInjector;
            },

            bindJQueryObject: function(input) {
                if (input.is(this.$element)) {
                    return;
                }

                // The <input>
                this.$element = input;

                // beenInputed() returns true if and only if an input event (https://goo.gl/IHeZsl) whose target is the element
                // associated with this object has been fired since the instantiation of this object.
                this.beenInputed = (function($element){
                    var beenInputed = false;
                    var eventName = "input";
                    function handler() {
                        beenInputed = true;
                        $element.off(eventName, handler);
                    }
                    $element.on(eventName, handler);
                    return function() {
                        return beenInputed;
                    }
                })(this.$element);

                // The <input>'s <label>
                this.$label = this.$element.closest('label');

                this.$element.on("input", $.proxy(function(){ this.selectedSuggestionIsInEffect = false; }, this));

                // Accessibility
                // The ID for the DIV that is to receive the dynamic content
                // passed in via data attribute in INPUT markup.
                // For backwards compatibility, we use a preset ID so that tooltip
                // can append content correctly, even if accessibility doesnt work it won't
                // break pages.
                this.ariaOwns = this.$element.attr('aria-owns') || 'backwards';

                // Set up the input and listeners:
                this.$element.autocomplete = 'off';

                // For gecko-based browsers, we turn autocomplete off on the <form>,
                // not the <input>
                this.$element.closest('form').attr('autocomplete', 'off');

                this.$element
                    .on('click', $.proxy(this.onClick, this))
                    .on('focus', $.proxy(this.focus, this))
                    .on('keydown', $.proxy(this.keyDown, this))
                    .on('keyup', $.proxy(this.keyUp, this))
                    .on('keypress', $.proxy(this.keyPress, this))
                    .on('blur', $.proxy(this.blur, this));
                // Allen Kim: If you blur before the TA ajax call returns, it won't close so I'm using a blockRender
                // flag here. It gets set to false again on focus. https://jira/jira/browse/MAIN-101040
                //.on('blur', $.proxy(function() { this.blockRender = true; }, this));
                //Allen Kim: mobile isn't handling blur events well - https://jira/jira/browse/MAIN-129737, https://jira/jira/browse/MAIN-129750
                //  .on('blur', $.proxy(this.blur, this));
                $('body').on('click focus', $.proxy(function (evt) {
                    if (evt.target !== this.$element[0]) this.blur(evt);
                }, this));

                if (this.opts.tooltip) {
                    this.$element[tooltipPlugin]({
                        content: this.$ta,
                        template: '<div class="uitk-tooltip" role="presentation"><div class="tooltip-inner" role="presentation"></div><span class="tooltip-arrow-border"></span><span class="tooltip-arrow"></span></div>',
                        width: 600
                    });
                }
            }
        };

    }();

    // State variable that tracks when a user chooses an item
    // from the typeahead popup UI. When the user chooses an option from within the
    // typeahead list we set this to true. When the typeahead popup finally closes
    // the pubsub event 'typeahead.resultSelected' gets fired and then focus is restored
    // to the Typeahead control. At that time, use use this flag to know that for this
    // particular focus event fires, we know not to run out and render the typeahead popup again.
    // At that time the flag is toggled back to false.
    Typeahead.taItemChosen = false;

    //
    // Constants:
    //
    Typeahead.AIRPORT = 1;
    Typeahead.CITY = 2;
    Typeahead.MULTICITY = 4;
    Typeahead.NEIGHBORHOOD = 8;
    Typeahead.POI = 16;
    Typeahead.ADDRESS = 32;
    Typeahead.RENTAL = 32;
    Typeahead.METROCODE = 64;
    Typeahead.HOTEL = 128;
    Typeahead.TRAINSTATION = 512;
    Typeahead.METROSTATION = 1024;
    Typeahead.MULTIREGION = 256;
    // Set a default typeahead suggesturl
    Typeahead.SUGGESTURL_DEFAULT = "//suggest.expedia.com/hint/es/";
    Typeahead.SUGGESTURL = Typeahead.SUGGESTURL_DEFAULT;
    //gemma url for experiemnt 10406
    Typeahead.GEMMAURL= "https://gemma.expedia.com/gemma/rest/suggest";
    Typeahead.GEMMACLIENTID = "b73f2e66-c96a-4382-845b-30fa2d5ab102";
    Typeahead.GEMMACOUNT = "10";
    Typeahead.REGIONTYPE = {
        'ALL': 31,
        'AIRPORT': 1,
        'CITIES': 2
    };

    Typeahead.CATEGORIES = {
        'CITY': {
            'id': 0,
            name: loc.typeAhead.region,
            icon: 'location'
        },
        'ATTRACTION': {
            'id': 1,
            name: loc.typeAhead.attractions,
            icon: 'location'
        },
        'AIRPORT': {
            'id': 2,
            name: loc.typeAhead.airports,
            icon: 'flights'
        },
        'HOTEL': {
            'id': 3,
            name: loc.typeAhead.hotels,
            icon: 'hotels'
        },
        'ADDRESS': {
            'id': 4,
            name: loc.typeAhead.address,
            icon: 'location'
        },
        'TRAINSTATION': {
            'id': 5,
            name: loc.typeAhead.trains,
            icon: 'train'
        },
        'METROSTATION': {
            'id': 6,
            name: loc.typeAhead.metros,
            icon: 'train'
        },
        'MULTICITY': {
            'id': 7,
            name: loc.typeAhead.region,
            icon: 'location'
        },
        'NEIGHBORHOOD': {
            'id': 8,
            name: loc.typeAhead.region,
            icon: 'location'
        },
        'METROCODE': {
            'id': 9,
            name: loc.typeAhead.airports,
            icon: 'flights'
        },
        'POI': {
            'id': 11,
            name: loc.typeAhead.attractions,
            icon: 'location'
        },
        'RENTAL': {
            'id': 12,
            name: loc.typeAhead.rentals,
            icon: 'location'
        },
        'DEALS': {
            'id': 13,
            name: loc.typeAhead.deals,
            icon: 'location'
        },
        'POSTCODE': {
            'id': 14,
            name: loc.typeAhead.postcode,
            icon: 'location'
        },
        'HOTELS': {
            'id': 15,
            name: loc.typeAhead.hotels,
            icon: 'hotels'
        },
        'FLIGHTS': {
            'id': 16,
            name: loc.typeAhead.flights,
            icon: 'flights'
        },
        'PACKAGES': {
            'id': 17,
            name: loc.typeAhead.packages,
            icon: 'packages'
        },
        'CARS': {
            'id': 18,
            name: loc.typeAhead.cars,
            icon: 'cars'
        },
        'ACTIVITIES': {
            'id': 19,
            name: loc.typeAhead.activities,
            icon: 'activities'
        },
        'CRUISES': {
            'id': 20,
            name: loc.typeAhead.cruises,
            icon: 'cruises'
        },
        'HOTEL_NAME': {
            'id': 21,
            name: undefined, // Name is not required for display purposes
            icon: 'hotels'
        },
        'RECENTHISTORY': {
            'id': 22,
            name: loc.typeAhead.recent,
            icon: 'notime'
        },
        'ALL': {
            'id': 23,
            name: undefined,
            icon: 'location'
        },
        'TRENDINGSEARCH' : {
            'id': 24,
            name: loc.typeAhead.trending,
            icon: 'location'
        }
    };

    Typeahead.defaultOptions = {
        // "Options" - to be moved into this.opts, which is a merge from Typeahead.default
        // The options are overwriten with html attributes and need to be all lower case
        minchar: 3,
        maxitems: 10,
        version: 'v2',
        locale: 'en_US',
        abtest: '',
        mask: (Typeahead.AIRPORT | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.POI),
        lob: 'FLIGHTS',
        dest: false,
        closetext: 'Close',
        continuetext: 'Continue typing to refine search',
        selectioncallback: null, // called when an item is selected with mouse or keyboard, with one argument that is the selected <a>.
        tooltip: true,
        forceicon: false
    };

    Typeahead.isHierarchyEnabled = function (opts) {
        return _.contains(["FLIGHTS", "HOTELS"], opts.lob);
    }

    Typeahead.enableSuggestionHierarchy = function (opts) {
        if (Typeahead.isHierarchyEnabled(opts)) {
            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                locale: opts.locale,
                features: 'ta_hierarchy', // Instructs ESS to include suggestion hierarchy.
                ab: opts.abtest,
                lob: opts.lob,
                format: 'jsonp',
                dest: opts.dest,
                maxresults: opts.maxresults,
                client: opts.client
            };
            if (opts.lob === 'FLIGHTS') {
                opts.version = 'v4';
            }
            if (searchExperiments.getSearchExperimentVariant('8075') !== "0") {
                Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|nearby_airport';
            }

        }
    };

    Typeahead.request = function (text, instance, opts, callback) {
        var requestGenerator = ExpediaSuggestServiceRequestGenerator.defaultGenerator,
            essAbacusParameter = requestGenerator.generateAbacusParameter();
        Typeahead.SUGGESTURL = Typeahead.SUGGESTURL_DEFAULT;

        if(!env.essEndpoint) {
            // TODO: when we get client side logging, log info to server
            console.error("Missing environment config value for essEndpoint so defaulting to production endpoint.");
            Typeahead.V4URL = "//suggest.expedia.com/api/";
        } else {
            Typeahead.V4URL = env.essEndpoint;
        }

        Typeahead.URLPARAMS = undefined; //Stores the URL params for v4 call

        // only check hierarchy for sub-lob 'flight' and 'hotel'
        if ( _.contains(["flight", "hotel"], getCurrentLob())) {
            Typeahead.enableSuggestionHierarchy(opts);
        }

        if (abTest.get(6696).value == "1") {
            Typeahead.SUGGESTURL = "//suggest.integration.bgb.karmalab.net:52408/hint/es/";
        }

        //Global rollout of optimized categories for Cars except for BEX ASIA POS
        if (window.site_id && _.contains([14, 15, 16, 17, 18, 27, 28, 61, 62, 68, 71, 75], window.site_id) && _.contains(['car'], getCurrentLob())) {
            //BEX Asia POS
            //Default show airport
            //opts.mask = 1;
            opts.mask = Typeahead.AIRPORT;
        }
        else if (window.site_id && !_.contains([14, 15, 16, 17, 18, 27, 28, 61, 62, 68, 71, 75], window.site_id) && _.contains(['car'], getCurrentLob())) {
            //Non-BEX Asia POS
            //This substitutes POIs with train stations and metro stations
            if (searchExperiments.getSearchExperimentVariant('8206') !== "0") {
                //opts.mask = 1583;
                opts.mask = (Typeahead.AIRPORT | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.TRAINSTATION | Typeahead.METROSTATION | Typeahead.RENTAL);
            }
            else {
                //opts.mask = 1551;
                opts.mask = (Typeahead.AIRPORT | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.TRAINSTATION | Typeahead.METROSTATION);
            }
        }

        var url;
        var isESSTypeaheadEnabled = true;

        if (getCurrentLob() === 'hotel') {
            opts.version = 'v4';
             var featuresType = 'ta_hierarchy';

            var regionTypeNum = 1759;
            if (featuresType && featuresType !== '') {
                featuresType = featuresType + '|contextual_ta';
            }
            else {
                featuresType = 'contextual_ta';
            }

            if (searchExperiments.getSearchExperimentVariant('8812') !== "0") {
                if (featuresType && featuresType !== '') {
                    featuresType = featuresType + '|unspecified_area';
                }
                else {
                    featuresType = 'unspecified_area';
                }
            }

            if (searchExperiments.getSearchExperimentVariant('8664') !== "0") {
                regionTypeNum = regionTypeNum + 256;
            }

            Typeahead.URLPARAMS = {
                regiontype: regionTypeNum,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                features: featuresType,
                maxresults: opts.maxresults,
                client: opts.client
            };
        }

        if (getCurrentLob() === 'car') {
            opts.version = 'v4';

            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                maxresults: opts.maxresults,
                client: opts.client,
                sortcriteria: 'category'
            };
        }

        if (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_ACTIVITIES") !== 0) {
            opts.version = "v4";
            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                dest: true,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                maxresults: opts.maxresults,
                client: opts.client
            };
        }

        if (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_PACKAGES") !== 0) {
            opts.version = "v4";
            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                dest: opts.dest,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                maxresults: opts.maxresults,
                client: opts.client
            };
            if (Typeahead.isHierarchyEnabled(opts)) {
                Typeahead.URLPARAMS.features = "ta_hierarchy";
            }
        }
        if (opts.version == 'v4') {
            url = [Typeahead.V4URL, opts.version, '/typeahead/', encodeURIComponent(text), '?callback=?'].join('');
        }
        else {
            url = [
                Typeahead.SUGGESTURL,
                opts.version,
                '/ac/',
                opts.locale,
                '/',
                encodeURIComponent(text),
                '?callback=?'
            ].join('');
        }

        // Experiment 10406 : Support different types of typeahead within OpenSearch
        if (getCurrentLob() === 'openSearch' && abTest.get(10406).value) {
            if (abTest.get(10406).value == "3") {
                opts.mask = (Typeahead.HOTEL | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.POI);
                opts.version = 'v4';
                Typeahead.URLPARAMS = {
                    regiontype: opts.mask,
                    locale: opts.locale,
                    lob: opts.lob,
                    format: 'jsonp',
                    ab: opts.abtest,
                    features: featuresType,
                    maxresults: opts.maxresults,
                    rid: opts.regionid,
                    client: opts.client
                };
                url = [Typeahead.V4URL, opts.version, '/opensearch/', encodeURIComponent(text), '?callback=?'].join('');
            }
            else if(abTest.get(10406).value == "2") {
                isESSTypeaheadEnabled = false;
            }
        }

        var cb;

        if (!callback) {
            cb = $.noop;
        }
        else {
            cb = $.proxy(callback, instance);
        }

        //If the zero char typeahead trigger is on and there is no text
        if ((isRecentHistoryExperiment() || isTrendingSearchesNearYouExperiment()) &&  $.trim(text) == '') {
            setTimeout(cb, 1);
        }
        else {
            //If there is atleast one char in text
            if (Typeahead.URLPARAMS != undefined) {
                //rental location in Cars LOB
                if (searchExperiments.getSearchExperimentVariant('8206') !== "0") {
                    if (Typeahead.URLPARAMS.features && Typeahead.URLPARAMS.features !== '') {
                        Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|cars_rental';
                    }
                    else {
                        Typeahead.URLPARAMS.features = 'cars_rental';
                    }
                }

                //post code in Hotel and Cars LOB
                if (searchExperiments.getSearchExperimentVariant('8889') !== "0") {
                    if (Typeahead.URLPARAMS.features && Typeahead.URLPARAMS.features !== '') {
                        Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|postal_code';
                    }
                    else {
                        Typeahead.URLPARAMS.features = 'postal_code';
                    }
                    //Add bitmask for Typeahead.ADDRESS to hotel only as Cars already has that included in form of Typeahead.RENTAL
                    if (getCurrentLob() === 'hotel') {
                        Typeahead.URLPARAMS.regiontype = Typeahead.URLPARAMS.regiontype + 32;
                    }
                }

                //Bolding the destination text in ess v4 for hotel, flight and car LOB only
                if (searchExperiments.getSearchExperimentVariant('9242') !== "0") {
                    if (Typeahead.URLPARAMS.features && Typeahead.URLPARAMS.features !== '') {
                        Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|boldSearchDest';
                    }
                    else {
                        Typeahead.URLPARAMS.features = 'boldSearchDest';
                    }
                }

                if (essAbacusParameter) {
                    Typeahead.URLPARAMS.ab = essAbacusParameter;
                }

                Typeahead.URLPARAMS.client = requestGenerator.getClientId();
                Typeahead.URLPARAMS.siteid = requestGenerator.siteId;
                Typeahead.URLPARAMS.guid = requestGenerator.guid;

                if (isESSTypeaheadEnabled) {
                    $.getJSON(
                        url,
                        Typeahead.URLPARAMS,
                        cb
                    );
                }
                else{
                    callGemma(cb , text);
                }
                if (instance) {
                    instance.metricsLogger.timestamp(instance.metricsLogger.TimestampCategories.ESS_REQUEST, text);
                }
            }
            else {
                var param = {
                    type: opts.mask,
                    ab: essAbacusParameter,
                    lob: opts.lob,
                    format: 'json',
                    dest: opts.dest,
                    maxresults: opts.maxresults,
                    rid: opts.regionid,
                    client: requestGenerator.getClientId(),
                    siteid: requestGenerator.siteId,
                    guid: requestGenerator.guid
                };

                if (searchExperiments.getSearchExperimentVariant('8206') !== "0") {
                    param.features = 'cars_rental';
                }
                if (isESSTypeaheadEnabled) {
                    $.getJSON(
                        url,
                        param,
                        cb
                    );
                }
                else {
                    callGemma(cb , text);
                }
                if (instance) {
                    instance.metricsLogger.timestamp(instance.metricsLogger.TimestampCategories.ESS_REQUEST, text);
                }
            }
        }
    };

    function initTA($el, config) {
        var elementId = $el.attr("id");
        var typeahead = Typeahead.instanceByElementId[elementId];
        if (! typeahead) {
            typeahead = new Typeahead(config.getAll($el.data('ta-key')).typeahead);
            Typeahead.instanceByElementId[elementId] = typeahead;
        }
        typeahead.bindJQueryObject($el);
        return Typeahead.instanceByElementId;
    }

    Typeahead.instanceByElementId = {};

    // this is literally the only Typeahead property accessed outside the scope of this file
    Typeahead.init = function (taConfig) {
        var config = new configObj(taConfig);
        function appendTypeaheadContentToBodyElement() {
            // Accessibility
            // Insert DIV into DOM to receive the dynamic content.
            var acceptingID = 'uitk_ta_content',
                acceptingDiv = '<div id="' + acceptingID + '" role="presentation"></div>',
                alreadyExists = $('#' + acceptingID).length;

            //Append to body if typeahead tooltip does not exists
            if (alreadyExists === 0) {
                $('body').append(acceptingDiv);
            }
        }
        appendTypeaheadContentToBodyElement();
        Typeahead.request('zzzzz', null, config.getAll('def').typeahead, function () {});
        $('body').on('focus.typeahead', '[data-provide="typeahead"]', function (e) {
            try {
                e.preventDefault();
                Typeahead.instanceByElementId = initTA($(this), config, Typeahead.instanceByElementId);
            } catch (e) {
                if (_.isObject(console) && _.isFunction(console.log)) {
                    console.warn("Failed to (re-)initialize typeahead", e);
                }
            }
        });
    };

    // Types of cities yet to be integrated to GAIA. See the following Mingle card for detials:
    // /https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1518
    Typeahead.unintegratedCityTypes = ["BCOMCITY", "TRIPADVISORCITY"];

    Typeahead.encodeHtmlCharacterReferences = function(source) {
        if (typeof source !== "string") {
            return source;
        }
        var escapeMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };
        return String(source).replace(/[&<>"'`=\/]/g, function fromEscapeMap (s) {
            return escapeMap[s];
        });
    };

    // Converts a string that may contain HTML character entities into the corresponding string containing the
    // characters that are referred. For example, "C&#244;te d&#39;Ivoire" is converted to "Côte d'Ivoire".
    Typeahead.decodeHtmlCharacterEntities = function(encoded) {
        var textArea;
        if (typeof encoded !== "string") {
            return encoded;
        }
        textArea = document.createElement('textarea');
        textArea.innerHTML = encoded;
        return textArea.value;
    };

    /**
     * This function calls Gemma service to get response for prefix
     *
     * @param {Function} callback
     * @param {String} text
     */
    function callGemma(callback , text){
        $.ajax({
            url: Typeahead.GEMMAURL,
            dataType: 'xml',
            data: {clientid : Typeahead.GEMMACLIENTID ,
                count: Typeahead.GEMMACOUNT,
                prefix: text},
            success: function ajaxSuccess(response) {
                var json = formatGemmaResultsToJSON(response , text);
                callback(json);
            }
          });
    }
    /**
     * This function formats Gemma service results for easier parsing
     *
     * @param {Object} gemmaResponse
     * @param {String} prefix
     * @returns {Object} formatted gemma response
     */
    function formatGemmaResultsToJSON(gemmaResponse , prefix) {
        var suggestions = $(gemmaResponse).find('Suggestion')
            .map(function() {
                return this.innerHTML;
            })
            .get();

        var parseSuggestions = [];
        var index = 1;
        suggestions.forEach(function (suggestion)
        {
          var result = {
                "gemma" : "valid",
                "lob" : "GEMMA",
                "index" : index,
                "regionNames" : {
                    "fullName" : suggestion
                }
            };
          index++;
          parseSuggestions.push(result);
        });
        var jsonResponse = { "q" : prefix , "r" : parseSuggestions};
        return jsonResponse;
    }

    return Typeahead;

});
